import ContentOverlayNew from "../components/content_overlay_new";
import { Link } from "react-router-dom";

import "./sidenav.css";

function ArticlePage() {
  return (
    <ContentOverlayNew
      heading={
        <h2 style={{ textAlign: "center" }}>
          Spatial Distribution of Plants in Kerala{" "}
        </h2>
      }
      text_content={
        <>
          <div className="row">
            <div id="sidenav" className="col-3">
              <nav
                className="navbar-nav underline-hover"
                style={{
                  backgroundColor: "white",
                  borderRadius: "30px",
                  marginBottom: "70px",
                }}
              >
                <ul style={{ marginBottom: "60px" }}>
                  <li>
                    <a
                      className="nav-link underline-hover"
                      href="#Introduction"
                    >
                      {" "}
                      Introduction
                    </a>
                  </li>
                  <ul>
                    <li>
                      {" "}
                      <a className="nav-link" href="#World Plant Diversity">
                        {" "}
                        World Plant Diversity
                      </a>
                    </li>
                    <li>
                      <a className="nav-link" href="#Plant Diversity in India">
                        {" "}
                        Plant Diversity in India
                      </a>
                    </li>
                    <li>
                      <a className="nav-link" href="#Plant Diversity in Kerala">
                        {" "}
                        Plant Diversity in Kerala
                      </a>
                    </li>
                  </ul>
                  <li>
                    <a className="nav-link" href="#Review of Literature">
                      {" "}
                      REVIEW OF LITERATURE
                    </a>
                  </li>
                  <li>
                    <a className="nav-link" href="#Materials and Methods">
                      {" "}
                      MATERIALS AND METHODS
                    </a>
                  </li>
                  <ul>
                    <li>
                      <a className="nav-link" href="#Study Area">
                        {" "}
                        STUDY AREA
                      </a>
                    </li>
                    <li>
                      <a className="nav-link" href="#Methods">
                        {" "}
                        Methods
                      </a>
                    </li>
                  </ul>
                  <li>
                    <a className="nav-link" href="#Results">
                      {" "}
                      RESULTS
                    </a>
                  </li>
                  <ul>
                    <li>
                      <a
                        className="nav-link"
                        href="#Spatial Analysis of Species"
                      >
                        {" "}
                        Spatial Analysis of Species
                      </a>
                    </li>{" "}
                    <li>
                      <a className="nav-link" href="#Trees of Kerala">
                        {" "}
                        Trees of Kerala
                      </a>
                    </li>
                    <li>
                      <a className="nav-link" href="#Shrubs of Kerala">
                        {" "}
                        Shrubs of Kerala
                      </a>
                    </li>
                    <li>
                      <a className="nav-link" href="#Herbs of Kerala">
                        {" "}
                        Herbs of Kerala
                      </a>
                    </li>
                  </ul>
                  <li>
                    <a className="nav-link" href="#Conclusion">
                      {" "}
                      CONCLUSION
                    </a>
                  </li>
                  <li>
                    <a className="nav-link" href="#References">
                      {" "}
                      REFERENCES
                    </a>
                  </li>
                </ul>
              </nav>
            </div>

            <div className="col-9 content container">
              <nav
                className="navbar-nav"
                style={{
                  backgroundColor: "white",
                  borderRadius: "20px",
                  padding: "20px",
                }}
              >
                <ul>
                  <p
                    style={{
                      textAlign: "center",
                      fontWeight: "normal",
                      fontFamily: "Times New Roman, Times, serif",
                    }}
                  >
                    T.V Ramachandra, Minula Treesa Antony and Tulika Mondal{" "}
                    <br /> IISc-EIACP, Energy and Wetlands Research Group <br />{" "}
                    CES TE 15 - Indian Institute of Science <br /> Bangalore
                    560012 <br /> Web:{" "}
                    <a href="https://wgbis.ces.iisc.ac.in/">
                      https://wgbis.ces.iisc.ac.in/
                    </a>{" "}
                    <br /> Email:{" "}
                    <a href="mailto:envis.ces@iisc.ac.in">
                      envis.ces@iisc.ac.in
                    </a>
                    .
                    <a href="mailto:energy.ces@iisc.ac.in">
                      energy.ces@iisc.ac.in
                    </a>
                    .<a href="mailto:tvr@iisc.ac.in">tvr@iisc.ac.in</a>{" "}
                  </p>
                  <li className="nav-item">
                    <section id="Introduction">
                      <p
                        style={{
                          textAlign: "justify",
                          fontSize: "0.999999999em",
                        }}
                      >
                        <h3>1. Introduction</h3>
                        Plant diversity is the variety of plant species in an
                        area. It occurs mainly due to the different
                        characteristics and adaptations shown by plants to
                        different environments. They collectively grow in
                        specific ecosystems like forests and play a key role in
                        carbon sequestration, prevention of soil erosion, food,
                        timber, medicine, etc. Among biotic factors of our
                        ecosystem, plants are the important factor that support
                        life on Earth and sustain ecosystem dynamics. Plants are
                        primarily autotrophic organisms, which differ in size
                        and shape and range from single cells, such as algae, to
                        complex organisms, such as trees. They are the primary
                        producers capable of producing energy from abiotic
                        factors, allowing this energy to circulate around the
                        ecosystem. The diversity that the plants exhibit is
                        always a topic of study as plant diversity is a vast and
                        vital treasure still holding an unexplored large
                        portion. Research studies and new explorations in the
                        flora throw more light on our biodiversity knowledge and
                        help in the planning and implementation of conservation
                        strategies.{" "}
                      </p>
                    </section>
                  </li>{" "}
                  <br />
                  <ul>
                    <li>
                      <section id="World Plant Diversity">
                        <p
                          style={{
                            textAlign: "justify",
                            fontSize: "0.999999999em",
                          }}
                        >
                          <h5>1.1 World Plant Diversity</h5>
                          According to Corlett, 2016 study, there are around
                          500,000 species of land plants in the World, of which
                          450,000 are angiosperms. Studies suggest that
                          two-thirds of angiosperms are found within the
                          tropics, in which the Neotropics and Asia-Pacific
                          region have the highest diversity and Africa and
                          oceanic islands have lower diversity. Since 2020, more
                          than 8,600 plant species have been introduced to
                          science (Antonelli, 2023). Barthlott et al., 2005
                          study also agree with the statement that high
                          diversity is concentrated in the humid tropics, and
                          also points out five centers of highest species
                          richness in the World, namely Costa Rica-Chocó,
                          Tropical Eastern Andes, Atlantic Brazil, Northern
                          Borneo, and New Guinea, having density of more than
                          3,000 species per 10,000 km2. Nowadays, plants are
                          facing a greater threat of extinction, and the need
                          for effective conservation measures is gathering much
                          more importance. A recent study reports that 45% of
                          flowering plant species worldwide and three in four
                          unknown plant species are at risk of extinction
                          (Antonelli et al., 2023). Habitat loss due to forest
                          fragmentation, land degradation, deforestation,
                          overexploitation of the whole plant or enough of it to
                          reduce the chance of survival, invasive alien species,
                          soil acidification, change in nutrient cycles due to
                          air pollution and anthropogenic climate change are the
                          major threats faced by plants in a global level
                          (Corlett, 2016). Various government and non-government
                          organizations have stepped towards plant conservation
                          and for a conserved, sustainable world. The Royal
                          Botanic Garden (Kew) in London is not only a heritage
                          site but also a home for valuable floral knowledge
                          from centuries to the present date and a prominent
                          institution that cultures various conservation
                          measures in global level. It organizes many programs
                          to halt the extinction crisis of plants and also meets
                          the Sustainable Developmental Goals (Cowell et al.,
                          2022). The World Checklist of Vascular Plants (WCVP)
                          database is an easily assessable source of authentic
                          scientific details about the plants. WCVP is a
                          comprehensive list of vascular plants in the world,
                          which is scientifically derived, complied from four
                          decades, reviewed by experts, and continuously updated
                          in the Plants Of the World Online (POWO) website of
                          Kew. By 16th April 2021, the WCVP database includes
                          342,953 accepted vascular plant species worldwide
                          (Govaerts et al., 2021). This helps a common man or
                          any researcher to know valid details about a plant and
                          the latter to discover and study more on the global
                          plant resources. In 2010, the Conference of Parties
                          (COP) to the Convention on Biological Diversity (CBD)
                          adopted the Updated Global Strategy for Plant
                          Conservation (GSPC) 2011-2020, to stop the continuing
                          loss of plant diversity and for a sustainable future
                          where human support plant diversity and in turn plant
                          diversity improve human well-being. It speaks out the
                          fact that, without plants, life doesn’t exist, and our
                          planet's functioning and human survival depend upon
                          plants. Even though it was not likely to achieve the
                          ultimate goal to stop plant diversity loss by 2020, it
                          provided an entry point for government and
                          non-government organizations into plant conservation
                          and encouraged the development of target-specific
                          support groups linked through Global Partnership for
                          Plant Conservation (GPPC). The strategy reached a
                          number of targets, and the results resulted in the
                          launch of the World Flora Online website, which
                          provides a global overview of plant diversity. The
                          strategy also resulted in the progress of the red
                          listing of plants (Sharrock, 2020). Recently, at COP
                          15 in December 2022, CBD adopted the Kunming-Montreal
                          Global Biodiversity Framework to put biodiversity on
                          the path of recovery by 2030. On 12 May 2023 in the
                          International Day of Plant Health, David Cooper, the
                          Acting Executive Secretary of the CBD, stated about
                          the importance of healthy plants and challenges to
                          support the Kunming Montreal Global Biodiversity
                          Framework (David Cooper, 2023).
                        </p>
                      </section>
                    </li>{" "}
                    <br />
                    <li>
                      <section id="Plant Diversity in India">
                        <p
                          style={{
                            textAlign: "justify",
                            fontSize: "0.999999999em",
                          }}
                        >
                          <h5>1.2 Plant Diversity in India</h5>
                          India is one of the megadiversity countries in the
                          world. It is home to a variety of flora with a greater
                          number of endemics. With a geographical area of 329
                          million hectares, India accounts for flora of 17,000
                          species of flowering plants under 320 families, in
                          which 33 % are endemic to the country. Among different
                          biogeographical zones, the Eastern Himalayas and
                          Western ghats are botanically rich areas of world
                          significance. As these are threatened due to various
                          anthropogenic activities, the International Union for
                          the Conservation of Nature and Natural Resources
                          (IUCN) recognized these two areas as ‘Hotspots’.
                          Detailed knowledge of its floristic diversity will
                          help to organize action-oriented programs for
                          conservation (Hajra P.K & Mudgal V, 1997). Of India’s
                          total geographical area, 21.05% (692,027 km2) is
                          constituted by forest land, and 7 % (6700 km2) are
                          mangroves. India holds 2.4% of the world’s total
                          landmass, in which 47,513 plant species are present.
                          In that 17,527 species are angiosperms, 58
                          gymnosperms, 1200 pteridophytes, 2800 bryophytes, 2000
                          species of mosses, 2021 species of lichens, 14,500
                          fungi and 6500 algae. Over 30% of the geographical
                          area of our country still need to be explored of its
                          biodiversity (Arisdason & Lakshminarasimhan, n.d.).
                          This makes biodiversity study in India more important.
                          The Biological Diversity Act 2002 provides an
                          institutional framework in India to implement the
                          objectives of the Convention on Biological Diversity
                          (CBD). It constitutes a three-tier institutional
                          mechanism with National Biodiversity Authority (NBA)
                          at national level, State Biodiversity Boards (SBBs) at
                          the state level, and Biodiversity Management
                          Committees (BMCs) at the local level. It provides a
                          legislative framework to regulate access, use, and
                          rights over India’s rich biological resources
                          (Digvijay, 2014). The Ministry of Environment, Forest
                          and Climate Change (MoEFCC) act as a nodal agency in
                          India for natural resource conservation in the country
                          with the support of legislative and conservation
                          measures. Botanical Survey of India acts under the
                          MoEFCC, carryout floristic research and explorations
                          in the country, and involves ex-situ conservation of
                          plants.
                        </p>
                      </section>
                    </li>{" "}
                    <br />
                    <li>
                      <section id="Plant Diversity in Kerala">
                        <p
                          style={{
                            textAlign: "justify",
                            fontSize: "0.999999999em",
                          }}
                        >
                          <h5>1.3 Plant Diversity in Kerala</h5>
                          Kerala, a state of India, is situated in the
                          biodiversity-rich humid tropics (Nair et al., 2001).
                          Due to the long tract of the Western Ghats along the
                          eastern side and the Lakshadweep along the western
                          side, the physiography of the State is highly
                          diversified (N. Sasidharan, 2006). According to Nayar
                          et al., 2008, there are 4681 flowering plants in
                          Kerala, with 57 subspecies and 287 varieties. These
                          species fall under 1418 genera and 188 families and
                          hold 27.57% of flowering plants in India. The report
                          says that Kerala holds 865 Western Ghat endemic
                          species, in which 237 species are endemic to Kerala.
                          Of the total flowering plants in Kerala, 50.1% are
                          herbs, 15.8 % are shrubs and 15.08% are trees (Nayar
                          et al., 2008). As Kerala forests are part of the
                          biodiversity rich Western Ghats, most species are
                          endemic and unique to the area. Hence, effective
                          conservation measures are needed. Kerala Forest
                          Research Institute (KFRI), which comes under Kerala
                          State Council for Science, Technology and Environment
                          (KSCSTE), has contributed valuable information about
                          the tropical forests. The forest botany division of
                          KFRI study about the plant species diversity in
                          Kerala. Jawaharlal Nehru Tropical Botanic Garden and
                          Research Institute (JNTBGRI) also comes under the
                          KSCSTE of Kerala state and work on conserving tropical
                          plant resources and its sustainable utilization.
                          Several other botanic gardens, research institutes,
                          government organizations, and herbarium collections in
                          Kerala play an important role in the conservation of
                          plant resources. <br />
                          The study aims to gather information of each plant
                          species in Kerala from E-resources and literatures.
                          The objectives of the current study are to <br /> i.
                          collect details of different plant species in Kerala.{" "}
                          <br /> ii. document the species based on habits like
                          tree, shrub, and herb. <br /> iii. analyze the spatial
                          distribution of species in different districts of
                          Kerala.
                        </p>
                      </section>
                    </li>{" "}
                    <br />
                  </ul>
                  <li className="nav-item">
                    {/* Literature Review starts from here! */}
                    <section id="Review of Literature">
                      <p
                        style={{
                          textAlign: "justify",
                          fontSize: "0.999999999em",
                        }}
                      >
                        <h3>2. Review of Literature</h3>
                        Ramachandran &amp; Nair, 1988 studied the flora of
                        Cannanore, which is the Kannur district of Kerala state.
                        The total area of study was about 3670 sq.km, including
                        the present northern Wayanad taluk area, which was once
                        the part of Cannanore but now belongs to the Wayanad
                        district. The region has three natural divisions: the
                        lowlands, the midlands and the highlands. Thirteen
                        exploration trips of duration 15-20 days were conducted
                        in different seasons during five years. Every species
                        was collected in their flowering and fruiting stages,
                        and detailed field notes were noted. Further critical
                        studies were done with authentic materials and expert
                        opinions. According to (Champion &amp; Seth, 1968) there
                        are three types of forests in the area: tropical
                        evergreen, tropical semievergreen and tropical moist
                        deciduous types. Chandrasekaran, 1960 recognized two
                        types, climax type and secondary type. The flora of the
                        study area accounts for 1132 species of angiosperms in
                        658 genera and 157 families. Fabaceae (sensa lato) is
                        the dominant family in the study area. Gymnosperms are
                        represented by 2 species belonging to 2 genera and 2
                        families. From the total endemic angiosperms of
                        Peninsular India, 15 species belonging to 12 genera
                        under 10 families were collected during the study. 9
                        species which were known only from the type or other
                        very old collections were relocated. The flora of
                        Cannanore shows marked affinity with the flora of Sri
                        Lanka, having a number of species common to both.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Mohanan &amp; Henry, 1994 conducted a study and prepared
                        a report on the flora of Thiruvananthapuram district in
                        Kerala. A systematic botanical exploration was conducted
                        for five years with field observations. The study
                        results in collecting 1270 species in 710 genera under
                        163 families. Among the total flora, 939 species were
                        dicots, 328 were monocots, and 3 were gymnosperms. The
                        Leguminosae and Gramineae families are the first and
                        second largest families, respectively. Tea, rubber,
                        teak, and cashew plantations, jungle woods like{" "}
                        <em>Artocarpus hirsutus</em>,{" "}
                        <em>Artocarpus heterophyllus</em> and soft wood like{" "}
                        <em>Pithecellobium monadelphum</em> can be seen in the
                        area. The study resulted in the discovery of two new
                        species <em>Cinnamomum chemungianum</em> (Lauraceae) and{" "}
                        <em>Syzygium parameswaranii</em> (Myrtaceae)&nbsp; and
                        two new varieties <em>Eria muscicola </em>(Lindl.)
                        Lindl. var. <em>ponmudiana</em> (Orchidaceae) and{" "}
                        <em>Exacum courtallense </em>Arn. var.{" "}
                        <em>boneccordiana</em> (Gentlanaceae). During the study,{" "}
                        <em>Eragrostis cumingii</em> Steud. (Poaceae) and{" "}
                        <em>Exacum walkesi</em> Griseb. (Gentianaceae) are
                        recorded for the first time from India. Species such as{" "}
                        <em>Aphyllorchis montana</em> (Thw.) Reichb. f.
                        (Orchidaceae), <em>Asplenium affine</em> Sw. forma{" "}
                        <em>affine</em> (Aspliniaceae) and{" "}
                        <em>Malaxis latifolia</em> Sm. (Orchidaceae) are
                        recorded first time from Kerala.{" "}
                        <em>Actinodaphne campanulata</em> Hook.f var.{" "}
                        <em>obtusa</em> Gamble, <em>Clematis bourdillonii</em>{" "}
                        Dunn, <em>Cinnamomum travancoricum</em> Gamble,{" "}
                        <em>Eria muscicola </em>(Lindl.) Lindl. var.{" "}
                        <em>brevillnglus</em> Joseph &amp; Chandras and{" "}
                        <em>Ochlandra ebracteate</em> Raizada &amp; Chatterjee
                        are endemic to Thiruvananthapuram. Several rare and
                        threatened species was also observed during the study.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Sasidharan et al., 1994 conducted botanical studies in
                        the medicinal plant conservation areas (MPCAs) in
                        Kerala. Among 7 MPCAs in Kerala, 5 of them were explored
                        in the study: Athirapally, Peechi, Silent Valley, Periya
                        and Eravikulam. Specimens were collected in their
                        generative stages, and data were recorded. Herbarium
                        specimens were prepared and identified with the help of
                        standard literature and by comparing with authentic
                        specimens. Belt transects were laid and enumerated
                        species in the transects were carried out as per the
                        design provided by the FRLHT (The Foundation for
                        Revitalisation of Local Health Traditions). About 1% of
                        the area in each MPCA was covered by transects. Among
                        the five MPCAS, two are located in the Moist deciduous
                        forests (Athirapally and Peechi), two in the Evergreen
                        forests (Silent Valley and Periya), and one in the
                        Shola-Grasslands (Eravikulam). In Athirapally, 238
                        species under 186 genera were recorded. Fabaceae and
                        Poaceae, with 26 species each, are the largest families.
                        Peechi records 215 species under 167 genera and 67
                        families. Fabaceae, with 30 species, is the largest
                        family in Peechi. &nbsp;In Silent Valley, 343 species
                        under 270 genera and 104 families were recorded.
                        Orchidaceae is the largest family with 25 species. In
                        Periya, 234 species under 195 genera and 81 families
                        were recorded. Rubiaceae with 16 species is the largest
                        family. Eravikulam records 201 species under 154 genera
                        and 72 families. Orchidaceae, with 18 species, is the
                        largest. Among the five MPCAs, Peechi dominates with 107
                        species of medicinal plants, followed by Athirapally
                        with 95 species. In Silent Valley, the medicinal plants
                        are 59, while at Periya, it is 33. The lowest number
                        (23) is at Eravikulam as many of the species have not
                        been evaluated for their medicinal properties. Among the
                        MPCAs, the highest number of endemics (78) is recorded
                        from Silent Valley, followed by 67 at Periya, 57 at
                        Eravikulam, 42 at Athirapally, and 12 from Peechi.
                        Silent Valley, Periya and Eravikulam are relatively
                        undisturbed with a smaller number of exotic weeds.
                        Peechi and Athirapally are disturbed areas with many
                        exotic weeds, and they are under severe biotic pressure.
                        Regarding species diversity, Silent Valley ranks first
                        with 343 species, with 22.7% endemic species. The number
                        of Rare and Threatened species is more in Periya, Silent
                        Valley, and Eravikulam, with 12, 8 and 7 species,
                        respectively, while in Athirapally, there are 3 species,
                        and in Peechi there is only one. In general, the MPCAs
                        in the Evergreen forests at Silent Valley and Periya
                        exhibit a greater species diversity.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        Jose et al., 1994 studied the structural, floristic, and
                        edaphic attributes of the grassland-shola forests of
                        Eravikulam National Park in the Idukki district of
                        Kerala. The study area was selected based on visual
                        observations on floristic composition and density, which
                        caused the selection of a representative grassland-shola
                        forest type of the Rajamallay area in the Eravikulam
                        National Park. 50 quadrats of 10 X 10 m size were
                        established in shola forest, GBH of all trees and shrubs
                        were measured and recorded. Species-area relationships,
                        structural attributes, phytosociological parameters,
                        Importance Value Index (IVI) and Diversity Indices were
                        calculated from the Sholas. Ten quadrats of 1 X 1 m were
                        laid in grasslands near the sholas to study the species
                        diversity and biomass productivity. Soil samples were
                        collected to characterize the soil profile development
                        and the result showed a reddish-brown surface horizon
                        and a very dusky red lower horizon. The difference
                        between the grassland and shola profiles was
                        statistically not significant. From shola forests, 942
                        stems of at least 10 cm GBH, belonging to 53 species
                        were encountered, which is equivalent to a density of
                        1884/ ha. The species having the highest density was{" "}
                        <em>Pithecellobium subcoriaceum</em> Thw. Grasses were
                        mainly represented in the peripheral region of sholas,
                        where light availability to the ground floor is
                        comparatively high.&nbsp; A continuance canopy from
                        under-shrubs to shrubs and then to larger shola trees,
                        with no marked differentiation was observed in the shola
                        vegetation. Four species were encountered from the
                        grassland, in which <em>Arundinella vaginata</em> showed
                        a high degree of dominance. Biomass accumulation of
                        grasslands ranged from 471 to 633 g/m<sup>2</sup>.&nbsp;
                        Regarding structural features of vegetation, Eravikulam
                        shola forests were superior to the mid and low-elevation
                        forests of the Western Ghats.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Mohan Kumar et al., 1994 studied the diversity,
                        structure, and standing stock of wood in the home
                        gardens of Kerala. Out of 61 thaluks, 17 taluks were
                        randomly selected from nine districts throughout Kerala.
                        Detailed house-hold surveys were performed among
                        individual farmers belonging to the small (below 0.4
                        ha), medium (0.4 to 2 ha), and large (&gt; 2.0 ha)
                        holding size categories. Farmers were identified through
                        a stratified random process. A total of 252 farmers were
                        surveyed, five in each category from any given thaluk
                        during the years 1991 and 1992. General information on
                        crop and livestock production enterprises was gathered,
                        and all scattered trees and shrubs on the homestead and
                        border trees, except palms and rubber, were enumerated.
                        For palms and rubber, their mean height, girth and
                        frequency were recorded. In total, 127 woody species
                        were encountered. Coconut and arecanut were the most
                        dominant components of the home gardens of the entire
                        state. Smaller holdings had a higher density of trees
                        per unit area. Physiognomically, home gardens exhibit a
                        multi-tiered canopy structure that is somewhat similar
                        to that of tropical evergreen forests. Medium-sized
                        holdings registered the least value for Simpson's index,
                        which may be due to the focus of medium holders on cash
                        crops like coconut, rubber, cacao, and spices. The
                        density-based Shannon-Wiener diversity index (H')
                        suggested low to moderate levels of floristic diversity.
                        The mean number of individuals exhibited no marked
                        variation among the thaluks. Coastal areas show
                        relatively lower values of Simpson's diversity index and
                        equitability, while midlands exhibited higher diversity
                        functions. Major species were represented in all
                        size-classes, suggesting that home gardens are dynamic
                        as well as sustainable land use systems.&nbsp; The
                        frequency distribution of homestead trees indicates that
                        farmers prefer timber trees such as <em>Ailanthus</em>{" "}
                        and teak. The Sorensen's similarity indexes show
                        moderately high similarity for different tree species
                        encountered on the homesteads. Homegarden size is, by
                        and large, a function of the population density. The
                        northern thaluks, having relatively lower population
                        densities, had relatively larger home gardens. No
                        clearcut planting pattern was recognized in the home
                        gardens of Kerala. The average standing stock of
                        commercial timber ranged from 6.6 to 50.8 m<sup>3</sup>/
                        ha and fuel wood volume was of the order of 23 to 86 m
                        <sup>3</sup>/ha. This shows that a good amount of
                        society's wood demands are met from the homesteads.
                        Palms were the dominant component of standing commercial
                        timber and fuel wood volumes.&nbsp;
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Chandrashekara, 1996 studied the ecology of{" "}
                        <em>Bambusa arudinacea</em> (Retz.) Willd. growing in
                        teak plantations of the Kariem-muriem reserve of the
                        Nilambur Forest Division, in KeraIa where the natural
                        forests were tropical moist deciduous. Bamboo clump
                        distribution and clump size were analyzed at different
                        distances from the water course. Three convenient types
                        of bamboo distribution were recognized: Type A - having
                        3 or more clumps per 400 m<sup>2</sup>; Type B&nbsp;
                        having 1-3 clumps per 400 m<sup>2</sup>; Type C, having
                        0-3 clumps per 400 m<sup>2</sup>. Phytosociological
                        studies of herbs, shrubs, trees, seedlings, and saplings
                        were done using standard methods. The biomass of teak
                        was measured by a non-destructive volume estimation
                        method, while biomass estimation in bamboo was based on
                        destructive sampling. The biomass of herbs, shrubs, and
                        tree seedlings was determined separately by harvesting
                        above-ground biomass from October-November 1992. Shrubs,
                        seedlings, saplings, and mature trees of species showed
                        higher values for density, basal area and species
                        diversity index in site C, herbs were denser and had
                        more basal cover in site A and more species diversity in
                        site B. The density of teak did not show any significant
                        difference among the three site types, but its basal
                        area was significantly higher in site C. In case of
                        bamboo, the highest values for density and basal area
                        were recorded in site A. For each site, the contribution
                        of teak to the total above-ground biomass was generally
                        higher. Nutrient concentrations were generally highest
                        in leaves and lowest in main branches. Enrichment
                        quotients of potassium and nitrogen were significantly
                        higher in bamboo than in teak. However, teak had higher
                        enrichment ratios for calcium.&nbsp;&nbsp;
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Renuka et al., 1996 studied the palm resources of Kerala
                        and their utilisation. As part of the study, frequent
                        visits were made to the forest areas of Western Ghats
                        and other palm-growing habitats. Herbarium specimens
                        were prepared, field observations were noted, and
                        detailed enquiries were made with the local
                        people.&nbsp; Kerala has 10 genera and 21 species in its
                        palm wealth. Of these <em>Cocos nucifera</em> (coconut),{" "}
                        <em>Areca catechu</em> (arecanut) and{" "}
                        <em>Elaeis guineensis</em> (oil palm) are widely
                        cultivated. Another 13 different genera are cultivated
                        as ornamental palms. The only rattan genus in Kerala,{" "}
                        <em>Calamus</em>, is widely used in the furniture
                        industry. Genus like <em>Arenga</em>,{" "}
                        <em>Bentinckia</em> and <em>Pinanga</em> occur in
                        evergreen forests. <em>Phoenix</em> is seen in
                        grasslands at high elevation. <em>Borassus</em> and{" "}
                        <em>Corypha</em> are semi-wild palms seen in open areas
                        and are often cultivated. <em>Caryota</em> has a wider
                        distribution and is seen in evergreen, semievergreen,
                        and moist deciduous forests. Except <em>Phoenix</em> and{" "}
                        <em>Pinanga</em> all other palms are single stemmed. Of
                        the 6 subfamilies of Palmae family, only three
                        subfamilies are represented in Kerala; namely{" "}
                        <em>Coryphoideae</em>, <em>Calamoideae</em> and{" "}
                        <em>Arecoideae</em>. The fibro-vascular tissue of the
                        palms is valuable for woody constructional material and
                        provides the brush fibre. The tough leathery leaf blades
                        of a number of palms are used in thatching, basket
                        weaving, plaiting and wickerwork, handicrafts, fodder
                        and green manure. Leaflet blades of some species like{" "}
                        <em>Borassus flabellifer</em> and{" "}
                        <em>Corypha umbraculifera</em> are used for writing
                        manuscripts in ancient times. The main edible products
                        obtained from palms include parts of fruits and seed,
                        the tender apical portions of stem and storage products
                        and secretions such as starch, fats or sugars from other
                        parts. The sweet toddy is consumed fresh as a beverage
                        or converted into various useful products such as
                        palm-sugar, arrack, candy, vinegar etc. Palms are also
                        used for landscaping and agroforestry purposes. Loss of
                        habitat and over-exploitation are the major threats to
                        palms. As <em>Arenga wightii</em>,{" "}
                        <em>Bentinckia condapanna</em> and{" "}
                        <em>Pinanga dicksonii</em> are much restricted in
                        distribution, destruction of evergreen forests is
                        affecting the growth of their population.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Gopalan, 1997 studied the plant diversity in
                        Agastyamalai hills, situated at the southern end of
                        Western Ghats and falls within the hilly tracts of
                        Tirunelveli-Kattabomman and Kanniyakumari districts of
                        Tamil Nadu and Thiruvananthapuram district of Kerala.
                        The western slope in Kerala has an area of 180 sq. km
                        with two wildlife sanctuaries: Neyyar (128 sq.km) and
                        Peppara (53 sq.km) wildlife sanctuary. Agastyamalai has
                        a forest cover of 2000 sq.km and harbours 2000 flowering
                        plants, including 100 endemic and 50 rare and endangered
                        species. The floristic diversity and complexity make it
                        a rich gene pool region. More than 30 new taxa have been
                        discovered here in recent years.{" "}
                        <em>Aenhenrva agastyamalayana </em>Gopalan and{" "}
                        <em>Janakia arayalpathra</em> J. Joseph &amp; V.
                        Chandras. are two new genera discovered. 157 families
                        are represented in the region. Several Sri Lankan
                        species, which were so far considered to be endemic to
                        Sri Lanka have also been collected in these forests. The
                        region is known for rare plants that are still widely
                        used in ayurvedic medicines. Besides valuable timber
                        trees, revenue is being collected from the sale of minor
                        forest produce. The Kani tribes inhabiting in the area
                        collect honey, Cinnamomum bark, resin of white dammar,
                        black dammar, bark for red dye from{" "}
                        <em>Morinda tinctoria</em> Roxb. and fruits of{" "}
                        <em>Garcinia</em> spp. Commercial cash crops such as
                        coffee, tea, rubber, pepper, and cardamom are grown on
                        large scale in the hill slopes. Hydel/irrigation
                        projects, cultivation of plantation crops, increase in a
                        number of pilgrims, and the visitors intentional fire to
                        the seasonal dry forests had caused a loss of
                        biodiversity in the area. Also, there are many
                        threatened animal species in the area in which the tiger
                        is the apex of a complex biotype. The social and
                        environmental values that the area provides are yet to
                        be fully assessed.&nbsp;
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Sajeev &amp; Sasidharan,
                        1997&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; studied the
                        ethnobotanical observations on the tribals of Chinnar
                        Wildlife Sanctuary in the Idukki district of Kerala. The
                        sanctuary occupies and area of 90.44 km<sup>2</sup>. The
                        vegetation types are dry deciduous forests (dominant in
                        the sanctuary), moist deciduous forests, semi-evergreen
                        forests, grasslands, and shoal forests. The tribals in
                        the sanctuary are Hill Pulayas and Muthuvans, living at
                        11 settlements. Ethnobotanical details were collected
                        from the tribal medical practitioners from 1994 to 1996,
                        and the voucher specimens were prepared. 64 plant
                        species used by the tribals for various purposes were
                        observed. Among the 64 species, 55 were used as
                        medicinal plants, 3 as fiber-yielding, 2 as fish poison
                        and 3 as food plants. Of the 55 medicinal plants, 8
                        species were used to heal cuts and wounds, 6 as anodyne,
                        4 as antidote to poison, 4 against skin diseases, 4
                        anti-dysenteric, 2 as antipyretic and 2 insect
                        repellents.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Vivekananthan et al., 1997 studied the plant diversity
                        in Nilgiri Biosphere Reserve, Southern India. A good
                        amount of biodiversity occurs here mainly due to the
                        significant geographical location (Trijunction of
                        western Ghats) and the proximity of the tri-seas (the
                        Arabian sea, the Bay of Bengal, and the Indian Ocean).
                        All the important forest types in southern India, from
                        scrub jungles to wet evergreen forests and others that
                        are peculiar to the region. About 80% of flowering
                        plants reported from the Western Ghats (3187/4000)
                        appear to occur in the Nilgiri Biosphere Reserve. The
                        genus <em>Baeolepis Decne</em>.ex Moq. (Periplocaceae)
                        is exclusively endemic to the Nilgiris.{" "}
                        <em>Silentvalleya</em> V.J Nair et al. is the other
                        genus endemic to Silent Valley, an integral part of the
                        biosphere reserve. Out of the 1932 taxa of flowering
                        plants endemic to Peninsular India, about 818 (25%) are
                        found in the Nilgiris and adjoining areas.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Chandrashekara et al., 1998 studied the plant diversity
                        in different forest types of Kerala by laying out a
                        permanent sample plot in four different forests. They
                        are the tropical montane forest (shola forest) at
                        Mannavan Shola in Munnar Forest Division, the tropical
                        evergreen forest at Pothumala in Nemmara Forest
                        Division, the moist deciduous forest at Channakkad in
                        Trichur Forest Division, and the dry deciduous forest at
                        Chinnar Wildlife Sanctuary in Eravikulam Wildlife
                        Sanctuary Division. The plot was of 1-ha in size and was
                        subdivided into 100 quadrats 10 m x 10 m in size, with
                        quadrats permanently marked. In each permanent plot,
                        tree tagging and identification were carried out in
                        three stages by marking all trees above 30.1 cm girth at
                        breast height (GBH) as mature trees, with GBH ranging
                        from 10.1 cm to 30.0 cm as saplings and plants with less
                        than 10 cm girth and less than 1 m height as tree
                        seedlings. Most of the trees species were identified in
                        the field, while others were identified by referring the
                        herbaria. The relative density, relative frequency,
                        relative dominance and the Importance Value Index (IVI)
                        of species were calculated. Stands quality of shola and
                        wet evergreen forests was determined using RISQ
                        (Ramakrishnan index of Stand Quality) equation. The
                        Mannavan shola natural forest and dry deciduous forest
                        plot site was noticed without major disturbance. Almost
                        all species in the moist deciduous forest and dry
                        deciduous forest plots are widely distributed in the
                        Indian subcontinent. Among the four plots, shola and wet
                        evergreen forest plots are species-rich and comparable
                        to many tropical wet evergreen forests. The lowest
                        species diversity was recorded in dry deciduous forests
                        indicating the dominance of one or two species in the
                        tree community.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Varghese &amp; Menon, 1998 studied a variety of trees,
                        grasses, shrubs, and herbs in the moist mixed deciduous
                        forests of Agasthyamalai region of Kerala.{" "}
                        <em>Terminalia paniculata</em> and{" "}
                        <em>Pterocarpus marsupium</em> are the dominant species,
                        and co-dominants vary from locality to locality. Species
                        diversity, stand density and basal area cover are lower
                        in hilltop regions and higher for valleys. Compared to
                        the moist deciduous of the Western Ghats, the
                        Agasthyamalai part of Kerala showed comparatively lower
                        basal area cover, species diversity, and evenness.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Manilal &amp; Raveendrakumar, 1998 studied the additions
                        to the flora of Kerala since Gamble (1935). Gamble's
                        &lsquo;Flora of the Presidency of Madras&rsquo; (19 I
                        5-35) was usually consulted by general taxonomists and
                        students for the study and identification of flowering
                        plants of Kerala. Since then, a large number of new
                        species and records were reported. Information about all
                        the new taxa, new records, and new combinations of
                        angiosperms reported from Kerala (since Gamble), is
                        collected and provided in the literature. This includes
                        625 new taxa coming under 103 different families, which
                        have been published by various workers since Gamble. Of
                        these, 240 are new additions to the world flora. This
                        includes six new genera, 193 new species, 3 new
                        sub-species and 41 new varieties. An analysis of the
                        percentage of new reports from Kerala since Gamble
                        reveals that Orchidaceae (118.9 %), Zingiberaceae (88.2
                        %) and Araceae (69.2 %) show a very high increase in
                        number. The maximum number of reports are from Silent
                        Valley in Palakkad district (36), Chandanathode in
                        Kannur district (33) and Thenmala in Kollam district
                        (21). The new reports were chiefly from forest areas and
                        high ranges of Western Ghats.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Sasidharan, 1998 studied the flora of the Periyar Tiger
                        Reserve along the Western Ghats in Idukki District of
                        Kerala. The Tiger Reserve has an area of 777 km
                        <sup>2</sup>. The floristic study resulted in the
                        collection and description of 1965 taxa of flowering
                        plants, which belong to 823 genera under 151 families.
                        Dicotyledons dominate the area, with 1440 species under
                        128 families, and 525 species were monocotyledons, which
                        comes under 23 families. The Poaceae family dominate
                        with 168 species. Among 151 families, 34 families are
                        represented by only one species each. Among the 1965
                        species of flowering plants, 515 (26%) are endemic to
                        Southern Western Ghats. Orchidaceae family holds the
                        highest number of endemic species (55 sp.) in the Tiger
                        Reserve. One hundred fifty species in the study area
                        belonging to various threat categories. Among the plants
                        studied, 4 species were new records for India and 14
                        were new records for Kerala. Species{" "}
                        <em>Habenaria periyarensis</em> Sasi. was newly
                        described. The results show that Periyar Tiger Reserve
                        is home to diverse flora. The flora in the Reserve has
                        the richest account of grass flora in the state and has
                        high number of Orchids reported from a district.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Ecology and management of sacred groves in Kerala was
                        studied by Chandrashekara &amp; Sankar, 1998. Based on
                        management systems, three sacred groves, namely Sri
                        Bhagavathi Kavu at Iringole (managed by a temple trust
                        in association with the Devaswom Board), Sri
                        Shangukulangara Bhagavathi Kavu at Sree Narayana Puram
                        (managed by a committee comprising of a group of
                        families) and a Sarpa kavu at Ollur (managed by an
                        individual owner) were selected for the study. The
                        phytosociological analysis was done for trees.
                        Stakeholders, their interests, and the conservation and
                        management of sacred groves were identified based on
                        surveys and semi-structured interviews. &nbsp;A number
                        of 51, 17 and 24 tree species were recorded from
                        Iringole Kavu, S.N. Puram, and Ollur Kavu, respectively.
                        Values of stem density and basal area of mature trees
                        were higher in S.N. Puram Kavu, but in the case of
                        sapling and seedling phases these values were more in
                        Iringole Kavu. The one managed by an individual family
                        (Ollur Kavu) is highly disturbed, indicated by the low
                        stem density of mature trees and poor regeneration
                        potential. Of the 73 tree species recorded from the
                        three sacred groves, 13 are endemic to South western
                        Ghats, three are endemic to Western Ghats and one is
                        endemic to peninsular India.{" "}
                        <em>Myristica malabarica</em>,{" "}
                        <em>Nothopegia beddomei</em> and{" "}
                        <em>Antiaris toxicaria</em> are rare and threatened
                        species while <em>Aporosa bourdillonii</em> is a
                        vulnerable species found from the groves.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Sasidharan. N, 1999 studied about the flora of Chinnar
                        Wildlife Sanctuary, which is located along the rain
                        shadow region of the Western Ghats in Idukki district of
                        Kerala. The vegetation of the Sanctuary is classified
                        into six types according to (Champion &amp; Seth,
                        1968)and (Chandrasekaran, 1960) classification. Dry
                        deciduous forest and scrub jungle are the two main
                        forest types in the study area, and together, they
                        constitute about 50% of the total forest area. Extensive
                        field trips were conducted periodically during
                        1994-1998. The study documented 965 species of flowering
                        plants from the study area, which constitutes 24% of the
                        total flowering plants in Western Ghats. The species
                        belong to 578 genera under 135 families. Dicotyledons
                        are represented with 794 species, 82.3% of the flora of
                        the study area and monocotyledons are represented with
                        171 species constituting 17.7% of the flora of the study
                        area. There is only one species representing the
                        Gymnosperm. The first and second dominant families in
                        the study area are Fabaceae and Poaceae respectively. 41
                        families are represented with one species each. About
                        335 medicinal plants are present in the sanctuary, and
                        many are used by tribes in crude form.{" "}
                        <em>Ipomoea mombassana</em> collected from the Sanctuary
                        is a new record to India. <em>Albizia lathamii</em> a
                        critically endangered species from the sanctuary is the
                        first recollection after the type collection.{" "}
                        <em>Chrysopogon velutinum</em> and{" "}
                        <em>Theriophonum sivaganganum</em> are new records to
                        the flora of Kerala. Among the 5 centres of endemism in
                        the Southern Western Ghats, the study area falls within
                        the Anamalai-High Ranges. There are 114 peninsular
                        Indian endemics in the study area. Poaceae is the
                        largest family with 12 endemics and the genus Impatiens
                        is the largest endemic genus with 9 species. Flora of
                        the sanctuary has more resemblance to the
                        Deccan-Carnatic elements rather than that of the wet
                        regions of the Western Ghats. The large number of
                        families and genera with fewer number of species and low
                        percentage of endemism leads to the assumption that the
                        vegetation of the sanctuary is highly
                        disturbed.&nbsp;&nbsp;
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Jacob John &amp; M. Achuthan Nair, 1999 worked on
                        crop-tree inventory of the home gardens of&nbsp;
                        Thiruvananthapuram district of southern Kerala. The
                        different trees and crops grown in the homesteads were
                        documented through personal interviews and visual
                        identification. Frequency and percentage analysis was
                        done using the data. The average size of home gardens
                        surveyed was 0.33 ha per holding. Tuber crops (46.3 % of
                        total plants) predominated among the crop categories,
                        among that <em>Cassava</em> (64.19 % of total tuber
                        crops) was most commonly grown and banana was mostly
                        cultivated fruit. Rubber has been noticed in homesteads
                        as a tree crop. The tree density increases land holding
                        size of an individual decreases.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Varghese et al., 1999 studied the structure,
                        composition, and diversity of the tropical wet evergreen
                        forest of the Agasthyamalai region of Kerala. Plots of
                        0.1 ha size were established in four regions, namely the
                        Bonaccord locality (around 600 m), Karamana locality
                        (around 800 m), third from Athirumalai (at 1000 m), and
                        the fourth from Chemmunjimottai region (1200 m). All
                        tree species above 10 cm dbh (at 1.3 m) were enumerated.
                        The data was analyzed for percentage frequency, nature
                        of vegetation, species association, family importance
                        value, maturity index, species distribution, and
                        similarity index. Species richness was calculated using
                        Margalef (Rl) index, and species diversity of trees was
                        determined using Shannon's index. Pielou's index was
                        used to estimate species evenness or equitability.
                        Density, abundance, percentage frequency, and basal area
                        show the wide ecological amplitude of{" "}
                        <em>Mesua nagassarium</em> especially in higher
                        altitudes of the study area. The species association and
                        mean IVI show the association of the{" "}
                        <em>Mesua-Cullenia- Dimocarpus</em> series, in which{" "}
                        <em>Mesua nagassarium</em> dominates at high altitudes,{" "}
                        <em>Cullenia exarillata</em> middle and{" "}
                        <em>Dimocarpus longan</em> low altitudes. The
                        heterogeneous nature of vegetation, species evenness and
                        diversity decrease from low to high altitudes.
                        Agasthyamalai has comparatively high species per unit
                        area and stand density. High species richness, medium
                        diversity, and low equitability are the features of its
                        vegetation.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        Sasidharan N, 1999 studied the floristic diversity of
                        Shenduruny forest in the Western Ghats part of Kerala.
                        Vegetation of the sanctuary falls into five major
                        groups. Specimen samples in generative stages of three
                        years in different seasons were collected. This resulted
                        in the collection of 951 species of flowering plants in
                        118 families. Leguminosae and Orchidaceae families
                        dominate the sanctuary, with 70 species each. Of 951
                        species, 310 are endemic to western ghats. 100 rare and
                        threatened species were collected. Two new species were
                        described. 9 species that were considered to be
                        &lsquo;possibly extinct&rsquo; are found to be still
                        surviving in the sanctuary.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Varghese &amp; Menon, 1999 studied the floristic
                        composition, dynamics, and diversity of{" "}
                        <em>Myristica</em> Swamp forests of Agasthyamalai region
                        of Kerala. Myristica swamp forest was found within
                        100-500 m range. Random sampling through the census
                        quadrat method were adopted in seven places and
                        different analysis was conducted. 18 species of 12
                        families were recorded in the area. Species{" "}
                        <em>Gymnacranthera farquhariana</em> shows high density.
                        Due to the edaphic conditions and dense stilt root
                        system, the stand density (520 trees/ha) was low when
                        compared to other forest types.{" "}
                        <em>Gymnacranthera farquhariana </em>(3.00) and
                        <em> Myristica malabarica</em> (2.50) are the most
                        abundant species.{" "}
                        <em>
                          Gymnacranthera farquhariana, Myristica dactyloides{" "}
                        </em>
                        and<em> Knema attenuata </em>have percentage frequency
                        of 40.00 and more, showing a heterogeneous nature. None
                        of the species show regular distribution. Four species
                        that show random distribution are{" "}
                        <em>Myristica dactyloides</em>,<em> Myristica fatua</em>
                        , <em>Persea macrantha</em> and <em>Knema attenuata</em>{" "}
                        and all other 14 species show contiguous distribution.
                        The&nbsp; association is&nbsp; mainly&nbsp;
                        between&nbsp; <em>Gymnacranthera-Knema and Persea</em>.
                        Myristicaceae records the highest Family&nbsp;
                        Importance Value (FIV). Compared to other forest types
                        of southern western Ghats, Myristica swamps show low
                        stand density, medium basal area, low maturity index
                        value, very low species richness and medium diversity.
                        Some pockets of swamps in the valleys of low altitude
                        are under tremendous biotic pressure.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Stand structural diversity and dynamics in natural
                        forests of Kerala was studied by&nbsp; Chandrashekara et
                        al., 2002. A total of 60 sites were selected in common
                        forest types of state like, tropical montane forest
                        (shola forest), wet evergreen forest, semi-evergreen
                        forest, moist deciduous forest, and dry deciduous forest
                        and also in all geographical regions of the State. The
                        number of sites was determined primarily based on the
                        relative proportion of area covered by it in the state
                        and the accessibility to the site for regular and
                        frequent monitoring. In order to determine the size of
                        the plot species-area curves were drawn for each forest
                        type. In each permanent plot, tree tagging and
                        identification was carried out. Most of the tree, shrub
                        and herb species were identified in the field, while
                        others were identified with the help of regional floras
                        and referring the herbaria. Relative density, relative
                        frequency, and relative dominance, Importance Value
                        Index (IVI), species richness (Menhinick&rsquo;s index),
                        relative abundance (Shannon-Wiener index), and
                        Fisher&rsquo;s &alpha; were calculated. In these plots,
                        a total of 21,239 trees were marked in which 20,524
                        trees represent 327species while another 715 individuals
                        are yet to be identified. Species-level basic
                        information such as the location of trees in plots,
                        girth distribution pattern and frequency of distribution
                        in the different forest has been generated. Cluster
                        analysis shows divergence among the habitats with
                        respect to species composition.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Sasidharan, 2002 conducted detailed research and
                        prepared a report on the floristic diversity in the
                        Parambikulam Wildlife Sanctuary, in Palakkad district of
                        Kerala. The sanctuary is part of the Anamalai Hills and
                        has an area of 274 km<sup>2</sup>. Intensive seasonal
                        floristic collections were made during 1998-2001. Field
                        data were recorded, and specimens were collected. The
                        collected specimens were preserved or pressed
                        immediately and critically studied with relevant
                        literatures and compared with authentic specimens. The
                        sanctuary is situated in the northern end of the
                        Anamalai subunit of the Western Ghats, the most hotspot
                        region with respect to species diversity and endemism.
                        1432 species of angiosperms under 753 genera belonging
                        to 140 families were collected, forming about 35% of the
                        flora of Kerala. Dicotyledons are represented by 1,119
                        species under 120 families, while monocotyledons by 313
                        species under 20 families. Fabaceae, with 116 species,
                        is the largest family and Ficus with 20 species is the
                        largest genus. Among the 140 families, 31 dicot and
                        three monocot families are represented by a single
                        species each. Among the 1432 species, 653 are herbs, 359
                        species are trees, 268 are shrubs, and 152 are climbers.
                        Maximum collections were recorded from the Sungam Range,
                        followed by Karimala Range, due to the diverse habitats
                        in these two Ranges. Among the 60 endemic genera of
                        peninsular India, 13 were collected from the sanctuary.{" "}
                        <em>Haplothismia</em>, <em>Utleria</em> and{" "}
                        <em>Pseudoglochidion</em> are confined to Anamalai
                        hills. A new species, <em>Pteroceras monsooniae</em> was
                        collected from the sanctuary during the study period.
                        Orchidaceae has the highest number of endemic species
                        (34). The genus Impatiens has 12 endemic species.{" "}
                        <em>Heterophragma roxburghii</em> considered endemic to
                        the northern region of the Deccan plateau is collected
                        from the sanctuary. Among the 460 species of rare and
                        threatened flowering plants recorded from Kerala, 109
                        were collected during the study. Teak is the major
                        plantation in the sanctuary, occupying an area of 87 km
                        <sup>2</sup>.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Ann E Russell, 2002 studied the relationships between
                        crop-species diversity and soil characteristics in the
                        Thrissur district. 50 farms were randomly selected and a
                        paired-plot sampling design was used in the analysis.
                        Pairing consisted of one mono- or bi-culture with one
                        polyculture. Three forest plots were paired, each with
                        polyculture plots in a nearby farm. Altogether, there
                        were 70 pairs (140 plots) from 50 farms. Background
                        information was obtained through extensive interviews
                        with each farmer and agricultural officers. Plots of
                        10x10m size were established and crop species were
                        identified and their basal area and frequency were
                        measured from December 1996 until June 1997.
                        Identification of plants &lt;3.2 cm DBH and frequency
                        were determined to compare dominance patterns among
                        ecosystems. Study says that the agricultural plots were
                        dominated by woody species, with the exception of
                        monocultures of annuals. Of all 91 species found in 140
                        agricultural plots, 70% were woody, 14% herbaceous, 8%
                        root, 3% shrub, 3% vine, and 2% grass crops species. Of
                        all 49 species found in three forest plots, 88% were
                        woody, 2% herbaceous, 4% shrubs, and 6% vines.
                        Agricultural plots differ from forest plots in terms of
                        basal area. Forest basal area of large stems was double
                        that of polycultures, and composed entirely of wood.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Sharma et al., 2002 studied the biodiversity of the new
                        Amarambalam Reserved Forests of Nilgiri Biosphere
                        Reserve. New Amarambalam Reserved Forest is situated in
                        Malappuram District of Kerala, covering an area of
                        265.57 km<sup>2</sup>. Floristic surveys were conducted
                        concentrating on arborescent species available in the
                        287 sample plots of 30 m x 30 m size, laid in the
                        different vegetation types in the study area. The
                        reserve is the abode of all seven hill forest types of
                        southern India, namely tropical moist deciduous,
                        tropical semievergreen, tropical evergreen, subtropical
                        hill forests, subtropical savannahs, montane wet
                        temperate forests and montane wet temperate grasslands.
                        About 9.8 per cent of the area is occupied by teak
                        plantations and natural forests cover the remaining
                        area. Floral, insect, bird and mammalian diversity were
                        studied&nbsp; by laying sample plots in different
                        vegetation types from 1997 to 2000. Specimens were
                        collected, studied, and herbaria prepared. Floristic
                        analysis of the arborescent species recorded 305 taxa,
                        under 212 genera belonging to 73 families. The most
                        dominant family was Euphorbiaceae (33 species). The
                        dominant genera in the area was <em>Litsea</em> (7
                        species). 32 percent of the arborescent flora of the
                        area is composed of endemic species.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Raj et al., 2003 studied about the grass diversity of
                        Kerala focusing on its endemism and phytogeographical
                        significance. A detailed taxonomic survey and field
                        explorations were conducted for three years. Collected
                        plants were used to make a herbarium. It is estimated
                        that about 350 grass species belonging to 108 genera
                        occur in Kerala, forming the largest angiosperm family
                        (Poaceae) in the state. This represents 27% of the total
                        grass species of India and 90% of Peninsular Indian
                        grass flora. <em>Ischaemum,</em> with 36 species, and{" "}
                        <em>Dimeria,</em> with 26 species are the dominant
                        genera in the family and have a high degree of endemism
                        in Kerala. The two endemic genera{" "}
                        <em>Chandrasekharania</em> and <em>Silentvalleya,</em>{" "}
                        exclusively occur in Kerala. Lower attitude ecosystems
                        which are dominated by grass, show much diversity and
                        endemism. The tribe <em>Andropogoneae,</em> with about
                        120 species under 32 genera forming 27% of the total
                        grass species, has maximum diversity and endemism
                        compared to other grass tribes in the state.
                        Phytogeographical analysis of the grass flora of the
                        state shows affinity with that of Myanmar, Sri Lanka,
                        and tropical Africa including Madagascar.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Sasidharan N, 2003 reviewed the red-listed threatened
                        tree species in Kerala. There are 4,465 taxa of
                        flowering plants in Kerala, in which&nbsp; 4050 are
                        indigenous and the rest exotics. Among the 4,465
                        species, 812 are tree species in which 327 are endemic
                        to Peninsular India, and 26 are restricted to Kerala.
                        Among 1,272 Western Ghats taxa endemic to Kerala, 483
                        were placed under threatened categories. Based on
                        published literature, 497 species from Kerala belong to
                        the Red Listed categories, including 151 tree species.
                        The red listed tree species are assigned to categories
                        such as: Extinct (2 species), Low Risk/near threatened
                        (22 species) Critically Endangered (26 species),
                        Vulnerable (38 species) and Endangered (63 species).
                        Among the families, Myrtaceae has 20 Red Listed tree
                        species followed by Lauraceae (16 species). Among the
                        red listed species, 23 species are seen in the shola
                        forests, one species (<em>Albizia lathamii</em>) in the
                        dry deciduous forests and the rest in the evergreen/
                        semievergreen forests.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Sreedharan, 2004 study on the biodiversity of
                        Kalliasseri panchayat in Kannur district of Kerala shows
                        rich tree species in the area. This includes some of the
                        rare and threatened plants. Local varieties of{" "}
                        <em>Mangifera indica</em>,{" "}
                        <em>Cocos nucifera, Piper nigrum</em> can be seen in the
                        panchayat. 69 species of shrubs have been identified
                        from Kalliasseri. 162 species of medicinal plants, 20
                        species of fruit crops, 29 species of vegetables, 103
                        species of ornamental plants have also been identified.
                        The major cereal cultivated in the panchayat is rice.
                        The widely cultivated tuber crops of the area are the{" "}
                        <em>Manihot utilissima </em>(Tapioca),{" "}
                        <em>Amorphophallus companulatus</em>,{" "}
                        <em>Dioscorea alata</em>, and <em>Ipomaea batatas</em>.
                        The major commercial crops of the panchayat were
                        coconut, arecanut, pepper, and cashewnut. 9 species are
                        endangered and 20 species are rare species in the
                        panchayath. There were exotic plants from tropical
                        Asiatic, American, tropical Africans and Madagascan
                        elements found in this area.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Peyre et al., 2006 studied the dynamics of home garden,
                        its structure and function in Kerala. A case study was
                        carried out in two panchayats (Mundur and Puduparyaram)
                        of Palghat district in the central part of Kerala to
                        study the development trends in agroforestry systems. A
                        stratified sample of 30 farm households was selected
                        within the panchayats. The information of households
                        were gathered from the Integrated Rural Technology
                        Centre of Palghat district. A detailed survey on the
                        composition and management practices in the homegardens
                        was conducted. This results in the inventory of trees
                        and shrubs species and the number of individuals per
                        species. Only presence was recorded for herbs and
                        bi-annuals. The species were classified according to
                        their use into several categories like fruits and nuts,
                        staple food, beverage and stimulant, spices, timber and
                        firewood, medicinal products, religious plants,
                        ornamentals, multipurpose species with more than four
                        uses, and other. Rubber was the only species used
                        exclusively as a cash crop and classified as such.
                        During the survey oral information was collected on the
                        management practices for individual species and the
                        changes involved in it. The average number of species in
                        the various homegarden types ranges from 17 to 51. Cash
                        crops are subjected to a variety of management
                        practices. The most intensively managed species are{" "}
                        <em>Cocos nucifera</em>, <em>Hevea brasiliensis</em> and{" "}
                        <em>Areca catechu</em>. The valuable timber species{" "}
                        <em>Tectona grandis</em> receives no particular
                        attention to increase productivity. The study shows that
                        homegardens composition and management is gradually
                        evolving in response to the socioeconomic dynamics. 33%
                        of all respondents have adopted modern practices by
                        increasingly moving towards concentrated cash crop
                        production and use of external inputs.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Yesodharan &amp; Sujana, 2007 studied the status of
                        ethnomedicinal plants in the Parambikulam Wildlife
                        Sanctuary in Kerala. The sanctuary is situated in the
                        Palakkad district, which has major tribal communities
                        like Kadar, Malasar, Muduvar, and Malamalasar. Expansion
                        of agricultural land, fuel wood collection, and large
                        number of domestic cattle maintained by the tribes
                        impacts regeneration in the sanctuary. Anthropogenic
                        activities and natural calamities like land slips,
                        earthquakes, etc. are the major cause of rarity of
                        species. A complete list of threatened medicinal plants
                        used in the traditional system of medicine is enumerated
                        in the study. 139 species of plants belonging to 51
                        different families are used in the tribal medicine of
                        this region. Among them, 27% are included in different
                        categories of threat. Fabaceae is the dominant family
                        with the highest number of species used for medicinal
                        purposes. These plants are commonly used in the form of
                        juice, paste, infusion, and powder.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Yesodharan &amp; Sujana, 2007 also studied the wild
                        edible plants traditionally used by the tribes in the
                        Parambikulam Wildlife Sanctuary in Palakkad district of
                        Kerala. The data were collected from the tribals through
                        rural visits and questionnaire survey. A total of 83
                        species of edible plants were collected, in which 82
                        were angiosperms and one were gymnosperm. Among the 83
                        species, 31 species are used for fruits, 30 leafy
                        vegetables, 16 for seeds, 10 for rhizomes/tubers/corms
                        and 6 as food from stem/shoot. Among wild fruits,{" "}
                        <em>Artocarpus heterophyllus</em> and{" "}
                        <em>Mangifera indica</em> are commonly consumed. A
                        number of species is used as medicines, in which some
                        are also used as food. <em>Oxalis corniculate</em>,{" "}
                        <em>Sarcostigma kleinii</em>,{" "}
                        <em>Cassia obtusifolia</em>, <em>Ensete superbum</em>{" "}
                        and <em>Terminalia bellirica</em> are some species which
                        were used as food as well as medicinal plants. Some
                        plants are used to make liquors. The tribals use
                        mushrooms and other unidentified wood inhabiting fungi
                        and lichens as food.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Sabu &amp; Babu, 2007 conducted a study on the floristic
                        analysis of wetlands of Kerala. Floristic surveys were
                        conducted in 11 major wetlands of Kerala (six coastal
                        and five inland wetlands) and various data of species
                        was collected through a literature survey. The present
                        study included both inland and coastal wetlands from
                        Thiruvananthapuram to Kannur and listed 503 true wetland
                        species. A total of 100 species of phytoplanktons were
                        recorded from the selected wetlands. Desmidaceae had a
                        higher representation in the northern backwaters
                        (Neeleswaram to Azhikode) during the monsoon season,
                        whereas this was replaced by either Bacillariophyceae or
                        Chlorophyceae during the post-monsoon season.&nbsp; The
                        southern backwaters except Ashtamudi were dominated by
                        Bacillariophyceae during monsoon, which got replaced by
                        Myxophyceae during the post-monsoon season.&nbsp; During
                        the pre-monsoon period Chlorophyceae, Myxophyceae and
                        Chrysophyceae showed higher percentage incidence in the
                        southern backwaters, whereas Bacillariophyceae showed
                        higher incidence in the northern backwaters. A total of
                        725 vascular plants, which include 8 Pteridophytes and
                        717 Angiosperms in 81 families were recorded from the
                        wetlands studied. The first ten dominant families are
                        Cyperaceaae, Poaceae, Scrophulariaceae, Fabaceae,
                        Asteraceae, Eriocaulaceae, Araceae, Convolvulaceae,
                        Lythraceae, and Commelinaceae. In the wetland-dependent
                        category, herbs are the dominant group. Herbaceous
                        species dominate in all&nbsp; wetland areas except in
                        the unique Myristica Swamps of Kulathupuzha and
                        Shendurney Wildlife Sanctuary. Coastal wetlands are rich
                        in floristic diversity, and 281 species are common in
                        coastal and inland wetlands.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Augustine Jomy, 2008 studied the diversity,
                        distribution, and endemism of genus{" "}
                        <em>Strobilanthes </em>in high ranges of Kerala. The
                        hilltops and understory of evergreen forests in the High
                        ranges of Kerala and other parts of Western Ghats are
                        well known for the <em>Strobilanthes</em> thickets.
                        Altogether 43 species of <em>Strobilanthes</em> are
                        known from Kerala. Of these 38 are endemic to Peninsular
                        India, 3 are endemic to Kerala (
                        <em>S. dupeni, S. homotropus</em> and{" "}
                        <em>S. virendrakumarana</em>) and 2 species are
                        exclusively endemic to Idukki District (
                        <em>S. homotropus</em> and <em>S. andersonii</em>). 40
                        species of <em>Strobilanthes</em> are found in the High
                        ranges of Kerala, in which most of them occur within the
                        existing Protected Areas. 22 species and one sub-species
                        were known to occur in Eravikulam National Park, 18
                        species in Anamudi Chola National Park, 27 species in
                        Periyar Tiger Reserve, and only one species (
                        <em>Strobilanthes cuspidatus</em>) in Chinnar Wildlife
                        Sanctuary is recorded. The high ranges of Kerala is a
                        hotspot of endemic <em>Strobilanthes</em>. Possible
                        reasons may be the geographical isolation of many
                        highland valley and gorges, altitudinal and eco-climatic
                        zones. The largest number of species (27) within Periyar
                        Tiger Reserve may be due to the large tract of evergreen
                        forests and wide ranges of altitudinal variation (200 to
                        2016m asl). Monocarpic nature and gregarious flowering
                        are the specialty of <em>Strobilanthes</em> species. The
                        periodicity of flowering varies from annual to 16 years.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        Nayar T. S et al., 2008 conducted a primary analysis of
                        the flowering plants of Kerala based on 1303
                        publications. They found that 4694 species of flowering
                        plants have been recorded so far in Kerala, under 1418
                        genera and 188 families.&nbsp; The state constitutes
                        only 1.18% of the geographical area of India, but it
                        accommodates 27.57% (in total, 17,023 species in India)
                        of flowering plants occurring in the country.&nbsp; Out
                        of 496 publications from 1981 - 1990, 119 papers come up
                        with 168 new species from the state. This is due to the
                        establishment of Botany Department at Calicut University
                        (Malappuram district) (1968), Kerala Forest Research
                        Institute at Peechi (Thrissur district) (1975) and
                        Tropical Botanic Garden and Research Institute at Palode
                        (Thiruvananthapuram district) (1978) triggered intensive
                        botanical explorations in Kerala forests, which helped
                        to discover this many new species. Excluding 417
                        cultivated and/or planted species, there are 4277
                        species in the state, that come under 1238 genera and
                        173 families. Out of 4078 indigenous species, 237
                        species in 47 families (5.81%) are endemic to Kerala.
                        More than 45% (2051 spp.) of the total species are
                        represented by nine families which accommodate more than
                        100 species. Rest of the families have &le; 83 species.{" "}
                        <em>Impatiens</em> is the largest genus with 78 species.
                        There is no family endemic to Kerala. There are two
                        monotypic genera (<em>Silentvalleya </em>and{" "}
                        <em>Haplothismia</em>) endemic to the state. There are
                        199 exotic species naturalised in Kerala. Herbs
                        constitute 50.1%, shrubs 15.8 % and trees 15.08% of the
                        total flowering plant species of the state. Kerala is
                        horizontally segmented into three: Southern
                        (Thiruvananthapuram, Kollam, Alappuzha, Pathanamthitta,
                        Idukki and Kottayam districts), Central (Eranakulam,
                        Thrissur, and Palakkad districts) and Northern
                        (Malappuram, Kozhikode, Wayanad, Kannur and Kasaragod
                        districts). There are 378 species found in southern and
                        central Kerala alone, 228 species in southern and
                        northern Kerala alone and 36 species in central and
                        northern Kerala alone. Out of the 4078 indigenous
                        species, 203 species (4.97%) come under one or other
                        IUCN red list category. 1170 species occurring in the
                        state (27.35%) are used medicinally. There are 117
                        species used for softwood purposes, 146 species for
                        extraction of tannin, 29 species for latex, 111 species
                        for gum, 65 species for resin and 284 species for oil.
                        There are 224 species having poisonous properties. About
                        1,000 species are used for basketry and as detergent,
                        sand binder, green manure and so on. In fact in the
                        study, floras dealing with comprehensive descriptions of
                        species are absent. Species descriptions in many floras
                        are scanty and repetitive. About 3,990 Malayalam names
                        have been recorded for 1507 species (35.1%) and rest of
                        them (3187 species) do not possess Malayalam names,
                        possibly because the locals do not use them, not
                        accessible to them or local names are not fully
                        documented.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Silija et al., 2008 studied the ethnomedicinal plant
                        knowledge of the Mullu kuruma tribe in Wayanad district,
                        of Kerala. Out of 60 Mullu kuruma colonies, 10 colonies
                        were randomly selected. Field work was conducted from
                        April to June 2005 in Noolpuzha village, and the results
                        were based on interviews. Plant specimens were
                        collected, and herbaria was prepared. A total of 136
                        plants was found to be used by the tribes which involves
                        using its different parts like leaves, roots, rhizome,
                        inflorescence, fruit, seeds, etc for different medicinal
                        purpose. 19 plants were used to treat asthma and other
                        bronchial diseases, 14 for skin diseases, 13 for urinary
                        complaints, 11 for dysentery and anaemia, 10 for
                        inflammation, 9 for dandruff, 8 for jaundice and liver
                        diseases, 7 for epilepsy and leucorrhoea, 6 for piles,
                        burns and leprosy, 5 for wounds, 4 for constipation, 3
                        for abortifacient and malaria, 2 for migraine, and 1 for
                        tuberculosis treatment are used by the tribes.&nbsp;
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Sujana &amp; Sivaperuman C, 2008 studied the status and
                        conservation of threatened flora in selected sacred
                        groves in coastal areas of Thrissur district of Kerala.
                        5 sacred groves were selected, field observations were
                        carried out, and the neighboring people and temple
                        worshippers were interviewed. Plants were identified
                        with the help of standard floras, and herbarium data.
                        The diversity index was calculated using SPDIVERS.BAS.
                        The study revealed that sacred groves act as gene pools
                        and are home to many rare, endangered, endemic,
                        economically and ethno-medicinally important species.
                        Total of 25 threatened flora were encountered consisting
                        of 15 tree species, 6 climbers, 3 shrubs, and 1
                        palm.&nbsp; The abundance was higher in Madambath Kavu
                        and lowest in Pipoth Kavu.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Menon et al., 2010 conducted a study about the
                        vegetation characteristics of the Southern Secondary
                        Moist Mixed Deciduous Forests of Thrissur district of
                        Kerala. Four zones were selected, namely, Peechi,
                        Vazhani, Chimmney, and Chalakudy regions. Random
                        sampling by quadrate method (32 X 32 m) was done in five
                        localities of each of the four zones. Data of trees,
                        saplings, seedlings, shrubs and climbers from these
                        quadrats and data of herbs from nested quadrats (1 X 1
                        m) were collected for analysis. The study resulted in
                        the enumeration of 2919 individuals which includes 81
                        tree species, 21 shrubs, 58 herbs and 48 climbers. Among
                        trees, <em>Xylia xylocarpa</em> dominates the study
                        area. Shrub species was low in number due to the over
                        dominance of <em>Helecteres</em> and{" "}
                        <em>Chromolaena</em> species. Tree species diversity was
                        high in the study area when compared to other forests in
                        Western Ghats. High seedling diversity and low sapling
                        diversity were observed in the forest which warns the
                        decline of tree species in the future. The average
                        species density of Thrissur district was 34 species per
                        0.1ha. Vazhani region has high tree density among other
                        zones. Herb and shrub density was higher in Peechi and
                        climber show high density in Peechi and Chalakudy
                        region.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Mohan Kumar, 2011 studied the species richness and
                        aboveground carbon stocks in the homegardens of central
                        Kerala. Based on proximity to the Western Ghats and
                        occurrence of predominant land use activity in home
                        gardens, three districts, namely Thrissur, Palakkad and
                        Malappuram districts were selected for the study.
                        Two-stage stratified random sampling was employed where
                        10% of the panchayaths from each three districts (10
                        each from Thrissur and Malappuram, 8 from Palakkad) were
                        selected randomly and approximately 30 households per
                        panchayath were randomly selected. Common herbs, shrubs,
                        and trees were recorded and tree biomass was computed
                        using equations. Aboveground carbon stocks of trees were
                        computed on the basis of the area of home garden which
                        include 284 small size home gardens, 330 medium size,
                        and 225 large size homegardens. Data of one panchayat
                        from each three districts were used to compute Simpson's
                        diversity index and for elucidating garden size vs.
                        species richness relationships. Altogether 463 species
                        were recorded from all selected panchayaths in the three
                        selected districts, of which 208 were trees. Many home
                        garden floristic elements had multiple uses such as
                        timber, fuelwood, fodder, medicines, gums, resins,
                        latex, etc. Floristic richness decreased in the order of
                        medium, small, and large-sized holdings. Woody
                        perennials accounted for a considerable proportion of
                        the floristic spectrum in all holding size categories.
                        Average aboveground standing stocks of carbon ranged
                        from 16 to 36 Mg ha<sup>&minus;1</sup> with standard
                        error values in the range of 0.74&ndash;2.18. The size
                        of the gardens was a major factor affecting carbon
                        stocks per unit area, and the number decreased in the
                        order small &gt; medium &gt; large. The C stock
                        estimates are approximations of the C sequestration
                        potential (CSP). Therefore, increasing plant species
                        richness increases CSP of the home-gardens. Species
                        richness on a total home-garden area basis increased as
                        the size of the gardens increased, but the number of
                        species per unit area declined.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Ratheesh Narayanan, et al., 2011 studied the
                        ethnobotanically important trees and their uses by the
                        Kattunaikka tribe in the Wayanad Wildlife Sanctuary of
                        Kerala. Frequent trips were carried out for plant
                        collection in different seasons from 2006 to 2009.
                        Specimens were identified and deposited in the
                        herbarium. Five tribal colonies were randomly selected,
                        and data were gathered from Kattunaikka tribal groups. A
                        total of 101 taxa of trees under 79 genera belonging to
                        32 families were collected and identified. It accounts
                        about 15% of the total tree species of Kerala. Moist
                        deciduous forest is the dominant vegetation type. A
                        total of 75 trees are used for various purposes such as
                        medicines (22%), timber (20%), edible fruits (15%),
                        Non-Timber Forest Products (11%), socio-religious (4%)
                        and other uses (28%). 21 species are having high timber
                        value and used for house construction materials,
                        household articles, furniture, etc. 30 trees are used
                        for various domestic purposes like fire wood, making
                        toys, agricultural implements, ropes, etc. Wood of{" "}
                        <em>Shorea roxburghii</em> is widely used as a source of
                        fuelwood for cooking and making fireplaces. Crushed
                        leaves of <em>Casearia wynadensis </em>and fruits of{" "}
                        <em>Hydnocarpus pentandra</em> are used as fish poison.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Thomas et al., 2011 conducted a study on floristic
                        diversity along an altitudinal gradient of Mannavan
                        Shola forest in Kerala. The study area was segregated
                        into three gradients based on altitudes (1900, 2100, and
                        2300 msl) using Trimble GEOXT 2005 software. A field
                        survey was conducted; all mature trees, saplings, and
                        tree seedlings were tagged and vegetation analysis was
                        performed. 554 individuals of mature trees belonging to
                        40 species under 21 families were identified from the
                        first altitude (1900 msl). 552 individuals belonging to
                        31 species and 15 families were identified from second
                        altitude (2100 msl) and 234 individuals belonging to 24
                        species and 13 families were observed from third
                        altitude (2300 msl). This reveals that diversity was
                        higher in lower altitude followed by middle which may be
                        due to eco-physiological constraints and geographical
                        barriers.&nbsp; A total of 19 species were endemic to
                        Western Ghats.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Madhusudhanan &amp; Jayesh, 2011 studied the
                        physico-chemical and floristic studies of Mangalavanam
                        mangrove ecosystem in Ernakulam district of Kerala. A
                        physiochemical analysis of water was performed using
                        standard methods. Quantitative estimation of vegetation
                        and leaf anatomy of mangroves was also studied. The
                        hardness of mangrove water was 405.6 mg/L, and the
                        average value of phosphate was 0.17 mg/L. This lower
                        value of phosphate indicates the absence of
                        eutrophication. 5 true mangrove species under 3 families
                        and other mangrove associated species were identified
                        from the study area. <em>Acanthus ilicifolius</em> was
                        abundant among the true mangroves. Leaf anatomy study of{" "}
                        <em>Avicennia officinalis</em> show the presence of salt
                        gland covered by hairs and hairy nature of lower
                        epidermis. Sclereids were present in{" "}
                        <em>Rhizophora mucronata</em> species. &nbsp;&nbsp;
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Ratheesh Narayanan et al., 2011 studied about the wild
                        edible plants used by the Kattunaikka, Paniya and Kuruma
                        tribes of Wayanad District in Kerala. Field survey was
                        conducted from August 2001 to July 2003 and 2008-2010.
                        15 tribal hamlets from 5 study sites (randomly selected)
                        were selected. 366 knowledge holders of different age
                        groups from the three tribal groups were selected
                        randomly from the hamlets and directly interviewed.
                        Plant specimens were collected and herbarium vouchers
                        were prepared. A total of 165 plants were found to be
                        used for edible purposes by the communities. The Paniya
                        community possesses knowledge regarding 136 taxa of wild
                        edible plants, Kattunaikkas has knowledge of 97 taxa and
                        the Kurumas has knowledge of 42 taxa of wild edible
                        plants. Edible roots, tubers and rhizomes of 24 wild
                        plant species/varieties are consumed by the tribal
                        communities. 84 plant species are used as wild edible
                        greens. 62 edible fruits and seeds was collected during
                        the study, in which 33 are trees, which are usually
                        found in the forests and hills. Paniya community
                        successfully explored all the landscapes ranging from
                        forests to grazing lands, but more from the habitats
                        outside forest-thickets while the Kattunaikkas forage
                        mostly the forests, and the Kurumas access the
                        plantations and paddy fields.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        &nbsp;Magesh et al., 2011 conducted studies on
                        vegetation status, species diversity and endemism of
                        Sulimudi forests in the Southern Western Ghats of
                        Kerala, which is a part of Idamalayar forest range.
                        Seasonal variation survey, phytosociological
                        investigation and intensive field survey was carried
                        out. GBH, IVI, density, abundance, frequency, basal
                        area, Margalef index, Shannon and Wiener index,
                        Simpson&rsquo;s index were calculated. Trees, shrubs,
                        lianas, climbers and herbs in the area were documented
                        in the study. 124 species of flowering plants belonging
                        to 114 genera and 56 families were recorded. Some site
                        specific species like <em>Bentinckia condapana</em>{" "}
                        Berry &amp; Roxb, <em>Euphorbia santapaui</em> Henry are
                        interesting features in the study area.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Vidyasagaran et al., 2011 conducted a phytosociological
                        analysis of mangroves at Kannur district of Kerala. Six
                        sites were selected, and a phytosociological analysis
                        was carried out using the quadrate method. GBH of trees
                        was measured and structural parameters were calculated
                        using standard formulas. 12 species under 9 genera
                        belonging to 7 families were recorded. Rhizophoraceae
                        has maximum genera of four species.{" "}
                        <em>Acanthus illicifolius</em>,{" "}
                        <em>Avicennia marina</em> and{" "}
                        <em>Avicennia officinalis</em> were noticed in all the
                        study sites. The frequency was 300 individuals per
                        hectare. Phytosociological analysis reveals highest
                        density and maximum relative density for{" "}
                        <em>Acanthus illicifolius</em>. Highest IVI was for{" "}
                        <em>Avicennia officinalis</em>. Pappinisseri site has
                        highest Shannon Weiner index and equitability, while
                        highest Simpson's index was in Valapattanam-Madakkara
                        and Kavvayi has lowest value for Shannon Weiner index.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Vidyasagaran &amp; Anilkumar, 2011 conducted a study on
                        the structural analysis of ecosystems of Attappady in
                        Palakkad district of Kerala. It was studied using the
                        quadrat method by establishing 20 x 20 m size quadrats
                        with a minimum distance of 200 m size along the
                        transect. Numerical data about the species were
                        recorded, and various species analysis and indices were
                        worked out. In Muthikkulam tropical west coast wet
                        evergreen forest, 42 species belonging to 25 families
                        were observed whereas Euphorbiaceae represented the
                        maximum genera of 6 species. The highest density,
                        relative density, and abundance was for{" "}
                        <em>Xanthophyllum arnottianum</em> and Highest IVI&nbsp;
                        was for <em>Cullenia exarillata</em> in the Muthikkulam
                        forest. The rare and endemic species{" "}
                        <em>Vateria macrocarpa</em> is naturally present in
                        Muthikkulam. In the Kuruvambadi moist deciduous forest,
                        36 species belonging to 24 families were observed where
                        Fabaceae and Euphorbiaceae represented the maximum
                        genera. The highest density and relative density were
                        for <em>Wrightia tinctoria</em> and the lowest were for{" "}
                        <em>Artocarpus hirsutus</em>,{" "}
                        <em>Bauhinia malabarica</em>, and <em>Bombax ceiba</em>.{" "}
                        <em>Wrightia tinctoria</em> observed the highest IVI in
                        the moist deciduous forest. In Murappalam dry deciduous
                        forest, 27 tree species belonging to 18 families were
                        observed, where Euphorbiaceae represented maximum genera
                        of 4 species. The highest density was for{" "}
                        <em>Albizia amara</em>, the high relative density was
                        for <em>Naringi crenulate</em> and the lowest values of
                        density and relative density was for{" "}
                        <em>Acacia chundra</em>, <em>Anogeissus latifolia </em>
                        and <em>Argyreia</em> spp. <em>Givotia moluccana </em>
                        has high IVI and lowest for <em>Pavetta</em> spp.
                        Murappalam dry deciduous forest show comparatively low
                        canopy levels. The evergreen forest showed the highest
                        diversity index followed by moist deciduous forest. Dry
                        deciduous forest has the lowest values of all diversity
                        indices.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Sasidharan N. &amp; P. Sujanapal, 2011 examined and
                        studied the species of <em>Atuna</em> genus in Southern
                        Western Ghats, namely <em>Atuna indica</em> (Bedd.)
                        Kosterm. and <em>Atuna travancorica</em> (Bedd.)
                        Kosterm. The specimens of <em>A. indica</em> were first
                        collected by Beddome from Wayanad. During&nbsp; the
                        recent floristic exploration of authors, <em>Atuna</em>{" "}
                        <em>indica</em> was recollected from two localities in
                        northern Kerala, which caused the rediscovery of this
                        species after the type collection, about 150 years
                        later. Both species of Atuna were described in terms of
                        their morphological characteristics, flowering and
                        fruiting period, habitat, and areas of specimen
                        examination. <em>Atuna</em> genu show relatively high
                        rate of endemism. Among the eight species in the genus,
                        five are narrow endemics and placed under various threat
                        categories.&nbsp; <em>A.cordata</em> and{" "}
                        <em>A. pentangiana</em> are restricted to Malaysia and
                        are belonging to the Endangered category.{" "}
                        <em>Atuna elliptica</em>, is a red-listed species in the
                        Pacific region. <em>A. indica</em> and{" "}
                        <em>A. travancorica</em> from India are restricted to
                        the evergreen forests of southern Western Ghats and
                        belong to &lsquo;Endangered&rsquo; category (IUCN,
                        2006). <em>Atuna travancorica</em>, is known from Kerala
                        and Tamil Nadu. The species has a localised distribution
                        pattern in the Anamalai and Agasthyamali regions. The
                        population and extent of distribution are extremely low.
                        The extent of occurrence is less than 500 sq. km with a
                        severely fragmented population and is facing a high risk
                        of extinction in the wild.&nbsp; <em>Atuna indica</em>{" "}
                        shows restricted distribution and a limited extent of
                        occurrence than <em>A. travancorica</em>. This species
                        was known only from Wayanad region and Wayanad ghats in
                        Nilgiri hill ranges. This species faces a more serious
                        threat than what is stated by IUCN (Endangered). The
                        extent of occurrence is estimated to be less than 100 km
                        <sup>2</sup>. The population is severely fragmented and
                        known to exist in no more than five localities. This
                        indicates that the species can be placed under the
                        Critically Endangered category.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Manoj et al., 2012 conducted a phytosociological
                        analysis of riparian tree species of Alakyam stream in
                        Pariyaram, Kerala. Alakyam stream has a length of 8 km
                        and flows in Kannur district. The study was carried out
                        from December 2010 to June 2011 by adopting quadrate
                        method for trees. A stratified random sampling method
                        was used where roughly 10% sampling was conducted.
                        Primary analysis was carried out and various parameters
                        were measured. 63 species of trees were recorded. The
                        highest density was for <em>Hopea ponga</em>, an endemic
                        and endangered species. About 27% flora is endemic to
                        Western Ghats and 10% belongs to RET category. Species
                        like <em>Hopea ponga</em> and <em>Hopea parviflora</em>{" "}
                        have high ecological importance in the area. The Alakyam
                        stream plays a major role in the survival of these
                        species, especially in seed disposal.{" "}
                        <em>Syzygium travancoricum</em>, a critically endangered
                        tree species is also seen along the banks of streams.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Reneela &amp; Remesh, 2012 conducted a study on plant
                        resources of Kerala. Among the 10, 735 plant species,
                        the utilization potential is known only for about 1300
                        species (12%). Angiosperms are more explored for natural
                        products (400 species). The secondary metabolites of
                        plants are economically important in pharmaceuticals,
                        aromatics, fragrances, stimulants, color or pesticides.
                        Natural products isolated from plants are sources of
                        oils, flavours, fragrances, resins, gums, waxes,
                        saponins, pharmaceuticals, plant and insect growth
                        regulators and other products. In traditional material
                        culture, plants are used for dyes and pigments. In
                        Kerala, different systems of medicine like Ayurveda,
                        Sidha, Folk medicine, and Ethnomedicine are utilizing
                        plants for curing a number of diseases.
                        &lsquo;Jeevani&rsquo; drug was developed by scientists
                        at the Tropical Botanical Research Institute(TBGRI),
                        Thiruvananthapuram, and was formed from the
                        ethnobotanical knowledge of Kani tribes. Sustainable
                        extraction and application of plants and marine biota
                        will help industries produce dyes, paints, oils, resins,
                        gums, waxes, plant and insect growth regulators, etc.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Augustine, 2012 studied the flowering plant diversity of
                        Cardamon Hill Reserve (CHR), Southern Western Ghats,
                        Kerala. 1044 species of flowering plants were identified
                        in the Cardamom hill Reserve. The richness is comparable
                        to any Protected areas in Kerala. The various 21 places
                        of CHR are found to be floristically rich. The
                        vegetation and floristic composition of these areas
                        share the plant community of the other Protected areas
                        of the high Ranges. Tracts of grasslands with scattered
                        trees and small thickets of <em>Strobilanthus</em> and{" "}
                        <em>Psychotria</em> were the vegetation in most of the
                        areas. About 740 species of flowering plants were
                        collected and identified from Mathikettan Chola, showing
                        immense biodiversity richness.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Swarupanandan &amp; Balasubramanyan, 2013 studied and
                        prepared a report on ecology and conservation of five
                        selected tree endemics of Kerala, namely{" "}
                        <em>Vateria macrocarpa</em>,{" "}
                        <em>Dipterocarpus bourdillonii</em>,{" "}
                        <em>Dysoxylum malabaricum</em>,{" "}
                        <em>Anacolosa densiflora</em>, and{" "}
                        <em>Gluta travancorica</em>. Phyto-sociological and
                        demographic studies were conducted through extensive
                        field exploration and stratification of the distribution
                        area. Geospatial analysis and density data were utilized
                        to estimate population size. Reproductive phenological
                        studies, germination ecology, and some transplantation
                        experiments were also conducted. In Kerala
                        <em> Vateria macrocarpa</em> ranges between 550 and
                        1,300 m altitude, and the area of occurrence is around
                        40 km<sup>2</sup>. The species is found in some natural
                        forests and coffee and cardamom plantations of the
                        Siruvani Group of plantations. In areas of 900-1300 m
                        altitude, the species has high density, where all the
                        life stages are well represented; therefore, this area
                        is suitable to mark as a conservation area for the
                        species. One hundred seedlings of <em>V. macrocarpa</em>{" "}
                        were planted on the banks of a streamlet south of the
                        Palghat Gap at Upper Moozhiyar to evaluate its survival,
                        and it resulted in the survival of 44% of the species in
                        6 months. For the study of{" "}
                        <em>Dipterocarpus bourdillonii</em>, the areas like
                        Malayattur, Attappady, Achenkovil, Moozhiyar, Azhutha
                        and Pamba were explored in the study. The population in
                        Kerala is only around 200 trees, and suffers from
                        selective logging. The low population size makes it
                        &lsquo;Critically Endangered&rsquo;. The area of
                        occurrence of <em>Gluta travancorica</em> in Kerala is
                        178 km<sup>2</sup> and the average density is 30 tr/ha.
                        The species can be considered &lsquo;Low Risk, Near
                        Threatened&rsquo;. Two-hundred seedlings of the species
                        were transplanted at Upper Moozhiyar and Nilakkal
                        forests but because of the failure of NE monsoon in the
                        planting year, only 20% survival was obtained after 6
                        months. <em>Dysoxylum malabaricum</em> is distributed in
                        almost all districts in Kerala and occurs as dense
                        patches in ecotonal semi-evergreen forests. The species
                        is extremely rare except the known high-density areas of
                        Moozhiyar and Sholayar (17 km<sup>2</sup>), therefore,
                        the species may be considered &lsquo;Endangered&rsquo;.
                        A patch of semi-evergreen forest has been identified at
                        Moozhiyar, where the species grows gregarious and may be
                        protected as a conservation area. Together with two more
                        species of the same genus, this forest patch is a gene
                        reserve for the genus <em>Dysoxylum </em>in Kerala.
                        Pretreatment of seeds with bavistin can imporve
                        germination from 50 to 70%. Two hundred seedlings of{" "}
                        <em>D. malabaricum</em> were transplanted in canopy gaps
                        at Nilakkal and Upper Moozhiyar, and only 20% survived
                        after 6 months, due the failure of NE monsoon.{" "}
                        <em>Anacolosa densiflora</em>, is an extremely rare tree
                        recorded from Anamalai and Travancore which recorded 15
                        tree species in the Periyar Tiger Reserve. The species
                        may be assigned a &lsquo;Critically Endangered&rsquo;
                        status. The fruits sown in nursery beds failed to
                        germinate.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Sasidharan, 2013 conducted floristic studies in Aralam
                        Wildlife Sanctuary in Kannur district of Kerala. The
                        sanctuary covers an area of 55 km<sup>2</sup> with
                        evergreen and semi-evergreen forests as major
                        vegetation. 1005 species of flowering plants belonging
                        to 597 genera under 128 families and 2 sub families,
                        have been collected and described during the study.
                        Dicotyledons predominate the area with 818 species under
                        108 families and 2 sub families while monocotyledons
                        were 186 species under 19 families. Fabaceae with 83
                        species is the largest family and 28 angiosperm families
                        in the sanctuary are represented by only one species.
                        One single species of Gymnosperm was also observed in
                        the study area. Among 597 genera, <em>Strobilanthes</em>{" "}
                        and <em>Impatiens</em> have maximum number of species
                        (12 each). Out of 1005 species, 7 species are new
                        additions to Kerala flora and 247 are new to Kannur
                        district flora. Compared to other protected areas of
                        Nilgiri Biosphere Reserve, the dominance of Poaceae
                        family has low rank in Aralam Wildlife Sanctuary because
                        of the dense evergreen tree cover. Out of the 1005
                        species recorded, 274 are endemic to Peninsular India
                        and 135 are confined to Southern Western Ghats.
                        Rubiaceae family has high number of endemic species (28
                        sp.) in the study area. 59 species in the sanctuary
                        falls under various threat categories. Association of
                        species like <em>Dipterocarpus</em>- <em>Palaquium</em>
                        &ndash; <em>Mesua</em> was found in the sanctuary.
                        Critically endangered tree{" "}
                        <em>Dipterocarpus bourdillonii</em>, was observed in the
                        Sanctuary, which is the only presence in North Kerala to
                        Palakkad gap.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Sundarapandian et al., 2013 studied the edge effects on
                        plant diversity in tropical forest ecosystems at Periyar
                        Wildlife Sanctuary in the Western Ghats of India. Three
                        study sites were selected in the forest ecosystem based
                        on disturbance gradient. The study site I is close to
                        the Teak plantations and human settlements and severely
                        disturbed. Site II is a moderately disturbed forest
                        which is subjected to occasional dry wood collections by
                        tribal peoples. Site III is completely undisturbed
                        natural forest. Phytosociological studies and vegetation
                        analysis were conducted in three sub-plots of each site.
                        Data on trees, tree seedlings, shrubs, climbers were
                        collected. The plant samples were identified using flora
                        books and confirmed with Regional BSI, Coimbatore.
                        Species diversity index, the dominance of community,
                        species richness, evenness index of community was
                        calculated. One way ANOVA was used to test for
                        differences among the study sites in various
                        phytosociological characteristics. A total of 174 plant
                        species of 135 genera and 63 families were recorded. The
                        numbers of species were greater in the site III
                        (undisturbed forest). The dominant family in terms of
                        the number of species was Euphorbiaceae in site I and
                        III whereas, Lauraceae and Euphorbiaceae in site II. The
                        dominant tree species was <em>Tectona grandis</em>,{" "}
                        <em>Terminalia paniculata</em> in site I and II
                        respectively. In site III, <em>Terminalia bellirica</em>
                        , <em>Bruces javanica</em> and <em>Shorea gardneri</em>{" "}
                        shared the dominance. Site II is at forest transition
                        level because the site is dominated by both natural
                        species as well as plantation species such as{" "}
                        <em>Tectona grandis</em>. The shrub community in site I
                        and II was dominated by <em>Maesa indica</em>, in site
                        III it was <em>Mallotus tetracoccus</em>. The number of
                        species in the herbaceous community was greater in the
                        site I. <em>Cyrtococcum patens</em> was the dominant
                        species in both the study sites I and II. Whereas in
                        site III, the dominant herbal species was{" "}
                        <em>Pteris biaurita</em>. Cattle grazing and other
                        disturbances that alter the micro climate may be the
                        reason for single species dominance in sites I and II.
                        The number of species of sapling populations was greater
                        in site III. The study reveals that anthropogenic
                        disturbance causes exotic plant invasion, reduces the
                        species richness, and inhibits the regeneration of
                        native species. The species richness was observed to be
                        lower in site I in comparison to site III when
                        considering the number and diversity indices of trees,
                        seedlings, and saplings, but the trend was reversed when
                        only herbs were taken into account. The lower number of
                        tree diversity, species richness and greater herb
                        diversity in site I could be attributed to anthropogenic
                        disturbance, cattle grazing and other associated
                        disturbances. Disturbance helps the establishment of
                        rural weeds such as <em>Lantana camara</em> and{" "}
                        <em>Erysimum odoratum</em>. Invasion of such Exotic
                        plant resulted in the loss of local biodiversity.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Vaheeda &amp; Uma, 2013 studied the plant diversity
                        along the lower reaches of Bharathapuzha river in
                        Kerala. Total 10 sites were selected along the river
                        where the first seven sites are located in Palakkad
                        District and remaining three are located in Malappuram
                        district of Kerala. A survey was conducted and aquatic
                        and wetland macrophytes were collected from the selected
                        sites. Phyto-sociological parameters were analysed using
                        quadrat method. The study was conducted during March to
                        June 2011 (Pre-monsoon period). A total of 110
                        macrophytes under 41 families were observed in the study
                        area of which 29 families were dicotyledons, 9
                        monocotyledons and 3 Pteridophytes. 81 species were
                        typical herbs. Shannon-Weiner index of species richness
                        showed greater diversity in Pattambi in Palakkad
                        district and least at Chamravattam in Malappuram
                        district. ANOVA indicated no significant diversity
                        between the sites. Poaceae with 15 species dominated the
                        vegetation analysed. Majority of the plants recorded in
                        the study were either moisture loving or wetland
                        species. The sedges and grasses contribute 23 % to the
                        floral diversity. <em>Saccharum spontaneum</em> L.,
                        <em>Cyanadon dactylon </em>(L) Pers. and{" "}
                        <em>Cyperus compressus</em> L. were the major grasses.
                        25 % of the plants are alien to India. 34% of the plants
                        recorded during the study have medicinal properties. The
                        species richness is less compared with that of sholas of
                        Eravikulam. The relatively low values of species
                        richness may be due to the river water being regulated
                        by dams, leading to reduce flow and consequent dryness,
                        especially during the pre-monsoon period.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Rajan et al., 2013 studied the floristic diversity and
                        associated fauna in the Vagamon hills of Kerala. The
                        area consists of grasslands and shola forests and study
                        was conducted during 2007-2010 by selecting random
                        sampling sites. Vegetation analysis was done by both
                        qualitative and quantitative methods. Qualitative
                        methods include conducting field visits, collecting
                        plant components, preparing herbarium, and identifying
                        and studying them using standard floristic references.
                        Quantitative analysis was done by using quadrate method.
                        286 plant species from 85 families were identified where{" "}
                        <em>Asteraceae</em> family holds the most abundant
                        species. The different analysis show that the area is
                        rich in floristic diversity. 112 species of butterflies
                        and 78 species of birds were also discovered from the
                        area.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Abhilash et al., 2013 conducted an ecological analysis
                        in the abandoned forest plantations of Kannavam in
                        Kerala. Since 1949 no routine plantation activities were
                        done in the area, leading to the establishment of a
                        natural, moist deciduous forest. Quadrats of 0.1 ha were
                        laid out pertaining to trees. Density, Basal area,
                        Abundance, Frequency and its relative values were
                        determined. Species richness, diversity and evenness
                        were studied using standard indices measurement. 19 tree
                        species were enumerated, where <em>Tectona grandis</em>{" "}
                        alone constitutes 66 % of the total tree volume, high
                        density, and basal area. <em>Tectona grandis</em> and{" "}
                        <em>Terminalia paniculata</em> are the most frequently
                        distributed species. 29 endemic species were recorded,
                        of which 13 are of tree species, 4 shrubs, 5 climbers
                        and 7 herbs. As in the case of regenerants dominant
                        sapling is <em>Olea dioica</em> and in small trees{" "}
                        <em>Ixora brachiata</em>, <em>Aporusa lindleyana</em>{" "}
                        and <em>Ficus hispida</em> are the dominant regenerates.
                        The average Shannon diversity value of Kannavam forest
                        plantations is 2.13, similar to typical moist deciduous
                        forests and higher than the natural forests like Aralam,
                        Parambikulam, Andaman Islands, etc. Margaleff&rsquo;s
                        species richness index is high, which reveals its
                        biodiversity richness. 29 Endemic plants were observed
                        in the study area.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Arun &amp; Shaji, 2013 studied the diversity and
                        distribution of mangroves in Kumbalam island of Kerala.
                        Kumbalam is a coastal region located in the east of
                        Ernakulum district. Quadrat analysis was done, and
                        qualitative and quantitative structures of plant
                        community were studied. The mangrove flora comprises 7
                        true mangrove species, 2 semi mangrove species, and 8
                        species of mangrove associates. Maximum frequency,
                        density and abundance was showed by species{" "}
                        <em>Acanthus ilicifolius</em>.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Nair, 2013 conducted a comprehensive study on the
                        socio-economic and cultural aspects of sacred groves in
                        Kerala. Individual study reports of all 14 districts in
                        Kerala have been prepared and the first report was on
                        the sacred groves in Thiruvananthapuram district.
                        Thiruvananthapuram is the southernmost district of
                        Kerala, which has a geographical area of 2192 sq.km. The
                        total number of sacred groves in the district was 452
                        and the thaluk wise number was Neyyattinkara -122,
                        Thiruvananthapuram - 101, Nedumangadu &ndash; 66 and
                        Chirayinkil &ndash; 163. The size of sacred grove vary
                        from one cent to 3 acres. They were owned by different
                        groups like Travancore Devaswam Board, public
                        committees, government or private ownership. All three
                        land regions (highland, midland and lowland) in the
                        district have the same climatic condition and no marked
                        difference is noticed in the vegetation of sacred groves
                        except those in the low land-coastal region due to soil
                        variations. Most of the species belong to the families
                        Fabaceae, Rubiaceae, Euphorbiaceae, Amaranthaceae,
                        Moraceae, Rutaceae and Liliaceae in descending order.
                        The common species among the sacred groves were
                        tabulated under different plant forms like trees,
                        shrubs/herbs, and climbers, which mainly come under
                        evergreen and semi-evergreen forest types. Rare species
                        and species particularly seen on specific land forms
                        were listed. The regeneration status of species was
                        recorded by noting the pole crop and saplings. Natural
                        regeneration is generally good in{" "}
                        <em>Artocarpus hirsutus</em>,{" "}
                        <em>Adanenthera pavonia</em>,{" "}
                        <em>Holigarna arnotiana</em>,{" "}
                        <em>Apoousa lindleyana</em>, <em>Caryotta urens</em>,{" "}
                        <em>Hydnocarpus pentandra</em>,{" "}
                        <em>Struchnos nux-vomica</em>,{" "}
                        <em>Machilus macrantha</em>,{" "}
                        <em>Terminalia bellirica</em>,&nbsp; <em>Cinnamomum</em>{" "}
                        etc. which are common in almost all the sacred groves.{" "}
                        <em>Garcinia cambogia</em> regenerates well in many
                        sacred groves but mature trees are less, this may be due
                        to its delayed growth. Regeneration of{" "}
                        <em>Struchnos nux-vomica</em> is more in sacred groves
                        of Thiruvananthapuram taluk.{" "}
                        <em>Diospyros peregrina</em> and{" "}
                        <em>Emblica officinalis</em> are rare in the sacred
                        groves. <em>Morinda tinctoria</em>,{" "}
                        <em>Taberneamontana heyneana</em>,{" "}
                        <em>Sterculia foetida</em> and{" "}
                        <em>Borassus flabellifer</em> are seen in many sacred
                        groves as mature trees. Some of the trees like{" "}
                        <em>Alstonia scholaris</em>, <em>Michelia chempaka</em>,{" "}
                        <em>Ficus</em> sp., <em>Artocarpus hirsuta</em>,{" "}
                        <em>Aegle marmelos</em>, <em>Emblica officianalis</em>,{" "}
                        <em>Mimusops elengi</em>, <em>Azadirachta indica</em>,{" "}
                        <em>Strychnos nux-vomica</em> are believed to be the
                        abode of devi and therefor people adore and give special
                        protection and consideration to these trees.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Rahees et al., 2014 studied the phytosociological
                        analysis of the mangrove forest at Kadalundi-
                        Vallikkunnu community reserve in Kozhikode and
                        Malappuram districts of Kerala. It spread across 1.5 km
                        <sup>2</sup> situated at the Kadalundi river estuary.
                        Species area estimation and quadrat analysis was used to
                        study the distribution patterns of mangroves. The plant
                        diversity analysis was calculated using different
                        diversity indices. The mangrove flora in the study area
                        comprises about 7 true mangrove species under 6 genera
                        belonging to 5 families. Avicenniaceae is the largest
                        family. <em>Avicennia officinalis</em> holds the highest
                        density, frequency, and basal area value.{" "}
                        <em>Avicennia marina</em> was the least diverse species.
                        The pattern of distribution were discontinuous. Shannon
                        index value of 2.117 shows that the study area is a high
                        species diversity zone.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Prajeesh Parameswaran et al., 2014 conducted a study on
                        the vascular Plants associated with wetland paddy fields
                        (Vayals) of Wayanad District in Kerala. 34 paddy plot
                        sites were selected from different places in Wayanad. A
                        total of 319 species of vascular plants were recorded,
                        with 308 Angiosperms, which is 15% of the total species
                        reported from the district, and 11 Pteridophytes. Out of
                        319 species, 233 were herbs, 40 were shrubs, 17 were
                        climbers and 29 are trees. A total of 72 families (66
                        Angiosperm families and&nbsp; 6 Pteridophyte families)
                        were recorded and <em>Cyperaceae</em> (34) has the
                        highest number of species. Apart from the widely
                        cultivated crops and seasonal crops, six other
                        cultivated species found near the paddy fields are{" "}
                        <em>Artocarpus hirsutus</em>,{" "}
                        <em>Artocarpus heterophyllus</em>,{" "}
                        <em>Hibiscus rosa-sinensis</em>,{" "}
                        <em>Ipomoea batatas</em>, <em>Ipomoea turbinata</em> and{" "}
                        <em>Mangifera indica</em>. Paddy fields of these sites
                        harbour 118 species, paddy levees harbour 150 species
                        and 189 species were found both in paddy fields and
                        paddy levees. The study shows that the flowering plant
                        diversity of paddy-associated landscape is rich, and it
                        harbours 15% of the total Angiosperm species reported
                        from the district.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Xavier et al., 2014 conducted an ethnobotanical study of
                        Kani tribes in Iyyavilagam of Thoduhills in
                        Thiruvananthapuram district of Kerala. The study area
                        was investigated through field trips from March 2012 to
                        May 2013. At least 10 days were spent with the local
                        people during each field survey. Collected specimens
                        were identified and authenticated with the help of valid
                        references. A total of seven resource persons or
                        informants or traditional healers who have sound
                        knowledge of the medicinal plants and practice medicine,
                        were identified to get the ethnomedicinal information.
                        All the reported ailments were categorized into 14
                        categories. The Informant Consensus Factor (Fic) was
                        used to see if there was agreement in the use of plants
                        in the ailment categories between the plant users in the
                        study area. The relative importance of each plant
                        species is reported as the use value (UV). Fidelity
                        level (FL) was calculated to determine the most
                        frequently used plant species for treating a particular
                        ailment category. The Relative Importance (RI) of each
                        remedial plant was designed. 35 plant species are used
                        as herbal remedies to treat several ailments. Among
                        them,16 plants were herbs, 8 were shrubs, 6 were trees
                        and 5 climber species. Out of the 35 plant species
                        studied 29 were dicot, 5 were monocot and 1 was a
                        pteridophyte. Drugs are utilized in the fresh or dried
                        state. Leafy crude drug preparations are mostly
                        recommended as ethnomedicine. Most commonly used method
                        of preparation was paste (48%) followed by juice (28%),
                        raw material of plant parts like leaves, fruits, etc.
                        (12%) and decoction (10%).The Kani traditional healers
                        used more than two or three plant parts to prepare
                        medicine to treat single or multiple ailments. The most
                        commonly used species was <em>Plumbago zeylanica</em>,
                        which had 13 use reports from 7 informants (UV- 1.86).
                        The Fic values ranged from 0.70 to 1 for all ailment
                        categories. 23 species had the highest fidelity level of
                        100%. <em>Andropogon muricatus</em> had the highest RI
                        (92.5).
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Morvin Yabesh et al., 2014 conducted an ethnobotanical
                        study of medicinal plants used by traditional healers in
                        the Silent valley of Palakkad district in Kerala. The
                        study was conducted in 5 villages of Silent valley
                        (Agali, Kottathara, Mannarkad, Padavayal, and Sholayur).
                        The study area was investigated, and local traditional
                        healers of 5 villages were interviewed from September
                        2011 to August 2013. They were requested to collect
                        specimens of the plants they knew or to show the plant
                        species on site. The questionnaires were used to obtain
                        information on medicinal plants, and a field data sheet
                        was prepared. Voucher specimens of medicinal plants in
                        triplicate were collected, prepared and identified. All
                        the reported ailments were categorized into 15
                        categories. Data analysis was done by calculating the
                        Informant consensus factor (Fic), Use value (UV), and
                        Fidelity level (FL). 102 ethnomedicinal plant species
                        belonging to 53 families, in 95 genera, are commonly
                        used for treating 52 types of ailments. Among the
                        families, Euphorbiaceae has high number of species (7).
                        The majority of the plant remedies were prepared by
                        paste (39%). The most frequently used mode of remedy
                        administration is oral ingestion (62%).&nbsp; The most
                        commonly used species was <em>Moringa oleifera</em>{" "}
                        (highest UV=2.62), with 21 use reports from 8
                        informants. It is used in the treatment of various
                        diseases like cancer. The Fic values ranged from 0.63 to
                        1.00. 7 species had the highest fidelity level of 100%,
                        most of which were used in the single ailment category
                        with multiple informants.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Vidyasagaran et al., 2014 studied the distribution and
                        plant diversity of mangroves on the west coast of
                        Kerala. A team of experts visited various mangrove sites
                        in the coastal districts of Kerala and documented
                        information on extent, floristic diversity, structural
                        attributes, degradation status, etc. Secondary data was
                        collected from resource survey details of the land use
                        board and resource map prepared at the Panchayat level
                        and also through discussion to local experts, social
                        workers, environmentalists, and Panchayath officials.
                        Plant diversity was studied by the spot identification
                        of plant species. Plant specimens of unidentified
                        species were collected and identified with the help of
                        taxonomists.&nbsp; Kannur district occupies maximum
                        extent of mangroves (1100 ha) followed by Ernakulam (600
                        ha) and Kasaragod (315 ha). Similarly, minimum extend
                        was represented by three districts, namely Malappuram
                        (26 ha), Thiruvanthapuram (28 ha) and Thrissur (30 ha).
                        Out of the total extent of mangroves in Kerala (2502
                        ha), 1313 ha are under private ownership and 1189 km
                        belong to the State. The mangrove vegetation is mainly
                        influenced by the halophytic adaptations.&nbsp; During
                        the study, 15 pure mangroves species were recorded,
                        belonging to 9 genera and 6 families. Rhizophoraceae
                        represented 7 species, followed by two from families:
                        Avicenniaceae, Sonnaraceae and Euphorbiaceae. 33
                        mangrove associates were identified from various
                        locations in different districts.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        The grass diversity of Vagamon hills in Kerala was
                        studied by Mathew et al., 2014, and the area shows
                        exceptional biodiversity. The study was carried out
                        through field visits, and plant specimens were
                        collected, identified, and analyzed according to their
                        habit and conservation status. The study area is
                        dominated by tall grasses like{" "}
                        <em>Cymbopogon flexuosus</em>, <em>Themeda cymbaria</em>{" "}
                        etc. Rare species like <em>Zenkaria elegans</em>,{" "}
                        <em>Arthraxon lancifolius,</em> etc., are seen. Some
                        grasses are used for thatching and for medicinal
                        purposes. Out of 77 Species collected, 18 are Endemic to
                        Peninsular India. 25 Exotics indicate the degrading
                        nature of grasslands may be due to agricultural and
                        other developmental programs.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Sankaran K. V et al., 2014 studied the invasive plant
                        threats in Kerala forests. Data on the presence of
                        Invasive Alien Plants (IAPs) was collected through road
                        surveys during the period of 2012&ndash;2013 covering
                        evergreen, moist deciduous, and dry deciduous forests
                        and grasslands. There were a total of 655 observation
                        points throughout the State. At each location,
                        information on the IAPs in the area, intensity of their
                        infestation and the native species and habitats impacted
                        by these were collected. A total of 38 IAPs were located
                        in the forests of Kerala. Of these, 10 are of high risk,
                        12 pose medium risk, 10 low risk and the rest 6 are of
                        insignificant risk. These include 5 trees, 10 shrubs, 4
                        sub-shrubs, 13 herbs and 6 climbers. The land of origin
                        of majority of the species was Central and South
                        America. Most species&rsquo; introduction into the
                        forests was intentional, and few were accidentally
                        introduced. Forest surveillance, early detection and
                        rapid control, manual/mechanical removal of weeds
                        followed by planting of native species and assisted
                        regeneration are suggested as immediate steps to control
                        invasion and reduce impacts.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Senthilkumar et al., 2014 studied the Myristica swamp
                        forest in Kerala as part of the project of the Indian
                        Council of Forestry Research and Education (ICFRE) to
                        revisit the forest types of India through rapid
                        assessment mode to know whether there are any changes in
                        the forests characteristics which was classified and
                        described by Champion and Seth long before (1968). The
                        study was conducted on the Myristica swamp forest in
                        Kulathupuzha range of Thiruvananthapuram Division from
                        April 2012 to March 2013. The sample point locations
                        (geo-coordinates) were given by FSI, which falls under
                        Mayilamoodu and Sangili sections of Kulathupuzha forest
                        range. Ten Myristica swamps (5 in each section) were
                        selected based on the given latitude and longitude.
                        About 40% of the area of Kulathupuzha is occupied by
                        various plantations, the rest is constituted by
                        evergreen forests, grass lands, swamps, degraded forests
                        and human habitations. Swamps are located on hill
                        streams and in tributaries of Kulathupuzha River. Nine
                        quadrates were laid for each point, and data on
                        vegetation and other history was recorded for each
                        point. Samples were collected for the entire flora
                        observed. The species{" "}
                        <em>Gymnacranthera farquhariana</em> is dominated in
                        narrow valley swamps whereas <em>Myristica fatua</em>{" "}
                        var. <em>magnifica</em> is dominated in flat valley
                        swamps. It is observed that there is no change in forest
                        type of Myristica swamp as described by Champion and
                        Seth (1968).
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Kumr K, 2015 conducted studies and provided a checklist
                        of the vascular flora of Anamudi Shola National Park in
                        the Idukki district of Kerala. The area includes three
                        distinct sholas: Mannavan Shola, Pullaradi Shola, and
                        Idivara Shola. Since 1994, regular field trips have been
                        organized to these sholas, and plant specimens have been
                        collected and critically studied. Herbaria were prepared
                        using collected specimens as per standard procedure.
                        About 674 of vascular plants, including 598 taxa of
                        flowering plants and 76 pteridophytes, could be
                        collected. Among 598 taxa of flowering plants, 484 taxa
                        are dicotyledons, and 114 taxa are monocotyledons.{" "}
                        <em>Asteraceae</em> (from dicots) with 42 taxa,{" "}
                        <em>Poaceae</em> (from monocots) with 32 taxa, and{" "}
                        <em>Aspleniaceae</em> (from pteridophytes) with 12 taxa
                        were the largest families in their respective groups.
                        Out of the 484 dicot taxa, 39.5% belonged to herbs,
                        33.7% were shrubs and 26.9% were trees. Among
                        pteridophytes, there were more terrestrial taxa than
                        epiphytes and lithophytes. More than 30% of plants
                        collected during the study were restricted to the
                        Western Ghats. Out of the total 598 angiosperm taxa, 222
                        were endemics. During the study, 4 species of
                        angiosperms, which were earlier documented as
                        &lsquo;Possibly extinct&rsquo; could be rediscovered,
                        and about 66 plants were reported for the first time
                        from Kerala.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Vincy et al., 2015 compared the riparian species
                        diversity between the main river channel and
                        sub-watersheds of the Meenachil river basin of Kerala
                        and studied the diversity indices and analytical
                        features. The study mainly focused on the mainstream and
                        five sub-watersheds namely; Kattachira, Koduvan Ar,
                        Mannani, Payappara, and Thikovil sub-watersheds.
                        Vegetation analysis was conducted from 2009-2012.
                        Quadrats of size 10 &times; 10 m for trees; 5 &times; 5
                        m for shrubs, and 1 &times; 1 m for herbs were laid
                        randomly, and different analytical features and indices
                        were calculated. A total of 441 species belonging to 105
                        families were recorded. <em>Alstonia scholaris</em>,{" "}
                        <em>Artocarpus hirsutus</em>,{" "}
                        <em>Chrysophyllum cainito</em>, and{" "}
                        <em>Holigarna arnottiana</em> are the most common tree
                        species along the banks of the river. Leguminosae is the
                        leading plant family. There is no significant difference
                        in the diversity index of trees, herbs, and shrubs of
                        the main stream and other selected sub watersheds.
                        Koduvan Ar and Payappara exhibited the highest richness
                        for trees, whereas Kattachira revealed the highest
                        richness for herbs and shrubs. Mannani had the least
                        species richness, which may be due to deforestation and
                        rapid urbanization. A majority of the species show a
                        contagious pattern of distribution. Upstream watersheds
                        (Payappara and Thikovil) showed the greatest species
                        diversity.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Chandrashekara UM, 2015 studied the diversity,
                        management, and nutritive value of edible non-crop
                        plants in home gardens of Kerala. The study was
                        conducted in Karakkode Village. An area of 3 km x 1 km
                        was selected and divided into a 200 m x 200 m grid. The
                        grid intersection points were marked using GPS. Out of
                        90 grid intersection points, 48 represented home gardens
                        and were selected for the study. In each of the 48 home
                        gardens, three transects, each of 40 m x 10 m in size
                        were marked. Each transect was divided into 16 quadrats
                        (5 m x 5m). All the herbs and shrubs were identified.
                        Information on edible plants, parts used, frequency of
                        collection, and management was gathered from the home
                        garden owners. 27 species, belonging to 22 genera and 17
                        families were identified as edible non-crop plants. In
                        the 27 species, leaf is the edible part for 22 species,
                        while in the remaining 5 species, the whole plant is
                        edible. A significant positive correlation was noted
                        between the number of home gardens of occurrence and
                        number of home gardens where the species are used. No
                        special care was given to protect and nurture the
                        species in any home gardens. The average biomass of{" "}
                        <em>Cassia occidentalis</em> was significantly more than
                        the rest of species. The edible non-crop plants
                        contribute substantially to protein, mineral, and crude
                        fiber intake and are rich in calcium and iron minerals.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Vijayan et al., 2015 studied the floristic diversity and
                        structural analysis of mangrove forests at Ayiramthengu
                        in Kollam district of Kerala. Distribution patterns of
                        mangroves were studied using species area estimation and
                        quadrat analysis, in which 15 quadrats of 5x5 m in size
                        were taken. Density, frequency, basal area, and their
                        relative values, as well as the Importance Value Index
                        (IVI), diversity indices, and richness of mangrove
                        species, were calculated using standard methods. The
                        mangrove flora comprises 9 mangrove species belonging to
                        6 families. Family Avicenniaceae is the largest family,
                        and Avicennia marina sp. has the highest density,
                        frequency, and IVI. Relative density was maximum for{" "}
                        <em>Avicennia marina</em> and the lowest for&nbsp;{" "}
                        <em>Sonneratia caseolaris</em>. Shannon-Weiner diversity
                        index is considered as a medium to high diversity in
                        terms of species. Landfilling, increased aquaculture,
                        industrial developments, and housing are the major
                        threats faced by the mangroves of Ayiramthengu.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Kiran M et al., 2015 conducted a study about the
                        floristic diversity and structural dynamics of mangroves
                        on the northwest coast of Kerala. The study areas
                        selected were six different mangrove sites in Malappuram
                        district of Kerala. Data analysis was conducted using
                        quadrat method. GBH, density, frequency, basal area and
                        their relative values, abundance and IVI were
                        calculated. Plant diversity analysis was carried out
                        using Shannon-Wiener Index, Simpson&rsquo;s Index,
                        Equitability measure, Species richness and Beta
                        diversity. Jaccard&rsquo;s cluster diagram has been done
                        using Biodiversity Professional Ver.2 software. 11
                        species of true mangroves belonging to 5 families were
                        recorded from different sites. Rhizophoraceae has the
                        highest number of species. Among the locations, Pullooni
                        recorded the highest number of species.{" "}
                        <em>Avicennia officinalis</em> and{" "}
                        <em>Rhizophora mucronata</em> were found in all the six
                        study sites. <em>Rhizophora apiculata </em>and{" "}
                        <em>Sonneratia</em> alba were found to be rare and
                        confined in a single site.{" "}
                        <em>Avicennia officinalis</em> has the highest density,
                        maximum relative density, and relative frequency.{" "}
                        <em>Rhizophora apiculata</em> has lowest density,
                        minimum relative density, relative frequency and minimum
                        value of abundance. <em>Aegiceras corniculatum</em> has
                        a high abundance value. <em>Bruguiera sexangula,</em>{" "}
                        which is rare in Kerala, was found in four sites. The
                        pattern of distribution of species were discontinuous in
                        all the locations. Mangrove at Thalakkad-Pariyapuram has
                        the highest Shannon&ndash;Weiner index and
                        Simpson&rsquo;s index, while Mangattiri&ndash;
                        Etrikkadavu has lowest value of these indices. &nbsp;
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Pius OL et al., 2015 studied the diversity and
                        conservation of Malappuram District endemic and
                        threatened medicinal plants. Field explorations were
                        carried out from different habitats of the district
                        during 2008-2013, and the details of&nbsp; medicinal
                        plant were also collected from authentic literature. 869
                        species of vascular medicinal plants were documented in
                        the study, in which 85 of them are endemic and
                        threatened. Among the 85 species, 50 are endemic to
                        peninsular India. Remaining 35 are with wider
                        distribution pattern but their population is extremely
                        low. Out of 50 peninsular Indian endemics, 41 are
                        restricted to Western Ghats, including 29 species found
                        only Southern Western Ghats region. Out of 85 species,
                        51 are under various threat categories, including 28
                        Vulnerable, 11 Endangered, 7 Near Threatened, 4 Least
                        Concern and one Critically Endangered. Major forest
                        areas in Malappuram district come under the Nilgiri
                        phytogeographical region of Western Ghats, which has
                        many endemic and threatened species. The higher
                        percentage of medicinal plants in the district shows
                        rich traditional knowledge, and the area is also the
                        centre of primitive tribal groups. Among the 85 endemic
                        and threatened species, 77 (90%) are used in folk
                        systems. 9 species in whole, root of 19 species, bark of
                        20 species and wood of 9 species are used for preparing
                        medicines.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Nair, 2015 conducted a comprehensive study on the
                        socio-economic and cultural aspects of sacred groves in
                        Kerala, and their second report was on the sacred groves
                        in Kollam district. The Geographical extent of Kollam
                        district was 2491 sq. km. From available data of Social
                        Forestry, publicity in the press, and through word of
                        mouth, 895 sacred groves were found in the area. It
                        covers 98 ha of vegetative cover, and Thiravoor kavu (in
                        2.5 Acs.) in Karunagappally is the largest sacred grove.
                        Most sacred groves contain as many as 12-24 tree
                        species, 10-22 shrubs and 25-34 climbers. Rare and
                        threatened species like <em>Myristica malabarica</em>,{" "}
                        <em>Gynacranthera farquhariana</em>,{" "}
                        <em>Syzygium travancoricum</em>, etc. have been found in
                        the sacred groves. Euphorbiaceae, Lauraceae, Fabaceae,
                        Rubiaceae and Apocynaceae families are very well
                        represented. The vegetation has distinctive ecological
                        characteristics, such as clear tiers of trees, shrubs
                        and herbs, climbers, epiphytes, parasites etc. The
                        diversity among shrubs and herbs are comparatively low
                        with trees. The prevalence of woody climbers is the
                        specialty of Kollam sacred groves. Invasion of exotic
                        weeds such as <em>Mikania micrantha</em>,{" "}
                        <em>Eupatorium odoratum</em>, <em>Hyptis suaveolens</em>{" "}
                        and <em>Lantana camara</em> cause threat to the
                        biodiversity. <em>Ficus religiosa</em> and{" "}
                        <em>Ficus benghalensis</em> are considered to be
                        Keystone species in the sacred groves as they attract
                        birds, mammals, reptiles and several insects also the
                        strong winding roots of <em>Ficus</em> prevent soil
                        erosion. Interference with the sacred groves been
                        restricted culturally, which causes protection to the
                        ecosystem of sacred groves.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Vijayakumar et al., 2015 conducted a quantitative
                        ethnomedicinal study of plants in the Nelliyampathy
                        hills in Palakkad district of Kerala. The study was
                        conducted in eight villages in the area during the
                        period from September 2011 to August 2013. Data was
                        collected by means of interview with 66 local
                        traditional healers of the village in different age
                        groups. 6 field trips were organized, and a total of 60
                        days were spent with the local traditional healers.
                        Voucher specimens of medicinal plants were prepared. The
                        information was quantitatively analysed using Relative
                        Frequency Citation (RFC) index, Use Value (UV), and
                        Pearson correlation coefficient. 85 ethnomedicinal plant
                        species belonging to 49 families were used in as herbal
                        medicines for curing diseases. The Cucurbitaceae family
                        has the highest number of species due to its wide
                        occurrence, and the local informants knew a number of
                        traditional uses. 54% of the ethnomedicinal plant
                        species were herbs, 26% trees, 19% climbers, and 1%
                        shrubs. The most frequently used medicinal plant parts
                        were leaves. The majority of the herbal remedies were
                        prepared by paste, and the frequently used mode of
                        administration was through oral ingestion. Highest
                        number of plant species were used against the cold. The
                        highest value of RFC and highest UV was ranked for{" "}
                        <em>Solanum trilobatum</em>. Pearson correlation
                        coefficient was 0.638, indicating high positive
                        significant association between the local importance of
                        each species and relative importance of the use of
                        plants.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Nair, 2016 conducted a comprehensive study on the
                        socio-economic and cultural aspects of sacred groves in
                        Kerala, and their third report was on the sacred groves
                        in Kozhikode district of Kerala. The total Geographical
                        extent of the district was 2,206 sq. km having 4
                        thaluks. The number of sacred groves in the district
                        was1231 with 141 ha. of vegetative cover. Kozhikode
                        taluk contains the maximum number of sacred groves (653)
                        and Thamarassery thaluk has a minimum. The extent of
                        sacred groves varies from less than 3 cents (2%) to 24
                        acres. Most of the sacred groves are confined to the
                        coastal belt. 83 % of sacred groves are private
                        ownership. <em>Strychnos nux-vomica</em> is the most
                        common species. Euphorbiaceae, Rubiaceae, Fabaceae,
                        Dipterocarpaceae, Aracaceae, Menisprmaceae and
                        Icanthceae can be widely seen in the sacred groves.
                        Medicinally important and rare and threatened species
                        can be found in the groves. Shrub diversity is
                        comparatively low. Climbers, and herbs occurrence is
                        abundant in the area compared to southern districts.
                        Detailed floristic exploration in 28 sacred groves in
                        different taluks were performed. Based on the extent of
                        area, vegetation type, and location, one-time
                        enumeration was carried out in 27 sacred groves in the
                        four taluks, resulting to the enumeration of 372
                        species, of which 143 are trees, 121 are climbers, and
                        108 are shrubs. <em>Strychnos nux-vomica</em> occurred
                        in all the 27 sacred groves.{" "}
                        <em>Adenathera pavonina</em> and{" "}
                        <em>Pothos scandens</em> occur in 25 sacred groves, and{" "}
                        <em>Caryota urens</em>, <em>Chassalia ophioxyloides</em>{" "}
                        and <em>Mimusops elengi</em> is seen in 24 sacred
                        groves. 90 species occurs only in any one of the sacred
                        groves. Out of 372 species, 35 are Western Ghats
                        endemics (19 trees, 5 climbers, and 11 shrubs). 44
                        exotic species were recorded from the sacred groves.
                        Eight species serve as keystone species in the area.
                        Shifting deity, encroachment, disputes on ownership,
                        dumping waste, etc. are major threats, and awareness
                        programmes, distribution of grants, production of
                        quality seedlings, and conducting further research can
                        protect the groves.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Nair, 2016 conducted a comprehensive study on the
                        socio-economic and cultural aspects of sacred groves in
                        Kerala, and their fourth report was on the sacred groves
                        in Thrissur district. The geographical extent of the
                        district was 3032 sq. km, with a forest area of 992
                        sq.km and 6 Taluks. A total of 970 sacred groves were
                        recorded in the district covering an area of 32.54 ha.
                        The vegetation is mostly evergreen types. The number of
                        species of trees in a sacred grove range from 13-29.
                        Some rare and threatened species, as per IUCN status and
                        species used in Ayurvedic preparations, are observed in
                        sacred groves. A total of 35 sacred groves from all
                        thaluks were selected for vegetation and taxonomical
                        study. Inside the Sacred groves, herbs were found
                        wherever there were openings in the canopy. Among the
                        276 species enumerated from 35 sacred groves, 133 are
                        trees, 87 are climbers, and 56 shrubs. The most widely
                        occurring species are <em>Caryota urens</em> and{" "}
                        <em>Pothos scandens,</em> which occur in 31 sacred
                        groves followed by <em>Chassalia ophioxyloidesthos</em>{" "}
                        in 27. No species is found occurring in all sacred
                        groves. 96 species are unique to certain Sacred groves.
                        Out of the 276 species, 29 are endemics, and tree
                        endemism is relatively high with 17 species. 44 species
                        were exotics. Euphorbiaceae is the most dominant family
                        with 20 species. Threats faced by the groves include
                        shifting deity, encroachment, disputes on ownership,
                        dumping waste, etc. Awareness programmes, distribution
                        of grants, production of quality seedlings, interference
                        by the government, and conducting research on ecology
                        and carbon sequestration in Sacred Groves are the major
                        recommendations for conservation.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Dantas&nbsp;&amp; Nanu, 2016 prepared a checklist of
                        wild edible plants of Aralam Wildlife Sanctuary in
                        Kerala. Aralam Wildlife Sanctuary is the northernmost
                        sanctuary in Kerala and home to 1,005&nbsp;species of
                        plants. West Coast tropical evergreen and West Coast
                        semi-evergreen vegetation dominate the sanctuary. Field
                        data was collected by visiting all habitats of the
                        sanctuary. Specimens were identified with the help of
                        literature. A total of 43 wild edible plants were
                        identified in the area, where <em>Syzygium</em> genus is
                        the largest with 7 species.
                        Among&nbsp;these&nbsp;wild&nbsp;plants,&nbsp;32&nbsp;are&nbsp;fruits,&nbsp;
                        <em>Momordica&nbsp;sahyadrica</em>&nbsp;and&nbsp;
                        <em>Solanum&nbsp;torvum </em>
                        are&nbsp;used&nbsp;as&nbsp;vegetable.&nbsp;&nbsp;
                        <em>Phyllanthus&nbsp;emblica</em>,&nbsp;
                        <em>Mangifera&nbsp;indica</em>,&nbsp;
                        <em>
                          Spondias&nbsp;pinnata&nbsp;and&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          Baccaurea&nbsp;courtallensis
                        </em>
                        &nbsp;are&nbsp;consumed&nbsp;directly and used to
                        prepare pickles. Most of the fruits are consumed without
                        cooking. Varieties of <em>Garcinia&nbsp;gummi‐gutta</em>{" "}
                        are used as spices. For <em>Dioscorea</em> sp., tubers
                        are consumed after cooking. Some species are grown in
                        homesteads, but wild varieties are seen in forests.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        The floristic diversity of Vallikkaattu Kaavu, a sacred
                        grove of Kozhikode was studied by&nbsp; Sreeja et al.,
                        2016. History and details of this sacred grove was
                        collected through field visits, personal interviews with
                        members of the temple trust, and from temple records.
                        Plants were collected seasonally based on their
                        flowering season, and herbaria were prepared. Medicinal
                        uses of these plants were collected through personal
                        interviews with local medical practitioners and renowned
                        Ayurveda physicians of Kottakkal Arya Vaidya Sala,
                        Malappuram, Kerala. The present conservation and endemic
                        status of plants was listed. The sacred grove recorded
                        245 flowering plants belonging to 209 genera and 77
                        families. Among these 245 species, 75 species are herbs,
                        71 trees, 55 shrubs, and 44 climbers. Among the total
                        species, 44 are endemic. There were 34 threatened plants
                        listed. Out of the 245 species listed from this grove,
                        236 are medicinal, constituting 96% of the flowering
                        plants reported from this sacred grove.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Sreejith et al., 2016 studied the tree species
                        composition and distribution pattern in a Myristica
                        Swamp of Sivapuram, Koothuparambu, Kannur District of
                        Northern Kerala. An area of 5000 m<sup>2</sup> was
                        divided into five plots, and in each plot ten quadrats
                        (10 X 10 m) were established for the study. Vegetation
                        analyses were done by calculating IVI, species diversity
                        index, and Simpson&rsquo;s index of dominance, and the
                        data were statistically tested using ANOVA.{" "}
                        <em>Knema attenuata</em> and{" "}
                        <em>Myristica malabarica</em> contribute about half of
                        the total IVI. Species like{" "}
                        <em>Gymnacranthera canarica</em> and{" "}
                        <em>Myristica fatua </em>var. <em>magnifica</em>, which
                        are believed to be essential elements for a Myristica
                        swamp were not observed in the study area. But
                        irrespective of the species composition, the vegetation
                        is dominated by the family Myristicaceae and found in a
                        swampy environment with knee roots, which can be
                        considered a Myristica swamp. The density of trees was
                        806 individuals/ha and basal area was 34.25 m
                        <sup>2</sup>/ha. Most of the trees in the study were
                        represented with lower girth classes which results in
                        low basal area value. The Simpson&rsquo;s index of
                        species dominance shows high value when comparing to the
                        nearest semi-evergreen and evergreen forests. This may
                        be due to the lower diversity and over dominance of the
                        species of Myristicaceae. The similarity index shows
                        that the first plot near the stream side and the last
                        plot away from the stream share only 33% vegetation as
                        common. The girth class shows a normal distribution
                        pattern. In the lower girth class, <em>Knema</em> shows
                        poor regeneration, while that of <em>Myristica</em>{" "}
                        remains normal. Among two dominant species,{" "}
                        <em>Knema attenuata</em> is widely distributed away from
                        the stream while <em>Myristica malabarica</em> were
                        concentrated along the streamside.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        The diversity of herbaceous riparian flora in the lower
                        stretch of the Bharathappuzha&nbsp;river of Kerala was
                        studied by Cherullipadi et al., 2016. The taxonomic
                        survey was conducted from 2014 to 2015 in the lower
                        stretch of Bharathappuzha near Ponnani, Malappuram
                        district. Riparian plants were collected and identified
                        with standard floras. 8 sites were selected, and
                        quadrates of 1 X 1 m were employed for quantitative data
                        collection of herbs. This resulted in identifying 73
                        species in 29 families in the study area. The vegetation
                        profile includes 73 herbs, 32 shrubs, 22 climbers, and
                        54 trees. The most frequent&nbsp;herbs&nbsp;are&nbsp;
                        <em>Desmodium&nbsp;triflorum</em>,&nbsp;
                        <em>Emilia&nbsp;sonchifolia</em> and{" "}
                        <em>Dactyloctenium&nbsp;aegyptium</em>. The most
                        abundant species is <em>Brachiaria&nbsp;ramose</em>. The
                        Shannon Weiner diversity shows uniform diversity in the
                        area.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Deepa et al., 2016 studied about the medicinal plants in
                        the selected sacred groves of Kodungallur taluk in the
                        Thrissur district of Kerala. They selected 4 sacred
                        groves from Kodungallur: Ayyalath Nagayakshi Kavu,
                        Kumaramangalath Kavu, Chemathi Kavu and Kalapparambath
                        Kavu. Field visits were conducted during different
                        seasons from June 2013 to February 2016. Observations
                        like habit, phenology of the plant, colour, texture and
                        smell of leaves, local names and local uses were noted.
                        Analysis of floristic composition was done with the help
                        of floral books, and herbarium sheets prepared were
                        verified with the data of KFRI and Calicut University
                        Herbarium (CALI). The study records 89 species of
                        angiosperms coming under 83 genera and 43 families from
                        all four selected groves. Of these, 20.22% are trees,
                        16.85% are shrubs, 42.70% are herbs and 20.22% are
                        climbers. Leguminosae is the dominant family with 3 sub
                        families (Papilionoideae, Caesalpinioideae,
                        Mimosoideae). From the total plants 98.88% plants are
                        medicinal and used in different systems of medicines
                        such as Ayurveda, Folk, Unani, Siddha, Homoeopathy and
                        Tibetan. Different parts of the plants such as leaves,
                        roots, bark, latex, inflorescence, fruits, seeds, and
                        sometimes the whole plants, are used for different
                        medical purposes. <em>Chassalia curviflora</em> (Wall ex
                        Kurz) Thw. is a common plant present in all the four
                        groves.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Deepa et al., 2016 also studied the floristic
                        diversities and medicinal importance of selected sacred
                        groves in Thrissur district of Kerala. The study area
                        includes Adipparambukavu, Daivathinkavu, Kanisherykavu,
                        Kottaichalippattukavu, and Kottarathkavu. The floristic
                        composition was analysed between April 2013 and
                        September 2015 through field visits, and plants were
                        studied with the help of floras. A total of 119 species
                        of angiosperms under 104 genera and 51 families were
                        collected. 8 vulnerable, 12 endemic and 3
                        near-threatened species were present in the groves.{" "}
                        <em>Hydnocarpus pentandra</em>(Buch.-Ham.) Oken,{" "}
                        <em>Leea indica</em> (Burm. f.) Merr., and{" "}
                        <em>Pothos scandens</em> L. are common in the five
                        sacred groves. All 119 species have medicinal value.
                        17.64% of species were herbs, 19.33% were shrubs, 41.18%
                        were trees, and 21.85% were climbers. Fabaceae and
                        Moraceae are the dominant families in these sacred
                        groves. Kottarathkavu has a maximum number of endemic
                        plants.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Deepa M.R et al., 2016 studied the rare, endemic, and
                        medicinal plants of selected sacred groves in Chavakkad
                        Taluk of Thrissur district in Kerala. Five sacred groves
                        were selected for study, and they were visited during
                        different seasons from June 2013 to December 2015. Field
                        observations were made about plant characteristics and
                        studied with the help of floras. Floristic composition
                        and flowering twigs were collected and herbarium sheets
                        were prepared. 79 angiosperm species under 70 genera and
                        42 families were recorded. Out of these 46. 84 %
                        constitute trees, 15.19% were shrubs, 11.39% were herbs,
                        and 26.58% were climbers. All 79 species have medicinal
                        value. 8.86% of plants are endemic, another 8.86% are
                        vulnerable, and 3.8% of plants are at a lower risk near
                        threatened regionally. Moraceae is the dominant family.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Sreejith et al., 2016 studied the microhabitat diversity
                        in a lateritic hillock of&nbsp; Madayipara in Northern
                        Kerala. At least two field visits were made every month
                        from December 2012-November 2013. Each location was
                        marked with GPS, and plant specimens were collected and
                        identified with the help of floras. A checklist of
                        angiosperms has been prepared. The microhabitats were
                        classified based on edaphic properties, water
                        availability, and species composition. The similarity in
                        species composition of these microhabitats was
                        calculated using Sorensen&rsquo;s Similarity index.
                        Diversity indices like the Shannon-Wiener diversity
                        index and Menhinick&rsquo;s species richness index were
                        calculated. A total of 263 angiosperm species were
                        recorded of which 62 are endemic to Western Ghats. 9
                        microhabitats like Ephemeral flush vegetation, Exposed
                        rock surfaces, Rock crevices/Fissures, Small ephemeral
                        pools, Soil-filled depressions, Tree cover and Tree
                        associated, Boulders, Crust edges or Cliffs and
                        Soil-rich areas were identified in the study area and
                        majority of them shows very narrow ecological niche. For
                        their similarity in species composition, 36 combinations
                        were possible when 9 communities were compared with each
                        other, but only 2 found to have more than 50%
                        similarity, indicating the diversity of habitats within
                        the lateritic hillock.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Chandrashekara &amp; Thasini, 2016 conducted a study on
                        the non-crop edible plants and medicinal plants in the
                        homegarden agroforestry system of Palakkad district in
                        Kerala. The district has four agro-ecological zones:
                        Palakkad plains, Midland laterite area, Foothills and
                        High hills of Kerala. A total of 16 villages, four from
                        each agroecological zone, were selected with a minimum
                        distance of 15 km between nearby villages. From each
                        village, 10 homegardens were randomly selected,
                        resulting in 160 homegardens from the district. Only
                        herbs, shrubs and climbers were considered for the
                        study. Non-crop edible plants and medicinal plant
                        species in a homegarden were identified with the help of
                        the owners of respective home gardens. A new Index,
                        named the Index of Species Occurrence, Usage and
                        Management (ISOUM), was developed to study the
                        differences in species distribution pattern, usage level
                        and management in home gardens. The method used to
                        calculate ISOUM was similar to the estimation of the
                        species' importance value index in plant ecological
                        studies. A total of 97 non-crop edible and medicinal
                        plant species belonging to 40 families were recorded.
                        Among these, 22 species were edible, 59 were medicinal,
                        and the remaining 16 species were both edible and
                        medicinal plants. Out of 97 species only 7 species (
                        <em>Aerva lanata</em>, <em>Amaranthus viridis</em>,{" "}
                        <em>Cyanthillium cinereum</em>,{" "}
                        <em>Cyperus rotundus</em>, <em>Mimosa pudica</em>,{" "}
                        <em>Ocimum tenuiflorum</em>&nbsp; and{" "}
                        <em>Scoparia dulcis</em>), were seen in more than 30
                        homegardens. Among them <em>Ocimum tenuiflorum</em> was
                        actively managed in more than 75% of the gardens. Based
                        on index values, it is observed that{" "}
                        <em>Ocimum tenuiflorum</em>, <em>Aerva lanata</em>{" "}
                        and&nbsp; <em>Scoparia dulcis</em> are the first three
                        important non-crop plant species.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Anoop et al., 2017 studied the floristic diversity of
                        Thevarmala Sacred Grove in Kottayam district of Kerala,
                        which is 400 m above MSL and covers 15 acres of land
                        with a unique Western Ghats floristic composition. The
                        natural vegetation of the sacred grove is a mixed
                        deciduous type. Extensive floristic explorations were
                        conducted during 2015-2016 in different seasons to
                        assess the angiosperm plant diversity of Thevarmala
                        sacred grove. Specimens were collected, and herbarium
                        sheets were prepared. A total of 152 flowering plants
                        belonging to 136 genera under 50 families were
                        documented. Dicots dominate, with 129 species in 41
                        families, while monocots represent 23 species in 9
                        families. Shrubs dominate the area with 64 species (42
                        %), followed by herbs with 56 species (37 %) and trees
                        with 32 species (21 %). Almost half of the shrubs are
                        climbers. Among the herbs, 3 orchids, namely,{" "}
                        <em>Bulbophyllum sterile</em> (Lam.) Suresh,{" "}
                        <em>Dendrobium barbatulum</em> Lindl. and{" "}
                        <em>Pholidota imbricata</em> Hook. are epiphytes. Of the
                        total 152 species,18 are endemic to the Indian
                        peninsula, and the majority of them are strictly
                        confined to the Southern Western Ghats. 18 species found
                        only in the Western Ghats-Sri Lanka biodiversity
                        hotspot. Critically Endangered trees like{" "}
                        <em>Vateria indica</em> L.were also reported. About half
                        of the documented plants have recorded medicinal
                        properties. Many plants are economically important as
                        food (8 species), timber (6 species), and fodder (3
                        species) and as sources of fibres and resins (2
                        species).&nbsp;
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Deepa et al., 2017 conducted a taxonomical and
                        phytosociological study on Chithalikavu sacred grove in
                        Thrissur district of Kerala. Field visits and plant
                        collection were conducted during different seasons
                        between April 2013 and September 2015. Field
                        observations such as habit, habitat, local names, and
                        medicinal uses available were noted by considering all
                        angiosperms like trees, shrubs, herbs, and climbers for
                        the study. Herbaria were prepared, and each species in
                        fresh condition was critically studied with the help of
                        floras. A phytosociological study by quadrate method was
                        also conducted. Size and number of the quadrate were
                        determined by species-area curve method. Two 20 m
                        &times;20 m size quadrates were randomly established in
                        the site for tree species studies. Frequency, relative
                        frequency, density, relative density, relative basal
                        area and importance value index were estimated using
                        standard formula. This resulted in collecting and
                        identifying 57 species of angiosperms belonging to 54
                        genera and 35 families. Among them, 29.82 % were trees,
                        24.56 % were shrubs, 15.79 % were herbs, and 29.82 %
                        were climbers. Almost all the plants have medicinal
                        value. During this study, Euphorbiaceae was recorded as
                        the dominant family of seven species. Only eight tree
                        species were observed in the study area. Among them,{" "}
                        <em>Strychnos nux-vomica </em>L. was the dominating
                        species.&nbsp;
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Ratheesh N. et al., 2017 studied the diversity of&nbsp;
                        Mangroves in the Asramam area of Kollam District in
                        Kerala. 48 acres in the Asramam adventure park and near
                        the link road portion was studied in detail from March
                        &ndash; June, 2016. The study was based on species-area
                        estimation and quadrant analysis. Seven quadrates were
                        selected randomly, and size of quadrate was fixed for 5
                        X 5 m. Quantitative characters such as frequency,
                        density, abundance, relative frequency, relative
                        density, relative dominance, Importance Value Index
                        (IVI) were calculated. Diversity indices and species
                        richness, Shannon&ndash; Weiner diversity, Simpson
                        index, and equitability were measured by analyzing
                        vegetation data. Six true mangroves species belonging to
                        4 plant families and several mangrove associates were
                        recorded. <em>Rhizophora apiculata</em> showed highest
                        abundance<em>. Sonneratia caseolaris</em>, a rare and
                        threatened species, is present in large quantities along
                        the Link Road area. <em>Acrostichum aureum</em>, a
                        Pteridophyte species, shows fairly rich species
                        diversity even in a highly degraded condition.{" "}
                        <em>Rhizophora apiculate</em> shows the highest IVI and
                        density values and high abundance. Relative frequency of{" "}
                        <em>Sonneratia caseolaris</em> is high in all regions.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Sureshkumar et al., 2017 studied the medicinal plants
                        used by the Adiyan community in Wayanad district of
                        Kerala. The field survey was carried out from August
                        2015 to July 2016 among the Adiyan people in three
                        villages of the Wayanad district, and ethnomedicinal
                        information was obtained through interviews/discussions.
                        A total of 30 informants were interviewed, aged between
                        20 and 89 years. A&nbsp; total of 71 plant species
                        distributed in 60 genera from 38 families were used to
                        treat 59 ailments, and the details were documented. The
                        Lamiaceae family contributed the highest number of
                        medicinal plants. The leaf was the most commonly used
                        plant part. The different parts of the plant were made
                        into different forms like powder, decoction, etc. 82% of
                        herbal preparations were taken internally and 13% were
                        used as a topical application, whereas 5% were used both
                        internally and topically.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Synudeen Sahib, 2017 studied the biodiversity of
                        Myristica swamp forests patches of&nbsp; Kulathupuzha
                        and Anchal Forest Ranges and Shendurney Wildlife
                        Sanctuary in Kerala. The floristic diversity indices
                        were assessed by the quadrate method. A total of&nbsp;
                        246 angiosperms species belonging to 186 genera from 83
                        families were recorded. <em>Myristica fatua </em>var.{" "}
                        <em>magnifica</em> and <em>Gymnacranthera canarica</em>{" "}
                        of the Myristicaceae family are the dominant species.{" "}
                        <em>Myristica fatua</em> is highly restricted to swampy
                        areas only, hence it is considered as a flagship
                        species. The dominant family is Fabaceae, with highest
                        number of species. The flora shows a high degree of
                        endemism. The vegetation is four storied with a
                        continuous canopy. The species richness and floristic
                        diversity of Myristica swamp is very low compared to
                        other forest types and ecosystems of Western Ghats. This
                        may be due to prevailing edaphic conditions and
                        ecological requirements of swampy species. A major
                        threat to the Myristica swamps was their conversion into
                        rice fields.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        K Praveenkumar, 2018 studied the floristic diversity of
                        the sacred grove of Madathody Naga Kavu, Chalavara,
                        Palakkad district of Kerala. The sacred grove was
                        visited during different seasons, and two specimens of
                        each species were collected and observations like plant
                        habit, phenology, color, texture and smell of leaves,
                        abundance, local names, local uses were noted. Species
                        in fresh condition were critically studied using floras
                        and identified by reference collections available at
                        herbariums. 50 taxa of angiosperms coming under 49
                        genera and 25 families, including 19 herbs, 13 shrubs,
                        10 trees and 8 climbers were collected. Out of 50
                        species, 6 are endemic, 8 are exotic and 38 are
                        medicinally important. &nbsp;&nbsp;&nbsp;
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Sreelekshmi et al., 2018 studied the diversity, stand
                        structure, and zonation pattern of mangroves in Kerala.
                        117 mangrove study sites were identified and
                        investigated with the help of a Global Navigation
                        Satellite System from 10 coastal districts of Kerala.
                        The floristic survey and field sampling were conducted
                        from March 2011 to April 2013. Quadrat method was used
                        for the structural analysis of true mangrove flora. Each
                        species in the quadrat was identified, counted, and
                        analyzed. Structural variables such as stem density,
                        relative density, abundance, and basal area were
                        calculated using standard formula. Diversity indices,
                        Shannon diversity, Margalef's species richness, Pielou's
                        evenness and Simpson's dominance index were determined.
                        The mangroves in Kerala comprised 18 species under 11
                        genera of eight families. Structural analysis revealed
                        that the mean stem density was highest for{" "}
                        <em>Acanthus ilicifolius</em>.{" "}
                        <em>Avicennia officinalis</em> showed the highest mean
                        basal area and highest IVI. For entire Kerala, the
                        Shannon diversity index was 3.14 and the Simpson
                        dominance index was 0.86. Mangrove vegetation is
                        comparatively good in Kollam, Alappuzha, and Kannur
                        districts and very sparse in Thiruvananthapuram district
                        regarding diversity and richness. Among the ten
                        districts, a maximum number of species were from Kollam
                        district (15), followed by Alappuzha (14) and Ernakulam
                        (13) districts. The least number of species was observed
                        in Thiruvananthapuram district (3). All 18 mangrove
                        species are evenly distributed throughout the coastal
                        districts, occurring in heterogeneous mixtures. The
                        study also shows the extinction of{" "}
                        <em>Bruguiera parviflora</em> and sparse population of{" "}
                        <em>Ceriops tagal</em>, <em>Avicennia alba</em>, and{" "}
                        <em>Sonneratia alba.</em>
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Praveenkumar, 2018 studied the floristic diversity of
                        Puliyanamkunnu in Palakkad district of Kerala.
                        Puliyanamkunnu is a moist deciduous forest element with
                        2 major roads, 23 ponds, 2 canals and 7 sacred groves.
                        The study was conducted in the Puliyanamkunnu watershed
                        area using field observations from different seasons.
                        Two specimens each for different species were collected,
                        and in fresh condition, species were studied critically
                        with the help of standard floras. This resulted in the
                        collection of 80 taxa of angiosperms, including 36
                        herbs, 18 trees, 14 Shrubs and 12 climbers. 12 species
                        among them were endemics, and 10 were rare and
                        red-listed. Sixty-nine species are used for medicinal
                        purposes.&nbsp;&nbsp;
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Grinson George et al., 2018 studied the structure and
                        regeneration status of mangrove patches along the
                        estuarine and coastal stretches of Kerala. All major
                        mangroves in Kerala were studied by selecting 46 sites.
                        The study was conducted from June 2014 to March 2015 by
                        laying multiple line transects at each site.
                        Quantitative data was collected using the quadrat
                        method. A total of 13 mangrove tree species belonging to
                        five families and eight genera were observed.
                        Rhizophoraceae family has the highest number of species.
                        From 10 districts in Kerala where mangroves show a
                        presence, Ernakulam has the maximum number of species.
                        15,656 plants were counted, which comprised 31.31%
                        saplings, 45.22% seedlings, and 23.47% trees. The genus
                        Avicennia alone constituted 56% of the IVI which shows
                        the dominance of the species in Kerala. Kozhikode has
                        highest tree density and basal area. A comparison of
                        diversity indices shows that mangroves in Kannur are the
                        most diverse. The density of young plants is less than
                        50% of tree density, depicting the poor regeneration
                        potential of mangroves in Kerala.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Neethu &amp; Harilal , 2018 studied the diversity and
                        distribution of mangroves in the coastal ecosystems of
                        Kerala. Extensive literature survey and field visits
                        were carried out. The mangrove patches were categorized
                        into homogeneous and heterogeneous types. The assemblage
                        of true mangrove species and their associates in a
                        particular area, were grouped as homogeneous, while
                        patches of true mangroves along with mangrove associates
                        and other vegetation, were categorized as heterogeneous
                        types. The regions were surveyed using a GPS. Plant
                        specimens were collected, identified, and preserved.
                        District-wise analysis and the extent and state of
                        mangroves were studied. The survey estimated a total of
                        19.531 km<sup>2 </sup>mangroves in Kerala. Out of 10
                        districts studied, Kannur district has the highest
                        mangrove cover. An increasing mangrove cover of about
                        2.821 km<sup>2</sup> within the last 25 years is noted
                        in Kerala. 15 true mangrove species falling under 9
                        genera and 6 families are observed. Even though there
                        has been a technical increase in the number of
                        mangroves, most mangrove-growing areas are under drastic
                        pressure due to anthropogenic activities.&nbsp;
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Nair, 2018 conducted a comprehensive study on the
                        socio-economic and cultural aspects of sacred groves in
                        Kerala, and their fifth report was about the sacred
                        groves in Alappuzha district. The Geographical extent of
                        the district was 1414 sq. km and holds 6 thaluks. The
                        total number of sacred groves in the district was 2242,
                        and it covers an area of 451.84 acres (182.93 ha.). Most
                        of them have 0.3 to 0.8 canopy density. Trees are more
                        in the groves, followed by climbers. The vegetation has
                        clear tiers of trees, shrubs, herbs, besides the
                        climbers, epiphytes, parasites, etc. The abundance of
                        woody climbers is the most notable feature of the sacred
                        groves in Alappuzha district. One time enumeration was
                        carried out in 32 sacred groves based on the extant
                        area, and it resulted in the enumeration of 324 species,
                        of which 134 are trees, 112 climbers and 78 are shrubs.
                        The most widely occurring species is{" "}
                        <em>Pothos scandens</em>, which is seen in 31 sacred
                        groves, followed by <em>Artocarpus hirsutus</em> in 28,{" "}
                        <em>Holigarna arnottiana</em> in 27,{" "}
                        <em>Uvaria narum</em> in 24 and{" "}
                        <em>Hydnocarpus pentandra</em> in 23 sacred groves. No
                        species are found in all sacred groves, whereas 122
                        species occur only in one sacred grove. Leguminosae is
                        the dominating family with 34 species, followed by
                        Rubiaceae with 22 species. Among the taluks, Mavelikkara
                        has the highest species diversity. Encroachment,
                        disputes on ownership, dumping waste, etc., are the
                        major threats faced by the groves. The main
                        recommendations by the researchers include conducting
                        awareness programmes with suggestions to prevent the
                        dumping of solid waste, fair grant distribution to
                        deserving custodians, production of quality seedlings,
                        and appropriate recognition to custodians for
                        contribution to carbon sequestration.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Nair, 2018 conducted a comprehensive study on the
                        socio-economic and cultural aspects of sacred groves in
                        Kerala, and their sixth report was on the sacred groves
                        in the Kannur district. The Geographical extent of the
                        district was 2966 sq. km and includes 1096 sacred groves
                        covering a total area of 263.82 Ha. The canopy density
                        of most of the sacred groves is 0.3-0.8. Among these 74
                        sacred groves are more than one acre of area. The
                        dominance of trees and climbers is noticed. An
                        association of <em>Myristia malabarica</em> and{" "}
                        <em>Knema attenuata</em> is seen where swampy areas
                        prevail. A number of pteridophytes and bryophytes can
                        also be seen in the groves. Species like{" "}
                        <em>Caryota urens</em>,{" "}
                        <em>Artocarpus heterophyllus</em>, etc., provide plenty
                        of edible fruit and attract all birds and other fauna.
                        Rare and important plants like{" "}
                        <em>Actinodaphne malabarica</em>, <em>Aglaia lawii</em>{" "}
                        can be seen in the groves. 25 sacred groves were
                        inspected for plant identification, and a total of 343
                        species were enumerated in the study. It includes 144
                        trees, 103 climbers and 96 shrubs. The most widely
                        occurring species are <em>Pothos scandens</em>,{" "}
                        <em>Holigarna arnottiana</em>, and{" "}
                        <em>Caryota urens</em>. Leguminosae is dominating among
                        the 348 species. As Kannur district area is a flat
                        terrain, the general floristic composition and
                        physiognomy of vegetation of the sacred groves are
                        typically like the lowland evergreen forests. Soil
                        samples collected from 15 sacred groves were tested and
                        the result shows that in most cases, organic carbon
                        availability is generally medium. Ponds were present in
                        almost all sacred groves. The sacred grooves harbour
                        numerous birds, butterflies, bats, some primates, and
                        small mammals. 78% of the total sacred groves in Kannur
                        was owned by individuals, families, or family trusts,
                        14% by public or Janakeeya Committees, and 8% by Temple
                        trusts or Devasam Boards. Encroachment to the groves,
                        development activities, dumping of solid waste and
                        presence of invasive species are major threats the
                        sacred groves face. Awareness campaigns, production of
                        quality seedlings of plants, etc., are the recommended
                        measures to protect the groves.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Nair, 2019 conducted a comprehensive study on the
                        socio-economic and cultural aspects of sacred groves in
                        Kerala, and their seventh report was on the sacred
                        groves in Kottayam district. The Geographical extent of
                        the district was 2208 sq. km. A total of 562 sacred
                        groves, distributed to a total area of 35.20 Ha, are
                        listed from the district. Most of the sacred groves have
                        0.5-0.9 canopy density, and the size of Sacred Groves
                        varies from 3 cents-1100 cents (11 Acs.). 36&nbsp;
                        Sacred Groves have been studied about the flora present,
                        and the species under different forms were listed. Rare
                        and threatened species like{" "}
                        <em>Myristica malabarica</em>,{" "}
                        <em>Gynecranthera farquhariana</em>, and{" "}
                        <em>Syzygium travancoricum</em> have been found in the
                        groves. A total of 335 species were enumerated during
                        the one-time enumeration study of 16 groves which
                        include 133 trees, 80 climbers, 53 shrubs and 69 herbs.
                        Among the 335 species, 116 occur only in one sacred
                        grove. But species like <em>Ophixinoides</em>,{" "}
                        <em>Artocarpus hirsutus</em>, <em>Centrosema molle</em>,{" "}
                        <em>Chassalia curviflora</em> var.{" "}
                        <em>ophioxyloides</em>, and <em>Pothos scandens</em>
                        &nbsp; occur in all 16 groves. <em>
                          Caryota urens
                        </em>{" "}
                        (flowers and fruits attract many birds and mammals) and{" "}
                        <em>Holygarna arnotiana</em> (porcupine likes fruit)
                        serve as keystone species. The fauna of the sacred
                        groves include termites, bats, peacocks and civets. The
                        major threats the sacred groves face include; intention
                        to reduce the extent for self-motives, legal disputes on
                        ownership, dumping of solid waste, and damage by
                        invasive species.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Divya &amp; Anitha, 2020 studied the community
                        dependence on the natural resources of Parambikulam
                        Tiger Reserve in Kerala. Four indigenous communities,
                        namely Kadar, Muthuvar, Malasar and Malamalasar were
                        inhabited in various six tribal colonies in the tiger
                        reserve. The study is based on both primary and
                        secondary data. Eleven Focus Group Discussions (FGDs)
                        were conducted with the forest-dwelling community (one
                        with each community), Forest Department (3), tribal
                        coordinators (1), tribal watchers (1), and guides (1).
                        From a total of 399 tribal households in all four tribal
                        communities, 194 households were selected using
                        stratified random sampling at 5 percent level of
                        significance. From March 2018 to March 2019, a direct
                        household survey was conducted. The Forest Dependence
                        Index(FDI) helps to identify the dependence of the
                        household on the resources available from forest.
                        Logistic regression model with the help of SPSS software
                        version 24 is used to develop the relationship between
                        the socio-economic variables and forest dependency. The
                        community was heterogeneous, with an average family size
                        of 4 and a total population of 797 from 194 households.
                        Primary sector dominance with wage employment was the
                        main occupation. The dependence of the resident
                        community on the Reserve ranges from the collection of
                        food, fuelwood, poles, Non-Timber Forest Products (NTFP)
                        to employment in forestry and allied activities, such as
                        guards, watchers, and daily wage employees, providing an
                        additional source of income to the local communities.
                        The ecotourism enterprises involve honey processing,
                        paper carry bag-making units for reducing plastic
                        pollution, bamboo handicraft units where the products
                        are sold through the Ecoshops, jams, and pickle units
                        and bee wax balm production units for producing balm
                        from the bee wax collected and the product is
                        medicinally important for curing body aches and
                        headaches. The FDI of the resident population depicts
                        high economic dependency in terms of income generation
                        from the collection of Non-Timber Forest Products
                        (NTFP), fish (from the catchment areas), and the sale of
                        the cultivars (pepper, arecanut, turmeric and ginger, of
                        which the pepper is exported to Germany yielding a high
                        price). The model developed for bringing out the
                        relationship between the dependence and the
                        socio-economic factors, predicted the result with 69.6
                        per cent accuracy, land holding size and market access
                        showing expected result with p-values (&alpha;) less
                        than or equal to&thinsp;0.05.&nbsp;
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Bindhu et al., 2020 conducted a preliminary study on the
                        medicinal plants of Annallur Kole lands, Chalakudy, in
                        Thrissur district of Kerala. Wetland plants were
                        collected from Annallur Kole land during
                        September-December 2019 to explore its diversity during
                        post monsoon season. Field observations were recorded,
                        specimens were collected and prepared herbarium. 44
                        species of medicinal herbs under 40 genera and 22
                        families were observed in the study area. Family
                        Asteraceae was predominant with 8 genera. 3 ferns were
                        noticed. The plant species were used for medicinal
                        purposes like to cure gastrointestinal disorders,
                        respiratory ailments, dermatological snags, urinogenital
                        illnesses, cardiovascular problems, and neuro disorders.
                        They were prepared in various forms, such as decoction,
                        extraction, infusion, and paste preparation. Oral
                        administration, inhalation, smoking, and massaging are
                        the various methods of application in practice. Kole
                        land plants in the region could provide
                        income-generating opportunities to local communities.
                        Almost all the medicinal plants found in Annallur Kole
                        lands are commonly seen in Kerala.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Nair, 2020 conducted a comprehensive study on the
                        socio-economic and cultural aspects of sacred groves in
                        Kerala, and their eighth report was on the sacred groves
                        in Idukki district. The Geographical extent of the
                        district was 4358 sq. km., with four taluks namely
                        Thodupuzha, Peermade, Idukki and Devikulam. Only 32
                        sacred groves were found in the district, which had
                        around 3 ha. of vegetative cover. Most of them are
                        between 3 cents - 10 cents. Devikulam taluk has a high
                        concentration of sacred groves. The sacred groves in
                        Marayur are very open, having rocky outcrops and
                        scattered trees. Diversity in pants and richness in
                        their number are comparatively low in the sacred groves
                        of Idukki district. Amarankavu in Thodupuzha village,
                        Paloor kavu in Mundakayam and Vazhuvelil kavu in
                        peruvanthanam support thick vegetation with good
                        diversity. In the rest of the sacred groves, the canopy
                        is open or with too many climbers. The ground flora is
                        very thin except in sacred groves of Thodupuzha. In
                        Peermade and Thodupuzha taluks there is good collection
                        of medicinally valued trees, herbs and orchids. One time
                        enumeration of flora was carried out in 9 sacred groves
                        in Thodupuzha and Peerumedu thaluks. A total of 210
                        species were enumerated from those 9 sacred groves, in
                        which 99 are trees, 38 climbers, 34 shrubs and 39 were
                        herbs. 116 species occur only in any one sacred grove.
                        Amaramkavu in Thodupuzha village has the highest
                        diversity. Of the 210 species studied, 33 are endemic,
                        37 are exotic, and 140 are indigenous. Faunal
                        significance in the sacred groves was very low.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Nair, 2020 conducted a comprehensive study on the
                        socio-economic and cultural aspects of sacred groves in
                        Kerala, and their ninth report was on the sacred groves
                        in Palakkad district. The Geographical extent of the
                        district was 4480 sq. km, having a forest area of 1761
                        sq.km. A total of 184 sacred groves were found in the
                        district, which had a 63 % extent or below 5 cents.
                        Pattambi taluk in the district contains the maximum
                        number of sacred groves. The largest sacred grove in the
                        district is Parakatt kavu in Alathur taluk (25 Acres in
                        extent). The district consists of both deciduous and
                        evergreen vegetation. Unlike in other districts, common
                        plants such as <em>Artocarpus hirsute</em>,{" "}
                        <em>Bombax ceiba</em>, <em>Terminalia bellirica</em> ,{" "}
                        <em>Saraca asoka,</em> etc. are scarce in the sacred
                        groves of Palakkad district. Larger sacred groves
                        exhibit a high diversity of trees, climbers, and herbs.
                        One time enumeration was carried out in 18 sacred groves
                        and a total of 332 species were enumerated. In the 332
                        species, 106 were trees, 71 climbers, 56 shrubs, and 99
                        were herbs. Species like <em>Cassia fistula</em>,{" "}
                        <em>Ichnocarpus frutescens,</em> and <em>Dioscorea</em>{" "}
                        sp. were found in 16 sacred groves studied. As many as
                        171 species occur only in any one sacred grove. There
                        are a greater number of tree species, but the frequency
                        is poor. The density of vegetation is poor as the area
                        of most of the sacred groves is less. A number of plants
                        have medicinal value. The open canopy density in the
                        district receives direct sunlight, long periods of dry
                        season, and wind blowing along the Palakkad gap promotes
                        more plants of medicinal value.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Thomas et al., 2020 studied the angiosperm diversity of
                        agroecosystems by conducting a case study from
                        Kooroppada Gramapanchayath in Kottayam district of
                        Kerala. Floristic analysis was carried out by collecting
                        samples from 9 sites of the panchayath. Plants were
                        identified using standard floras and enumerated
                        according to APG III. Quantitative data was collected by
                        the quadrat method based on the species-area curve
                        method. The biodiversity assessment shows 402 known
                        angiosperm species in 101 families in different areas.
                        Family Fabaceae dominates with 37 members. The
                        vegetation profile includes 125 herbs, 98 shrubs, 49
                        climbers, and 118 trees. The highest distribution
                        frequencies are shown by <em>Ageratum conyzoides</em>,{" "}
                        <em>Glycosmis pentaphylla</em> and{" "}
                        <em>Hevea brasiliensis</em> in herbs, shrubs and
                        climbers and trees categories respectively.{" "}
                        <em>Oldenlandia corymbosa</em>,{" "}
                        <em>Psychotria flavida</em> and{" "}
                        <em>Hevea&nbsp; brasiliensis</em> showed the highest
                        density values among the herbs, shrubs and climbers and
                        trees categories respectively. The abundance value was
                        highest in herbs by <em>Bambusa vulgaris</em> and{" "}
                        <em>Bulbophyllum sterile</em>, in shrubs and climbers by{" "}
                        <em>Psychotria flavida</em> and in among trees by{" "}
                        <em>Hevea brasiliensis</em>.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        George &amp; Christopher, 2020 studied the structure,
                        diversity, and utilization of plant species in tribal
                        home gardens of Attappady valley, Palakkad district of
                        Kerala. From a total of 189 hamlets in Attappady, 8
                        hamlets were selected from 3 tribal communities
                        (Irula-4, Muduga-2 and Kurumba-2), which have different
                        rainfall zones, represent proportionately the tribal
                        communities, have accessibility with at least jeepable
                        road and actively participate in agricultural practices.
                        Data were collected from 104 randomly selected home
                        gardens from each of the eight sample hamlets. Species
                        diversity and similarity was calculated. A cluster
                        analysis considering the occurrence of species was
                        performed. A total of 182 plant species belonging to 160
                        genera and 67 families were recorded of which 43% were
                        herbs, 26% were shrubs, 19% were trees, and 12% were
                        climbers. The diversity and richness of tribal
                        homegardens in Attappady is relatively high (182 species
                        from 104 home gardens) when compared with the various
                        studies conducted in Kerala State. Rainfall and
                        proximity to non-tribal hamlets influence the floristic
                        composition in the area. A high similarity of plant
                        species is observed between Muduga and Kurumba. A total
                        of 56 plant species were common distribution across the
                        gardens of all three communities. 39% of species were
                        edible plants, 25% were used for medicinal purpose, 24%
                        species have ornamental value, 5% were used in ritual
                        events and 7% contributed for construction, timber,
                        firewood, shade tree, fence, and saleable products.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Halliru Bilyaminu et al., 2021 conducted an ecological
                        study on the southern secondary moist deciduous forest
                        of Shendurney Wildlife Sanctuary in Kollam district of
                        Kerala. The data was collected from 2019 to 2020
                        following a primary survey. Structural analysis was
                        carried out, and sample plots were collected using a
                        stratified random sampling method. Structural attributes
                        and phytosociological observations were enumerated. 58
                        species with DBH &ge; 10 cm were recorded. Out of these
                        7 species are endemic to the Western Ghats, 2 are
                        endangered, another 2 belong to the near-threatened
                        category, and 4 are vulnerable to extinction.{" "}
                        <em>Terminalia paniculata</em> is the dominant species
                        and the species with maximum species importance value.
                        The Euphorbiaceae family has a maximum family index
                        value. The distribution of the trees showed a completely
                        L-shaped distribution with decreasing density with
                        increasing girth size. The tree species density was
                        876.97 individuals per hectare. The abundance-frequency
                        ratio depicts that species show both contagious and
                        uniform distribution patterns.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Nair, 2021 conducted a comprehensive study on the
                        socio-economic and cultural aspects of sacred groves in
                        Kerala, and their tenth report was on the sacred groves
                        in Kasargod district. The Geographical extent of the
                        district was 1061 sq. km, with a forest area of 857 sq.
                        km. A total of 392 sacred groves were present in the
                        district, of which 13 % are of and below 5 cents in
                        extent, and 64 sacred groves are of and above one acre
                        extend, which shows that comparatively, Kasargod
                        district has more large sacred groves in the state.
                        Evergreen and semi-evergreen types of vegetation can be
                        seen in the district. Adukathukavu, Edayilakkadu kavu,
                        Kammadam kavu and Paaliyerikavu are some examples of
                        large sacred groves with thick vegetation and high
                        diversity of trees, shrubs, climbers, and herbs.
                        Indigenous species as well as endemic species such as{" "}
                        <em>Hopea parviflora</em>, <em>Hopea ponga</em>,{" "}
                        <em>Myristica malabarica</em>, <em>Knema attenuate</em>,{" "}
                        <em>Diospyros malabarica</em>,{" "}
                        <em>Percia malabarica</em> can be seen plenty. Myristica
                        swamps are common, and orchid diversity is prominent in
                        the district. Vegetation contains more number of trees
                        with dense growth.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Sebastian et al., 2021 studied the species diversity and
                        abundance patterns of epiphytic orchids in Aralam
                        Wildlife Sanctuary in Kerala. Field sampling was done,
                        and linear line transects were developed in four
                        habitats like: Wet evergreen (low-mid elevation), Moist
                        deciduous, Semi-evergreen, and Montane wet evergreen
                        (high elevation) habitats. Characteristics of habitat,
                        host tree, and the substrate of orchids were recorded.
                        Statistical analysis of data from 40 transects was
                        performed using the statistical software R (version
                        3.5.0) and PAST 3.19. Orchids were ranked based on their
                        abundance, and rarefied diversity indices were
                        estimated. <em>Bulbophyllum fischeri</em> and{" "}
                        <em>B. fuscopurpureum</em> were found growing both as
                        epiphyte and terrestrial forms. 29%&nbsp; of&nbsp; total
                        orchids (62 orchids) and 38% of epiphytic orchids (39
                        orchids) from the area were endemic to the Western
                        Ghats. Species accumulation curves suggest that species
                        are yet to be sampled from Aralam Wildlife Sanctuary.
                        All four habitat types possessed distinct epiphytic
                        orchid diversity. Wet evergreen was the most diverse
                        habitat for epiphytic orchids.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Pradheep et al., 2021 conducted a study about the update
                        status of agriculturally important crops in Kerala. All
                        the cultivated taxa (except medicinal, aromatic,
                        ornamental and forestry species) were considered for
                        analysis. Field observations, literature survey,
                        information from social media, visits to crop-based
                        institutes and botanical gardens, interaction with crop
                        experts, herbarium consultation, and live material
                        studies were the methods employed for the study.
                        Analysis shows that 306 crop taxa (290 crop species)
                        belonging to 179 genera under 61 families are being
                        cultivated in various regions across the state. Top
                        genera representing&thinsp;greater than&thinsp;5
                        cultivated species include <em>Solanum</em>,{" "}
                        <em>Citrus</em>, <em>Dioscorea</em>, <em>Garcinia</em>,{" "}
                        <em>Annona</em>, <em>Syzygium</em>, <em>Artocarpus</em>{" "}
                        and <em>Vigna</em>. The top families with more crop
                        species, are <em>Fabaceae</em>, <em>Poaceae</em>,{" "}
                        <em>Cucurbitaceae</em>, <em>Solanaceae</em>,{" "}
                        <em>Myrtaceae</em>, <em>Rutaceae</em> and{" "}
                        <em>Malvaceae</em>. The analysis was critically compared
                        with the early estimate in 2011 by Nayar NM and it shows
                        104% higher estimate of crop species (142 vs. 290)
                        stemming from the present work.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Archana &amp; Gayatri, 2021 studied the floristic
                        diversity of Chirakkal chira and Rajarajeshwara chira in
                        Kannur district, which are the largest temple ponds in
                        the district. The samples were collected in a polythene
                        bag in November 2018 and&nbsp; screened for algae and
                        fungi under a compound research microscope. Angiosperms
                        and pteridophyte flora were studied from the site, and
                        herbarium was prepared. A total of 27 algae were
                        identified, of which 16 belong to Chlorophyceae. 10
                        genera of fungi belonging to Ascomycetes and
                        Deuteromycetes were identified. Bryophytes were absent
                        in both sites. 4 pteridophytes and 20 angiosperms were
                        observed from the sites. Asteraceae was the dominant
                        family in the angiosperms. Chirakkal chira supported a
                        vast diversity of flora than Rajarajeshwara
                        chira.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Divya et al., 2021 studied the diversity,
                        classification, and ethnobotanical uses of wild edible
                        fruit plants in the Kallar and Ponmudi region of
                        Agasthyamala Biosphere Reserve in Kerala. A detailed
                        literature survey was conducted and a check list of wild
                        edible fruit plants was prepared. 12 plant exploration
                        trips were conducted to different localities of the
                        region in all seasons during the period 2017-2019. A
                        herbarium were prepared, and passport data sheets for
                        each accession with first-hand information were prepared
                        from the field. Wild edible fruit plants of 30
                        indigenous species from 13 angiosperm families were
                        enumerated. There were 9 endemic, 4 threatened and 7
                        least concern species. Family Myrtaceae was the mostly
                        used plant family having 8 fruit species. 11 indigenous
                        wild fruit plants are used by the Kani tribe of the
                        locality, 7 species are seasonal in harvest, 4
                        indigenous wild species were not much exploited and 8
                        species were exclusively wild, lesser known, endangered
                        endemic fruit plants. Most of the species&rsquo;
                        flowering and fruiting period was from January to
                        June.&nbsp;
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Sreelekshmi et al., 2021 studied the mangrove forests
                        along Kerala's coastline, focusing on its current status
                        and future prospects. The northern zone of Kerala has a
                        higher area of mangroves (11.91 km2), and Kannur
                        district holds a high area among other districts in
                        Kerala. Mangroves hold 18 species of which{" "}
                        <em>Avicennia officinalis</em> and{" "}
                        <em>Rhizophora mucronata</em> are the dominant species.
                        Reclamation of land for inhabitation and agriculture,
                        utilization of mangrove resources as a source of income
                        are the two major reasons for mangrove degradation in
                        Kerala. Most of the mangrove wetlands in Kerala were
                        polluted through agricultural runoff and the discharge
                        of untreated sewage, trace elements, plastics, and other
                        degradable and non-degradable materials. The mangrove
                        flora has remained stunted or degraded in many pockets
                        in the coastal area due to the increase in the pollution
                        load. Mangrove patches in Chettuva (Thrissur district),
                        Kumarakom (Kottayam district), Munroe Island, Asramam
                        (Kollam district) and Veli (Thiruvananthapuram district)
                        are tourism spots, which create a huge threat to the
                        pristine mangrove ecosystems of the region. The vertical
                        rise of the water column due to sea-level rise will
                        result in water logging and the destruction of mangroves
                        and associated fauna. Institutional efforts in
                        conservation through legal and financial support have to
                        be considered to improve the extent of mangroves.
                        Awareness should be created among the local communities
                        about the importance of this unique ecosystem. Effective
                        governance, adaptation, mitigation options for climate
                        change, better planning for rehabilitating degraded
                        mangroves, etc. are necessary to conserve, protect and
                        restore mangrove ecosystems.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Archana &amp; Surabhi, 2022 studied the ethnobotanical
                        relevance of flora in the Kollam and Thiruvananthapuram
                        districts of Kerala. Varkala in Thiruvananthapuram
                        district and Eravipuram in Kollam district are chosen as
                        study areas. The climatic conditions of the study area
                        are similar to the biodiversity hotspot Agasthyarkoodam;
                        therefore, a wide range of endemic species can be found
                        across these two districts. Survey was carried out
                        mainly in both study areas' wetlands, river banks and
                        rural regions. Field trips involve interviews with
                        experienced people and Ayurvedic doctors. Plant species
                        names and local names of the plant, family, and their
                        uses against various diseases are documented. The tribal
                        medicines are prepared from various plant parts such as
                        seeds, flowers, bark, leaves, roots, and stems. Fresh
                        herbs are rich in its nutritive and therapeutic
                        constituents such as volatile oils, tannins, terpenoids,
                        saponins, flavonoids, alkaloids, and anthraquinones.
                        They are used as traditional remedies to various
                        illnesses like diarrhoea, dysentery, dyspnoea, piles,
                        tuberculosis, etc. Most of these formulations are
                        devised by the Kani tribal community.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        Faizal et al., 2022 studied the status of plant
                        bioresources utilised in herbal industries and the need
                        for conservation in Kerala state. Raw data about 25
                        licensed herbal manufacturing units with a turnover of
                        more than one crore rupees were shortlisted from
                        baseline data of pharmaceutical companies from 14
                        districts of Kerala. This data was sorted, tabulated,
                        and compiled in district-wise by including the part
                        used, quantity and IUCN status, and local/regional
                        conservation status. About 562 species of plants are
                        currently in trade for herbal preparations by
                        herbal-cosmetic and nutraceutical industries. 10% of
                        plants are used above 10 tonnes. 40% of the plant
                        species are consumed below 100 kilograms. The root is
                        the most important for herbal preparation among the
                        plant parts. To meet the demand for root, 142 species
                        are harvested destructively. 116 species are used
                        wholly, and seeds of about 87 species are used for
                        formulations. The industries also use heartwood and
                        metabolites. The 90% of the plants fall either in the
                        Least Concerned (LC) or Not Evaluated (NE) or Data
                        Deficient (DD) category of conservation status. Of the
                        remaining, 8% (45) are in the threatened list at global
                        (IUCN) or regional level (Western Ghats). Ten species
                        are with Near Threatened (NT) status. The most consumed
                        medicinal and aromatic plants includes nutraceuticals
                        like <em>Moringa oleifera</em>, <em>Curcuma longa</em>,{" "}
                        <em>Eclipta prostrata</em>, <em>Sida rhombifolia</em>,{" "}
                        <em>Aegle marmelos</em>, and <em>Justicia adhatoda</em>.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Nair, 2022 conducted a comprehensive study on the
                        socio-economic and cultural aspects of sacred groves in
                        Kerala, and their eleventh report was on the sacred
                        groves in Pathanamthitta district. The Geographical
                        extent of the district was 2652 sq. km, with a forest
                        area of 1385.27 sq. km. There are 721 sacred groves in
                        this district, covering an area of 144.55 Acres. 16
                        sacred groves are of and below 5 cents, and 13 are of
                        and above one acre in extent. Adoor taluk in the
                        district contains the highest number of sacred groves
                        (238 ), in which 9 are very large ones (&gt;1 acre). The
                        vegetation in the sacred groves consist of evergreen,
                        semi evergreen and deciduous, most of which come under
                        evergreen category. Undisturbed groves have good
                        vegetation, and several stories of trees and shrubs can
                        be seen with plenty of highly buttressed trees such as,{" "}
                        <em>Ficus</em>.sp, <em>Vateria indica</em>,{" "}
                        <em>Hydnocarpus</em> etc. One time, enumeration was
                        carried out in 13 sacred groves in Adoor and Thiruvalla
                        thaluks. 256 species were enumerated of which 97 are
                        trees, 68 climbers, 49 shrubs and 47 are herbs. In all
                        the 13 sacred groves studied,{" "}
                        <em>Chassalia curviflora</em> var.{" "}
                        <em>ophioxyloides</em>, <em>Pothos scandens</em> and{" "}
                        <em>Xanthophyllum arnottianum</em> were found in all of
                        them. <em>Cetrosema molle </em>and{" "}
                        <em>Ichnocarpus frutescens </em>were found in 12 sacred
                        groves. 87 species occur only in one sacred grove. With
                        more number of trees, thick vegetation density can be
                        seen in some sacred groves while in others climbers
                        dominate and their density is poor. Species like{" "}
                        <em>Artocarpus hirsutus</em>,{" "}
                        <em>Adanenthera pavonina</em>,{" "}
                        <em>Holigarna arnotiana</em> and{" "}
                        <em>Hydnocarpus pentandra</em> show generally good
                        regeneration and are common in almost all sacred groves.
                        Medicinal plants like <em>Curculigo orchiodes</em> and{" "}
                        <em>Costus speciosus</em> were noticed in the sacred
                        groves.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Nair, 2022 conducted a comprehensive study on the
                        socio-economic and cultural aspects of sacred groves in
                        Kerala, and their twelfth report was on the sacred
                        groves in Malappuram district. The Geographical extent
                        of the district was 3549 sq. km, with a forest area of
                        758.8 sq. km. There are 1120 sacred groves in the
                        district. 738 of them fall under 5-10 cents category,
                        and 22 sacred groves have above one acre extend.
                        Evergreen, semi-evergreen and deciduous vegetation types
                        can be seen in the sacred groves in which most are
                        evergreen type. Undisturbed sacred groves have luxuriant
                        vegetation, while disturbed sacred groves have low
                        density of vegetation and a preponderance of climber
                        species. Some climbers are large, have long age and are
                        seen on trees such as <em>Lophopetalum</em>. Coastal
                        zones of sacred groves have random occurrences of trees
                        like <em>Diospyros perigrina</em>,{" "}
                        <em>Aphanamixis polystachia</em>,{" "}
                        <em>Samadera indica </em>and shrubs like{" "}
                        <em>Rauvolfia tetraphylla</em>. Rare palm{" "}
                        <em>Corypha umbaculifera</em> is seen in Kayalot Kavu.{" "}
                        <em>Antiaris toxicaria</em> have good regeneration. One
                        time enumeration was carried out in 22 sacred groves
                        resulting in the enumeration of 382 species in which 120
                        are trees, 92 climbers, 77 shrubs and 93 were herbs. A
                        rare tree <em>Syzygium chavaran</em> is seen in
                        Mukkuthala Temple Kavu of Ponnani taluk. Most of the
                        sacred groves have Ficus species, and more than five
                        species of Ficus can be seen in them. In sacred groves
                        where climbers are predominant, fruit-bearing trees are
                        fewer and birds attracted to these groves are few.{" "}
                        <em>Vateria indica</em>, <em>Alstonia scholaris</em> and{" "}
                        <em>Aphanamixis polystachya</em> severe as keystone
                        species in the groves. Medicinally important species and
                        invasive species were also noticed in the sacred groves.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Nair, 2022 conducted a comprehensive study on the
                        socio-economic and cultural aspects of sacred groves in
                        Kerala, and their thirteenth report was on the sacred
                        groves in Ernakulam district. There are 708 sacred
                        groves in the district,of which 39% are of and below 5
                        cents and 9 sacred groves are above one-acre extent.
                        Among the 708 sacred groves, 20 sacred groves have been
                        studied in detail. Most of the sacred groves contain 12
                        to 24 tree species, 10 to 22 shrubs, and 25 to 34
                        climbers. Rare and threatened species like{" "}
                        <em>Myristica malabarica</em>,{" "}
                        <em>Gynecranthera farquhariana</em>,{" "}
                        <em>Syzygium travancoricum</em> have been noticed in
                        these sacred groves, and families like Euphorbiaceae,
                        Lauraceae, Fabaceae, Rubiaceae, and Apocynaceae are very
                        well represented. <em>Vateria indica</em>,{" "}
                        <em>Holigarna arnottiana</em>,{" "}
                        <em>Calophyllam calaba</em>, and <em>Hopea ponga</em>{" "}
                        are the most common dominant species in the groves that
                        shows an affinity towards each other. The sacred groves
                        hold valuable presence of a variety of species like{" "}
                        <em>Raphidophora pertusa</em> (large climber),{" "}
                        <em>Naringi crenulata</em> (small evergreen tree),{" "}
                        <em>Morinda umbulata</em> (rare medicinal plant),{" "}
                        <em>Acampe praemorsa</em> (Orchid) and{" "}
                        <em>Bulbophyllum neilgherrense</em> (Orchid). The
                        vegetation pattern in these groves is different from
                        others because the number of tree species is higher than
                        other habit forms. 6 species of Ficus can be seen in the
                        groves that serve as keystone species in the
                        ecosystem.&nbsp;&nbsp;
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Nair, 2022 conducted a comprehensive study on the
                        socio-economic and cultural aspects of sacred groves in
                        Kerala, and their fourteenth report was on the sacred
                        groves in Wayanad district. The Geographical extent of
                        the district is 2132 sq. km with a forest area of 886
                        sq.km. A total of 137 sacred groves were present in the
                        Wayanad district, in which very small sacred groves were
                        almost absent, and 14% are large in extent. Both
                        evergreen and semi-evergreen types of vegetation can be
                        seen in these sacred groves. Luxuriant vegetation and
                        high diversity are seen in less disturbed and largely
                        sacred groves. Some endemic species are seen plenty in
                        the sacred groves, which include species such as{" "}
                        <em>Hopea parviflora</em>, <em>Hopea ponga</em>,{" "}
                        <em>Myristica malabarica</em>, <em>Knema attenuate</em>,{" "}
                        <em>Diospyros malabarica</em> and{" "}
                        <em>Percia malabarica</em>. Promising growth of bamboos
                        can be seen in some sacred groves of Wayanad, which was
                        rarely seen among the sacred groves of other districts
                        except of Thrissur. Good regeneration was observed in
                        the sacred groves because many important trees in the
                        groves were either shade demanding or shade tolerant.
                        One time enumeration was conducted in nine sacred
                        groves, and plants found in these groves were listed. As
                        most of the sacred groves lie in hilly tracts of the
                        district, the general floristic composition and
                        vegetation physiognomy of sacred groves in Wayanad are
                        typically like hilly evergreen forests. More than eight
                        species of Ficus can be seen in the groves, which serve
                        as keystone species by attracting birds and providing
                        habitat for insects.&nbsp;
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Lekshmi et al., 2022 studied the floral diversity in
                        Villumala in Kulathupuzha region of Kollam district in
                        Kerala. The study was conducted from January to April
                        2019. Field trips were conducted to Villumala, raw
                        materials were collected, plant species were identified
                        with the help of floras and medicinal uses of species
                        were obtained from people. A total of 34 species were
                        documented in which all of them have potential medicinal
                        importance. The various uses of species include fodder,
                        food, basket making, spice production etc. Out of 34
                        species <em>Cassia alata</em> and{" "}
                        <em>Aporosa cardiosperma</em> have antimicrobial
                        property and <em>Connarus monocarpus</em> is used for
                        eye diseases, <em>Centella asiatica</em> and{" "}
                        <em>Ocimum sanctum</em> are used in fever, cold, flue
                        etc. The floral wealth is depleting due to
                        deforestation, overgrazing, habitat destruction, and
                        improper agricultural practices.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Ameesha &amp; Saradha, 2023 documented the floristic
                        diversity of medicinal plants in Ponparakunnu hills of
                        Kozhikode district in Kerala and the biological
                        activities of <em>Eclipta prostrata</em> L. and{" "}
                        <em>Eupatorium triplinerve</em> Vahl species in
                        Asteraceae family. Field survey was carried out during
                        October- December 2022. Based on personal knowledge and
                        with the help of local people, information about
                        medicinal plants were collected and classified on the
                        basis of habit of the plant. Leaves of{" "}
                        <em>Eclipta prostrata</em> and{" "}
                        <em>Eupatorium triplinerve</em> were collected, washed,
                        air dried, powdered, and ethyl acetate extract and
                        ethanolic extract were prepared to study the
                        antibacterial and antioxidant activity of the plant. 30
                        species of medicinal plants belonging to 18 families
                        were recorded, showing Asteraceae as the dominant family
                        in the area. Of the total 30 species, 16 were herbs, 7
                        were shrubs, 6 were trees, and 1 species was climber.
                        The phytochemical analysis in the leaf extracts of{" "}
                        <em>Eclipta prostrata</em> and{" "}
                        <em>Eupatorium triplinerve</em> revealed the presence of
                        carbohydrates, protein, phenol, tannin, flavonoids,
                        saponins, glycosides, steroids, terpenoids, and
                        alkaloids in the species and show prominent antioxidant
                        and antibacterial activity of the species.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Krishnan Remya &amp; S Nelson Jiji, 2023 conducted a
                        floristic study in ten randomly selected paddy fields of
                        Thiruvananthapuram district of Kerala. Field surveys
                        were conducted, and quadrat method were used for
                        sampling. Field identification was carried out by
                        dividing the field into field proper, bunds, and ditch
                        sections. Monthly observations were carried out at each
                        site, and the details of the species, genera, families,
                        economic importance and IUCN status were recorded. A
                        total of 44 plant species belonging to 41 genera of 22
                        families were observed. Poaceae was the dominant family.
                        21 species were dicots, 19 were monocots, and 4 were
                        Pteridophytes. 32 species are used for medicinal
                        purposes.
                      </p>
                      <p style={{ fontSize: "0.999999em" }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Venkatesan et al., 2023 studied the conservation status
                        and diversity of medicinal plants used in the Indian
                        system of medicine, focusing on the Munnar Forest
                        Division, Kerala. The study was conducted in November
                        2015 by collecting information about the medicinal
                        plants in the Munnar forest division through
                        conversations with traditional healers and comparing the
                        data with previous literature. 31 rare wild medicinal
                        plant species used in Ayurveda, Siddha, Unani and also
                        folk medicine were identified. They were used to treat
                        various diseases such as dry cough, menstrual disorders,
                        piles, viral fever, kidney stone, joint pain, jaundice,
                        skin diseases, contraceptive purposes, etc. The plant
                        species were of different habits like trees (14), herbs
                        (9), shrubs (5), and Climbing shrub (3) and statuses of
                        plants show 23 rare, 3 Endangered, 2 Critically
                        endangered, each one of Threatened, Vulnerable and Least
                        Concern species in the study area.
                      </p>
                    </section>
                  </li>{" "}
                  <br />
                  <li className="nav-item">
                    <section id="Materials and Methods">
                      <p
                        style={{
                          textAlign: "justify",
                          fontSize: "0.999999999em",
                        }}
                      >
                        <h3>3. Materials and Methods</h3>
                      </p>
                    </section>
                  </li>{" "}
                  <ul>
                    <li>
                      <section id="Study Area">
                        <p
                          style={{
                            textAlign: "justify",
                            fontSize: "0.999999999em",
                          }}
                        >
                          <h5>3.1 Study Area</h5>
                          Kerala state is situated in the southwest corner of
                          India. The state has a total area of 38,863 sq km,
                          between the Arabian Sea in the West and the Western
                          Ghats in the East. Kerala lies in approximately 8&deg;
                          17' 30'' N to 12&deg; 47' 40'' N latitude and 74&deg;
                          27' 47'' E to 77&deg; 37' 12'' E longitude with 14
                          districts(Government of Kerala).
                        </p>
                        <p style={{ fontSize: "0.999999em" }}>
                          <strong>Geography </strong>
                        </p>
                        <p style={{ fontSize: "0.999999em" }}>
                          Geographically, the state is divided into Highland,
                          Mid plains, and coastal areas. The highlands include
                          the area in and around the Western Ghats, which have
                          high peaks and evergreen forests. On the West, lies
                          the Coastal belt parallel to the Western Ghats. In
                          between these lies the mid-lands (Government of
                          Kerala).
                        </p>
                        <p style={{ fontSize: "0.999999em" }}>
                          <strong>Climate</strong>
                        </p>
                        <p style={{ fontSize: "0.999999em" }}>
                          Kerala experiences a tropical climate. South-West
                          monsoon (June-September), North-East monsoon&nbsp;
                          (October - December), and summer (March-May) are the
                          major seasons in Kerala. The winter season
                          (December-February) is not marked much compared to
                          other states of India (Government of Kerala).
                        </p>
                        <p style={{ fontSize: "0.999999em" }}>
                          <strong>Forests </strong>
                        </p>
                        <p style={{ fontSize: "0.999999em" }}>
                          Kerala forest covers an area of 11,524.149 sq. km,
                          which occupies 29.65% of the state's total area. In
                          the total forest area, 3213.24 Km<sup>2</sup> area are
                          protected as National Parks, Wildlife Sanctuaries, and
                          Community Reserves(Kerala Forests and Wildlife
                          Department). The major forest types in Kerala are the
                          following;
                        </p>
                        <p style={{ fontSize: "0.999999em" }}>
                          West Coast semi-evergreen forests:
                        </p>
                        <p style={{ fontSize: "0.999999em" }}>
                          West coast semi-evergreen forests are found between
                          600-800 m, sometimes up to 900 m. Animals such as
                          lion-tailed macaque, Nilgiri marten, and birds like
                          the great Indian hornbill can be seen in these
                          forests. Evergreen species such as{" "}
                          <em>Artocarpus heterophyllus</em>,{" "}
                          <em>Hopea ponga</em>, <em>Mangifera indica</em>, and
                          deciduous species like <em>Bombax ceiba</em>,{" "}
                          <em>Dalbergia latifolia</em> can be seen as plant
                          species (Kerala Forests and Wildlife Department).
                        </p>
                        <p style={{ fontSize: "0.999999em" }}>&nbsp;</p>
                        <p style={{ fontSize: "0.999999em" }}></p>
                        <p style={{ fontSize: "0.999999em" }}>
                          Southern Hilltop Tropical Evergreen Forest:
                        </p>
                        <p style={{ fontSize: "0.999999em" }}>
                          It reaches to a maximum height of 10 m and is usually
                          seen on slopes and hilltops.{" "}
                          <em>Artocarpus heterophyllus</em> (tree),{" "}
                          <em>Ochlandra travancorica</em> (Bamboo),{" "}
                          <em>Strobilanthes</em> spp (Shrub) and{" "}
                          <em>Calamus</em> spp (Climber) are some of the common
                          species seen in the forest (Kerala Forests and
                          Wildlife Department).
                        </p>
                        <p style={{ fontSize: "0.999999em" }}>
                          West Coast tropical evergreen:
                        </p>
                        <p style={{ fontSize: "0.999999em" }}>
                          These forests are seen at an altitude of 250-1200 m
                          with lofty trees of 45 m or more height and dense
                          evergreen vegetation. Trees such as{" "}
                          <em>Palaquium ellipticum</em>,{" "}
                          <em>Calophyllum elatum</em> and shrubs such as{" "}
                          <em>Leea indica</em>, <em>Strobilanthes</em> etc., are
                          present (Kerala Forests and Wildlife Department).
                        </p>
                        <p style={{ fontSize: "0.999999em" }}>
                          Wet evergreen and semi-evergreen climax forests:
                        </p>
                        <p style={{ fontSize: "0.999999em" }}>
                          Wet evergreen forests of Kerala are seen on the
                          windward side of western ghats, which have rainfall
                          above 2000 mm. The forests are further subdivided into
                          eight main floristic types and three facies based on
                          the presence of certain characteristic species (Kerala
                          Forests and Wildlife Department).
                        </p>
                        <p style={{ fontSize: "0.999999em" }}>
                          Secondary Dry Deciduous Forests:
                        </p>
                        <p style={{ fontSize: "0.999999em" }}>
                          Poorly shaped, small-sized trees are dominant in these
                          forests. The soil surface is hard.{" "}
                          <em>Bombax ceiba</em> and <em>Lantana camara</em> are
                          examples of plant speciesn these forests (Kerala
                          Forests and Wildlife Department).
                        </p>
                        <p style={{ fontSize: "0.999999em" }}>
                          Southern Dry Deciduous Forests:
                        </p>
                        <p style={{ fontSize: "0.999999em" }}>
                          This forest can be seen in dry localities experiencing
                          rainfall of 875 mm &ndash;1125mm. The presence of{" "}
                          <em>Boswellia</em> species is visible in these forests
                          (Kerala Forests and Wildlife Department).
                        </p>
                        <p style={{ fontSize: "0.999999em" }}>
                          Primary moist deciduous forests (
                          <em>
                            Lagerstroemia microcarpa &ndash; Tectona grandis
                            &ndash; Dillenia pentagyna{" "}
                          </em>
                          type &ndash; LTD):
                        </p>
                        <p style={{ fontSize: "0.999999em" }}>
                          They are found in isolated patches seen in between the
                          Anamalai and Wayanad plateaus. Characteristic species
                          of these forests are <em>Dillenia pentagyna</em> and{" "}
                          <em>Tabernaemontana heyneana</em> (Kerala Forests and
                          Wildlife Department).
                        </p>
                        <p style={{ fontSize: "0.999999em" }}>
                          Secondary moist deciduous forests:
                        </p>
                        <p style={{ fontSize: "0.999999em" }}>
                          Secondary forests cover a large area in Kerala.{" "}
                          <em>Dillenia pentagyna</em>,{" "}
                          <em>Tabernaemontana heyneana</em>,{" "}
                          <em>Strychnos nux-vomica</em>, and{" "}
                          <em>Xylia xylocarpa</em> are common in these forests
                          (Kerala Forests and Wildlife Department).
                        </p>
                        <p style={{ fontSize: "0.999999em" }}>
                          Dry Deciduous forests:&nbsp;&nbsp;
                        </p>
                        <p style={{ fontSize: "0.999999em" }}>
                          These forests are rarely seen in Kerala and are found
                          in areas experiencing less than 1200 mm of rainfall.
                          Dry deciduous forests can be of three types:{" "}
                          <em>Albizia amara</em> &ndash;<em>Acacia</em> spp.{" "}
                          <em>Gyrocarpus asiaticus</em> (AAG) type is seen in
                          Chinnar Wildlife Sanctuary,{" "}
                          <em>Anogeissus latifolia</em> &ndash;{" "}
                          <em>Pterocarpus marsupium</em> &ndash;{" "}
                          <em>Terminalia</em> spp. (APT) type in Mannarkad
                          Division (northern part) and Chinnar WLS and{" "}
                          <em>Anogeissus latifolia</em> &ndash;{" "}
                          <em>Tectona grandis</em> &ndash; <em>Terminalia</em>{" "}
                          spp. (ATT) type in the South Wayanad WLS (Kerala
                          Forests and Wildlife Department).
                        </p>
                        <p style={{ fontSize: "0.999999em" }}>
                          Grasslands:&nbsp;
                        </p>
                        <p style={{ fontSize: "0.999999em" }}>
                          In Kerala, grasslands are found above 1500 m.
                          Grasslands below 1800 m have tall grasses to a height
                          of 1.5 m, commonly represented by{" "}
                          <em>Arundinella purpurea</em>, <em>Themeda</em> sp,
                          etc. At above 1800 m, especially in the Anamalai
                          region (Eravikulam and Munnar), the grass layer is
                          less than 1 m, and species such as{" "}
                          <em>Arundinella</em> spp., <em>Cymbopogon</em> spp.,
                          etc. can be seen (Kerala Forests and Wildlife
                          Department).
                        </p>
                        <p style={{ fontSize: "0.999999em" }}>Mangroves:</p>
                        <p style={{ fontSize: "0.999999em" }}>
                          In Kerala, mangroves are highly localized but possess
                          good species diversity of mangroves and associates.
                          They are found in all districts except Idukki,
                          Pathanamthitta, Palakkad and Wayanad. Kannur district
                          has a high extent of mangroves.{" "}
                          <em>Acanthus cillicifolius</em>,{" "}
                          <em>Avicennia officinalis</em>,{" "}
                          <em>
                            and Excoecaria agallocha are some important mangrove
                            plants{" "}
                          </em>
                          in Kerala (Kerala Forests and Wildlife Department).
                        </p>
                        <p style={{ fontSize: "0.999999em" }}>
                          <strong>Agro-ecological Zones </strong>
                        </p>
                        <p style={{ fontSize: "0.999999em" }}>
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          Based on climate, geomorphology, land use, and soil
                          variability, the agroecological zones (AEZ) of Kerala
                          can be divided into five zones (Kerala Soil Health
                          Information System).
                        </p>
                        <p style={{ fontSize: "0.999999em" }}>Coastal Plain:</p>
                        <p style={{ fontSize: "0.999999em" }}>
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          Coastal plains are the area along the coast between
                          the sea and midlands. The zone has an elevation below
                          30 meters and covers an area of 4,60,074 ha (11.84 %)
                          in the state (Kerala Soil Health Information System).
                        </p>
                        <p style={{ fontSize: "0.999999em" }}>
                          Midland Laterites:
                        </p>
                        <p style={{ fontSize: "0.999999em" }}>
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          Midland laterites extend from the southern end to the
                          northern end of the state with an elevation of 30 to
                          300 m and cover 10,56,385 ha (27.18 %) of the state
                          (Kerala Soil Health Information System).
                        </p>
                        <p style={{ fontSize: "0.999999em" }}>Foothills</p>
                        <p style={{ fontSize: "0.999999em" }}>
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          Foothills are the zone between midland laterite on the
                          west and high hills on the east. The elevation of the
                          zone ranges from 300-600 m and has very narrow
                          valleys. The state's 4,60,074 ha (11.84 %) area is
                          covered by foothills (Kerala Soil Health Information
                          System).
                        </p>
                        <p style={{ fontSize: "0.999999em" }}>High hills</p>
                        <p style={{ fontSize: "0.999999em" }}>
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          High hills are the largest zone comprising Western
                          Ghats and plateaus, which are 600 m above msl (Kerala
                          Soil Health Information System).
                        </p>
                        <p style={{ fontSize: "0.999999em" }}>Palakkad Plain</p>
                        <p style={{ fontSize: "0.999999em" }}>
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          Palakkad plain comprises gentle sloping lands of
                          Palakkad with low elevation covering 1,60,006 ha (4.12
                          %) of the state (Kerala Soil Health Information
                          System).
                        </p>
                      </section>
                    </li>{" "}
                    <br />
                    <li>
                      <section id="Methods">
                        <p
                          style={{
                            textAlign: "justify",
                            fontSize: "0.999999999em",
                          }}
                        >
                          <h5>3.2 Methods</h5>
                          The details of each plant species were collected from
                          research papers, government websites like the Indian
                          Biodiversity Portal (https://indiabiodiversity.org/),
                          e-flora of Kerala (https://www.eflorakerala.com/), and
                          also from various other E-resources. International
                          websites like Plants of the World Online (POWO,
                          https://powo.science.kew.org/) and International Plant
                          Names Index (IPNI, https://www.ipni.org/) were
                          referred for authentic and updated plant species
                          nomenclature. Family names of species were given
                          according to APG III system. Common names of the
                          species are given in Malayalam (Vernacular) and
                          English languages. Plant characteristics include of
                          the trunk, stem, bark, branchlets, leaves, flowers,
                          fruit, and seed. The flowering and fruiting period of
                          the plant and the known use of each species are
                          listed. District-wise distribution of all the species
                          is given in detail, and spatial analysis was done
                          using QGIS software.  
                        </p>
                      </section>
                    </li>{" "}
                    <br />
                  </ul>
                  <li className="nav-item">
                    <section id="Results">
                      <p
                        style={{
                          textAlign: "justify",
                          fontSize: "0.999999999em",
                        }}
                      >
                        <h3>4. Results</h3>
                      </p>
                    </section>
                  </li>{" "}
                  <ul>
                    <li>
                      <section id="Spatial Analysis of Species">
                        <p>
                          <b> Spatial Analysis of Species</b>
                        </p>
                        <p style={{ fontSize: "0.999999em" }}>
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          Spatial analysis of species in different habits like
                          trees, shrubs, and herbs results in the mapping of
                          1860 species in all districts. Based on the
                          distribution of 1860 species, the total number of
                          trees, shrubs and herbs in each district are given in
                          table 1. Idukki district has the highest proportion of
                          species. It holds 68.89% of the total species of which
                          data was collected during the study. Idukki is
                          followed by Palakkad district with 60.61%. Herbs
                          constitute more proportion than trees and shrubs in
                          all the districts.
                        </p>
                        <p style={{ fontSize: "0.999999em" }}>&nbsp;</p>
                        <p style={{ fontSize: "0.999999em" }}>
                          <a name="_Toc165292929"></a>Table 1: Total number of
                          species in each district
                        </p>
                        <table style={{ width: "80%" }}>
                          <tbody>
                            <tr>
                              <td>
                                <p style={{ fontSize: "0.999999em" }}>
                                  <strong>DISTRICT</strong>
                                </p>
                              </td>
                              <td>
                                <p style={{ fontSize: "0.999999em" }}>
                                  <strong>TREES</strong>
                                </p>
                              </td>
                              <td style={{ width: "85px" }}>
                                <p style={{ fontSize: "0.999999em" }}>
                                  <strong>SHRUBS</strong>
                                </p>
                              </td>
                              <td style={{ width: "85px" }}>
                                <p style={{ fontSize: "0.999999em" }}>
                                  <strong>HERBS</strong>
                                </p>
                              </td>
                              <td style={{ width: "85px" }}>
                                <p style={{ fontSize: "0.999999em" }}>
                                  <strong>TOTAL</strong>
                                </p>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <p style={{ fontSize: "0.999999em" }}>
                                  Thiruvananthapuram
                                </p>
                              </td>
                              <td>
                                <p style={{ fontSize: "0.999999em" }}>282</p>
                              </td>
                              <td style={{ width: "85px" }}>
                                <p style={{ fontSize: "0.999999em" }}>203</p>
                              </td>
                              <td style={{ width: "85px" }}>
                                <p style={{ fontSize: "0.999999em" }}>458</p>
                              </td>
                              <td style={{ width: "85px" }}>
                                <p style={{ fontSize: "0.999999em" }}>943</p>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <p style={{ fontSize: "0.999999em" }}>Kollam</p>
                              </td>
                              <td>
                                <p style={{ fontSize: "0.999999em" }}>286</p>
                              </td>
                              <td style={{ width: "85px" }}>
                                <p style={{ fontSize: "0.999999em" }}>201</p>
                              </td>
                              <td style={{ width: "85px" }}>
                                <p style={{ fontSize: "0.999999em" }}>439</p>
                              </td>
                              <td style={{ width: "85px" }}>
                                <p style={{ fontSize: "0.999999em" }}>926</p>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <p style={{ fontSize: "0.999999em" }}>
                                  Pathanamthitta
                                </p>
                              </td>
                              <td>
                                <p style={{ fontSize: "0.999999em" }}>199</p>
                              </td>
                              <td style={{ width: "85px" }}>
                                <p style={{ fontSize: "0.999999em" }}>168</p>
                              </td>
                              <td style={{ width: "85px" }}>
                                <p style={{ fontSize: "0.999999em" }}>348</p>
                              </td>
                              <td style={{ width: "85px" }}>
                                <p style={{ fontSize: "0.999999em" }}>715</p>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <p style={{ fontSize: "0.999999em" }}>
                                  Alappuzha
                                </p>
                              </td>
                              <td>
                                <p style={{ fontSize: "0.999999em" }}>147</p>
                              </td>
                              <td style={{ width: "85px" }}>
                                <p style={{ fontSize: "0.999999em" }}>131</p>
                              </td>
                              <td style={{ width: "85px" }}>
                                <p style={{ fontSize: "0.999999em" }}>274</p>
                              </td>
                              <td style={{ width: "85px" }}>
                                <p style={{ fontSize: "0.999999em" }}>552</p>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <p style={{ fontSize: "0.999999em" }}>
                                  Kottayam
                                </p>
                              </td>
                              <td>
                                <p style={{ fontSize: "0.999999em" }}>157</p>
                              </td>
                              <td>
                                <p style={{ fontSize: "0.999999em" }}>150</p>
                              </td>
                              <td style={{ width: "85px" }}>
                                <p style={{ fontSize: "0.999999em" }}>290</p>
                              </td>
                              <td style={{ width: "85px" }}>
                                <p style={{ fontSize: "0.999999em" }}>597</p>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <p style={{ fontSize: "0.999999em" }}>Idukki</p>
                              </td>
                              <td>
                                <p style={{ fontSize: "0.999999em" }}>349</p>
                              </td>
                              <td style={{ width: "85px" }}>
                                <p style={{ fontSize: "0.999999em" }}>257</p>
                              </td>
                              <td style={{ width: "85px" }}>
                                <p style={{ fontSize: "0.999999em" }}>676</p>
                              </td>
                              <td style={{ width: "85px" }}>
                                <p style={{ fontSize: "0.999999em" }}>1282</p>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <p style={{ fontSize: "0.999999em" }}>
                                  Ernakulam
                                </p>
                              </td>
                              <td>
                                <p style={{ fontSize: "0.999999em" }}>141</p>
                              </td>
                              <td style={{ width: "85px" }}>
                                <p style={{ fontSize: "0.999999em" }}>110</p>
                              </td>
                              <td style={{ width: "85px" }}>
                                <p style={{ fontSize: "0.999999em" }}>220</p>
                              </td>
                              <td style={{ width: "85px" }}>
                                <p style={{ fontSize: "0.999999em" }}>471</p>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <p style={{ fontSize: "0.999999em" }}>
                                  Thrissur
                                </p>
                              </td>
                              <td>
                                <p style={{ fontSize: "0.999999em" }}>272</p>
                              </td>
                              <td style={{ width: "85px" }}>
                                <p style={{ fontSize: "0.999999em" }}>187</p>
                              </td>
                              <td style={{ width: "85px" }}>
                                <p style={{ fontSize: "0.999999em" }}>384</p>
                              </td>
                              <td style={{ width: "85px" }}>
                                <p style={{ fontSize: "0.999999em" }}>843</p>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <p style={{ fontSize: "0.999999em" }}>
                                  Palakkad
                                </p>
                              </td>
                              <td>
                                <p style={{ fontSize: "0.999999em" }}>322</p>
                              </td>
                              <td style={{ width: "85px" }}>
                                <p style={{ fontSize: "0.999999em" }}>239</p>
                              </td>
                              <td style={{ width: "85px" }}>
                                <p style={{ fontSize: "0.999999em" }}>567</p>
                              </td>
                              <td style={{ width: "85px" }}>
                                <p style={{ fontSize: "0.999999em" }}>1128</p>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <p style={{ fontSize: "0.999999em" }}>
                                  Malappuram
                                </p>
                              </td>
                              <td>
                                <p style={{ fontSize: "0.999999em" }}>234</p>
                              </td>
                              <td style={{ width: "85px" }}>
                                <p style={{ fontSize: "0.999999em" }}>179</p>
                              </td>
                              <td style={{ width: "85px" }}>
                                <p style={{ fontSize: "0.999999em" }}>389</p>
                              </td>
                              <td style={{ width: "85px" }}>
                                <p style={{ fontSize: "0.999999em" }}>802</p>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <p style={{ fontSize: "0.999999em" }}>
                                  Kozhikode
                                </p>
                              </td>
                              <td>
                                <p style={{ fontSize: "0.999999em" }}>203</p>
                              </td>
                              <td style={{ width: "85px" }}>
                                <p style={{ fontSize: "0.999999em" }}>170</p>
                              </td>
                              <td style={{ width: "85px" }}>
                                <p style={{ fontSize: "0.999999em" }}>344</p>
                              </td>
                              <td style={{ width: "85px" }}>
                                <p style={{ fontSize: "0.999999em" }}>717</p>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <p style={{ fontSize: "0.999999em" }}>
                                  Wayanad
                                </p>
                              </td>
                              <td>
                                <p style={{ fontSize: "0.999999em" }}>285</p>
                              </td>
                              <td style={{ width: "85px" }}>
                                <p style={{ fontSize: "0.999999em" }}>209</p>
                              </td>
                              <td style={{ width: "85px" }}>
                                <p style={{ fontSize: "0.999999em" }}>468</p>
                              </td>
                              <td style={{ width: "85px" }}>
                                <p style={{ fontSize: "0.999999em" }}>962</p>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <p style={{ fontSize: "0.999999em" }}>Kannur</p>
                              </td>
                              <td>
                                <p style={{ fontSize: "0.999999em" }}>226</p>
                              </td>
                              <td style={{ width: "85px" }}>
                                <p style={{ fontSize: "0.999999em" }}>172</p>
                              </td>
                              <td style={{ width: "85px" }}>
                                <p style={{ fontSize: "0.999999em" }}>390</p>
                              </td>
                              <td style={{ width: "85px" }}>
                                <p style={{ fontSize: "0.999999em" }}>788</p>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <p style={{ fontSize: "0.999999em" }}>
                                  Kasargod
                                </p>
                              </td>
                              <td>
                                <p style={{ fontSize: "0.999999em" }}>157</p>
                              </td>
                              <td style={{ width: "85px" }}>
                                <p style={{ fontSize: "0.999999em" }}>131</p>
                              </td>
                              <td style={{ width: "85px" }}>
                                <p style={{ fontSize: "0.999999em" }}>276</p>
                              </td>
                              <td style={{ width: "85px" }}>
                                <p style={{ fontSize: "0.999999em" }}>564</p>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </section>

                      <p style={{ fontSize: "0.999999em" }}>&nbsp;</p>
                    </li>
                    <li>
                      <section id="Trees of Kerala">
                        <h5>Trees of Kerala</h5>
                        <p style={{ fontSize: "0.999999em" }}>
                          The spatial mapping of tree species in each districts
                          of Kerala are given in figures 1-14.and Table{" "}
                          <a href="#Table2">2</a>, <a href="#Table3">3</a>,{" "}
                          <a href="#Table4">4</a>
                          &nbsp;lists family-wise species for trees, shrubs and
                          herbs&nbsp; in Kerala state.
                          <br />
                          <a href="#Image1">
                            1. Spatial Distribution of Trees in
                            Thiruvananthapuram District
                          </a>
                          <br />
                          <a href="#Image2">
                            2. Spatial Distribution of Trees in Kollam District
                          </a>
                          <br />
                          <a href="#Image3">
                            3. Spatial Distribution of Trees in Pathanamthitta
                            District
                          </a>
                          <br />
                          <a href="#Image4">
                            4. Spatial Distribution of Trees in Alappuzha
                            District
                          </a>
                          <br />
                          <a href="#Image5">
                            5. Spatial Distribution of Trees in Kottayam
                            District
                          </a>
                          <br />
                          <a href="#Image6">
                            6. Spatial Distribution of Trees in Idukki District
                          </a>
                          <br />
                          <a href="#Image7">
                            7. Spatial Distribution of Trees in Ernakulam
                            District
                          </a>
                          <br />
                          <a href="#Image8">
                            8. Spatial Distribution of Trees in Thrissur
                            District
                          </a>
                          <br />
                          <a href="#Image9">
                            9. Spatial Distribution of Trees in Palakkad
                            District
                          </a>
                          <br />
                          <a href="#Image10">
                            10. Spatial Distribution of Trees in Malappuram
                            District
                          </a>
                          <br />
                          <a href="#Image11">
                            11. Spatial Distribution of Trees in Kozhikode
                            District
                          </a>
                          <br />
                          <a href="#Image12">
                            12. Spatial Distribution of Trees in Wayanad
                            District
                          </a>
                          <br />
                          <a href="#Image13">
                            13. Spatial Distribution of Trees in Kannur District
                          </a>
                          <br />
                          <a href="#Image14">
                            14. Spatial Distribution of Trees in Kasargod
                            District
                          </a>
                          <br />
                        </p>

                        <section id="Image1">
                          <p style={{ fontSize: "0.999999em" }}>
                            <img src="images/article/trees/1.png" alt="" />
                            <p style={{ fontSize: "0.999999em" }}>
                              {" "}
                              Figure 1: Map of spatial distribution of trees in
                              Thiruvananthapuram district{" "}
                            </p>
                          </p>
                        </section>
                        <p style={{ fontSize: "0.999999em" }}>&nbsp;</p>
                        <section id="Image2">
                          <p style={{ fontSize: "0.999999em" }}>
                            <img src="images/article/trees/2.png" alt="" />
                            <p style={{ fontSize: "0.999999em" }}>
                              Figure 2: Map of spatial distribution of trees in
                              Kollam district
                            </p>
                          </p>
                        </section>
                        <section id="Image3">
                          <p style={{ fontSize: "0.999999em" }}>&nbsp;</p>
                          <p style={{ fontSize: "0.999999em" }}>
                            <img src="images/article/trees/3.png" alt="" />
                            <p style={{ fontSize: "0.999999em" }}>
                              Figure 3: Map of spatial distribution of trees in
                              Pathanamthitta district
                            </p>
                          </p>
                        </section>
                        <p style={{ fontSize: "0.999999em" }}>&nbsp;</p>
                        <section id="Image4">
                          <p style={{ fontSize: "0.999999em" }}>
                            <img src="images/article/trees/4.png" alt="" />
                            <p style={{ fontSize: "0.999999em" }}>
                              Figure 4: Map of spatial distribution of trees in
                              Alappuzha district
                            </p>
                          </p>
                        </section>
                        <p style={{ fontSize: "0.999999em" }}>&nbsp;</p>
                        <section id="Image5">
                          <p style={{ fontSize: "0.999999em" }}>
                            <img src="images/article/trees/5.png" alt="" />
                            <p style={{ fontSize: "0.999999em" }}>
                              Figure 5: Map of spatial distribution of trees in
                              Kottayam district
                            </p>
                          </p>
                        </section>
                        <section id="Image6">
                          <p style={{ fontSize: "0.999999em" }}>&nbsp;</p>
                          <p style={{ fontSize: "0.999999em" }}>
                            <img src="images/article/trees/6.png" alt="" />
                            <p style={{ fontSize: "0.999999em" }}>
                              Figure 6: Map of spatial distribution of trees in
                              Idukki district
                            </p>
                          </p>
                        </section>
                        <section id="Image7">
                          {" "}
                          <p style={{ fontSize: "0.999999em" }}>&nbsp;</p>
                          <p style={{ fontSize: "0.999999em" }}>
                            <img src="images/article/trees/7.png" alt="" />
                            <p style={{ fontSize: "0.999999em" }}>
                              Figure 7: Map of spatial distribution of trees in
                              Ernakulam district
                            </p>
                          </p>
                        </section>
                        <p style={{ fontSize: "0.999999em" }}>&nbsp;</p>
                        <section id="Image8">
                          {" "}
                          <p style={{ fontSize: "0.999999em" }}>
                            <img src="images/article/trees/8.png" alt="" />
                            <p style={{ fontSize: "0.999999em" }}>
                              Figure 8: Map of spatial distribution of trees in
                              Thrissur district
                            </p>
                          </p>
                        </section>
                        <p style={{ fontSize: "0.999999em" }}>&nbsp;</p>
                        <section id="Image9">
                          <p style={{ fontSize: "0.999999em" }}>
                            <img src="images/article/trees/9.png" alt="" />
                            <p style={{ fontSize: "0.999999em" }}>
                              Figure 9: Map of spatial distribution of trees in
                              Palakkad district
                            </p>
                          </p>
                        </section>
                        <section id="Image10">
                          <p style={{ fontSize: "0.999999em" }}>&nbsp;</p>
                          <p style={{ fontSize: "0.999999em" }}>
                            <img src="images/article/trees/10.png" alt="" />
                            <p style={{ fontSize: "0.999999em" }}>
                              Figure 10: Map of spatial distribution of trees in
                              Malappuram district
                            </p>
                          </p>
                        </section>
                        <section id="Image11">
                          {" "}
                          <p style={{ fontSize: "0.999999em" }}>
                            <img src="images/article/trees/11.png" alt="" />
                            <p style={{ fontSize: "0.999999em" }}>
                              Figure 11: Map of spatial distribution of trees in
                              Kozhikode district
                            </p>
                          </p>
                        </section>
                        <p style={{ fontSize: "0.999999em" }}>&nbsp;</p>
                        <section id="Image12">
                          {" "}
                          <p style={{ fontSize: "0.999999em" }}>
                            <img src="images/article/trees/12.png" alt="" />
                            <p style={{ fontSize: "0.999999em" }}>
                              Figure 12: Map of spatial distribution of trees in
                              Wayanad district
                            </p>
                          </p>
                        </section>
                        <section id="Image13">
                          <p style={{ fontSize: "0.999999em" }}>
                            <img src="images/article/trees/13.png" alt="" />
                            <p style={{ fontSize: "0.999999em" }}>
                              Figure 13: Map of spatial distribution of trees in
                              Kannur district
                            </p>
                          </p>
                        </section>
                        <p style={{ fontSize: "0.999999em" }}>&nbsp;</p>
                        <section id="Image14">
                          <p style={{ fontSize: "0.999999em" }}>
                            <img src="images/article/trees/14.png" alt="" />
                            <p style={{ fontSize: "0.999999em" }}>
                              Figure 14: Map of spatial distribution of trees in
                              Kasargod district
                            </p>
                          </p>
                        </section>
                        <p style={{ fontSize: "0.999999em" }}>&nbsp;</p>
                        <p style={{ fontSize: "0.999999em" }}>&nbsp;</p>
                        <p style={{ fontSize: "0.999999em" }}>&nbsp;</p>
                        <section id="Table2">
                          <p style={{ fontSize: "0.999999em" }}>
                            <a name="_Toc165292930"></a>Table 2: Trees in Kerala
                          </p>
                          <table style={{ width: "80%" }}>
                            <tbody>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>PLANT NUMBER</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>SCIENTIFIC NAME</strong>
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>FAMILY</strong>
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>1</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Acacia catechu </em>(L.f.) Willd.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>2</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Acacia chundra</em> (Rottler) Willd.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>3</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Acacia dealbata</em> Link
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>4</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Acacia horrida</em> (L.) Willd.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>5</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Acacia leucophloea</em> (Roxb.) Willd.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>6</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Acacia mangium</em> Willd.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>7</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Acacia mearnsii</em> De Wilde
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>8</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Acacia melanoxylon</em> R.Br.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>9</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Acacia nilotica </em>(L.) Del.ssp.
                                    <em> indica </em>(Benth.) Brenan
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>10</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Acacia planifrons</em> Wight &amp; Arn.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>11</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Acacia polyacantha</em> Willd.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>12</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Acrocarpus fraxinifolius</em> Wight
                                    &amp; Arn.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>13</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Acronychia pedunculata</em> (L.) Miq.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Rutaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>14</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Actephila excelsa</em> (Dalzell)
                                    Mull.Arg
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Phyllanthaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>15</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Actinodaphne angustifolia</em> (Blume)
                                    Nees
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Lauraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>16</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Actinodaphne bourdillonii</em> Gamble
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Lauraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>17</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Actinodaphne bourneae</em> Gamble
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Lauraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>18</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Actinodaphne campanulata</em> J. Hk.
                                    var. <em>campanulata</em>
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Lauraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>19</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Actinodaphne lawsonii</em> Gamble
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Lauraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>20</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Actinodaphne maderaspatana</em> Bedd. ex
                                    Hook.f.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Lauraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>21</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Actinodaphne malabarica</em> N.P.Balakr.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Lauraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>22</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Actinodaphne salicina</em> Meisn.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Lauraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>23</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Actinodaphne tadulingamii</em> Gamble
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Lauraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>24</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Adansonia digitata</em> L.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Malvaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>25</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Adenanthera pavonina </em>L
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>26</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Aegle marmelos </em>(L.) Correa
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Rutaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>27</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Agasthiyamalai pauciflora</em> (Bedd.)
                                    S. Rajkumar &amp; Janarth.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Calophyllaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>28</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Aglaia apiocarpa</em> (Thwaites) Hiern
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Meliaceae&nbsp;
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>29</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Aglaia barberi</em> Gamble
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Meliaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>30</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Aglaia bourdillonii</em> Gamble
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Meliaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>31</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Aglaia edulis</em> (Roxb.) Wall
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Meliaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>32</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Aglaia elaeagnoidea</em> (A.Juss.)
                                    Benth.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Meliaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>33</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Aglaia lawii</em> (Wight) C.J.Saldanha
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Meliaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>34</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Aglaia malabarica</em> Sasidh.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Meliaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>35</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Aglaia perviridis</em> Hiern
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Meliaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>36</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Aglaia simplicifolia</em> (Bedd.) Harms
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Meliaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>37</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Aglaia tomentosa</em> Teijsm. &amp;
                                    Binn.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Meliaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>38</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Agrostistachys borneensis</em> Becc.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Euphorbiaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>39</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Ailanthus excelsa </em>Roxb
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    &nbsp;Simaroubaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>40</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Ailanthus integrifolia</em> subsp.{" "}
                                    <em>calycina</em> (Pierre) Noot
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Simaroubaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>41</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Ailanthus triphysa</em> (Dennst.) Alston
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    &nbsp;Simaroubaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>42</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Alangium salviifolium </em>(L. f.) Wang.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Cornaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>43</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Albizia amara </em>(Roxb.) B.Boivin
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae&nbsp;
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>44</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Albizia chinensis</em> (Osbeck) Merr.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>45</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Albizia lathamii</em> Hole
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>46</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Albizia lebbeck</em> (L.) Benth.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>47</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Albizia odoratissima</em> (L.f.) Benth.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>48</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Albizia procera</em> (Roxb.) Benth.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>49</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Aleurites moluccanus</em> (L.) Willd.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Euphorbiaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>50</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Alnus nepalensis</em> D.Don
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Betulaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>51</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Alphonsea sclerocarpa</em> Thwaites
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Annonaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>52</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Alseodaphne semecarpifolia</em> Nees
                                    var. <em>angustifolia</em> Meisner
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Lauraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>53</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Alseodaphne semecarpifolia</em> Nees
                                    var. <em>semecarpifolia</em>
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Lauraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>54</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>
                                      Alstonia macrophylla Wall. &amp; G.Don{" "}
                                    </em>
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Apocynaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>55</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Alstonia scholaris</em> (L.) R.Br.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Apocynaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>56</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Amherstia nobilis</em> Wall.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>57</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Anacardium occidentale </em>L.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Anacardiaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>58</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Anacolosa densiflora</em> Bedd.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Olacaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>59</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Annona cherimola</em> Mill.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Annonaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>60</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Annona glabra</em> L.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Annonaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>61</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Annona muricata </em>L.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Annonaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>62</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Annona reticulata </em>L.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Annonaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>63</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Annona squamosa </em>L.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Annonaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>64</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Anogeissus latifolia </em>(Roxb. ex DC.)
                                    Wall. ex Guill. &amp; Perr.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Combretaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>65</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Antiaris toxicaria </em>Lesch.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Moraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>66</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Antidesma alexiteria</em> L.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Phyllanthaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>67</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Antidesma bunius</em> (L.) Spreng.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Phyllanthaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>68</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Antidesma ghaesembilla</em> Gaertn.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Phyllanthaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>69</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Antidesma montanum</em> Blume
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Phyllanthaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>70</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Aphanamixis polystachya </em>(Wall.) R.
                                    Parker
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Meliaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>71</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Aphananthe cuspidata</em> (Bl.) Planch.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Ulmaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>72</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Apodytes dimidiata</em> E.Mey. ex Arn.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Icacinaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>73</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Apollonias arnottii</em> Nees
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Lauraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>74</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Aporosa acuminata</em> Thwaites
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Phyllanthaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>75</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Aporosa bourdillonii</em> Stapf
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Phyllanthaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>76</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Aporosa cardiosperma </em>(Gaertn.)
                                    Merr.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Phyllanthaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>77</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Aporosa fusiformis</em> Thwaites
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Phyllanthaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>78</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Aquilaria malaccensis</em> Lam
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Thymelaeaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>79</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Archidendron bigeminum </em>(L.) Neilson
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>80</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Archidendron clypearia</em> (Jack)
                                    I.C.Nielsen
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>81</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Ardisia depressa</em> C.B.Cl
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Primulaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>82</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Ardisia rhomboidea</em> Wight
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Primulaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>83</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Ardisia solanacea</em> (Poir.) Roxb.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Primulaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>84</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Areca catechu</em> L.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Arecaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>85</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Arenga wightii</em> Griff.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Arecaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>86</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Artocarpus gomezianus</em> subsp.{" "}
                                    <em>zeylanicus</em> Jarrett
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Moraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>87</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Artocarpus heterophyllus </em>Lam.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Moraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>88</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Artocarpus hirsutus </em>Lam.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Moraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>89</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Artocarpus incisus</em> (Thunb.)
                                    L.f.&nbsp;
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Moraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>90</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Atalantia monophylla</em> (L.) Corr.
                                    Serr.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Rutaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>91</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Atalantia racemosa </em>var.{" "}
                                    <em>bourdillonii</em> K.Narayanan &amp;
                                    M.P.Nayar
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Rutaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>92</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Atuna indica </em>(Bedd.) Kosterm
                                    <em>. </em>
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Chrysobalanaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>93</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Atuna travancorica </em>(Bedd.) Kosterm.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Chrysobalanaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>94</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Averrhoa bilimbi </em>L.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Oxalidaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>95</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Averrhoa carambola </em>L.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Oxalidaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>96</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Avicennia marina</em>
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Acanthaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>97</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Avicennia officinalis </em>L.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Acanthaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>98</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Azadirachta indica </em>A.Juss.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Meliaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>99</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>
                                      Baccaurea courtallensis (Wight)
                                      Muell.-Arg.{" "}
                                    </em>
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Euphorbiaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>100</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Baccaurea motleyana</em> (Muell.-Arg.)
                                    Muell.-Arg.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Euphorbiaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>101</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Bambusa vulgaris </em>Schrad. ex
                                    J.C.Wendl.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Poaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>102</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Barringtonia acutangula</em> (L.)
                                    Gaertn.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Lecythidaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>103</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Barringtonia racemosa</em> (L.) Spreng.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Lecythidaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>104</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Bauhinia malabarica</em> Roxb.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>105</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Bauhinia purpurea </em>L.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae&nbsp;
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>106</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Bauhinia racemosa</em> Lam
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>107</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Bauhinia variegata</em> L.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>108</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Beilschmiedia bourdillonii</em> Brandis
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Lauraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>109</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Beilschmiedia wightii</em> (Nees) Benth.
                                    ex Hook. f.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Lauraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>110</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Benkara malabarica</em> (Lam.) Tirveng.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Rubiaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>111</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Bentinckia condapanna</em> Berry ex
                                    Roxb.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Arecaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>112</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Berrya cordifolia</em> (Willd.) Burret
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Malvaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>113</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Berrya javanica</em> (Turcz.)
                                    Burret&nbsp;
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Malvaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>114</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Bhesa indica</em> (Bedd.) Ding Hou
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Celastraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>115</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Bischofia javanica</em> Blume
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Phyllanthaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>116</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Bixa orellana </em>L.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Bixaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>117</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Blachia andamanica</em> (Kurz) Hook.f.
                                    ssp. <em>denudata</em> (Benth.) N.P.Balakr.
                                    &amp; Chakrab.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Euphorbiaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>118</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Blachia umbellata</em> (Willd.) Baill.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Euphorbiaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>119</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Blepharistemma serratum</em> (Dennst.)
                                    Suresh
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Rhizophoraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>120</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Blighia sapida</em> K.D.Koenig&nbsp;
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Sapindaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>121</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Bombax ceiba</em> L.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Malvaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>122</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Bombax insigne</em> Wall.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Malvaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>123</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Borassus flabellifer </em>L.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Arecaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>124</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Boswellia serrata</em> Roxb. ex Colebr.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Burseraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>125</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Bridelia retusa </em>(L.) A.Juss.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Phyllanthaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>126</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Broussonetia papyrifera</em> (L.) Vent.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Moraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>127</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Brownea grandiceps</em> Jacq.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>128</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Brucea javanica</em> (L.) Merr.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Simaroubaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>129</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Bruguiera cylindrica</em> (L.) Blume
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Rhizophoraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>130</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Bruguiera gymnorrhiza</em> (L.) Lam.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Rhizophoraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>131</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Bruguiera sexangula</em> (Lour.) Poir.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Rhizophoraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>132</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Buchanania axillaris</em> (Desr.)
                                    Ramamoorthy
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Anacardiaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>133</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Buchanania barberi</em> Gamble
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Anacardiaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>134</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Buchanania lanceolata</em> Wight
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Anacardiaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>135</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Buchanania lanzan</em> Spreng
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Anacardiaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>136</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Butea monosperma </em>(Lam.) Taub.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>137</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Caesalpinia coriaria</em> (Jacq.) Willd.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>138</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Caesalpinia sappan </em>L.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>139</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Callicarpa tomentosa </em>(L.) L.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Lamiaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>140</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Calophyllum austroindicum</em>{" "}
                                    Kostermans ex P.F.Stevens
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Calophyllaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>141</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Calophyllum calaba</em> L.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Calophyllaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>142</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Calophyllum inophyllum </em>L.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Clusiaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>143</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Calophyllum polyanthum</em> Wall. ex
                                    Choisy
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Calophyllaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>144</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Cananga odorata</em> (Lam.) Hook.f.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Annonaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>145</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Canarium strictum </em>Roxb.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Burseraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>146</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Canarium vulgare</em> Leenh.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Burseraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>147</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Canthium travancoricum</em> (Bedd.)
                                    Hook.f.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Rubiaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>148</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Capparis divaricata</em> Lam.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Capparaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>149</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Capparis grandis</em> L.f.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Capparaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>150</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Carallia brachiata</em> (Lour.) Merr.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Rhizophoraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>151</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Careya arborea </em>Roxb.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Lecythidaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>152</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Carica papaya </em>L.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Caricaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>153</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Caryota urens </em>L.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Arecaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>154</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Cascabela thevetia</em> (L.) Lippold
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Apocynaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>155</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Casearia bourdillonii</em> N. Mukh.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Salicaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>156</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Casearia glomerata</em> Roxb.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Salicaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>157</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Casearia graveolens</em> Dalz.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Salicaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>158</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Casearia ovata</em> (Lam.) Willd.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Salicaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>159</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Casearia rubescens</em> Dalz.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Salicaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>160</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Casearia thwaitesii</em> Briq.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Salicaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>161</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Casearia tomentosa</em> Roxb.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Salicaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>162</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Casearia wynadensis</em> Bedd.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Salicaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>163</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Casimiroa edulis</em> La Llave
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Rutaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>164</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Cassia fistula </em>&nbsp;L.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>165</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Cassia grandis</em> L.f.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>166</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Cassia javanica</em> subsp.{" "}
                                    <em>nodosa</em> (Roxb.) K.Larsen &amp;
                                    S.S.Larsen
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>167</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Cassia roxburghii</em> DC.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>168</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Cassine albens</em> (Retz.) A.J.G.H.
                                    Kostermans
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Celastraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>169</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Cassine kedarnathii</em> N. Sasidharan
                                    &amp; K. Swarupanandan
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Celastraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>170</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Cassine paniculata</em> (Wight &amp;
                                    Arn.) Lobr.-Callen
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Celastraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>171</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Castanospermum australe</em> A.Cunn.
                                    &amp; C.Fraser
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>172</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Castilla elastica</em> Cerv.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Moraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>173</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Casuarina equisetifolia</em> L.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Casuarinaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>174</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Catunaregam spinosa</em> (Thunb.)
                                    Tirveng.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Rubiaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>175</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Celtis philippensis</em>{" "}
                                    <em>wightii</em> (Planch.) E. Soepadmo
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Cannabaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>176</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Celtis tetrandra</em> Roxb.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Cannabaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>177</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Celtis timorensis</em> Span.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Cannabaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>178</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Cerbera odollam</em> Gaertn.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Apocynaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>179</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Ceriops tagal</em> (Perr.) C.B. Robins.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Rhizophoraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>180</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Chionanthus albidiflorus</em> Thwaites
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Oleaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>181</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Chionanthus</em> <em>mala-elengi</em>{" "}
                                    subsp. <em>linocieroides</em> (Wight)
                                    P.S.Green
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Oleaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>182</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Chionanthus mala-elengi</em> subsp.{" "}
                                    <em>mala-elengi</em>
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Oleaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>183</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Chionanthus ramiflorus</em> Roxb.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Oleaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>184</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Chionanthus zeylanica</em> L.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Oleaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>185</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Chloroxylon swietenia</em> DC
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Rutaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>186</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Chrysophyllum cainito </em>L.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Sapotaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>187</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Chrysophyllum roxburghii</em> G.Don
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Sapotaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>188</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Chukrasia tabularis </em>A. Juss
                                    <em>.</em>
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Meliaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>189</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Cinchona calisaya</em> Wedd.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Rubiaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>190</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Cinnamomum camphora </em>(L.) J.Presl
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Lauraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>191</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Cinnamomum chemungianum</em> M.Mohanan
                                    &amp; A.N.Henry
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Lauraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>192</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Cinnamomum filipedicellatum</em>{" "}
                                    Kosterm.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Lauraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>193</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Cinnamomum heyneanum</em> Nees
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Lauraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>194</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Cinnamomum keralaense</em> Kosterm.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Lauraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>195</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Cinnamomum macrocarpum</em> Hook.f.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Lauraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>196</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Cinnamomum malabatrum </em>(Burm.f.)
                                    J.Presl
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Lauraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>197</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Cinnamomum nicolsonianum</em> Manilal et
                                    Shylaja
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Lauraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>198</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Cinnamomum palghatensis</em> M.Gangop.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Lauraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>199</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Cinnamomum perrottetii</em> Meisn.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Lauraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>200</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Cinnamomum riparium</em> Gamble
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Lauraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>201</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Cinnamomum sulphuratum</em> Nees
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Lauraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>202</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Cinnamomum travancoricum</em> Gamble
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Lauraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>203</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Cinnamomum verum </em>J.Presl
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Lauraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>204</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Cinnamomum walaiwarense</em> Kosterm.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Lauraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>205</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Cinnamomum wightii</em> Meisner
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Lauraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>206</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Citharexylum spinosum</em> L.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Verbenaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>207</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Citrus aurantiifolia</em> (Christm.)
                                    Swingle
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Rutaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>208</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Citrus aurantium</em> L.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Rutaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>209</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Citrus limetta</em> Risso
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Rutaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>210</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Citrus limon </em>(L.) Osbeck
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Rutaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>211</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Citrus maxima </em>(Burm.) Merr.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Rutaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>212</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Citrus pennivesiculata</em> (Lush.)
                                    Yu.Tanaka
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Rutaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>213</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Citrus reticulata</em> Blanco
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Rutaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>214</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Citrus sinensis</em> (L.) Osbeck
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Rutaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>215</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Clausena indica</em> (Dalzell) Oliver
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Rutaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>216</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Cleidion javanicum</em> Blume
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Euphorbiaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>217</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Cleistanthus collinus </em>(Roxb.)
                                    Benth. ex Hook. f.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Euphorbiaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>218</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Cleistanthus malabaricus</em>{" "}
                                    (M&uuml;ll.Arg.) M&uuml;ll.Arg.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Euphorbiaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>219</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Cleistanthus patulus</em> (Roxb.)
                                    M&uuml;ll.Arg.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Euphorbiaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>220</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Cleistanthus travancorensis</em> Jabl.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Phyllanthaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>221</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Cocculus laurifolius</em> DC.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Menispermaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>222</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Cochlospermum religiosum</em> (L.)
                                    Alston
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Bixaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>223</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Cocos nucifera </em>L.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Arecaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>224</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Commiphora berryi</em> (Arn.) Engl.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Burseraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>225</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Commiphora caudata </em>(Wight &amp;
                                    Arn.) Engl.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Burseraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>226</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Commiphora caudata</em> var.{" "}
                                    <em>pubescens</em> (Wight &amp; Arn.)
                                    K.M.Matthew&nbsp;
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Burseraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>227</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Cordia dichotoma</em> G. Forst.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Boraginaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>228</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Cordia monoica</em> Roxb.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Boraginaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>229</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Cordia octandra</em> A.DC.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Boraginaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>230</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Cordia sebestena</em> L.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Boraginaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>231</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Cordia sinensis</em> Lam.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Boraginaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>232</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Cordia wallichii </em>G. Don
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Boraginaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>233</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Corymbia citriodora</em> (Hook.)
                                    K.D.Hill &amp; L.A.S.Johnson
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Myrtaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>234</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Corymbia torelliana</em> (F.Muell.)
                                    K.D.Hill &amp; L.A.S.Johnson
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Myrtaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>235</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Corypha umbraculifera </em>L.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Arecaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>236</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Couroupita guianensis</em> Aublet
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Lecythidaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>237</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Crateva adansonii</em> subsp.{" "}
                                    <em>odora</em> (Buch.-Ham.) Jacobs
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Capparaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>238</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Crateva magna </em>(Lour.) DC.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Capparaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>239</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Crescentia cujete</em> L.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Bignoniaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>240</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Croton laccifer</em> L.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Euphorbiaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>241</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Croton malabaricus</em> Bedd.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Euphorbiaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>242</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Croton persimilis </em>M&uuml;ll.Arg.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Euphorbiaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>243</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Croton tiglium </em>L.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Euphorbiaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>244</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Cryptocarya anamalayana</em> Gamble
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Lauraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>245</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Cryptocarya beddomei</em> Gamble
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Lauraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>246</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Cryptocarya lawsonii</em> Gamble
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Lauraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>247</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Cryptocarya muthuvariana</em> R. Jagad.,
                                    Sureshkumar, Gangapr. &amp; S.P. Mathew
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Lauraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>248</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Cryptocarya praetervisa</em>{" "}
                                    M.G.Gangop., Chakrab. &amp; A.S.Chauhan
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Lauraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>249</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Cryptocarya sheikelmudiyana</em> A.K.H.
                                    Bachan &amp; P.K. Fasila
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Lauraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>250</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Cryptocarya stocksii</em> Meisn.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Lauraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>251</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Cryptocarya wightiana</em> Thwaites
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Lauraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>252</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Cullenia exarillata</em> Robyns
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Bombacaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>253</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Cyathocalyx zeylanicus</em> Champ. ex
                                    Hook.f. &amp; Thomson
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Annonaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>254</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Cynometra beddomei</em> Prain
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>255</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Cynometra travancorica</em> Bedd.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>256</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Dalbergia lanceolaria</em> L.f.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>257</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Dalbergia lanceolaria</em> subsp.{" "}
                                    <em>paniculata</em> (Roxb.)Thoth.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>258</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Dalbergia latifolia</em> Roxb.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>259</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Dalbergia sericea</em> G.Don
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>260</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Dalbergia sissoides</em> Graham ex Wight
                                    &amp; Arn.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>261</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Dalbergia sissoo</em> Roxb.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>262</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Daphniphyllum neilgherrense</em> (Wight)
                                    K.Rosenthal
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Daphniphyllaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>263</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Debregeasia wallichiana</em> (Wedd.)
                                    Wedd.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Urticaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>264</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Debregeasia wallichiana</em> subsp.{" "}
                                    <em>ceylanica</em> (Hook.f.) Wilmot-Dear
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Urticaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>265</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Delonix elata</em> (L.) Gamble
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>266</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Delonix regia </em>
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>267</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Dendrocnide sinuata</em> (Blume) Chew
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Urticaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>268</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Desmodium oojeinense</em> (Roxb.)
                                    H.Ohashi
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>269</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Dialium travancoricum</em> Bourd.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>270</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Dichrostachys cinerea</em> (L.) Wight.
                                    &amp; Arn.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>271</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Dillenia bracteata</em> Wight
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Dilleniaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>272</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Dillenia indica</em> L.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Dilleniaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>273</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Dillenia pentagyna </em>Roxb.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Dilleniaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>274</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Dillenia suffruticosa</em> (Griff.)
                                    Martelli
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Dilleniaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>275</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Dimocarpus longan</em> Lour.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Sapindaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>276</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Dimorphocalyx beddomei</em> (Benth.)
                                    Airy Shaw
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Euphorbiaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>277</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Dimorphocalyx glabellus</em> Thwaites
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Euphorbiaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>278</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Dimorphocalyx glabellus</em> var.{" "}
                                    <em>lawianus</em> (Hook.f.) Chakrab. &amp;
                                    N.P.Balakr.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Euphorbiaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>279</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Diospyros barberi</em> Ramaswami
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Ebenaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>280</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Diospyros bourdillonii</em> Brandis
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Ebenaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>281</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Diospyros buxifolia</em> (Blume) Hiern
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Ebenaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>282</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Diospyros candolleana</em> Wight
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Ebenaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>283</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Diospyros crumenata</em> Thwaites
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Ebenaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>284</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Diospyros discolor</em> Willd.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Ebenaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>285</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Diospyros ebenum</em> J.Koenig ex Retz.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Ebenaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>286</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Diospyros foliolosa</em> Wall. ex A.DC
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Ebenaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>287</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Diospyros ghatensis</em> B.R.Ramesh
                                    &amp; D.De Franceschi
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Ebenaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>288</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Diospyros hirsuta</em> L.f.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Ebenaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>289</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Diospyros malabarica</em> (Desr.)
                                    Kostel.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Ebenaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>290</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Diospyros melanoxylon</em> Roxb.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Ebenaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>291</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Diospyros melanoxylon</em> var.{" "}
                                    <em>tupru</em> (Buch.-Ham.) V.Singh
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Ebenaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>292</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Diospyros montana </em>Roxb.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Ebenaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>293</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Diospyros nilagirica</em> Bedd.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Ebenaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>294</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Diospyros oocarpa</em> Thwaites
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Ebenaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>295</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Diospyros ovalifolia</em> Wight
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Ebenaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>296</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Diospyros paniculata</em> Dalzell
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Ebenaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>297</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Diospyros pruriens</em> Dalzell
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Ebenaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>298</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Diospyros ridleyi</em> Bakh.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Ebenaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>299</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Diospyros saldanhae</em> Kostermans
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Ebenaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>300</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Diospyros sulcata</em> Bourd.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Ebenaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>301</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Diospyros sylvatica</em> Roxb.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Ebenaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>302</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Diospyros toposia </em>Buch.-Ham.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Ebenaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>303</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Diospyros trichophylla</em> Alston
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Ebenaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>304</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Dipterocarpus bourdillonii</em> Brandis
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Dipterocarpaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>305</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Dipterocarpus indicus</em> Bedd
                                    <em>. </em>
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Dipterocarpaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>306</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Discospermum sphaerocarpum</em> Dalzell
                                    ex Hook.f.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Rubiaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>307</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Dolichandrone arcuata</em> (Wight)
                                    Clarke
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Bignoniaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>308</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Dolichandrone atrovirens</em> (Roth)
                                    Sprague
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Bignoniaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>309</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Dolichandrone spathacea</em> (L. f.)
                                    K.Schum.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Bignoniaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>310</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Drypetes confertiflora</em> (Hook.f.)
                                    Pax &amp; K.Hoffm.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Putranjivaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>311</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Drypetes gardneri</em> (Thwaites) Pax
                                    &amp; K.Hoffm.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Putranjivaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>312</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Drypetes malabarica</em> (Bedd.) Airy
                                    Shaw
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Putranjivaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>313</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Drypetes oblongifolia</em> (Bedd.) Airy
                                    Shaw
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Putranjivaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>314</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Drypetes sepiaria</em> (Wight &amp;
                                    Arn.) Pax &amp; K.Hoffm.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Putranjivaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>315</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Drypetes venusta</em> (Wight) Pax &amp;
                                    K.Hoffm.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Putranjivaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>316</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Drypetes wightii</em> (Hook.f.) Pax
                                    &amp; K.Hoffm
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Putranjivaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>317</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Durio zibethinus</em> L.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Malvaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>318</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Dysoxylum beddomei</em> Hiern
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Meliaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>319</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Dysoxylum gotadhora</em> (Buch.-Ham.)
                                    Mabb.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Meliaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>320</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Dysoxylum malabaricum </em>Bedd. ex C.DC
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Meliaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>321</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Dysoxylum swaminathanianum</em> Anil
                                    Kumar &amp; Sivad.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Meliaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>322</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Ehretia aspera</em> Willd.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Boraginaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>323</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Ehretia matthewii</em> Kottaim.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Boraginaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>324</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Elaeis guineensis</em> Jacq.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Arecaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>325</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Elaeocarpus munronii</em> (Wight)
                                    Masters
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Elaeocarpaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>326</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Elaeocarpus recurvatus</em> Corner
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Elaeocarpaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>327</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Elaeocarpus serratus</em> L.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Elaeocarpaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>328</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Elaeocarpus serratus</em> var.{" "}
                                    <em>weibelii</em> Zmarzty
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Elaeocarpaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>329</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Elaeocarpus sphaericus</em> (Gaertn.)
                                    Heer
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Elaeocarpaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>330</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Elaeocarpus tuberculatus </em>Roxb.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Elaeocarpaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>331</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Elaeocarpus variabilis</em> Zmarzty
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Elaeocarpaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>332</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Elaeocarpus venustus</em> Bedd.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Elaeocarpaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>333</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Ellipanthus tomentosus</em> Kurz
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Connaraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>334</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Enterolobium cyclocarpum</em> (Jacq.)
                                    Griseb.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>335</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Epiprinus mallotiformis</em>{" "}
                                    (M&uuml;ll.Arg.) Croizat
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Euphorbiaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>336</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Eriolaena hookeriana </em>Wight &amp;
                                    Arn
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Malvaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>337</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Eriolaena lushingtonii</em> Dunn
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Malvaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>338</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Eriolaena quinquelocularis</em> (Wight
                                    &amp; Arn.) Wight
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Malvaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>339</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Erythrina fusca</em> Lour.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>340</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Erythrina stricta </em>Roxb.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>341</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Erythrina suberosa</em> Roxb.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>342</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>
                                      Erythrina subumbrans (Hassk.) Merr.{" "}
                                    </em>
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>343</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Erythrina sykesii</em> Barneby &amp;
                                    Krukoff
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>344</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Erythrina variegata</em> L.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>345</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Erythroxylum lanceolatum</em> (Wight)
                                    Walp.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Erythroxylaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>346</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Erythroxylum monogynum</em> Roxb.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Erythroxylaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>347</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Erythroxylum moonii</em> Hochr.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Erythroxylaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>348</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Erythroxylum obtusifolium</em> (Wight)
                                    Hook.f.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Erythroxylaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>349</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Eucalyptus globulus</em> Labill.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Myrtaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>350</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Eucalyptus tereticornis</em> Sm.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Myrtaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>351</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Eugenia agasthiyamalayana</em> Gopalan
                                    &amp; Murugan
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Myrtaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>352</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Eugenia argentea</em> Bedd.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Myrtaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>353</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Eugenia codyensis</em> Munro ex Wight
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Myrtaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>354</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Eugenia discifera</em> Gamble
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Myrtaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>355</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Eugenia floccosa</em> Bedd.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Myrtaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>356</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Eugenia indica</em> (Wight) Chithra
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Myrtaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>357</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Eugenia rottleriana </em>Wight &amp;
                                    Arn.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Myrtaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>358</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Eugenia roxburghii</em> DC.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Myrtaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>359</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Eugenia singampattiana</em> Bedd.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Myrtaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>360</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Eugenia terpnophylla</em> Thwaites
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Myrtaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>361</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Euonymus crenulatus</em> Wall. ex Wight
                                    &amp; Arn.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Celastraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>362</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Euonymus dichotomus</em> Heyne ex
                                    Wallich
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Celastraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>363</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Euonymus indicus </em>Heyne ex Roxb.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Celastraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>364</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Eurya japonica</em> Thunb.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Theaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>365</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Eurya nitida</em> Korth
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Theaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>366</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Excoecaria agallocha</em> L.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Euphorbiaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>367</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Excoecaria oppositifolia</em> var.{" "}
                                    <em>crenulata</em> (Wight) Chakrab. &amp;
                                    M.Gangop.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Euphorbiaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>368</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Falcataria moluccana </em>(Miq.) Barneby
                                    &amp; J.W.Grimes
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>369</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Ficus benghalensis </em>L.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Moraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>370</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Ficus microcarpa </em>L.f.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Moraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>371</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Ficus racemosa</em> L.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Moraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>372</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Ficus religiosa </em>L.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Moraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>373</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Flacourtia montana </em>J.Graham
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Salicaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>374</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Garcinia gummi-gutta</em> (L.) Roxb.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Clusiaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>375</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Gmelina arborea </em>Roxb.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Lamiaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>376</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Grewia tiliifolia </em>Vahl
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Malvaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>377</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Haldina cordifolia </em>(Roxb.) Ridsdale
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Rubiaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>378</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Harpullia arborea </em>(Blanco) Radlk.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Sapindaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>379</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Heptapleurum chandrasekharanii (</em>
                                    Ramam. &amp; Rajan) Lowry &amp; G.M.Plunkett
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Araliaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>380</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Holarrhena pubescens </em>Wall. ex G.
                                    Don
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Apocynaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>381</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Holoptelea integrifolia </em>(Roxb.)
                                    Planch
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Ulmaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>382</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Hydnocarpus macrocarpa </em>Warb.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Achariaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>383</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Hydnocarpus pentandrus </em>
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Achariaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>384</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Ilex gardneriana</em> Wight
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Aquifoliaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>385</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Julostylis ampumalensis</em> Pradeep
                                    &amp; Sivar.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Malvaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>386</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Julostylis angustifolia</em> Thwaites
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Malvaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>387</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Julostylis polyandra</em> Ravi &amp;
                                    Anil Kumar
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Malvaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>388</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Kandelia candel</em> (L.) Druce
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Rhizophoraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>389</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Kingiodendron pinnatum </em>(DC.) Harms
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae&nbsp;
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>390</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Knema attenuata </em>Warb.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Myristicaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>391</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Kydia calycina</em> Roxb.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Malvaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>392</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Lagerstroemia speciosa </em>(L.) Pers.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Lythraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>393</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Lannea coromandelica</em> (Houtt.) Merr.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Anacardiaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>394</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Madhuca longifolia latifolia </em>
                                    (Roxb.) A. Chev.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Sapotaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>395</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Madhuca neriifolia </em>(Moon) H. J. Lam
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Sapotaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>396</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Magnolia champaca </em>
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Magnoliaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>397</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Mallotus philippensis </em>(Lam.)
                                    M&uuml;ll.Arg.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Euphorbiaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>398</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Mangifera indica </em>L.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Anacardiaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>399</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Manilkara zapota </em>(L.) P.Royen
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Sapotaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>400</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Mastixia arborea</em> ssp.{" "}
                                    <em>arborea</em>
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Cornaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>401</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Mastixia arborea </em>subsp
                                    <em>. meziana </em>(Wangerin) K.M.Matthew ex
                                    Ramamoorthy
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Cornaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>402</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Melicope lunu-ankenda</em> (Gaertn.)
                                    T.G.Hartley
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Rutaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>403</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Mesua ferrea </em>var.<em> ferrea </em>
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Calophyllaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>404</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Mimusops elengi </em>L.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Sapotaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>405</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Morinda citrifolia </em>L.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Rubiaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>406</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Moringa pterygosperma </em>Gaertn.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Moringaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>407</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Murraya koenigii </em>
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Rutaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>408</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Myristica beddomei </em>King
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Myristicaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>409</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Myristica fragrans </em>
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Myristicaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>410</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Myristica malabarica </em>Lam.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Myristicaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>411</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Naringi crenulata</em> (Roxb.) Nicolson
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Rutaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>412</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Neolamarckia cadamba </em>(Roxb.) Bosser
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Rubiaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>413</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Neolitsea cassia</em> (L.) Kosterm.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Lauraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>414</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Neolitsea fischeri</em> Gamble
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Lauraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>415</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Neonauclea purpurea</em> (Roxb.) Merr.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Rubiaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>416</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Nephelium lappaceum</em> L.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Sapindaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>417</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Nothapodytes nimmoniana </em>(J.Graham)
                                    Mabb.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Icacinaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>418</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Nothopegia aureofulva</em> Bedd. ex
                                    Hook.f.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Anacardiaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>419</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Nothopegia beddomei</em> Gamble
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Anacardiaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>420</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Nothopegia heyneana</em> (Hook. f.)
                                    Gamble
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Anacardiaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>421</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Nothopegia monadelpha</em> (Roxb.)
                                    Forman
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Anacardiaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>422</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Nothopegia racemosa</em> (Dalz.) T.P.
                                    Ramamoorthy
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Anacardiaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>423</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Nothopegia travancorica</em> Bedd. ex
                                    Hook.f.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Anacardiaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>424</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Nyctanthes arbor-tristis</em> L.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Oleaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>425</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Oroxylum indicum </em>(L.) Kurz
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Bignoniaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>426</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Persea macrantha </em>(Nees) Kosterm
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Lauraceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>427</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Phyllanthus emblica </em>L.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Phyllanthaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>428</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Polyalthia shendurunii</em> Basha &amp;
                                    Sasidharan
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Annonaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>429</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Pongamia pinnata </em>(L.) Pierre
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae&nbsp;
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>430</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Psidium guajava </em>L<em>.</em>
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Myrtaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>431</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Pterocarpus marsupium </em>Roxb.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae&nbsp;
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>432</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Pterocarpus santalinus </em>L.f.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae&nbsp;
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>433</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Pterospermum rubiginosum </em>Heyne
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Malvaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>434</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Putranjiva roxburghii </em>Wall.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Putranjivaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>435</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Quassia indica</em> (Gaertn.) Noot
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Simaroubaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>436</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Sageraea laurina</em> Dalzell
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Annonaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>437</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Sageraea thwaitesii</em> Hook. f. &amp;
                                    Thomson
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Annonaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>438</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Salix tetrasperma </em>Roxb.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Salicaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>439</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Santalum album</em> L.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Santalaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>440</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Saraca ashoca </em>
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>441</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Senegalia ferruginea (DC.) Pedley</em>.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>442</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Sesbania grandiflora </em>(L.) Poir.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>443</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Simarouba amara </em>Aubl.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Simaroubaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>444</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Spondias pinnata </em>(L. f.) Kurz
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Anacardiaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>445</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Sterculia guttata </em>Roxb.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Malvaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>446</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Stereospermum colais</em> var.{" "}
                                    <em>colais</em>
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Bignoniaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>447</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Strychnos nux-vomica </em>L.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Loganiaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>448</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Strychnos potatorum </em>L.f.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Loganiaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>449</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Symplocos cochinchinensis </em>ssp.
                                    <em> laurina</em>
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Symplocaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>450</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Symplocos racemosa </em>Roxb.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Symplocaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>451</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Syzygium aromaticum </em>(L.) Merr.
                                    &amp; L.M.Perry
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Myrtaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>452</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Syzygium cumini </em>var.
                                    <em> cumini </em>
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Myrtaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>453</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Syzygium gardneri</em> Thw.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Myrtaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>454</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Tabernaemontana alternifolia</em> L.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Apocynaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>455</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Tamarindus indica </em>L.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae&nbsp;
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>456</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Terminalia arjuna </em>(Roxb. ex DC.)
                                    Wight &amp; Arn.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Combretaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>457</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Terminalia bellirica </em>(Gaertn.)
                                    Roxb.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Combretaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>458</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Terminalia catappa </em>L.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Combretaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>459</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Terminalia chebula </em>Retz.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Combretaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>460</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Thespesia populnea </em>(L.) Sol. ex
                                    Corr&ecirc;a
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Malvaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>461</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Toona ciliata </em>M.Roem.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Meliaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>462</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Vachellia farnesiana</em> (L.) Wight
                                    &amp; Arn.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>463</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Vateria indica</em> L.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Dipterocarpaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>464</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Vitex altissima</em> L.f.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Lamiaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>465</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Vitex negundo </em>L.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Lamiaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>466</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Walsura trifolia</em> (A. Juss.) Harms.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Meliaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>467</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Wendlandia bicuspidata</em> Wight &amp;
                                    Arn.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Rubiaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>468</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Wendlandia thyrsoidea</em> (Roem. &amp;
                                    Schult.) Steud.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Rubiaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>469</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Wrightia arborea</em> (Dennst.) Mabb.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Apocynaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>470</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Wrightia tinctoria </em>R. Br.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Apocynaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>471</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Xanthophyllum arnottianum</em> Wight
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Polygalaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>472</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Xanthophyllum flavescens</em> Roxb.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Polygalaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>473</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Xantolis tomentosa</em> (Roxb.) Raf.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Sapotaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>474</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Ximenia americana</em> L.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Olacaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>475</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Xylia xylocarpa</em> (Roxb.) Taub.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Leguminosae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>476</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Xylocarpus granatum</em> J. Koenig
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Meliaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>477</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Xylopia parvifolia</em> Hook.f. &amp;
                                    Thomson
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Annonaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>478</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Xylosma longifolia</em> Clos
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Salicaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>479</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Zanthoxylum rhetsa </em>DC
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Rutaceae
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "80px" }}>
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <strong>480</strong>
                                  </p>
                                </td>
                                <td width="359">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    <em>Ziziphus jujuba </em>Mill.
                                  </p>
                                </td>
                                <td width="123">
                                  <p style={{ fontSize: "0.999999em" }}>
                                    Rhamnaceae
                                  </p>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </section>
                      </section>
                    </li>{" "}
                    <br />
                    <li>
                      <section id="Shrubs of Kerala">
                        <p
                          style={{
                            textAlign: "justify",
                            fontSize: "0.999999999em",
                          }}
                        >
                          <h5>Shrubs of Kerala</h5>
                          <p style={{ fontSize: "0.999999em" }}>
                            The spatial mapping of shrub species in each
                            districts of Kerala are given in the following
                            figures; <br />
                            <a href="#Image15">
                              1. Spatial Distribution of Shrubs in
                              Thiruvananthapuram District
                            </a>
                            <br />
                            <a href="#Image16">
                              2. Spatial Distribution of Shrubs in Kollam
                              District
                            </a>
                            <br />
                            <a href="#Image17">
                              3. Spatial Distribution of Shrubs in
                              Pathanamthitta District
                            </a>
                            <br />
                            <a href="#Image18">
                              4. Spatial Distribution of Shrubs in Alappuzha
                              District
                            </a>
                            <br />
                            <a href="#Image19">
                              5. Spatial Distribution of Shrubs in Kottayam
                              District
                            </a>
                            <br />
                            <a href="#Image20">
                              6. Spatial Distribution of Shrubs in Idukki
                              District
                            </a>
                            <br />
                            <a href="#Image21">
                              7. Spatial Distribution of Shrubs in Ernakulam
                              District
                            </a>
                            <br />
                            <a href="#Image22">
                              8. Spatial Distribution of Shrubs in Thrissur
                              District
                            </a>
                            <br />
                            <a href="#Image23">
                              9. Spatial Distribution of Shrubs in Palakkad
                              District
                            </a>
                            <br />
                            <a href="#Image24">
                              10. Spatial Distribution of Shrubs in Malappuram
                              District
                            </a>
                            <br />
                            <a href="#Image25">
                              11. Spatial Distribution of Shrubs in Kozhikode
                              District
                            </a>
                            <br />
                            <a href="#Image26">
                              12. Spatial Distribution of Shrubs in Wayanad
                              District
                            </a>
                            <br />
                            <a href="#Image27">
                              13. Spatial Distribution of Shrubs in Kannur
                              District
                            </a>
                            <br />
                            <a href="#Image28">
                              14. Spatial Distribution of Shrubs in Kasargod
                              District
                            </a>
                            <br />
                          </p>
                          <section id="Image15">
                            {" "}
                            <p style={{ fontSize: "0.999999em" }}>
                              <img src="images/article/shrubs/1.png" alt="" />{" "}
                              <p style={{ fontSize: "0.999999em" }}>
                                {" "}
                                Figure 15: Map of spatial distribution of shrubs
                                in Thiruvananthapuram district
                              </p>
                            </p>
                          </section>
                          <p style={{ fontSize: "0.999999em" }}>&nbsp;</p>
                          <section id="Image16">
                            {" "}
                            <p style={{ fontSize: "0.999999em" }}>
                              <img src="images/article/shrubs/2.png" alt="" />{" "}
                              <p style={{ fontSize: "0.999999em" }}>
                                Figure 15: Map of spatial distribution of shrubs
                                in Kollam district
                              </p>
                            </p>
                          </section>
                          <p style={{ fontSize: "0.999999em" }}>&nbsp;</p>
                          <section id="Image17">
                            <p style={{ fontSize: "0.999999em" }}>
                              <img src="images/article/shrubs/3.png" alt="" />{" "}
                              <p style={{ fontSize: "0.999999em" }}>
                                Figure 17: Map of spatial distribution of shrubs
                                in Pathanamthitta
                              </p>
                              district
                            </p>
                          </section>
                          <p style={{ fontSize: "0.999999em" }}>&nbsp;</p>
                          <section id="Image18">
                            {" "}
                            <p style={{ fontSize: "0.999999em" }}>
                              <img src="images/article/shrubs/4.png" alt="" />{" "}
                              <p style={{ fontSize: "0.999999em" }}>
                                Figure 18:Map of spatial distribution of shrubs
                                in Alappuzha district
                              </p>
                            </p>
                          </section>
                          <p style={{ fontSize: "0.999999em" }}>&nbsp;</p>
                          <section id="Image19">
                            <p style={{ fontSize: "0.999999em" }}>
                              <img src="images/article/shrubs/5.png" alt="" />{" "}
                              <p style={{ fontSize: "0.999999em" }}>
                                Figure 19: Map of spatial distribution of shrubs
                                in Kottayam district
                              </p>
                            </p>
                          </section>
                          <p style={{ fontSize: "0.999999em" }}>&nbsp;</p>
                          <section id="Image20">
                            {" "}
                            <p style={{ fontSize: "0.999999em" }}>
                              <img src="images/article/shrubs/6.png" alt="" />{" "}
                              <p style={{ fontSize: "0.999999em" }}>
                                {" "}
                                Figure 20: Map of spatial distribution of shrubs
                                in Idukki district
                              </p>
                            </p>
                          </section>
                          <section id="Image21">
                            {" "}
                            <p style={{ fontSize: "0.999999em" }}>
                              <img src="images/article/shrubs/7.png" alt="" />
                              <p style={{ fontSize: "0.999999em" }}>
                                Figure 21: Map of spatial distribution of shrubs
                                in Ernakulam district
                              </p>
                            </p>
                          </section>
                          <p style={{ fontSize: "0.999999em" }}>&nbsp;</p>
                          <section id="Image22">
                            {" "}
                            <p style={{ fontSize: "0.999999em" }}>
                              <img src="images/article/shrubs/8.png" alt="" />
                              <p style={{ fontSize: "0.999999em" }}>
                                Figure 22: Map of spatial distribution of shrubs
                                in Thrissur district
                              </p>
                            </p>
                          </section>
                          <p style={{ fontSize: "0.999999em" }}>&nbsp;</p>
                          <p style={{ fontSize: "0.999999em" }}>&nbsp;</p>
                          <section id="Image23">
                            {" "}
                            <p style={{ fontSize: "0.999999em" }}>
                              <img src="images/article/shrubs/9.png" alt="" />
                              <p style={{ fontSize: "0.999999em" }}>
                                Figure 23: Map of spatial distribution of shrubs
                                in Palakkad district
                              </p>
                            </p>
                          </section>
                          <p style={{ fontSize: "0.999999em" }}>&nbsp;</p>
                          <section id="Image24">
                            {" "}
                            <p style={{ fontSize: "0.999999em" }}>
                              <img src="images/article/shrubs/10.png" alt="" />
                              <p style={{ fontSize: "0.999999em" }}>
                                Figure 24: Map of spatial distribution of shrubs
                                in Malappuram
                              </p>
                              district
                            </p>
                          </section>
                          <p style={{ fontSize: "0.999999em" }}>&nbsp;</p>
                          <section id="Image25">
                            {" "}
                            <p style={{ fontSize: "0.999999em" }}>
                              <img src="images/article/shrubs/11.png" alt="" />
                              <p style={{ fontSize: "0.999999em" }}>
                                Figure 25: Map of spatial distribution of shrubs
                                in Kozhikode district
                              </p>
                            </p>
                          </section>
                          <p style={{ fontSize: "0.999999em" }}>&nbsp;</p>
                          <section id="Image26">
                            <p style={{ fontSize: "0.999999em" }}>
                              <img src="images/article/shrubs/12.png" alt="" />
                              <p style={{ fontSize: "0.999999em" }}>
                                Figure 26: Map of spatial distribution of shrubs
                                in Wayanad district
                              </p>
                            </p>
                          </section>
                          <section id="Image27">
                            <p style={{ fontSize: "0.999999em" }}>
                              <img src="images/article/shrubs/13.png" alt="" />
                              <p style={{ fontSize: "0.999999em" }}>
                                Figure 27: Map of spatial distribution of shrubs
                                in Kannur district
                              </p>
                            </p>
                          </section>
                          <p style={{ fontSize: "0.999999em" }}>&nbsp;</p>
                          <section id="Image28">
                            {" "}
                            <p style={{ fontSize: "0.999999em" }}>
                              <img src="images/article/shrubs/14.png" alt="" />
                              <p style={{ fontSize: "0.999999em" }}>
                                Figure 28: Map of spatial distribution of shrubs
                                in Kasargod district
                              </p>
                            </p>
                          </section>
                          <p style={{ fontSize: "0.999999em" }}>&nbsp;</p>
                          <p style={{ fontSize: "0.999999em" }}>&nbsp;</p>
                          <p style={{ fontSize: "0.999999em" }}>
                            <a name="_Toc165292931"></a>Table 3: : Shrubs of
                            Kerala
                          </p>
                          <section id="Table3">
                            <table style={{ width: "80%" }}>
                              <tbody>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <strong>Sl. No</strong>
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <strong>SCIENTIFIC NAME</strong>
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <strong>FAMILY</strong>
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>1</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Abelmoschus angulosus</em> Wall ex
                                      Wight &amp; Arn. var. <em>angulosus </em>
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Malvaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>2</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Abelmoschus angulosus</em> Wall. ex
                                      Wight &amp; Arn. var.{" "}
                                      <em>grandiflorus </em>
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Malvaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>3</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Abelmoschus angulosus</em> Wall. ex
                                      Wight &amp; Arn. var. <em>purpureus</em>{" "}
                                      Thw.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Malvaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>4</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Abroma augustum</em> (L.) L.f.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Malvaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>5</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Abutilon hirtum</em> (Lam.) Sweet
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Malvaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>6</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Abutilon indicum indicum</em>
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Malvaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>7</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Abutilon indicum </em>var.{" "}
                                      <em>guineense</em> (Schumach.) K.M.Feng
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Malvaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>8</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Abutilon neilgherrense</em> Munro ex
                                      Wight
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Malvaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>9</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Abutilon persicum</em> (Burm.f.) Merr.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Malvaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>10</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Abutilon ramosum</em> (Cav.) Guill.
                                      &amp; Pers.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Malvaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>11</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Abutilon striata</em> (Dicks. ex
                                      Lindl.) Donnell
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Malvaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>12</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Acacia mellifera</em> (M.Vahl) Benth.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>13</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Acalypha amentacea</em> subsp.{" "}
                                      <em>wilkesiana</em> (M&uuml;ll.Arg.)
                                      Fosberg
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Euphorbiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>14</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Acalypha capitata</em> Willd.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Euphorbiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>15</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Acalypha ciliata</em> Forssk.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Euphorbiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>16</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Acalypha fruticosa </em>Forssk.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Euphorbiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>17</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Acanthus ebracteatus</em> Vahl
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>18</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Acanthus ilicifolius</em> L.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>19</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Acanthus montanus</em> (Nees)
                                      T.Anderson
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>20</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Actinodaphne campanulata</em> Hook.f.
                                      var. <em>obtusa</em> Gamble
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Lauraceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>21</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Adenium obesum</em> (Forssk.) Roem.
                                      &amp; Schult.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Apocynaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>22</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Aegiceras corniculatum</em> (L.)
                                      Blanco
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Primulaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>23</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Aerva persica</em> (Burm. f.) Merr.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Amaranthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>24</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Aeschynanthus perrottetii</em> A. DC.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Gesneriaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>25</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Aeschynomene aspera</em> L.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>26</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Agave americana</em> L.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Asparagaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>27</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Agave salmiana </em>var.{" "}
                                      <em>ferox</em> (K.Koch) Gentry
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Asparagaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>28</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Agave sisalana </em>Perrine ex Engelm.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Asparagaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>29</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Agave vivipara</em> L.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Asparagaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>30</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Ageratina adenophora</em> (Spreng.)
                                      King &amp; Robinson
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>31</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Agrostistachys indica</em> Dalzell
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Euphorbiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>32</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Allophylus cobbe </em>(L.) Raeusch
                                      <em>.</em>
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Sapindaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>33</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Allophylus concanicus</em> Radlk.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Sapindaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>34</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Allophylus serratus</em> (Roxb.) Kurz
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Sapindaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>35</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Allophylus subfalcatus</em> var.{" "}
                                      <em>distachyus</em> (DC.) Mukerjee.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Sapindaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>36</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Alstonia venenata</em> R.Br.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Apocynaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>37</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Andrographis explicata</em> (C. B.
                                      Cl.) Gamble
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>38</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Andrographis lawsonii </em>Gamble
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>39</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Andrographis lineata</em> Nees
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>40</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Anisomeles malabarica</em> (L.) R.Br.
                                      ex Sims
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Lamiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>41</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Antidesma acidum</em> Retz.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Phyllanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>42</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Antidesma keralense</em> Chakrab.
                                      &amp; M.Gangop.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Phyllanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>43</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Antistrophe serratifolia</em> (Bedd.)
                                      Hook.f.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Primulaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>44</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Aporosa indo-acuminata</em> Chakrab.
                                      &amp; N.P.Balakr
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Euphorbiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>45</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Aralia malabarica</em> Bedd.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Araliaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>46</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Archidendron monadelphum</em> (Roxb.)
                                      Nielson var. <em>gracile</em> (Bedd.)
                                      Sanjappa
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>47</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Ardisia amplexicaulis</em> Bedd.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Primulaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>48</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Ardisia blatteri</em> Gamble
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Primulaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>49</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Ardisia gardneri zeylanica</em> (C. B.
                                      Cl.) Trim.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Primulaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>50</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Ardisia littoralis</em> Andrews
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Primulaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>51</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Ardisia missionis</em> Wall. ex A.DC.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Primulaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>52</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Ardisia pauciflora</em> Heyne ex Roxb.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Primulaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>53</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Ardisia sonchifolia</em> Mez
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Primulaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>54</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Ardisia stonei</em> N. Sasidharan
                                      &amp; V.V. Sivarajan
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Primulaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>55</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Argyreia cuneata </em>Willd. ex
                                      Ker-Gawl.&nbsp;
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Convolvulaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>56</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Argyreia fulgens</em> Wall. ex Choisy
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Convolvulaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>57</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Artemisia nilagirica</em> (C.B.Clarke)
                                      Pamp.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>58</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Asparagus fysonii</em> J.F.Macbr.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Liliaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>59</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Asystasia chelonoides</em> Nees
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>60</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Atalantia racemosa</em> var.{" "}
                                      <em>racemosa</em>.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Rutaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>61</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Atalantia simplicifolia</em> (Roxb.)
                                      Engl.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Rutaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>62</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Atalantia wightii</em> Tanaka
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Rutaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>63</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Azima tetracantha </em>Lam.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Salvadoraceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>64</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Baliospermum solanifolium </em>(Burm.)
                                      Suresh
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Euphorbiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>65</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Bambusa balcooa</em> Roxb.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>66</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Bambusa bambos</em> (L.) Voss
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>67</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Bambusa polymorpha</em> Munro
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>68</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Bambusa tuldoides</em> Munro
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>69</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Barleria acuminata</em> Nees
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>70</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Barleria buxifolia</em> L.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>71</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Barleria courtallica</em> Nees
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>72</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Barleria cristata</em> L.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>73</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Barleria cuspidata</em> Heyne ex Nees
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>74</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Barleria involucrata</em> var.{" "}
                                      <em>elata</em> (Dalzell) C.B.Clarke
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>75</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Barleria involucrata</em> var.{" "}
                                      <em>involucrata </em>
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>76</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Barleria lawii</em> T. Anders.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>77</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Barleria longiflora</em> L.f
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>78</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Barleria montana</em> Nees
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>79</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Barleria mysorensis</em> Roth.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>80</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Barleria pilosa</em> F.Heyne ex Nees
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>81</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Barleria prattensis </em>Santapau
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>82</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Barleria prionitis</em> L.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>83</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Barleria strigosa</em> Willd.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>84</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Bauhinia acuminata </em>L. &nbsp;
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>85</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Bauhinia tomentosa </em>L.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>86</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Begonia malabarica </em>Lam.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Begoniaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>87</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Berberis tinctoria</em> Lesch.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Berberidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>88</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Berberis wightiana</em> Schneid.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Berberidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>89</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Blachia calycina</em> Benth.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Euphorbiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>90</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Blepharispermum petiolare</em>{" "}
                                      DC.&nbsp;
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>91</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Boehmeria glomerulifera</em> Miq.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Urticaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>92</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Boehmeria macrophylla </em>var.{" "}
                                      <em>macrophylla</em>
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Urticaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>93</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Bougainvillea glabra</em> Choisy
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Nyctaginaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>94</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Bougainvillea spectabilis</em> Willd.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Nyctaginaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>95</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Breynia retusa</em> (Dennst.) Alston
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Phyllanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>96</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Breynia vitis-idaea</em> (Burm.f.)
                                      Fischer
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Phyllanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>97</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Bridelia stipularis </em>(L.) Blume
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Phyllanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>98</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Brugmansia arborea</em> (L.) Steud.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Solanaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>99</p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Brugmansia suaveolens</em> (Humb.
                                      &amp; Bonpl. ex Willd.) Bercht. &amp;
                                      J.Presl
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Solanaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      100
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Brunfelsia americana</em> L
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Solanaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      101
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Brunfelsia grandiflora</em> D.Don
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Solanaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      102
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Buddleja asiatica</em> Lour.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Scrophulariaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      103
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Buddleja madagascariensis</em> Lam.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Scrophulariaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      104
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Byrsophyllum tetrandrum</em> (Bedd.)
                                      Hook.f
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Rubiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      105
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cadaba fruticosa</em> (L.) Druce
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Capparaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      106
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cadaba trifoliata</em> (Roxb.) Wight.
                                      &amp; Arn
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Capparaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      107
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Caesalpinia decapetala</em> (Roth)
                                      Alston
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      108
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Caesalpinia globulorum</em> Bakh.f.
                                      &amp; P.Royen
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      109
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Caesalpinia pulcherrima</em>
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      110
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cajanus cajan</em> (L.) Huth
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      111
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cajanus goensis</em> Dalzell
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      112
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cajanus lineatus</em> (Wight &amp;
                                      Arn.) Maesen
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      113
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cajanus trinervius</em> (DC.) Maesen
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      114
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Calacanthus grandiflorus</em> (Dalz.)
                                      Radlk
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      115
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Calotropis gigantea </em>(L.) Dryand
                                      <em>. </em>
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Apocynaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      116
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Camellia sinensis</em> (L.) Kuntze
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Theaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      117
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cannabis sativa</em> L.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cannabaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      118
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Canthium angustifolium</em> Roxb.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Rubiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      119
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Canthium coromandelicum</em> (Burm.f.)
                                      Alston
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Rubiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      120
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Canthium rheedei</em> DC.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Rubiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      121
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Capparis brevispina</em> Auct. non DC.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Capparaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      122
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Capparis diversifolia</em> Wight &amp;
                                      Arn.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Capparaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      123
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Capparis fusifera</em> Dunn
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Capparaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      124
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Capparis moonii</em> Wight
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Capparaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      125
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Capparis rheedei</em> DC.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Capparaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      126
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Capparis sepiaria</em> L.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Capparaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      127
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Capparis shevaroyensis</em>{" "}
                                      Sundararagh.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Capparaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      128
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Capparis tenera</em> Dalz.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Capparaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      129
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Capparis zeylanica</em> L.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Capparaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      130
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Capsicum annuum</em> var.{" "}
                                      <em>glabriusculum</em> (Dunal) Heiser
                                      &amp; Pickersgill
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Solanaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      131
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Carissa carandas</em> L.&nbsp;
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Apocynaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      132
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Carissa spinarum</em> L.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Apocynaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      133
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Carissa spinarum</em> L. var.{" "}
                                      <em>microphylla</em> Gamble
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Apocynaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      134
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Carmona retusa</em> (Vahl) Masamune
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Boraginaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      135
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cereus pterogonus</em> Le Marie
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cactaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      136
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cestrum aurantiacum</em> Lindl.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Solanaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      137
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cestrum nocturnum</em> L.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Solanaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      138
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Chamaecrista nigricans</em> (Vahl)
                                      Greene
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      139
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Chassalia curviflora</em> var.{" "}
                                      <em>ophioxyloides</em> (Wall.) Deb &amp;
                                      B.Krishna
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Rubiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      140
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Chromolaena odorata</em> (L.) R.M.King
                                      &amp; H.Rob.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      141
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cipadessa baccifera</em> (Roth) Miq.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Meliaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      142
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cirsium wallichii</em> DC.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      143
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Citrus medica </em>L.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Rutaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      144
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Claoxylon anomalum</em> Hook.f.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Euphorbiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      145
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Clausena anisata</em> (Willd.) Hook.
                                      f., De Wild. &amp; Staner
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Rutaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      146
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Clausena austroindica</em> B.C.Stone
                                      &amp; K.N.Nair
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Rutaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      147
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cleistanthus sankunnianus</em>{" "}
                                      Sivarajan &amp; Indu Balachandran
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Euphorbiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      148
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cleistanthus travancorensis</em> Jabl.
                                      var. <em>jaleelianus</em> E.Girish &amp;
                                      Sunojk.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Phyllanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      149
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Clematis udayanii</em> Anilkumar
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Ranunculaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      150
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Clerodendrum calamitosum</em> L.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Lamiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      151
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Clerodendrum chinense</em> (Osbeck)
                                      Mabb.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Lamiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      152
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Clerodendrum heterophyllum</em>{" "}
                                      (Poir.) R.Br.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Lamiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      153
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Clerodendrum incisum</em> Klotzsch
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Lamiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      154
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Clerodendrum indicum</em> (L.) Kuntze
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Lamiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      155
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Clerodendrum infortunatum </em>L.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Lamiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      156
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Clerodendrum phlomidis</em> L.f.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Lamiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      157
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Clerodendrum wallichii</em> Merr.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Lamiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      158
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Clerodentrum paniculatum</em>
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Lamiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      159
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Clidemia hirta</em> (L.) D. Don
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Melastomataceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      160
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Clinacanthus nutans </em>(Burm.f.)
                                      Lindau
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      161
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Codariocalyx motorius</em> (Houtt.)
                                      H.Ohashi
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      162
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Codiaeum variegatum</em> (L.) Rumph.
                                      ex A.Juss.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Euphorbiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      163
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Coffea arabica</em> L.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Rubiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      164
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Coffea liberica</em> Hiern
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Rubiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      165
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Colebrookea oppositifolia</em> J. E.
                                      Smith
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Lamiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      166
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Coleus adenanthus </em>(Dalzell &amp;
                                      A.Gibson) A.J.Paton
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Lamiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      167
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Coleus argenteus </em>(Gamble)
                                      A.J.Paton
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Lamiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      168
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Coleus dysophylloides </em>(Benth.)
                                      A.J.Paton
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Lamiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      169
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Coleus robustus </em>(Hook.f.)
                                      A.J.Paton.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Lamiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      170
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Coleus suffruticosus </em>(Wight)
                                      A.J.Paton
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Lamiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      171
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Colubrina asiatica</em> (L.) Brogniart
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Rhamnaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      172
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Colubrina travancorica</em> Bedd.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Rhamnaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      173
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cordia cylindrostachya</em> (Ruiz
                                      &amp; Pav.) Roem. &amp; Schult.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Boraginaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      174
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cordyline fruticosa</em> (L.) A.Chev.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Asparagaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      175
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cotoneaster buxifolius</em> Wall. ex
                                      Lindl.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Rosaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      176
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cressa cretica</em> L.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Convolvulaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      177
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crossandra infundibuliformis</em>
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      178
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria agatiflora</em> Schweinf.
                                      ex Engl
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      179
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria alata</em> D.Don
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      180
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria albida</em> Heyne ex Roth
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      181
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria angulata</em> Miller
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      182
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria assamica</em> var.{" "}
                                      <em>keralensis</em> Krishnaraj, N.Mohanan
                                      et V.T.Antony
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      183
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria barbata</em> Graham ex
                                      Wight &amp; Arn.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      184
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria beddomeana</em> Thoth.
                                      &amp; A.A. Ansari
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      185
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria berteroana DC. </em>
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      186
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria candicans</em> Wight &amp;
                                      Arn.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      187
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria dubia</em> Graham ex Benth.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      188
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria formosa</em> Graham ex
                                      Wight &amp; Arn.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      189
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria grahamiana</em> Wight &amp;
                                      Arn
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      190
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria heyneana</em> Graham ex
                                      Wight &amp; Arn.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      191
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria hirsuta</em> Willd.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      192
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria incana</em> L.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      193
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria incana</em> subsp.{" "}
                                      <em>purpurascens</em> (Lam.) Milne-Redh.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      194
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria laburnifolia</em> Sensu
                                      Brenan
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      195
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria laevigata</em> Lam.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      196
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria leptostachya</em> Benth.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      197
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria longipes </em>Wight &amp;
                                      Arn.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      198
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria madurensis</em> Wight &amp;
                                      Arn.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      199
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria micans</em> Link
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      200
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria multiflora</em> (Arn.)
                                      Benth.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      201
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria notonii</em> Wight &amp;
                                      Arn.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      202
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria obtecta</em> var.{" "}
                                      <em>glabrescens</em> (Benth.) Baker
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      203
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria obtecta</em> Wight &amp;
                                      Arn
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      204
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria pallida</em> Aiton
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      205
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria pallida</em> var.{" "}
                                      <em>obovata</em> (G.Don) Polhill
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      206
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria peduncularis</em> Graham ex
                                      Wight &amp; Arn.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      207
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria salicifolia</em> Wight
                                      &amp; Arn.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      208
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria scabra</em> Gamble
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      209
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria semperflorens</em> Vent.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      210
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria sessiliflora</em> L
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      211
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria speciosa</em> Heyne ex Roth
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      212
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria spectabilis</em> Roth
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      213
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria stipitata</em> Wight &amp;
                                      Arn.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      214
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria subperfoliata</em> Wight
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      215
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria trifoliastrum</em> Willd.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      216
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria walkeri</em> Arn.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      217
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria wightiana</em> Graham ex
                                      Wight &amp; Arn.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      218
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria willdenowiana</em> DC.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      219
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Croton klotzschianus</em> (Wight)
                                      Thwaites
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Euphorbiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      220
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Croton zeylanicus</em> Muell.-Arg.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Euphorbiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      221
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cryptanthus zonatus</em> (Vis.) Beer
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Bromeliaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      222
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cyamopsis tetragonoloba</em> (L.)
                                      Taub.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      223
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cycas circinalis </em>L.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cycadaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      224
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cylindropuntia ramosissima</em>{" "}
                                      (Engelm.) F.M.Knuth
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cactaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      225
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cyphomandra betacea</em> (Cav.)
                                      Sendtn.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Solanaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      226
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cytisus scoparius</em> (L.) Link
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      227
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dahlia imperialis</em> Roezl ex
                                      Ortgies
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      228
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dalbergia pinnata</em> var.{" "}
                                      <em>acaciifolia</em> (Dalzell)Thoth.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      229
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Datura metel </em>L.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Solanaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      230
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Datura stramonium </em>L.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Solanaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      231
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Debregeasia longifolia</em> (Burm.f.)
                                      Wedd.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Urticaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      232
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Decalepis arayalpathra</em> (J.Joseph
                                      &amp; V.Chandras.) Venter
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Apocynaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      233
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Decaschistia crotonifolia</em> Wight
                                      &amp; Arn.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Malvaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      234
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dendrocalamus giganteus</em> Munro
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      235
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dendrocalamus strictus</em> (Roxb.)
                                      Nees
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      236
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dendrolobium triangulare</em> (Retz.)
                                      Schindl
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      237
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dendrophthoe falcata</em> (L.f.)
                                      Etting.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Loranthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      238
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dendrophthoe falcata</em> var.{" "}
                                      <em>pubescens</em> (Hook.f.) V.Chandras.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Loranthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      239
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dendrophthoe memecylifolia</em> (Wight
                                      &amp; Arn.) Danser
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Loranthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      240
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dendrophthoe neelgherrensis</em>{" "}
                                      (Wight &amp; Arn.) Tiegh.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Loranthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      241
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dendrophthoe trigona</em> (Wight &amp;
                                      Arn.) Danser ex Santapau
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Loranthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      242
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Desmodium caudatum</em> (Thunb.) DC.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      243
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Desmodium dolabriforme</em> Benth.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      244
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Desmodium ferrugineum</em> subsp.{" "}
                                      <em>wynaadense</em> (Gamble) H.Ohashi
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      245
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Desmodium ferrugineum</em> Thwaites
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      246
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Desmodium gangeticum </em>(L.) DC.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      247
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Desmodium heterocarpon</em> (L.) DC.
                                      var. <em>gymnocarpum</em> Schindl.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      248
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Desmodium motorium </em>(Houtt.) Merr.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      249
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Desmodium pryonii</em> DC.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      250
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Desmodium pulchellum </em>(L.) Benth.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      251
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Desmodium styracifolium</em> (Osbeck)
                                      Merr.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      252
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Desmodium triquetrum</em> (L.) DC.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      253
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Desmodium velutinum </em>(Willd.) DC.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      254
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dichapetalum gelonioides</em> (Roxb.)
                                      Engl.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Dichapetalaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      255
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dicliptera foetida</em> (Forssk.)
                                      Blatt.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      256
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dicliptera manilalii</em> Karthik.
                                      &amp; Moorthy
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      257
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Discospermum apiocarpum</em> Dalzell
                                      ex Hook.f.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Rubiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      258
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dodonaea viscosa</em> (L.) Jacq.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Sapindaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      259
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dombeya burgessiae</em> Gerrard ex
                                      Harv. &amp; Sond.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Malvaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      260
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dracaena reflexa</em> Lam.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Asparagaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      261
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dracaena terniflora</em> Roxb.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Asparagaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      262
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Duranta erecta</em> L.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Verbenaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      263
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Ecbolium ligustrinum</em> (Vahl)
                                      Vollesen var. <em>aryankavensis</em>{" "}
                                      Remadevi &amp; Binojkumar
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      264
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>
                                        Ecbolium ligustrinum var. ligustrinum{" "}
                                      </em>
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      265
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Ecbolium viride </em>(Forssk.) Alston
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      266
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Ecbolium viride var. viride </em>
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      267
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Ehretia wightiana</em> Wall. ex G.Don
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Boraginaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      268
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Endostemon viscosus</em> (Roth)
                                      M.R.Ashby
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Lamiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      269
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Epiphyllum oxypetalum</em> (DC.) Haw.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cactaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      270
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Eranthemum pulchellum</em> Andrews
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      271
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Eranthemum roseum</em> (Vahl) R.Br.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      272
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Eugenia mabaeoides</em> Wight
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Myrtaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      273
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Eugenia mooniana</em> Wight
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Myrtaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      274
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Eugenia terpnophylla</em> var.{" "}
                                      <em>keralensis</em> Shareef, E.S.S Kumar
                                      &amp; P.E. Roy
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Myrtaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      275
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Euonymus angulatus</em> Wight
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Celastraceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      276
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Euonymus laxiflorus</em> Champ. ex
                                      Benth.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Celastraceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      277
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Euonymus serratifolius</em> Bedd.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Celastraceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      278
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Euphorbia antiquorum</em> L.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Euphorbiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      279
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Euphorbia cotinifolia</em> L.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Euphorbiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      280
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Euphorbia nivulia</em>{" "}
                                      Buchanan-Hamilton
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Euphorbiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      281
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Euphorbia rothiana</em> Spreng.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Euphorbiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      282
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Euphorbia santapaui</em> A.N.Henry
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Euphorbiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      283
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Euphorbia tirucalli</em> L.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Euphorbiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      284
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Euphorbia tortilis</em> Rottler ex
                                      Ainslie [
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Euphorbiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      285
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Euphorbia trigona</em> Mill.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Euphorbiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      286
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Euphorbia vajravelui</em> Binojk.
                                      &amp; N.P.Balakr.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Euphorbiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      287
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Excoecaria cochinchinensis</em> Lour.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Euphorbiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      288
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Flacourtia indica </em>(Burm. f.)
                                      Merr.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Salicaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      289
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Glycosmis pentaphylla </em>(Retz.) DC.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Rutaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      290
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Gymnostachyum sahyadricum</em>{" "}
                                      C.N.Mohanan, Remadevi &amp; Binojk.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      291
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Helicteres isora </em>L<em>. </em>
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Malvaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      292
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Hibiscus rosa-sinensis </em>var
                                      <em>. rosa-sinensis </em>
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Malvaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      293
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Hibiscus surattensis </em>L<em>.</em>
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Malvaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      294
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Homonoia riparia </em>Lour.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Euphorbiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      295
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Hygrophila auriculata </em>(Schumach.)
                                      Heine
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      296
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Ixora coccinea </em>L.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Rubiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      297
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Jasminum bignoniaceum</em> Wall. &amp;
                                      G.Don
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Oleaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      298
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Jasminum cuspidatum</em> Rottler
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Oleaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      299
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Jatropha curcas</em> L.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Euphorbiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      300
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Jatropha gossypiifolia</em> L.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Euphorbiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      301
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Jatropha integerrima</em> Jacq.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Euphorbiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      302
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Jatropha tanjorensis</em> J.L.Ellis
                                      &amp; Saroja
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Euphorbiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      303
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Jatropha villosa</em> Wight
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Euphorbiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      304
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Justicia adhatoda </em>L.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      305
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Justicia beddomei</em> (C.B.Clarke)
                                      Bennet
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      306
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Justicia betonica</em> L.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      307
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Justicia betonica</em> var.{" "}
                                      <em>ramocissima</em> (Nees) Clarke
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      308
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Justicia gendarussa </em>Burm. f.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      309
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Justicia santapaui </em>Benn.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      310
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Kleinia grandiflora</em> (Wall. ex
                                      DC.) N. Rani
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      311
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Kleinia walkeri</em> (Wight)
                                      M.R.Almeida
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      312
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Kuruna densifolia </em>(Munro)
                                      Attigala, Kaththr. &amp; L.G.Clark
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      313
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Kuruna floribunda </em>(Thwaites)
                                      Attigala, Kaththr. &amp; L.G.Clark
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      314
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Kuruna walkeriana </em>(Munro)
                                      Attigala, Kaththr. &amp; L.G.Clark
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      315
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Kuruna wightiana </em>(Nees) Attigala,
                                      Kathr. &amp; L.G.Clark
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      316
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Lantana camara </em>var.
                                      <em> camara </em>
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Verbenaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      317
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Lawsonia inermis </em>L.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Lythraceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      318
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Leea macrophylla </em>Roxb. ex Hornem
                                      <em>.</em>
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Vitaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      319
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Martynia annua </em>L.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Martyniaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      320
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Melastoma malabathricum </em>L.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Melastomataceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      321
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Murraya paniculata </em>(L.) Jack.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Rutaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      322
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Mussaenda frondosa </em>L.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Rubiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      323
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Nerium oleander</em>
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Apocynaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      324
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Nostolachma crassifolia</em> (Gamble)
                                      Deb &amp; Lahiri
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Rubiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      325
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Ocimum gratissimum </em>L.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Lamiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      326
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Ocimum tenuiflorum </em>L.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Lamiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      327
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Orophea malabarica</em> Sasidharan
                                      &amp; Sivarajan
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Annonaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      328
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Orophea sivarajanii </em>Sasidh.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Annonaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      329
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Pandanus odorifer </em>(Forssk.)
                                      Kuntze
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Pandanaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      330
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Phaeanthus malabaricus</em> Bedd.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Annonaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      331
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Phlogacanthus albiflorus</em> Bedd.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      332
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Phyllodium longipes</em> (Craib)
                                      Schindl.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      333
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Pittosporum tetraspermum </em>Wight
                                      &amp; Arn.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Pittosporaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      334
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Plumbago indica </em>L.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Plumbaginaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      335
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Plumbago zeylanica </em>L.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Plumbaginaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      336
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Premna serratifolia </em>L.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Lamiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      337
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Pseudarthria viscida </em>(L.) Wight
                                      and Arn
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      338
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Psilanthus travancorensis</em> (Wight
                                      &amp; Arn.) J.-F.Leroy
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Rubiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      339
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Psilanthus wightianus</em> (Wall. ex
                                      Wight &amp; Arn.) J.-F.Leroy.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Rubiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      340
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Punica granatum </em>L.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Lythraceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      341
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Rauvolfia serpentina </em>(L.) Benth.
                                      ex Kurz
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Apocynaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      342
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Rhinacanthus nasutus </em>(L.) Kurz
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      343
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Ricinus communis </em>L<em>.</em>
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Euphorbiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      344
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Rotheca serrata </em>(L.) Steane &amp;
                                      Mabb
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Lamiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      345
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Rotula aquatica </em>Lour.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Boraginaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      346
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Senna alata </em>(L.) Roxb<em>.</em>
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      347
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Senna hirsuta </em>(L.) H.S. Irwin
                                      &amp; Barneby
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      348
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Senna tora </em>(L.) Roxb<em>.</em>
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      349
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Sida acuta </em>Burm. f.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Malvaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      350
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Sida rhombifolia </em>L. subsp.
                                      Alnifolia (L.) Ugbor.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Malvaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      351
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Solanum torvum </em>Sw.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Solanaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      352
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Solanum viarum </em>Dunal
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Solanaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      353
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Solanum violaceum </em>Ortega
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Solanaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      354
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Strobilanthes ciliata </em>Nees
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      355
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Strobilanthes dupenii</em> Bedd. ex
                                      C.B.Clarke
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      356
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Strobilanthes pushpangadanii</em>{" "}
                                      Santhosh, Jabbar &amp; Shanavas
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      357
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Tabernaemontana divaricata</em>
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Apocynaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      358
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Thottea abrahamii</em> M. Dan, P.J.
                                      Mathew, C.M. Unnithan &amp; P.
                                      Pushpangadan
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Aristolochiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      359
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Thottea idukkiana</em> A.G.
                                      Pandurangan &amp; V.J. Nair
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Aristolochiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      360
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Thottea ponmudiana</em> Sivarajan
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Aristolochiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      361
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Thottea siliquosa </em>(Lam.) Ding Hou
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Aristolochiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      362
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Thottea sivarajanii </em>E.S.S.Kumar,
                                      A.E.S.Khan &amp; Binu
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Aristolochiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      363
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Volkameria inermis </em>L.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Lamiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      364
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Withania somnifera </em>(L.) Dunal
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Solanaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      365
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Woodfordia fruticosa </em>(L.) Kurz
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Lythraceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      366
                                    </p>
                                  </td>
                                  <td width="418">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Wrightia antidysenterica</em> (L.)
                                      R.Br.
                                    </p>
                                  </td>
                                  <td width="129">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Apocynaceae
                                    </p>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </section>
                          <p style={{ fontSize: "0.999999em" }}>&nbsp;</p>
                        </p>
                      </section>
                    </li>{" "}
                    <br />
                    <li>
                      <section id="Herbs of Kerala">
                        <p
                          style={{
                            textAlign: "justify",
                            fontSize: "0.999999999em",
                          }}
                        >
                          <h5>Herbs of Kerala</h5>
                          <p style={{ fontSize: "0.999999em" }}>
                            The spatial mapping of herb species in each
                            districts of Kerala are given in the following
                            figures; <br />
                            <a href="#Image29">
                              1. Spatial Distribution of Shrubs in
                              Thiruvananthapuram District
                            </a>
                            <br />
                            <a href="#Image30">
                              2. Spatial Distribution of Shrubs in Kollam
                              District
                            </a>
                            <br />
                            <a href="#Image31">
                              3. Spatial Distribution of Shrubs in
                              Pathanamthitta District
                            </a>
                            <br />
                            <a href="#Image32">
                              4. Spatial Distribution of Shrubs in Alappuzha
                              District
                            </a>
                            <br />
                            <a href="#Image33">
                              5. Spatial Distribution of Shrubs in Kottayam
                              District
                            </a>
                            <br />
                            <a href="#Image34">
                              6. Spatial Distribution of Shrubs in Idukki
                              District
                            </a>
                            <br />
                            <a href="#Image35">
                              7. Spatial Distribution of Shrubs in Ernakulam
                              District
                            </a>
                            <br />
                            <a href="#Image36">
                              8. Spatial Distribution of Shrubs in Thrissur
                              District
                            </a>
                            <br />
                            <a href="#Image37">
                              9. Spatial Distribution of Shrubs in Palakkad
                              District
                            </a>
                            <br />
                            <a href="#Image38">
                              10. Spatial Distribution of Shrubs in Malappuram
                              District
                            </a>
                            <br />
                            <a href="#Image39">
                              11. Spatial Distribution of Shrubs in Kozhikode
                              District
                            </a>
                            <br />
                            <a href="#Image40">
                              12. Spatial Distribution of Shrubs in Wayanad
                              District
                            </a>
                            <br />
                            <a href="#Image41">
                              13. Spatial Distribution of Shrubs in Kannur
                              District
                            </a>
                            <br />
                            <a href="#Image42">
                              14. Spatial Distribution of Shrubs in Kasargod
                              District
                            </a>
                            <br />
                          </p>
                          <section id="Image29">
                            {" "}
                            <p style={{ fontSize: "0.999999em" }}>
                              <img src="images/article/herbs/1.png" alt="" />
                              <p style={{ fontSize: "0.999999em" }}>
                                Figure 29: Map of spatial distribution of herbs
                                in Thiruvananthapuram district
                              </p>
                            </p>
                          </section>
                          <p style={{ fontSize: "0.999999em" }}>&nbsp;</p>
                          <section id="Image30">
                            {" "}
                            <p style={{ fontSize: "0.999999em" }}>
                              <img src="images/article/herbs/2.png" alt="" />
                              <p style={{ fontSize: "0.999999em" }}>
                                Figure 30: Map of spatial distribution of herbs
                                in Kollam district
                              </p>
                            </p>
                          </section>
                          <p style={{ fontSize: "0.999999em" }}>&nbsp;</p>
                          <section id="Image31">
                            {" "}
                            <p style={{ fontSize: "0.999999em" }}>
                              <img src="images/article/herbs/3.png" alt="" />
                              <p style={{ fontSize: "0.999999em" }}>
                                Figure 31: Map of spatial distribution of herbs
                                in Pathanamthitta district
                              </p>
                            </p>
                          </section>
                          <p style={{ fontSize: "0.999999em" }}>&nbsp;</p>
                          <section id="Image32">
                            {" "}
                            <p style={{ fontSize: "0.999999em" }}>
                              <img src="images/article/herbs/4.png" alt="" />{" "}
                              <p style={{ fontSize: "0.999999em" }}>
                                Figure 32: Map of spatial distribution of herbs
                                in Alappuzha district
                              </p>
                            </p>{" "}
                          </section>
                          <p style={{ fontSize: "0.999999em" }}>&nbsp;</p>
                          <section id="Image33">
                            {" "}
                            <p style={{ fontSize: "0.999999em" }}>
                              <img src="images/article/herbs/5.png" alt="" />{" "}
                              <p style={{ fontSize: "0.999999em" }}>
                                Figure 33: Map of spatial distribution of herbs
                                in Kottayam district
                              </p>
                            </p>
                          </section>
                          <p style={{ fontSize: "0.999999em" }}>&nbsp;</p>
                          <section id="Image34">
                            <p style={{ fontSize: "0.999999em" }}>
                              <img src="images/article/herbs/6.png" alt="" />
                              <p style={{ fontSize: "0.999999em" }}>
                                Figure 34: Map of spatial distribution of herbs
                                in Idukki district
                              </p>
                            </p>
                          </section>
                          <p style={{ fontSize: "0.999999em" }}>&nbsp;</p>
                          <section id="Image35">
                            {" "}
                            <p style={{ fontSize: "0.999999em" }}>
                              <img src="images/article/herbs/7.png" alt="" />
                              <p style={{ fontSize: "0.999999em" }}>
                                Figure 35: Map of spatial distribution of herbs
                                in Ernakulam district
                              </p>
                            </p>
                          </section>
                          <p style={{ fontSize: "0.999999em" }}>&nbsp;</p>
                          <section id="Image36">
                            {" "}
                            <p style={{ fontSize: "0.999999em" }}>
                              <img src="images/article/herbs/8.png" alt="" />
                              <p style={{ fontSize: "0.999999em" }}>
                                Figure 36: Map of spatial distribution of herbs
                                in Thrissur district
                              </p>
                            </p>
                          </section>
                          <p style={{ fontSize: "0.999999em" }}>&nbsp;</p>
                          <p style={{ fontSize: "0.999999em" }}>&nbsp;</p>
                          <section id="Image37">
                            {" "}
                            <p style={{ fontSize: "0.999999em" }}>
                              <img src="images/article/herbs/9.png" alt="" />
                              <p style={{ fontSize: "0.999999em" }}>
                                Figure 37: Map of spatial distribution of herbs
                                in Palakkad district
                              </p>
                            </p>
                          </section>
                          <p style={{ fontSize: "0.999999em" }}>&nbsp;</p>
                          <section id="Image38">
                            {" "}
                            <p style={{ fontSize: "0.999999em" }}>
                              <img src="images/article/herbs/10.png" alt="" />
                              <p style={{ fontSize: "0.999999em" }}>
                                Figure 38: Map of spatial distribution of herbs
                                in Malappuram district
                              </p>
                            </p>
                          </section>
                          <p style={{ fontSize: "0.999999em" }}>&nbsp;</p>
                          <section id="Image39">
                            {" "}
                            <p style={{ fontSize: "0.999999em" }}>
                              <img src="images/article/herbs/11.png" alt="" />
                              <p style={{ fontSize: "0.999999em" }}>
                                Figure 39: Map of spatial distribution of herbs
                                in Kozhikode district
                              </p>
                            </p>
                          </section>
                          <p style={{ fontSize: "0.999999em" }}>&nbsp;</p>
                          <section id="Image40">
                            <p style={{ fontSize: "0.999999em" }}>
                              <img src="images/article/herbs/12.png" alt="" />
                              <p style={{ fontSize: "0.999999em" }}>
                                Figure 40: Map of spatial distribution of herbs
                                in Wayanad district
                              </p>
                            </p>
                          </section>
                          <p style={{ fontSize: "0.999999em" }}>&nbsp;</p>
                          <section id="Image41">
                            {" "}
                            <p style={{ fontSize: "0.999999em" }}>
                              <img src="images/article/herbs/13.png" alt="" />
                              <p style={{ fontSize: "0.999999em" }}>
                                Figure 41: Map of spatial distribution of herbs
                                in Kannur district
                              </p>
                            </p>
                          </section>
                          <p style={{ fontSize: "0.999999em" }}>&nbsp;</p>
                          <section id="Image42">
                            {" "}
                            <p style={{ fontSize: "0.999999em" }}>
                              <img src="images/article/herbs/14.png" alt="" />
                              <p style={{ fontSize: "0.999999em" }}>
                                Figure 42: Map of spatial distribution of herbs
                                in Kasargod district
                              </p>
                            </p>
                          </section>
                          <p style={{ fontSize: "0.999999em" }}>&nbsp;</p>
                          <p style={{ fontSize: "0.999999em" }}>
                            <a name="_Toc165292932"></a>Table 4: : Herbs of
                            Kerala
                          </p>
                          <section id="Table4">
                            <table style={{ width: "80%" }}>
                              <tbody>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <strong>Sl. No</strong>
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <strong>SCIENTIFIC NAME</strong>
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <strong>FAMILY</strong>
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>1</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Abelmoschus crinitus</em> Wall.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Malvaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>2</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Abelmoschus manihot</em> (L.) Medik.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Malvaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>3</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Abelmoschus moschatus </em>Medik.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Malvaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>4</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Abelmoschus rhodopetalus </em>F.Muell.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Malvaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>5</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Acalypha brachystachya</em> Hornem.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Euphorbiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>6</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Acalypha indica </em>L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Euphorbiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>7</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Acalypha lanceolata</em> Willd.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Euphorbiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>8</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Acalypha malabarica</em>{" "}
                                      M&uuml;ll.Arg.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Euphorbiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>9</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Acalypha paniculata</em> Miq.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Euphorbiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>10</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Acampe ochracea</em> (Lindl.) Hochr.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>11</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Acampe praemorsa</em> (Roxb.)
                                      Blatt.&amp; McCann.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>12</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Acampe rigida</em> (Buch.-Ham. ex Sm.)
                                      P.F.Hunt
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>13</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Acanthephippium bicolor</em> Lindl.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>14</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Acanthospermum hispidum </em>DC.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>15</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Achillea millefolium</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>16</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Achimenes longiflora</em> DC.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Gesneriaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>17</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Achyranthes aspera</em> L<em>.</em>
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Amaranthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>18</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Achyranthes aspera</em> var.{" "}
                                      <em>porphyristachya</em> (Wall. ex Moq.)
                                      Hook.f.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Amaranthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>19</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Achyranthes aspera</em> var.{" "}
                                      <em>pubescens</em> ( Moq. ) Towns.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Amaranthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>20</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Achyranthes bidentata</em> Blume
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Amaranthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>21</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Acmella calva </em>(DC.) R.K. Jansen
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>22</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Acmella ciliata </em>(Kunth) Cass.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>23</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Acmella oleracea </em>(L.) R.K.Jansen
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>24</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Acorus calamus</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acoraceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>25</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Acranthera anamallica</em> Bedd.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Rubiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>26</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Acranthera grandiflora</em> Bedd.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Rubiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>27</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Acroceras munroanum</em> (Balansa)
                                      Henrard
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>28</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Acrotrema agastyamalayanum</em>{" "}
                                      Santhosh,M. Dan et G. M. Nair
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Dilleniaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>29</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Acrotrema arnottianum</em> Wight
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Dilleniaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>30</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Acrotrema uniflorum </em>Hook. var.{" "}
                                      <em>uniflorum</em>
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Dilleniaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>31</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Adenoon indicum</em> Dalzell
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>32</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Adenosma indianum</em> (Lour.) Merr.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Plantaginaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>33</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Adenosma malabaricum</em> Hook.f.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Plantaginaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>34</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Adenosma subrepens</em> Benth. ex
                                      Hook.f.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Plantaginaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>35</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Adenostemma lavenia</em>
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>36</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Adenostemma lavenia</em> var.{" "}
                                      <em>angustifolium</em> (L.) O. Kuntze
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>37</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Adenostemma macrophylla</em> (Blume)
                                      DC.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>38</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Aeginetia indica</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orobanchaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>39</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Aeginetia pedunculata</em> (Roxb.)
                                      Wallr.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orobanchaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>40</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Aeluropus lagopoides</em> (L.)
                                      Thwaites
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>41</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Aenhenrya rotundifolia</em> (Blatt.)
                                      C.S.Kumar &amp; F.N.Rasm.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>42</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Aerides crispa</em> Lindl.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>43</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Aerides ringens</em> (Lindl.)
                                      C.E.C.Fisch.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>44</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Aerva lanata </em>(L.) Juss<em>.</em>
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Amaranthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>45</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Aerva sanguinolenta</em> (L.) Blume
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Amaranthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>46</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Aeschynomene americana</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>47</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Aeschynomene indica</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>48</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Agapanthus africanus</em> (L.)
                                      Hoffmanns.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Amaryllidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>49</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Ageratum conyzoides</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>50</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Ageratum houstonianum</em> Mill.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>51</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Agrostis peninsularis</em> Hook.f.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>52</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Agrostis pilosula</em> Trin.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>53</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Agrostis stolonifera</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>54</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Alcea rosea</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Malvaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>55</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Alchemilla indica</em> Gardner
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Rosaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>56</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Allmania nodiflora</em> (L.) R.Br. ex
                                      Wight
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Amaranthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>57</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Alloteropsis cimicina</em> (L.) Stapf
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>58</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Alloteropsis semialata</em> (R.Br.)
                                      Hitch. var. <em>viatica</em> (Griff.)
                                      Ellis &amp; Karthik.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>59</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Alocasia fornicata</em> (Kunth) Schott
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Araceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>60</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Alocasia macrorrhizos</em> (L.) G.Don
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Araceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>61</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Aloe vera </em>(L.) Burm. f.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Xanthorrhoeaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>62</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Alpinia abundiflora</em> Burtt &amp;
                                      R.M.Sm.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Zingiberaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>63</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Alpinia calcarata </em>(Haw.) Roscoe
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Zingiberaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>64</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Alpinia fax</em> Burtt &amp; R.M.
                                      Smith
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Zingiberaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>65</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Alpinia galanga </em>(L.) Willd
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Zingiberaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>66</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Alpinia malaccensis</em> (Burm.f.)
                                      Roscoe
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Zingiberaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>67</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Alpinia mutica</em> Roxb.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Zingiberaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>68</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Alpinia nigra</em> (Gaertn.) Burtt
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Zingiberaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>69</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Alpinia smithiae</em> Sabu &amp;
                                      Mangaly
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Zingiberaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>70</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Alpinia vittata</em> W.Bull
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Zingiberaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>71</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Alpinia zerumbet</em> (Pers.) Burtt
                                      &amp; R.M.Sm
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Zingiberaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>72</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Alstroemeria aure</em>a Graham
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Alstroemeriaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>73</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Alternanthera bettzickiana</em>{" "}
                                      (Regel) Voss
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Amaranthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>74</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Alternanthera paronychioides</em>{" "}
                                      A.St. Hil.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Amaranthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>75</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Alternanthera philoxeroides</em>{" "}
                                      (Mart.) Griseb.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Amaranthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>76</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Alternanthera pulchella </em>Kunth
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Amaranthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>77</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Alternanthera pungens</em> Kunth
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Amaranthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>78</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Alternanthera sessilis</em> (L.) R.Br.
                                      ex DC.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Amaranthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>79</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Alternanthera tenella</em> var.{" "}
                                      <em>tenella</em>
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Amaranthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>80</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Alysicarpus bupleurifolius</em> (L.)
                                      DC.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>81</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Alysicarpus glumaceus </em>(Vahl) DC.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>82</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Alysicarpus hamosus</em> Edgew.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>83</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Alysicarpus heterophyllus</em> (Baker)
                                      Jafri &amp; Ali
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>84</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Alysicarpus monilifer</em> (L.) DC.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>85</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Alysicarpus scariosus </em>(Rottler ex
                                      Spreng.) Graham
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>86</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Alysicarpus vaginalis</em> (L.) DC.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>87</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Alysicarpus vaginalis </em>var.{" "}
                                      <em>nummularifolius</em> (DC.) Miq.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>88</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Amaranthus blitum</em> var.{" "}
                                      <em>oleraceus</em> (L.) Hook.f.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Amaranthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>89</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Amaranthus caudatus</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Amaranthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>90</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>
                                        Amaranthus graecizans thellungianus
                                      </em>{" "}
                                      (Nevski) Gusev
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Amaranthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>91</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Amaranthus spinosus</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Amaranthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>92</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Amaranthus tricolor</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Amaranthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>93</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Amaranthus viridis</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Amaranthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>94</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Ammannia aegyptica</em> Willd.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Lythraceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>95</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Ammannia auriculata</em> Willd.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Lythraceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>96</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Ammannia baccifera</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Lythraceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>97</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Ammannia multiflora</em> Roxb.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Lythraceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>98</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Amomum cannicarpum</em> (Wight) Benth.
                                      ex Baker
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Zingiberaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>99</p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Amomum fulviceps</em> Thwaites
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Zingiberaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      100
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Amomum masticatorium</em> Thwaites
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Zingiberaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      101
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Amomum muricatum</em> Bedd.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Zingiberaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      102
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Amomum nilgiricum</em> V.P.Thomas
                                      &amp; M.Sabu
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Zingiberaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      103
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Amomum pterocarpum</em> Thwaites
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Zingiberaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      104
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Amorphophallus bonaccordensis</em>{" "}
                                      Sivad. &amp; N.Mohanan
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Araceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      105
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Amorphophallus bulbifer</em> (Roxb.)
                                      Blume
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Araceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      106
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Amorphophallus commutatus</em>{" "}
                                      (Schott) Engl.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Araceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      107
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Amorphophallus hohenackeri</em>{" "}
                                      (Schott) Engl. &amp; Gehrm.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Araceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      108
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Amorphophallus nicolsonianus</em>{" "}
                                      Sivadasan
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Araceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      109
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Amorphophallus paeoniifolius </em>
                                      (Dennst.) Nicolson
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Araceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      110
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Amorphophallus smithsonianus</em>{" "}
                                      Sivadasan
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Araceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      111
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Amorphophallus sylvaticus</em> (Roxb.)
                                      Kunth
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Araceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      112
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Ananas bracteatus</em> (Lindl.)
                                      Schult. &amp; Schult.f.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Bromeliaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      113
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Ananas comosus</em> (L.) Merr.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Bromeliaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      114
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Anaphalis aristata</em> (DC.) DC.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      115
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Anaphalis barnesii</em> C.E.C.Fisch.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      116
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Anaphalis beddomei </em>Hook.f.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      117
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Anaphalis bournei</em> Fyson
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      118
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Anaphalis elliptica</em> (DC.) DC.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      119
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Anaphalis lawii</em> (Hook.f.) Gamble
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      120
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Anaphalis leptophylla</em> (DC.) DC.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      121
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Anaphalis marcescens</em> (Wight)
                                      C.B.Clarke
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      122
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Anaphalis meeboldii</em> W.W.Sm.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      123
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Anaphalis neelgerryana</em> (DC.) DC.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      124
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Anaphalis notoniana</em> (DC.) DC.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      125
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Anaphalis subdecurrens</em> (DC.)
                                      Gamble
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      126
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Anaphalis travancorica</em> W.W.Sm.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      127
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Anaphalis wightiana</em> DC.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      128
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Anaphyllum beddomei</em> Engl.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Araceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      129
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Anaphyllum wightii</em> Schott
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Araceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      130
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Andrographis affinis</em> Nees
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      131
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Andrographis alata</em> (Vahl) Nees
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      132
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Andrographis atropurpurea</em>{" "}
                                      (Dennst.) Alston
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      133
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Andrographis chendurunii</em>{" "}
                                      E.S.S.Kumar, A.E.S.Khan &amp; S.G.Gopal
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      134
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Andrographis echioides</em> (L.) Nees
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      135
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Andrographis elongata </em>(Vahl) T.
                                      Anders<em>.</em>
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      136
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Andrographis macrobotrys</em> Nees
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      137
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Andrographis megamalayana</em>{" "}
                                      Gnanasek., Karupp. &amp; G.V.S. Murthy
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      138
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Andrographis neesiana</em> Wight var.{" "}
                                      <em>neesiana</em>
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      139
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Andrographis ovata</em> (T.Anderson ex
                                      Bedd.) Benth. &amp; Hook.f.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      140
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Andrographis paniculata </em>(Burm.f.)
                                      Nees
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      141
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Andrographis producta</em> Gamble.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      142
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Andrographis serpyllifolia</em> (Vahl)
                                      Wight
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      143
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Andrographis stellulata</em> C. B. Cl.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      144
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Andrographis stenophylla</em> C.B. Cl.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      145
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Andropogon lividus</em> Thwaites
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      146
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Andropogon polyptychos</em> Steud.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      147
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Angelonia salicariifolia</em> Humb.
                                      &amp; Bonpl.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Scrophulariaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      148
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Anisochilus carnosus </em>(L. f.) Wall
                                      <em>. </em>
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Lamiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      149
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Anisomeles heyneana</em> Benth.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Lamiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      150
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Anisomeles indica</em> (L.) Kuntze
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Lamiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      151
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Anoectochilus elatus</em> Lindl.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      152
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Anoectochilus setaceus</em> Blume
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      153
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Anogeissus acuminata</em> (Roxb. ex
                                      DC.) Guillaum. &amp; Perr.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Combretaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      154
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Anthoxanthum borii</em> S.K.Jain &amp;
                                      Pal
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      155
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Antistrophe glabra</em>{" "}
                                      A.G.Pandurangan &amp; V.J.Nair
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Primulaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      156
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Aphyllorchis montana</em> Rchb.f.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      157
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Apluda mutica</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      158
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Apocopis cochinchinensis</em> A.Camus
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      159
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Apocopis courtallumensis</em> (Steud.)
                                      Henrard
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      160
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Apocopis mangalorensis</em> (Hochst.)
                                      Henr.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      161
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Arachis glabrata</em> Benth.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      162
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Arachis hypogaea</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      163
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Arachis pintoi</em> Krapov. &amp; W.C.
                                      Gregory
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      164
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Argemone mexicana </em>L<em>.</em>
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Papaveraceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      165
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Argostemma anupama</em> Sivar.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Rubiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      166
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Argostemma courtallense</em> Arn.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Rubiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      167
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Argostemma rostratum</em> Wall.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Rubiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      168
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Argostemma verticillatum</em> Wall.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Rubiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      169
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Ariopsis peltata </em>Nimmo
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Araceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      170
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Arisaema agasthyanum</em> Sivad. &amp;
                                      C.S.Kumar
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Araceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      171
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Arisaema barnesii</em> C.E.C.Fisch.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Araceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      172
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Arisaema echinatum</em> (Wall.) Schott
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Araceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      173
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Arisaema jacquemontii</em> Blume
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Araceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      174
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Arisaema leschenaultii</em> Blume
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Araceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      175
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Arisaema muricaudatum</em> Sivad.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Araceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      176
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Arisaema murrayi</em> (J.Graham) Hook.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Araceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      177
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Arisaema nilamburense</em> Sivad.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Araceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      178
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Arisaema peltatum</em> C.E.C. Fisch.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Araceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      179
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Arisaema psittacus</em> E.Barnes
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Araceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      180
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Arisaema sarracenioides</em> E.Barnes
                                      &amp; C.E.C.Fisch
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Araceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      181
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Arisaema tortuosum</em> (Wall.) Schott
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Araceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      182
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Arisaema tortuosum</em> var.{" "}
                                      <em>curvatum</em> (Roxb.) Engl.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Araceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      183
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Arisaema translucens</em> C.E.C.Fisch.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Araceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      184
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Arisaema tylophorum</em> C.E.C.Fisch.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Araceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      185
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Aristea ecklonii</em> Baker
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Iridaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      186
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Aristida adscensionis</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      187
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Aristida hystrix</em> L. f.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      188
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Aristida setacea</em> Trin.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      189
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Aristolochia bracteolata </em>Lam
                                      <em>. </em>
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Aristolochiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      190
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Artanema longifolium</em> (L.) Vatke
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Scrophulariaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      191
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Artemisia japonica</em> Thunb.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      192
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Arthraxon castratus</em> (Griff.)
                                      V.Naray. ex Bor
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      193
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Arthraxon hispidus</em> (Thunb.)
                                      Makino
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      194
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Arthraxon lanceolatus</em> (Roxb.)
                                      Hochst.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      195
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Arthraxon lancifolius</em> (Trin.)
                                      Hochst.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      196
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Arthraxon meeboldii</em> Stapf
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      197
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Arthraxon nudus</em> (Steud.) Hochst.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      198
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Arthraxon typicus </em>(Buse) Koord.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      199
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Arthraxon villosus</em> C.E.C.Fisch.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      200
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Arundina graminifolia</em> (D.Don)
                                      Hochr.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      201
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Arundinella cannanorica</em> V.J.Nair,
                                      Sreek. &amp; N.C.Nair
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      202
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Arundinella ciliata</em> (Roxb.) Nees
                                      ex Miq.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      203
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Arundinella leptochloa</em> (Nees ex
                                      Steud.) Hook.f.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      204
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Arundinella mesophylla</em> Nees ex
                                      Steud.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      205
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>
                                        Arundinella metzii Hochst.ex Miq.{" "}
                                      </em>
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      206
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Arundinella nepalensis</em> Trin.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      207
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Arundinella nervosa</em> (Roxb.) Nees
                                      ex Hook. &amp; Arn.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      208
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Arundinella pradeepiana</em> Sunil
                                      &amp; Naveen Kum.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      209
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Arundinella pumila</em> (Hochst. ex
                                      A.Rich.) Steud.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      210
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Arundinella purpurea</em> var.{" "}
                                      <em>purpurea</em>
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      211
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Arundinella ravii</em> Shaju &amp;
                                      Mohanan
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      212
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Arundinella setosa</em> Trin.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      213
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Arundinella spicata</em> Dalzell
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      214
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Arundinella tuberculata</em> Munro ex
                                      Lisboa
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      215
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Arundinella vaginata</em> Bor
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      216
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Arundo donax</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      217
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Asyneuma fulgens</em> (Wall.) Briq.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Campanulaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      218
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Asystasia crispata</em> Benth.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      219
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Asystasia dalzelliana</em> Santapau
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      220
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Asystasia gangetica</em> (L.)
                                      T.Anderson
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      221
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Asystasia travancorica</em> Bedd.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      222
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Axonopus compressus</em> (Sw.)
                                      P.Beauv.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      223
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Ayapana triplinervis </em>(Vahl)
                                      R.M.King &amp; H.Rob.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      224
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Bacopa floribunda</em> (R.Br.) Wettst.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Plantaginaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      225
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Bacopa hamiltoniana</em> (Benth.)
                                      Wettst.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Scrophulariaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      226
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Bacopa monnieri</em> (L.) Wettst.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Scrophulariaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      227
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Balanophora abbreviata</em> Blume
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Balanophoraceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      228
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Balanophora dioica</em> R.Br.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Balanophoraceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      229
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Balanophora fungosa </em>var.
                                      <em> indica</em>
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Balanophoraceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      230
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Basilicum polystachyon</em> (L.)
                                      Moench
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Lamiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      231
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Begonia albo-coccinea</em> Hook.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Begoniaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      232
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Begonia aliciae</em> C.E.C. Fish.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Begoniaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      233
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Begonia canarana</em> Miq.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Begoniaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      234
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Begonia cordifolia</em> (Wight)
                                      Thwaites
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Begoniaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      235
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Begonia crenata</em> Dryand
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Begoniaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      236
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Begonia floccifera</em> Bedd.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Begoniaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      237
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Begonia integrifolia</em> Dalzell
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Begoniaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      238
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Begonia subpeltata</em> Wight
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Begoniaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      239
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Begonia trichocarpa</em> Dalzell
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Begoniaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      240
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Belosynapsis kewensis</em> Hassk.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Commelinaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      241
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Belosynapsis moluccana</em> (Rox.)
                                      C.E.C.Fisch
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Commelinaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      242
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Belosynapsis vivipara</em> (Dalzell)
                                      C.E.C.Fisch.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Commelinaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      243
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Bergia ammannioides</em> Roxb.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Elatinaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      244
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Bergia capensis</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Elatinaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      245
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Beta vulgaris</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Chenopodiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      246
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Bhidea burnsiana</em> Bor
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      247
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Bhidea fischeri</em> Sreek. &amp;
                                      B.V.Shetty
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      248
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Bidens biternata</em> (Lour.) Merr.
                                      &amp; Sherff ex Sherff
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      249
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Bidens pilosa</em> var. <em>minor</em>{" "}
                                      (Blume) Sherff&nbsp;
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      250
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Billbergia pyramidalis</em> (Sims)
                                      Lindl
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Bromeliaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      251
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Biophytum congestiflorum</em> Govind.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Oxalidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      252
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Biophytum insigne</em> Gamble
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Oxalidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      253
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Biophytum intermedium</em> Wight
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Oxalidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      254
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Biophytum longipedunculatum</em>{" "}
                                      Govind.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Oxalidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      255
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Biophytum nervifolium</em> Thw.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Oxalidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      256
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Biophytum reinwardtii keralanum</em>{" "}
                                      E.S.S.Kumar, Yeragi, K.N.Babu &amp;
                                      A.E.S.Khan
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Oxalidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      257
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Biophytum reinwardtii </em>var
                                      <em>. reinwardtii </em>
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Oxalidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      258
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Biophytum sensitivum</em>
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Oxalidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      259
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Biophytum sensitivum candolleanum</em>{" "}
                                      (Wight) Edgew. &amp; Hook.f.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Oxalidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      260
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Biophytum umbraculum</em> Welw.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Oxalidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      261
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Biophytum veldkampii</em> A. E.
                                      Shanavas Khan, E. S. Santhosh Kurstar, S.
                                      Binu &amp; P. Pushpangadan
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Oxalidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      262
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Blainvillea acmella</em> (L.) Philip.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      263
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Blepharis integrifolia</em> (L. fil.)
                                      E. Mey. &amp; Drege
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      264
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Blepharis lawsonii</em> G.S.Giri &amp;
                                      R.N.Banerjee
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      265
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Blepharis maderaspatensis</em> (L.)
                                      Roth.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      266
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Blumea axillaris</em> (Lam.) DC.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      267
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Blumea barbata</em> DC.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      268
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Blumea belangeriana</em> DC.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      269
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Blumea clarkei</em> Hook.f.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      270
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Blumea eriantha</em> DC.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      271
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Blumea heiracifolia</em> var.{" "}
                                      <em>heiracifolia</em>
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      272
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Blumea hieracifolia flexuosa</em>{" "}
                                      (C.B.Clarke) Randeria
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      273
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Blumea lacera</em> (Burm.f.) DC.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      274
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Blumea lanceolaria</em> (Roxb.) Druce
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      275
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Blumea lanceolaria spectabilis</em>{" "}
                                      (DC.) Randeria
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      276
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Blumea membranacea</em> DC.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      277
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Blumea membranacea jacquemontii</em>{" "}
                                      (Hook.f.) Randeria
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      278
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Blumea membranacea</em> Wall. ex DC.
                                      var. <em>gracilis</em> Hook. f.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      279
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Blumea obliqua</em> (L.) Druce
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      280
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Blumea oxyodonta</em> DC.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      281
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Blumea viscosa</em> (Mill.)
                                      V.M.Badillo
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      282
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Boerhavia chinensis</em> (L.) Asch.
                                      &amp; Schweinf.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Nyctaginaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      283
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Boerhavia diffusa </em>L<em>.</em>
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Nyctaginaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      284
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Boerhavia erecta</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Nyctaginaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      285
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Boesenbergia pulcherrima</em> (Wal.)
                                      Kuntze
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Zingiberaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      286
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Boesenbergia tiliifolia</em> (Baker)
                                      Kuntze
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Zingiberaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      287
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Bothriochloa bladhii</em> (Retz.)
                                      S.T.Blake
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      288
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Bothriochloa insculpta</em> (A.Rich.)
                                      A.Camus
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      289
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Bothriochloa pseudoischaemum</em>{" "}
                                      (Nees ex Steud.) Henrard
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      290
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Brachiaria brizantha</em> (A.Rich.)
                                      Stapf
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      291
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Brachiaria decumbens</em> Stapf
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      292
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Brachiaria distachya</em> (L.)
                                      Stapf&nbsp;
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      293
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Brachiaria eruciformis</em> (Sm.)
                                      Griseb.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      294
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Brachiaria miliiformis</em> (C.Presl)
                                      A.Chase
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      295
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Brachiaria mutica</em> (Forssk.) Stapf
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      296
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Brachiaria paspaloides</em> (J.Presl)
                                      C.E.Hubb.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      297
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Brachiaria ramosa</em> (L.) Stapf
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      298
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Brachiaria remota</em> (Retz.) Haines
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      299
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Brachiaria reptans</em> (L.)
                                      C.A.Gardner &amp; C.E.Hubb.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      300
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Brachiaria semiundulata</em> (Hochst.)
                                      Stapf
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      301
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Brachiaria semiverticillata</em>{" "}
                                      (Rottler) Alston
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      302
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Brachiaria villosa</em> (Lam.) A.Camus
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      303
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Brachycorythis iantha</em> (Wight)
                                      Summerh.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      304
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Brachycorythis splendida</em> Summerh.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      305
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Brachycorythis wightii</em> Summerh.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      306
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Brachystelma kolarenses</em> Arekal
                                      &amp; T.M.Ramakrishna
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Apocynaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      307
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Brachystelma swarupa</em> Kishore
                                      &amp; Goyder
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Apocynaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      308
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Brachystelma vartakii</em> Kambale
                                      &amp; S.R.Yadav
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Apocynaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      309
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Brassica juncea</em> (L.) Czern.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Brassicaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      310
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Brassica nigra</em> (L.) W.D.J. Koch
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Brassicaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      311
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Briza minor</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      312
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Browallia americana</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Solanaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      313
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Bryophyllum fedtschenkoi</em>{" "}
                                      (Raym.-Hamet &amp; H. Perrier)
                                      Lauz.-March.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Crassulaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      314
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Bryophyllum pinnatum </em>(Lam.) Kurz
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Crassulaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      315
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Bryophyllum serratum</em> (Mannoni
                                      &amp; Boiteau) Blanco
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Crassulaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      316
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Buchnera hispida</em> Ham. ex D. Don
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Scrophulariaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      317
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Bulbophyllum acutiflorum</em> A.Rich.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      318
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Bulbophyllum aureoflavum</em>{" "}
                                      Karuppusamy &amp; Ravichandran
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      319
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Bulbophyllum aureum</em> (Hook.f.)
                                      J.J. Smith
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      320
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Bulbophyllum careyanum</em> (Hook.)
                                      Spreng.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      321
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Bulbophyllum elegantulum</em> (Rolfe)
                                      J.J.Sm.&nbsp;
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      322
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Bulbophyllum fimbriatum</em> (Lindl.)
                                      Rchb.f.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      323
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Bulbophyllum fischeri</em> Seidenf
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      324
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Bulbophyllum fuscopurpureum</em> Wight
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      325
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Bulbophyllum kaitiense</em> Rchb.f.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      326
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Bulbophyllum keralense</em> M.Kumar
                                      &amp; Sequiera
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      327
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Bulbophyllum macraei</em> (Lindl.)
                                      Rchb.f.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      328
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Bulbophyllum maskeliyense</em> Livera
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      329
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Bulbophyllum mysorense</em> (Rolfe)
                                      J.J.Sm.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      330
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Bulbophyllum orezii</em> C.S.Kumar
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      331
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Bulbophyllum rheedei</em> Manilal
                                      &amp; C.S.Kumar
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      332
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Bulbophyllum rosemarianum</em>{" "}
                                      Sathish, Kumar &amp; Saleem
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      333
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Bulbophyllum silentvalliensis</em>{" "}
                                      M.P.Sharma &amp; S.K.Srivast.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      334
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Bulbophyllum tremulum </em>Wight
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      335
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Bulbophyllum xylophyllum</em>{" "}
                                      E.C.Parish &amp; Rchb.f.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      336
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Bulbostylis barbata</em>
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cyperaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      337
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Bulbostylis barbata</em> subsp.{" "}
                                      <em>pulchella</em> (Thwaites) T.Koyama
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cyperaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      338
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Bulbostylis densa</em> (Wall. ex
                                      Roxb.) Hand.-Mazz.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cyperaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      339
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Bulbostylis thouarsii</em> (Roem.
                                      &amp; Schult.)
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cyperaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      340
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Bunium nothum</em> (C.B.Clarke) P.K.
                                      Mukherjee
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Apiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      341
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Bupleurum distichophyllum</em> Wight
                                      &amp; Arn.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Apiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      342
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Bupleurum mucronatum</em> Wight &amp;
                                      Arn.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Apiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      343
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Bupleurum wightii</em> P. K. Mukherjee
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Apiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      344
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Burmannia championii</em> Thwaites
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Burmanniaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      345
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Burmannia coelestis</em> D. Don
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Burmanniaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      346
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Burmannia stricta</em> Jonker
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Burmanniaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      347
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Burnnia indica</em> Jonker
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Burmanniaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      348
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Byttneria herbacea</em> Roxb.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Malvaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      349
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cajanus scarabaeoides </em>(L.)
                                      Thouars
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      350
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Caladium bicolor</em> (Ait. ex
                                      Dryand.) Vent.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Araceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      351
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Calanthe sylvatica</em> (Thouars)
                                      Lindl.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      352
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Calanthe triplicata</em> (Willemet)
                                      Ames
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      353
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Calathea ornata</em> (Linden)
                                      K&ouml;rn.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Marantaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      354
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Calathea zebrina</em> (Sims) Lindl.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Marantaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      355
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Calceolaria mexicana</em> Benth.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Scrophulariaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      356
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Caldesia oligococca</em> ( F.Muell. )
                                      Buch.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Alismataceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      357
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Calendula officinalis</em>
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      358
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Callisia repens</em> (Jacq.) L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Commelinaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      359
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Campanula alphonsii</em> Wall. ex
                                      A.DC.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Campanulaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      360
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Campbellia cytinoides</em> Wight
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orobanchaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      361
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Canna indica</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cannaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      362
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Canscora alata</em> (Roth) Wall
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Gentianaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      363
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Canscora bhatiana</em> K.S. Prasad
                                      &amp; K. Ravi
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Gentianaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      364
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Canscora diffusa</em> (Vahl) R.Br.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Gentianaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      365
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Canscora heteroclita</em> (L.) Gilg
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Gentianaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      366
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Canscora perfoliata</em> Lam.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Gentianaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      367
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Canscora roxburghii</em> Arn. ex Miq.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Gentianaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      368
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Capillipedium assimile</em> (Steud.)
                                      A.Camus
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      369
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Capillipedium filiculme</em> (Hook.f.)
                                      Stapf
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      370
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Capillipedium huegelii</em> (Hack.)
                                      A.Camus
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      371
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Capsella bursa-pastoris</em> (L.)
                                      Medik.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Brassicaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      372
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Capsicum annuum</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Solanaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      373
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Capsicum chinense</em> Jacq.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Solanaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      374
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Capsicum frutescens</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Solanaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      375
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Caralluma adscendens</em> (Roxb.) Haw.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Apocynaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      376
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Caralluma adscendens</em> (Roxb.) Haw.
                                      var. <em>attenuata</em> (Wight) Grav.
                                      &amp; Mayur.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Apocynaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      377
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Caralluma indica</em> (Wight &amp;
                                      Arn.) N.E.Br.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Apocynaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      378
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Caralluma pauciflora</em> (Wight)
                                      N.E.Br.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Apocynaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      379
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Caralluma procumbens</em> Gravely
                                      &amp; Mayur.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Apocynaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      380
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Caralluma umbellata</em> Roxb.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Apocynaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      381
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cardamine africana</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Brassicaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      382
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cardamine hirsuta</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Brassicaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      383
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cardamine trichocarpa</em> Hochst. ex
                                      A. Rich.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Brassicaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      384
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Carex baccans</em> Nees
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cyperaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      385
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Carex breviculmis</em> R.Br.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cyperaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      386
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Carex filicina</em> Nees
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cyperaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      387
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Carex hebecarpa</em> Mey. ssp.{" "}
                                      <em>ligulata</em> (Nees) T.Koyama
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cyperaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      388
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Carex indica</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cyperaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      389
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Carex jackiana</em> Boott
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cyperaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      390
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Carex lenta</em> D.Don
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cyperaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      391
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Carex leucantha</em> Arn. ex Boott
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cyperaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      392
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Carex lindleyana</em> Nees
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cyperaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      393
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Carex longicruris</em> Nees
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cyperaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      394
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Carex maculata</em> Boott
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cyperaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      395
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Carex myosurus</em> Nees
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cyperaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      396
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Carex nubigena</em> D.Don
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cyperaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      397
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Carex phacota</em> Spreng.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cyperaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      398
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Carex speciosa</em> Kunth
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cyperaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      399
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Carex stramentitia</em> Boott ex
                                      Boeckeler
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cyperaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      400
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Carex wightiana</em> Nees
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cyperaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      401
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Catharanthus pusillus</em> (Murray)
                                      G.Don
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Apocynaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      402
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Catharanthus roseus</em>
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Apocynaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      403
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Celosia argentea</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Amaranthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      404
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Celosia argentea</em> var.{" "}
                                      <em>cristata</em> (L.) Kuntze
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Amaranthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      405
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Celosia polygonoides</em> Retz.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Amaranthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      406
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Celosia pulchella</em> Moq.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Amaranthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      407
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cenchrus biflorus</em> Roxb.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      408
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cenchrus echinatus</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      409
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cenchrus setigerus</em> Vahl
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      410
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Centella asiatica </em>(L.) Urb.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Apiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      411
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Centipeda minima </em>(L.) A.Braun
                                      &amp; Asch.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      412
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Centotheca lappacea</em> (L.) Desv.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      413
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Centranthera indica</em> (L.) Gamble
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orobanchaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      414
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Centranthera nepalensis</em> D.Don
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orobanchaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      415
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Centranthera tranquebarica </em>
                                      (Spreng.) Merr
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orobanchaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      416
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Centratherum punctatum</em> Cass.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      417
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cerastium glomeratum</em> Thuill.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Caryophyllaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      418
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cerastium indicum</em> Wight &amp;
                                      Arn.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Caryophyllaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      419
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Ceropegia beddomei</em> Hook.f.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Apocynaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      420
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Ceropegia fimbriifera</em> Bedd.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Apocynaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      421
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Ceropegia pusilla</em> Wight &amp;
                                      Arn.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Apocynaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      422
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Ceropegia spiralis</em> Wight
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Apocynaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      423
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Chaetoseris cyanea</em> (D.Don) C.Shih
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      424
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Chamaecrista absus</em> (L.) H.S.Irwin
                                      &amp; Barneby
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      425
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Chamaecrista auricoma</em> (Benth.)
                                      V.Singh
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      426
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Chamaecrista kleinii</em> (Wight &amp;
                                      Arn.) V.Singh
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      427
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Chamaecrista mimosoides</em> (L.)
                                      Greene
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      428
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Chamaecrista pumila</em> (Lam.)
                                      K.Larsen
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      429
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Chandrasekharania keralensis</em>{" "}
                                      V.J.Nair, V.S.Ramach. &amp; Sreek.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      430
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cheirostylis flabellata</em> (A.Rich.)
                                      Wight
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      431
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cheirostylis parvifolia</em> Lindl.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      432
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Chenopodium album</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Amaranthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      433
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Chiloschista fasciata</em> (F.Muell.)
                                      Seidenf. &amp; Ormerod
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      434
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Chiloschista glandulosa</em> Blatt.
                                      &amp; McCann
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      435
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Chionachne gigantea</em> (J.Koenig)
                                      Veldkamp
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      436
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Chloris barbata</em> Sw.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      437
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Chloris roxburghiana</em> Schult.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      438
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Chlorophytum arundinaceum </em>Baker
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Asparagaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      439
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Chlorophytum heynei</em> Baker
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Asparagaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      440
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Chlorophytum indicum</em> (Willd. ex
                                      Schult. &amp; Schult.f.) Dress
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Asparagaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      441
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Chlorophytum laxum</em> R.Br.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Asparagaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      442
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Chlorophytum malabaricum</em> Baker
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Asparagaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      443
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Chlorophytum nimmonii</em> (Graham)
                                      Dalzell
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Asparagaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      444
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Chlorophytum orchidastrum</em> Lindl.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Asparagaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      445
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Chlorophytum palghatense</em>{" "}
                                      K.M.P.Kumar &amp; Adsul
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Asparagaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      446
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Chlorophytum sharmae</em> Adsul,
                                      Lekhak &amp; S.R.Yadav
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Asparagaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      447
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Chlorophytum tuberosum</em> (Roxb.)
                                      Baker
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Asparagaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      448
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Christisonia bicolor</em> Gardner
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orobanchaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      449
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Christisonia calcarata </em>Wight
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orobanchaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      450
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Christisonia indica</em> Anil Kumar
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orobanchaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      451
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Christisonia keralensis</em> Erady
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orobanchaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      452
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Christisonia tubulosa</em> (Wight)
                                      Benth. ex. Hook.f.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orobanchaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      453
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Chrozophora rottleri</em> (Geiseler)
                                      A.Juss. ex Spreng.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Euphorbiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      454
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Chrysoglossum ornatum</em> Blume
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      455
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Chrysopogon aciculatus</em> (Retz.)
                                      Trin.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      456
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Chrysopogon asper</em> B.Heyne ex
                                      Blatt. &amp; McCann
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      457
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Chrysopogon fulvus</em> (Spreng.)
                                      Chiovenda
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      458
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Chrysopogon hackelii</em> (Hook.f.)
                                      C.E.C.Fisch.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      459
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Chrysopogon narayanii </em>Sunil,
                                      Ratheesh &amp; Sivadasan
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      460
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Chrysopogon nodulibarbis</em> (Hochst.
                                      ex Steud.) Henrard
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      461
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Chrysopogon orientalis</em> (Desv.)
                                      A.Camus
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      462
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Chrysopogon purushothamanii</em> Ravi,
                                      Mohanan <em>et</em> Kiran Raj
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      463
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Chrysopogon tadulingamii</em> Sreek.,
                                      V.J.Nair &amp; N.C.Nair
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      464
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Chrysopogon velutinus</em> (Hook.f.)
                                      Bor
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      465
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Chrysopogon verticillatus</em> (Roxb.)
                                      Trin. ex Steud.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      466
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Chrysopogon zizanioides </em>(L.)
                                      Roberty
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      467
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Chrysothemis pulchella</em> Decne.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Gesneriaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      468
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cicer arietinum</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      469
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cichorium endivia</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      470
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Circaea alpina</em> subsp.{" "}
                                      <em>imaicola</em> (Asch. &amp; Magnus)
                                      Kitam.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Onagraceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      471
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cleisostoma tenuifolium</em> (L.)
                                      Garay
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      472
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cleistachne sorghoides</em> Benth.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      473
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cleome angustifolia</em> Forssk.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cleomaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      474
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cleome aspera</em> J. Konig ex DC.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cleomaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      475
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cleome chelidonii</em> L.f.&nbsp;
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cleomaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      476
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cleome gynandra</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cleomaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      477
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cleome monophylla</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cleomaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      478
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cleome rutidosperma</em> DC.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cleomaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      479
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cleome rutidosperma</em> var.{" "}
                                      <em>burmannii</em> (Wight &amp; Arn.)
                                      Siddiqui &amp; S.N.Dixit
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cleomaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      480
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cleome speciosa</em> Raf.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cleomaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      481
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cleome spinosa</em> Jacq.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cleomaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      482
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cleome viscosa</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cleomaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      483
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Clinopodium umbrosum</em> (M. Bieb.)
                                      C. Koch
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Lamiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      484
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Coelachne perpusilla</em> (Nees ex
                                      Steud.) Thwaites
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      485
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Coelachne simpliciuscula </em>(Steud.)
                                      Munro ex Benth.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      486
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Coelogyne breviscapa</em> Lindl.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      487
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Coelogyne mossiae</em> Rolfe
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      488
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Coelogyne nervosa</em> Rich.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      489
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Coelogyne odoratissima</em> Lindl.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      490
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Coix gigantea</em> Hort. ex Jacq.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      491
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Coix lacryma-jobi</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      492
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Coldenia procumbens</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Boraginaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      493
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Coleus ater </em>A.J.Paton
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Lamiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      494
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Coleus scaber </em>(Benth.) A.J.Paton
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Lamiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      495
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Colocasia esculenta </em>(L.) Schott
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Araceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      496
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Commelina attenuata</em> K.D.Koenig ex
                                      Vahl
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Commelinaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      497
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Commelina benghalensis</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Commelinaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      498
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Commelina caroliniana</em> Walter
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Commelinaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      499
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Commelina clavata</em> C.B.Clarke
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Commelinaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      500
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Commelina clavatoides</em> Nampy &amp;
                                      S.Joseph
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Commelinaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      501
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Commelina diffusa</em> Burm. F.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Commelinaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      502
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Commelina ensifolia</em> R.Br.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Commelinaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      503
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Commelina erecta</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Commelinaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      504
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Commelina imberbis</em> Ehrenb. ex
                                      Hassk.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Commelinaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      505
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Commelina indehiscens</em> E.Barnes
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Commelinaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      506
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Commelina longifolia</em> Lam.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Commelinaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      507
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Commelina maculata</em> Edgew.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Commelinaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      508
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Commelina paleata</em> Hassk.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Commelinaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      509
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Commelina paludosa</em> Blume
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Commelinaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      510
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Commelina suffruticosa</em> Blume
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Commelinaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      511
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Commelina wightii</em> Raizada
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Commelinaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      512
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Conchidium braccatum</em> (Lindl.)
                                      Brieger
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      513
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Conchidium filiforme</em> (Wight)
                                      Rauschert
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      514
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Conchidium microchilos</em> (Dalzell)
                                      Rauschert
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      515
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Conchidium muscicola</em> (Lindl.)
                                      Rauschert
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      516
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Conchidium nanum</em> (A.Rich.)
                                      Brieger
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      517
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Conyza bonariensis</em> (L.) Cronquist
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      518
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Conyza japonica</em> (Thunb.) Less.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      519
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Conyza leucantha</em> (D.Don) Ludlow
                                      &amp; Raven
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      520
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Corchorus aestuans </em>L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Malvaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      521
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Corchorus capsularis</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Malvaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      522
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Corchorus olitorius</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Malvaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      523
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Corchorus tridens</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Malvaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      524
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Corchorus trilocularis</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Malvaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      525
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Corchorus urticifolius</em> Wight
                                      &amp; Arn.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Malvaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      526
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Coreopsis grandiflora</em> Hogg ex
                                      Sweet
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      527
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Coriandrum sativum </em>L<em>. </em>
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Apiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      528
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Coronopus didymus</em> (L.) Sm.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Brassicaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      529
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Corymborkis veratrifolia</em> (Reinw.)
                                      Blume
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      530
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cosmos caudatus</em> Kunth
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      531
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cosmos sulphureus</em> Cav.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      532
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Costus erythrophyllus</em> Loes.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Costaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      533
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Costus malortieanus</em> H.Wendl.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Costaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      534
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Costus pictus</em> D.Don
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Costaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      535
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crassocephalum crepidioides</em>{" "}
                                      (Benth.) S. Moore
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      536
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crinum amabile</em> Donn ex Ker Gawl
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Amaryllidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      537
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crinum asiaticum</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Amaryllidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      538
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crinum latifolium</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Amaryllidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      539
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crinum moorei</em> Hook.f.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Amaryllidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      540
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crinum viviparum</em> (Lam.) R.Ansari
                                      &amp; V.J.Nair
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Amaryllidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      541
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crocosmia crocosmiiflora</em>{" "}
                                      (Lemoine) N.E.Br.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Iridaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      542
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria acicularis</em> Benth.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      543
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria bifaria</em> L.f.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      544
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria calycina</em> Schrank
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      545
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria clarkei</em> Gamble
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      546
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria evolvuloides</em> Wight ex
                                      Wight &amp; Arn.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      547
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria ferruginea</em> Graham ex
                                      Benth.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      548
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria fysonii</em> Dunn
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      549
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria fysonii</em> var.{" "}
                                      <em>glabra</em> Gamble
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      550
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria hebecarpa</em> (DC.) Rudd
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      551
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria hirta</em> Willd.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      552
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria humifusa</em> Benth.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      553
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria juncea</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      554
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria linifolia</em> L.f.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      555
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria medicaginea</em> Lam.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      556
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria multiflora </em>var
                                      <em>. kurisumalayana </em>(Sibichen &amp;
                                      Nampy) Krishnaraj &amp; Mohanan
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      557
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria mysorensis</em> Roth
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      558
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria nana</em> Burm.f.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      559
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria nana</em> var.{" "}
                                      <em>umbellata</em> (Wight &amp; Arn.)
                                      A.A.Ansari
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      560
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria prostrata</em> Rottler ex
                                      Willd.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      561
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria pusilla</em> Heyne ex Roth
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      562
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria quinquefolia</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      563
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria retusa</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      564
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria scabrella</em> Wight &amp;
                                      Arn.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      565
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria triquetra</em> Dalzell
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      566
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Crotalaria verrucosa</em> L
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      567
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Croton bonplandianus</em> Baill.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Euphorbiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      568
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Croton hirtus</em> L'H&eacute;r.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Euphorbiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      569
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cryptocarya griffithiana</em> Wight
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Lauraceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      570
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cryptocoryne consobrina</em> Schott
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Araceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      571
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cryptocoryne retrospiralis</em>{" "}
                                      (Roxb.) Kunth
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Araceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      572
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cryptocoryne spiralis</em> (Retz.)
                                      Fisch. ex Wydler
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Araceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      573
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Curculigo orchioides </em>Gaertn
                                      <em>. </em>
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Hypoxidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      574
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Curculigo trichocarpa</em> (Wight)
                                      Bennet &amp; Raizada
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Hypoxidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      575
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Curcuma aeruginosa</em> Roxb.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Zingiberaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      576
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Curcuma amada glabra</em> Velay.,
                                      Unnikr., Asha &amp; Maya
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Zingiberaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      577
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Curcuma amada </em>Roxb
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Zingiberaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      578
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Curcuma aromatica </em>Salisb.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Zingiberaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      579
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Curcuma aurantiaca</em> Zijp
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Zingiberaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      580
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Curcuma coriacea</em> Mangaly &amp;
                                      M.Sabu
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Zingiberaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      581
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Curcuma decipiens</em> Dalzell
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Zingiberaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      582
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Curcuma haritha</em> Mangaly &amp;
                                      Sabu
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Zingiberaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      583
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Curcuma longa </em>L
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Zingiberaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      584
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Curcuma montana</em> Roxb.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Zingiberaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      585
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Curcuma mutabilis</em>{" "}
                                      &Scaron;korničk., M.Sabu &amp; Prasanthk.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Zingiberaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      586
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Curcuma oligantha</em> var.{" "}
                                      <em>oligantha</em>
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Zingiberaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      587
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Curcuma pseudomontana</em> J.Graham
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Zingiberaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      588
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Curcuma vamana</em> M.Sabu &amp;
                                      Mangaly
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Zingiberaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      589
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Curcuma zanthorrhiza </em>Roxb
                                      <em>.</em>
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Zingiberaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      590
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Curcuma zedoaria </em>(Christm.)
                                      Roscoe
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Zingiberaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      591
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cyanotis arachnoidea</em> C.B.Clarke
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Commelinaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      592
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cyanotis arcotensis</em> R.S.Rao
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Commelinaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      593
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cyanotis burmanniana </em>Wight
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Commelinaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      594
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cyanotis cerifolia</em> R.S.Rao &amp;
                                      Kammathy
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Commelinaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      595
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cyanotis cristata</em> (L.) D.Don
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Commelinaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      596
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cyanotis fasciculata</em> (B.Heyne ex
                                      Roth) Schult. &amp; Schult.f.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Commelinaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      597
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cyanotis obtusa</em> (Trimen) Trimen
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Commelinaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      598
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cyanotis papilionacea</em> (Burm.f.)
                                      Schult. &amp; Schult.f
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Commelinaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      599
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cyanotis pilosa</em> Schult. &amp;
                                      Schult.f.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Commelinaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      600
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cyanotis racemosa</em> B.Heyne ex
                                      Hassk.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Commelinaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      601
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cyanotis thwaitesii</em> Hassk.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Commelinaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      602
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cyanotis tuberosa</em> (Roxb.) Schult.
                                      &amp; Schult.f.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Commelinaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      603
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cyanotis villosa</em> (Spreng.)
                                      Schult. &amp; Schult.f.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Commelinaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      604
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cyanthillium cinereum </em>(L.) H.Rob
                                      <em>. </em>
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      605
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cyathocline lutea</em> law ex
                                      Wight&nbsp;
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      606
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cyathocline purpurea</em> (Buch.-Ham.
                                      ex D.Don) Kuntze
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      607
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cyathula prostrata </em>(L.) Blume
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Amaranthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      608
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cyathula tomentosa</em> (Roth) Moq.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Amaranthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      609
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cyclanthus bipartitus</em> Poit. ex A.
                                      Rich.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cyclanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      610
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cymbidium aloifolium</em> (L.) Sw.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      611
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cymbidium bicolor</em> Lindl.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      612
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cymbidium haematodes</em> Lindl.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      613
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cymbopogon caesius</em> (Hook. &amp;
                                      Arn.) Stapf
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      614
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cymbopogon citratus</em> (DC.) Stapf
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      615
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cymbopogon csus </em>(Nees ex Steud.)
                                      W.Watson
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      616
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cymbopogon martini</em> (Roxb.) Wats.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      617
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cymbopogon nardus</em> (L.) Rendle
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      618
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cynodon barberi</em> Rang. &amp;
                                      Tadul.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      619
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cynodon dactylon </em>(L.) Pers.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      620
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cynodon radiatus </em>Roth
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      621
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cynoglossum zeylanicum</em> (Sw. ex
                                      Lehm.) Thunb. ex Brand
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Boraginaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      622
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cyperus alopecuroides</em> Rottboell
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cyperaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      623
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cyperus alternifolius</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cyperaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      624
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cyperus alternifolius</em> L. ssp.{" "}
                                      <em>flabelliformis</em> (Rottb.) Kukenth.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cyperaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      625
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cyperus amabilis</em> Vahl
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cyperaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      626
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cyperus arenarius</em> Retz.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cyperaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      627
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cyperus articulatus</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cyperaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      628
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cyperus brevifolius </em>var.
                                      <em> stellulatus </em>(Valck.Sur.)
                                      K&uuml;k.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cyperaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      629
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cyperus bulbosus</em> Vahl
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cyperaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      630
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cyperus castaneus</em> Willd.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cyperaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      631
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cyperus cuspidatus</em> Kunth
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cyperaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      632
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cyperus cyperinus</em> (Retz.) Sur.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cyperaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      633
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cyperus cyperoides</em> (L.) Kuntze
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cyperaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      634
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cyperus diffusus</em> Vahl
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cyperaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      635
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cyperus dives</em> Delile
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cyperaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      636
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cyperus dubius</em> Rottb.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cyperaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      637
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cyperus exaltatus</em> Retzius
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cyperaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      638
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cyperus hortensis</em> (Salzm. ex
                                      Steud.) Dorr
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cyperaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      639
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cyperus metzii</em> (Hochst. ex
                                      Steud.) Mattf. &amp; K&uuml;k.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cyperaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      640
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cyperus nutans</em> Vahl
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cyperaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      641
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cyperus pangorei</em> Rottboell
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cyperaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      642
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cyperus paniceus</em> (Rottb.)
                                      Boeckeler
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cyperaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      643
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cyperus rotundus </em>L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cyperaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      644
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cyperus sesquiflorus</em> subsp.{" "}
                                      <em>cylindricus</em> (Nees) T.Koyama
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cyperaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      645
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cyperus sphacelatus</em> Rottb.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cyperaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      646
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cyperus yadavii</em> Wad.Khan,
                                      D.P.Chavan &amp; Solanke
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cyperaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      647
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cyperus zollingeri</em> Steud.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cyperaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      648
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cyrtococcum deccanense</em> Bor
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      649
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cyrtococcum longipes</em> (Wight &amp;
                                      Arn. ex Hook.f.) A.Camus
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      650
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cyrtococcum muricatum</em> (Retz.) Bor
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      651
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cyrtococcum oxyphyllum</em> (Steud.)
                                      Stapf
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      652
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cyrtococcum patens</em> (L.) A.Camus
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      653
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Cyrtococcum trigonum</em> A.Camus
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      654
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dahlia hortensis</em> Guillaumin
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      655
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Danthonidium gammiei</em> (Bhide)
                                      C.E.Hubb.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      656
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Daucus carota</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Apiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      657
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dendrobium anamalayanum</em>{" "}
                                      Chandrab., V.Chandras. &amp; N.C.Nair
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      658
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dendrobium aphyllum</em> (Roxb.)
                                      C.E.C.Fisch.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      659
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dendrobium aqueum</em> Lindl.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      660
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dendrobium barbatulum</em> Lindl.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      661
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dendrobium crepidatum</em> Lindl.
                                      &amp; Paxton
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      662
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dendrobium diodon</em> subsp.{" "}
                                      <em>kodayarensis</em> Gopalan &amp;
                                      A.N.Henry
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      663
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dendrobium herbaceum</em> Lindl.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      664
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dendrobium heterocarpum</em> Wall. ex
                                      Lindl.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      665
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dendrobium heyneanum</em> Lindl.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      666
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dendrobium microbulbon</em> A.Rich.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      667
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dendrobium nanum</em> Hook.f.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      668
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dendrobium nutans</em> Lindl.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      669
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dendrobium ovatum</em> (L.) Kraenzl.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      670
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dendrobium panduratum</em> Lindl.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      671
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dendrobium panduratum</em> var.{" "}
                                      <em>villosum</em> Gopalan &amp; A.N.Henry
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      672
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dendrobium peguanum</em> Lindl
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      673
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dendrobium salaccense</em> (Blume)
                                      Lindl.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      674
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dendrobium wightii </em>A.D.Hawkes
                                      &amp; A.H.Heller
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      675
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dentella repens</em> (L.) J.R.Forst.
                                      &amp; G.Forst.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Rubiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      676
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dentella repens</em> var.{" "}
                                      <em>serpyllifolia</em> (Wall. ex Craib)
                                      Verdc.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Rubiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      677
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Desmodiastrum racemosum </em>(Benth.)
                                      A.Pramanik &amp; Thoth.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      678
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Desmodiastrum racemosum</em> var.{" "}
                                      <em>rotundifolium</em> (Baker) A.Pramanik
                                      &amp; Thoth.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      679
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Desmodium alysicarpoides</em>{" "}
                                      Knaap-van Meeuwen
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      680
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Desmodium heterocarpon</em> (L.) DC.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      681
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Desmodium heterocarpon</em> var.{" "}
                                      <em>strigosum</em> Neeuw.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      682
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Desmodium heterophyllum</em> (Willd.)
                                      DC.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      683
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Desmodium laxiflorum</em> DC.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      684
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Desmodium laxum</em> DC
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      685
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Desmodium microphyllum</em> (Thunb.)
                                      DC.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      686
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Desmodium scorpiurus</em> (Sw.) Desv.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      687
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Desmodium tortuosum</em> (Sw.) DC
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      688
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Desmodium triflorum </em>(L.) DC
                                      <em>.</em>
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      689
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Desmodium uncinatum</em> (Jacq.) DC.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      690
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Desmodium zonatum</em> Miq.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      691
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Desmostachya bipinnata</em> (L.) Stapf
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      692
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dianella ensifolia</em> (L.)
                                      Redout&eacute;
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Asparagaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      693
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dianella tasmanica</em> Hook.f.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Asparagaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      694
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dianthus caryophyllus</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Caryophyllaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      695
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dianthus chinensis</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Caryophyllaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      696
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dicerma biarticulatum</em> (L.) DC
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      697
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dichaetaria wightii</em> Nees ex
                                      Steud.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      698
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dichanthium annulatum</em> (Forssk.)
                                      Stapf
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      699
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dichanthium caricosum</em> (L.)
                                      A.Camus
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      700
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dichanthium foulkesii</em> (Hook.f.)
                                      Jain &amp; Deshpande
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      701
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dichanthium oliganthum</em> (Hochst.
                                      ex Steud.) Cope
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      702
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dichrocephala chrysanthemifolia</em>{" "}
                                      (Blume) DC.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      703
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dichrocephala integrifolia</em> (L.f.)
                                      Kuntze
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      704
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dicliptera cuneata</em> Nees
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      705
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dicliptera verticillata</em> (Forssk.)
                                      Christensen
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      706
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dictyospermum montanum</em> Wight
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Commelinaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      707
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dictyospermum ovalifolium</em> Wight
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Commelinaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      708
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Didymoplexis pallens</em> Griff.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      709
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Didymoplexis seidenfadenii</em>{" "}
                                      Sath.Kumar &amp; Ormerod
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      710
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dieffenbachia seguine</em> (Jacq.)
                                      Schott
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Araceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      711
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dienia ophrydis</em> (J.Koenig)
                                      Seidenf.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      712
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Digera muricata</em> (L.) Mart.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Amaranthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      713
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Digitaria abludens</em> (Roem. &amp;
                                      Schult.) Veldkamp
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      714
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Digitaria bicornis</em> (Lam.) Roem.
                                      &amp; Schult.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      715
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Digitaria ciliaris</em> (Retz.) Koeler
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      716
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Digitaria griffithii</em> (Hook.f.)
                                      Henrard
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      717
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Digitaria longiflora</em> (Retz.)
                                      Pers.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      718
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Digitaria setigera</em> Roth ex Roem.
                                      &amp; Schult.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      719
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Digitaria ternata</em> (A. Rich.)
                                      Stapf ex Dyer
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      720
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Digitaria violascens</em> Link
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      721
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Digitaria wallichiana</em> (Wight
                                      &amp; Arn. ex Steud.) Stapf&nbsp;
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      722
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dimeria agasthyamalayana</em> Kiran
                                      Raj &amp; Ravi
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      723
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dimeria avenacea </em>(Retz.)
                                      C.E.C.Fisch.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      724
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dimeria bialata</em> C.E.C.Fisch
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      725
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dimeria borii</em> Sreek., V.J.Nair
                                      &amp; N.C.Nair
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      726
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dimeria ceylanica </em>Bor
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      727
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dimeria chelariensis</em> Ravi
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      728
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dimeria connivens</em> Hack.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      729
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dimeria copeana</em> Sreek., V.J.Nair
                                      &amp; N.C.Nair [
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      730
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dimeria copei </em>Ravi
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      731
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dimeria deccanensis</em> Bor
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      732
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dimeria eradii</em> Ravi
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      733
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dimeria fischeri</em> Bor
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      734
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dimeria fuscescens</em> Trin
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      735
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dimeria gracilis</em> Nees ex Steud.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      736
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dimeria hohenackeri</em> Hochst. ex
                                      Miq
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      737
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dimeria hohenackeri</em> Hochst. ex
                                      Miq. subsp. <em>kodaguensis</em>
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      738
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dimeria idukkiensis</em> Ravi &amp;
                                      Anil Kumar
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      749
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dimeria jainii</em> Sreek., V.J.Nair
                                      &amp; N.C.Nair
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      740
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dimeria josephi</em> Ravi &amp;
                                      N.Mohanan
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      741
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dimeria kanjirapallilana</em>{" "}
                                      K.C.Jacob
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      742
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dimeria keralae</em> N.C.Nair, Sreek.
                                      &amp; V.J.Nair
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      743
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dimeria lawsonii</em> (Hook.f.)
                                      C.E.C.Fisch
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      744
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dimeria mooneyi</em> Raizada
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      745
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dimeria ornithopoda</em> Trin.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      746
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dimeria pubescens</em> Hack
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      747
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dimeria raizadae</em> V.J.Nair, Sreek.
                                      &amp; N.C.Nair
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      748
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dimeria sivarajanii</em> N.Mohanan
                                      &amp; Ravi
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      749
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dimeria sreenarayanae</em> Ravi &amp;
                                      Anil Kumar
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      750
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dimeria thwaitesii</em> Hack.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      751
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Diodella teres</em> (Walter) Small
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Rubiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      752
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Diplocentrum congestum</em> Wight
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      753
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Diplocentrum recurvum</em> Lindl.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      754
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Diploprora championii</em> (Lindl.)
                                      Hook.f.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      755
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Disperis neilgherrensis</em> Wight
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      756
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Disporum cantoniense</em> (Lour.)
                                      Merr.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Colchicaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      757
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dorstenia indica</em> Wall. ex Wight
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Moraceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      758
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Drimia indica</em> (Roxb.) Jessop
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Asparagaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      759
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Droguetia iners</em> subsp.{" "}
                                      <em>urticoides</em> (Wight) Friis &amp;
                                      Wilmot-Dear
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Urticaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      760
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Drosera burmanni</em> Vahl
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Droseraceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      761
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Drosera indica</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Droseraceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      762
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Drymaria diandra</em> Blume
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Caryophyllaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      763
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dyschoriste nagchana</em> (Nees)
                                      S.S.R. Bennet
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      764
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Dysphania ambrosioides</em> (L.)
                                      Mosyakin &amp; Clemants
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Amaranthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      765
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Eclipta prostrata </em>(L.) L
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      766
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Eclipta prostrata</em> var.{" "}
                                      <em>dixitii</em> An.Kumar &amp; K.K.Khanna
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      767
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Elatostema acuminatum</em> (Poir.)
                                      Brongn.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Urticaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      768
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Elatostema cuneatum</em> Wight
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Urticaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      769
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Elatostema lineolatum</em> var.{" "}
                                      <em>lineare</em> Wedd.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Urticaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      770
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Elatostema lineolatum</em> var.{" "}
                                      <em>setosum</em> Henry
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Urticaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      771
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Elatostema lineolatum</em> Wight
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Urticaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      772
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Elatostema lineolatum</em> Wight var.{" "}
                                      <em>falcigera</em> Thw.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Urticaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      773
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Elatostema sessile</em> J.R.Forst.
                                      &amp; G.Forst
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Urticaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      774
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Elatostema surculosum</em> Wight
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Urticaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      775
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Elatostema wightii</em> Hook.f.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Urticaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      776
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Eleocharis ochrostachys</em> Steud
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cyperaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      777
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Elephantopus scaber </em>L
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      778
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Elettaria cardamomum </em>(L.) Maton
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Zingiberaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      779
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Elettaria ensal</em> (Gaertn.) Abeyw.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Zingiberaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      780
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Eleusine coracana</em> (L.) Gaertn.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      781
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Eleusine indica</em> (L.) Gaertn.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      782
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Eleutheranthera ruderalis</em> (Sw.)
                                      Sch.Bip.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      783
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Eleutherine bulbosa</em> (Mill.) Urban
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Iridaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      784
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Emilia javanica</em> (Burm.f.)
                                      C.B.Rob.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      785
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Emilia ramulosa</em> Gamb.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      786
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Emilia scabra</em> DC.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      787
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Emilia sonchifolia </em>(L.) DC. ex DC
                                      <em>. </em>
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      788
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Enicostema axillare</em> subsp.{" "}
                                      <em>littorale</em> (Blume) A.Raynal
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Gentianaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      789
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Enneapogon persicus</em> Boiss.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      790
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Ensete superbum </em>(Roxb.) Cheesman
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Musaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      791
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Enteropogon dolichostachyus </em>
                                      (Lag.) Keng
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      792
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Enteropogon monostachyos</em> (Vahl)
                                      K.Schum. ex Engl.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      793
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Epidendrum radicans</em> Pav. ex
                                      Lindl.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      794
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Epipogium roseum</em> (D.Don) Lindl.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      795
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Episcia cupreata</em> Hanst.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Gesneriaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      796
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Eragrostiella bifaria</em> (Vahl) Bor
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      797
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Eragrostis atrovirens</em> (Desf.)
                                      Trin. ex Steud.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      798
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Eragrostis cilianensis</em> (All.)
                                      Janch.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      799
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Eragrostis ciliaris</em> (L.) R.Br.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      800
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Eragrostis cumingii</em> Steud.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      801
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Eragrostis gangetica</em> (Roxb.)
                                      Steud.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      802
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Eragrostis japonica</em> (Thunb.)
                                      Trin.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      803
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Eragrostis maderaspatana</em> Bor
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      804
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Eragrostis nigra</em> Nees ex Steud.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      805
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Eragrostis tef</em> (Zucc.) Trotter
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      806
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Eragrostis tenella</em> (Linn.) P.
                                      Beauv. ex Roem. &amp; Schult.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      807
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Eragrostis tenuifolia</em> (A.Rich.)
                                      Hochst. ex Steud.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      808
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Eragrostis tremula </em>Hochst.ex
                                      Steud.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      809
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Eragrostis viscosa</em> (Retz.) Trin.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      810
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Eranthemum capense</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      811
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Eranthemum capense</em> var.{" "}
                                      <em>concanense</em> (Clarke) Sant.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      812
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Erechtites valerianifolia</em> (Link
                                      ex Wolf) Less. ex DC.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      813
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Eria albiflora</em> Rolfe
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      814
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Eria exilis</em> Hook.f.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      815
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Eria mysorensis</em> Lindl.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      816
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Eria pauciflora</em> Wight
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      817
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Eria pseudoclavicaulis</em> Blatt.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      818
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Erigeron Aegyptiacus</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      819
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Erigeron canadensis</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      820
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Erigeron karvinskianus</em> DC.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      821
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Erigeron sublyratus</em> DC.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      822
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Erigeron trilobus</em> (Decne.) Boiss.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      823
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Eriocapitella </em>rivularis
                                      (Buch.-Ham. ex DC.) Christenh. &amp; Byng
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Ranunculaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      824
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Eryngium foetidum</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Apiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      825
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Eulalia phaeothrix</em> (Hack.) O.
                                      Ktze.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      826
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Eulalia thwaitesii</em> (Hack.) Kuntze
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      827
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Eulophia epidendraea</em>{" "}
                                      (J.K&ouml;nig ex Retz.) C.E.C.Fisch
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      828
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Eulophia flava</em> (Lindl.) Hook.f.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      829
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Eulophia graminea</em> Lindl.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      830
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Eulophia pratensis</em> Lindl.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      831
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Eulophia pulchra</em> (Thouars) Lindl.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      832
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Eulophia spectabilis</em> (Dennst.)
                                      Suresh
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      833
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Eulophia zollingeri</em> (Rchb.f.)
                                      J.J.Sm.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      834
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Euphorbia cristata</em> B.Heyne ex
                                      Roth
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Euphorbiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      835
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Euphorbia deccanensis</em> V.S.Raju
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Euphorbiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      836
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Euphorbia dracunculoides</em> Lam.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Euphorbiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      837
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Euphorbia heterophylla</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Euphorbiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      838
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Euphorbia heyneana</em> Spreng.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Euphorbiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      839
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Euphorbia hirta</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Euphorbiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      840
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Euphorbia indica</em> Lam.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Euphorbiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      841
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Euphorbia pallens</em> Dillwyn
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Euphorbiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      842
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Euphorbia prostrata</em> Aiton
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Euphorbiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      843
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Euphorbia rosea</em> Retzius
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Euphorbiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      844
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Evolvulus alsinoides </em>(L.) L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Convolvulaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      845
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Evolvulus nummularius</em> (L.) L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Convolvulaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      846
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Exacum anamallayanum</em> Bedd.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Gentianaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      847
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Exacum atropurpureum</em> Bedd.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Gentianaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      848
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Exacum courtallense</em> Arn.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Gentianaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      849
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Exacum lawii</em> C.B.Clarke
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Gentianaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      850
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Exacum pedunculatum </em>L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Gentianaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      851
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Exacum pumilum</em> Griseb.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Gentianaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      852
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Exacum sessile</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Gentianaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      853
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Exacum tetragonum</em> Roxb.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Gentianaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      854
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Exacum tetragonum </em>var.<em> g</em>
                                      rande (Klack.) Shahina &amp; Nampy
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Gentianaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      855
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Exacum travancoricum</em> Bedd.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Gentianaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      856
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Exacum walkeri</em> Arn. ex Griseb.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Gentianaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      857
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Exacum wightianum</em> Arn.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Gentianaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      858
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Geophila repens </em>(L.) I.M.Johnst
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Rubiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      859
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Glebionis segetum</em> (L.) Fourr.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      860
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Habenaria malintana</em> (Blanco)
                                      Merr.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      861
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Habenaria periyarensis</em> Sasidh.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      862
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Heliotropium indicum </em>L
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Boraginaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      863
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Hellenia speciosa </em>(J.Koenig)
                                      S.R.Dutta
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Costaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      864
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Hemigraphis alternata </em>(Burm.f.)
                                      T. Anderson
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      865
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Henckelia bracteata</em> Janeesha
                                      &amp; Nampy
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Gesneriaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      866
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Henckelia fischeri </em>(Gamble)
                                      A.Weber &amp; B.L.Burtt
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Gesneriaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      867
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Henckelia humboldtiana</em> (Gardner)
                                      A.Weber &amp; B.L.Burtt
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Gesneriaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      868
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Henckelia incana</em> (Vahl) Spreng.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Gesneriaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      869
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Henckelia innominata</em> (B.L.Burtt)
                                      A.Weber &amp; B.L.Burtt
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Gesneriaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      870
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Henckelia lyrata</em> (Wight) A.Weber
                                      &amp; B.L.Burtt
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Gesneriaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      871
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Henckelia macrostachya </em>(E.Barnes)
                                      A.Weber &amp; B.L.Burtt
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Gesneriaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      872
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Henckelia meeboldii</em> (W.W.Sm.
                                      &amp; Ramaswami) A.Weber &amp; B.L.Burtt
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Gesneriaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      873
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Henckelia ovalifolia</em> (Wight)
                                      A.Weber &amp; B.L.Burtt
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Gesneriaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      874
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Henckelia pradeepiana</em> Nampy,
                                      Manudev &amp; A.Weber.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Gesneriaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      875
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Henckelia repens</em> (Bedd.) A.Weber
                                      &amp; B.L.Burtt
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Gesneriaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      876
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Henckelia wayanadensis</em> Janeesha
                                      &amp; Nampy
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Gesneriaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      877
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Henckelia wightii</em> (C.B.Clarke)
                                      A.Weber &amp;B.L.Burtt
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Gesneriaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      878
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Herissantia crispa</em> (L.) Briz.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Malvaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      879
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Hybanthus enneaspermus </em>(L.)
                                      F.Muell
                                      <em>. </em>
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Violaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      880
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Hydrocotyle javanica </em>Thunb.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Apiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      881
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Hylodesmum repandum</em> (Vahl)
                                      H.Ohashi &amp; R.R.Mill
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      882
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Imperata cylindrica </em>(L.) Raeusch.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      883
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Indigofera tinctoria </em>L
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      884
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Iris domestica</em> (L.) Goldblatt
                                      &amp; Mabb.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Iridaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      885
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Ischaemum lanatum</em> Ravi, Mohanan{" "}
                                      <em>et</em> Shaju
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      886
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Jansenella griffithiana</em>{" "}
                                      (C.Muell.) Bor
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      887
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Jerdonia indica</em> Wight
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Gesneriaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      888
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Justicia carnea</em> Lindl.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      889
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Justicia diffusa</em> var.{" "}
                                      <em>hedyotidifolia</em> (Nees) Clarke
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      890
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Justicia diffusa</em> Willd.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      891
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Justicia ekakusuma </em>A.K. Pradeep
                                      &amp; V.V. Sivarajan
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      892
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Justicia glabra</em> Koenig ex Roxb.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      893
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Justicia glauca</em> Rottl.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      894
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Justicia japonica</em> (Thunb.) Ellis
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      895
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Justicia latispica</em> (Clarke)
                                      Gamble
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      896
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Justicia nagpurensis</em> V.A.W.Graham
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      897
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Justicia neesii</em> T.P. Ramamoorthy.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      898
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Justicia pathanamthittiensis</em>{" "}
                                      Remadevi &amp; Binoj Kumar
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      899
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Justicia procumbens</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      900
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Justicia prostrata</em> Gamble
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      901
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Justicia quinqueangularis</em>{" "}
                                      K.D.Koenig ex Roxb.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      902
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Justicia tranquebariensis</em> L.f.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      903
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Justicia trinervia</em> Vahl
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      904
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Justicia vahlii</em> Roth
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      905
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Justicia wynaadensis</em> (Nees)
                                      T.Anderson
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      906
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Kaempferia elegans</em> (Wall.) Baker
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Zingiberaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      907
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Kaempferia galanga </em>L
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Zingiberaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      908
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Kaempferia rotunda </em>L<em>. </em>
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Zingiberaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      909
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Kalanchoe bhidei</em> T.Cooke
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Crassulaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      910
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Kalanchoe blossfeldiana</em> Poelln.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Crassulaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      911
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Kalanchoe delagoensis</em> Eckl. &amp;
                                      Zeyh.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Crassulaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      912
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Kalanchoe grandiflora</em> Wight &amp;
                                      Arn.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Crassulaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      913
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Kalanchoe laciniata</em> (L.) DC.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Crassulaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      914
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Kalanchoe lanceolata</em> (Forssk.)
                                      Pers.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Crassulaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      915
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Kalanchoe olivacea</em> Dalz.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Crassulaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      916
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Knoxia hookeriana</em>{" "}
                                      (R.Bhattacharjee &amp; Deb) Subba Rao
                                      &amp; Kumari
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Rubiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      917
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Knoxia sumatrensis</em> (Retz.) DC
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Rubiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      918
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Knoxia wightiana</em> Wall. &amp;
                                      G.Don
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Rubiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      919
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Korthalsella japonica</em> (Thunb.)
                                      Engl.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Santalaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      920
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Kyllinga nemoralis </em>(J.R.Forst.
                                      &amp; G.Forst.) Dandy ex Hutch. &amp;
                                      Dalziel
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cyperaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      921
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Lepidagathis keralensis</em> P.V.
                                      Madhusoodanan &amp; N.P. Singh
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      922
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Leucas aspera </em>(Willd.) Link
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Lamiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      923
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Leucas lavandulifolia </em>Sm
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Lamiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      924
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Lipoblepharis urticifolia</em> (Blume)
                                      Orchard
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      925
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Lysimachia ovalis </em>(Ruiz &amp;
                                      Pav.) U.Manns &amp; Anderb
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Primulaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      926
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Maranta arundinacea </em>L
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Marantaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      927
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Meistera agastyamalayana </em>
                                      (V.P.Thomas &amp; M.Sabu) &Scaron;korničk.
                                      &amp; M.F.Newman
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Zingiberaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      928
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Meistera ghatica </em>(K.G.Bhat)
                                      &Scaron;korničk. &amp; M.F.Newman
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Zingiberaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      929
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Meistera newmanii </em>(M.Sabu &amp;
                                      V.P.Thomas) &Scaron;korničk. &amp;
                                      M.F.Newman
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Zingiberaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      930
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Meistera sahyadrica </em>(V.P.Thomas
                                      &amp; M.Sabu) &Scaron;korničk. &amp;
                                      M.F.Newman
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Zingiberaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      931
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Mimosa pudica </em>L<em>. </em>
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Leguminosae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      932
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Mirabilis jalapa</em>
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Nyctaginaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      933
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Molineria capitulata</em> (Lour.)
                                      Herb.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Hypoxidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      934
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Nanorrhinum ramosissimum</em> (Wall.)
                                      Betsche
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Plantaginaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      935
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Naregamia alata </em>Wight &amp; Arn
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Meliaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      936
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Neanotis decipiens</em> (Hook.f.)
                                      Lewis
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Rubiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      937
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Neanotis indica</em> (DC.) W.H.Lewis
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Rubiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      938
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Neanotis longiflora</em> (Hutch.)
                                      W.H.Lewis
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Rubiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      939
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Neanotis rheedei</em> (Wall. ex Wight
                                      &amp; Arn.) W.H.Lewis
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Rubiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      940
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Neanotis subtilis</em> (Miq.) Govaerts
                                      ex Punekar &amp; Lakshmin
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Rubiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      941
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Neanotis tubulosa</em> (G.Don) Mabb.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Rubiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      942
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Nelsonia canescens</em> (Lam.) Spreng.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      943
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Neomarica gracilis</em> (Herb.)
                                      Sprague
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Iridaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      944
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Nervilia concolor </em>(Blume) Schltr
                                      <em>. </em>
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      945
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Nervilia crociformis </em>(Zoll. &amp;
                                      Moritzi) Seidenf<em>. </em>
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      946
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Nervilia infundibulifolia</em> Blatt.
                                      &amp; McCann
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      947
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Nervilia plicata </em>(Andrews) Schltr
                                      <em>. </em>
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      948
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Neurocalyx calycinus</em> (R.Br. ex
                                      Benn.) Rob.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Rubiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      949
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Neyraudia arundinacea</em> (L.)
                                      Henrard
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      950
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Nicandra physalodes</em> (L.) Gaertn
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Solanaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      951
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Nicotiana tabacum</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Solanaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      952
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Nothosaerva brachiata</em> (L.) Wight
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Amaranthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      953
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Ocimum americanum </em>L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Lamiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      954
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Ocimum basilicum </em>L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Lamiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      955
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Ocimum filamentosum</em> Forssk.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Lamiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      956
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Oldenlandia corymbosa </em>L
                                      <em>. </em>
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Rubiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      957
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Oldenlandia tenelliflora</em> (Blume)
                                      Kuntze
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Rubiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      958
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Ophiorrhiza barnesii</em> C.E.C.Fisch.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Rubiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      959
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Ophiorrhiza brunonis</em> Wight &amp;
                                      Arn.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Rubiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      960
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Ophiorrhiza radicans</em> Gardner ex
                                      Thwaites
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Rubiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      961
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Orthosiphon thymiflorus </em>(Roth)
                                      Sleesen
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Lamiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      962
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Oryza sativa </em>L<em>.</em>
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      963
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Oxalis corniculata </em>L
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Oxalidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      964
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Pedalium murex </em>L<em>.</em>
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Pedaliaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      965
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Phalaenopsis mysorensis</em>{" "}
                                      C.J.Saldanha
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      966
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Phalaenopsis parishii</em> Rchb.f.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      967
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Phyla nodiflora </em>(L.) Greene
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Verbenaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      968
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Phyllanthus amarus </em>Schumach.
                                      &amp; Thonn<em>.</em>
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Phyllanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      969
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Phyllorkis nilgherensis</em> (Wight)
                                      Kuntze
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      970
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Physalis angulata </em>L<em>.</em>
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Solanaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      971
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Pinalia polystachya</em> (A.Rich.)
                                      Kuntze
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      972
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Platostoma hispidum</em> (L.)
                                      A.J.Paton
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Lamiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      973
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Plectranthus ambonicus </em>(Lour.)
                                      Spreng
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Lamiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      974
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Pogostemon cablin </em>(Blanco) Benth
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Lamiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      975
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Pogostemon deccanensis</em>{" "}
                                      (Panigrahi) Press
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Lamiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      976
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Pogostemon erectus</em> (Dalzell)
                                      Kuntze
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Lamiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      977
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Pouzolzia zeylanica </em>(L.) Benn
                                      <em>.</em>
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Urticaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      978
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Pseudopogonatherum trispicatum</em>{" "}
                                      (Schult.) Ohwi
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Poaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      979
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Queenslandiella hyalina</em> (Vahl)
                                      Ballard
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Cyperaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      980
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Rhopalephora scaberrima</em> (Blume)
                                      Faden
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Commelinaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      981
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Ruellia patula</em> Jacq.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      982
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Ruellia prostrata</em> Poir.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      983
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Ruellia sivarajanii</em> Sreedevi,
                                      Remadevi &amp; Binojkumar
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Acanthaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      984
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Ruta chalepensis </em>L<em>.</em>
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Rutaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      985
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Sansevieria roxburghiana </em>Schult.
                                      &amp; Schult. f.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Asparagaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      986
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Scoparia dulcis </em>L<em>.</em>
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Plantaginaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      987
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Seidenfia rheedei </em>(Sw.) Szlach
                                      <em>.</em>
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      988
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Sesamum indicum </em>L<em>.</em>
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Pedaliaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      989
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Sida cordata </em>(Burm.f.)
                                      Borss.Waalk.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Malvaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      990
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Solanum americanum </em>Mill.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Solanaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      991
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Solanum virginianum </em>L<em>.</em>
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Solanaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      992
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Spermacoce hispida </em>L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Rubiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      993
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Spermacoce ocymoides</em> Burm.f.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Rubiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      994
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Spermacoce pusilla</em> Wall.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Rubiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      995
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Sphaeranthus indicus </em>L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      996
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Sphagneticola calendulacea</em> (L.)
                                      Pruski
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      997
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Sphagneticola trilobata </em>(L.)
                                      Pruski
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      998
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Tanacetum</em> <em>parthenium</em>{" "}
                                      (L.) Sch.-Bip.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      999
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Tragia involucrata </em>L<em>.</em>
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Euphorbiaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      1000
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Wahlenbergia hookeri</em> (C.B.Clarke)
                                      Tuyn
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Campanulaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      1001
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Wahlenbergia marginata</em> (Thunb.)
                                      DC.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Campanulaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      1002
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Waltheria indica</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Malvaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      1003
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Xanthium strumarium </em>L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      1004
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Xanthosoma sagittifolium</em> (L.)
                                      Schott
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Araceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      1005
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Xenikophyton seidenfadenianum</em>{" "}
                                      M.Kumar, Sequiera &amp; J.J.Wood
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      1006
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Xenikophyton smeeanum</em> (Reichb.f.)
                                      Garay
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Orchidaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      1007
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Xyris capensis</em> Thunb.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Xyridaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      1008
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Xyris complanata</em> R.Br.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Xyridaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      1009
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Xyris indica</em> L.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Xyridaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      1010
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Youngia fuscipappa</em> Thwaites
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      1011
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Youngia japonica</em> (L.) DC.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      1012
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Youngia nilgiriensis</em> Babc.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Compositae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      1013
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Zingiber officinale </em>Roscoe
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Zingiberaceae
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ width: "80px" }}>
                                    <p style={{ fontSize: "0.999999em" }}>
                                      1014
                                    </p>
                                  </td>
                                  <td width="425">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      <em>Zingiber zerumbet </em>(L.) Roscoe ex
                                      Sm.
                                    </p>
                                  </td>
                                  <td width="136">
                                    <p style={{ fontSize: "0.999999em" }}>
                                      Zingiberaceae
                                    </p>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </section>
                          <p style={{ fontSize: "0.999999em" }}>&nbsp;</p>
                        </p>
                      </section>
                    </li>{" "}
                    <br />
                  </ul>
                  <li className="nav-item">
                    <section id="Conclusion">
                      <p
                        style={{
                          textAlign: "justify",
                          fontSize: "0.999999999em",
                        }}
                      >
                        <h3>5. Conclusion</h3>
                        Plant diversity is the variety of plants in an area.
                        Assessment of plant diversity provide insights to the
                        floral wealth, which helps in evolving strategies for
                        conservation. The study documented trees, shrubs and
                        herb species in Kerala and analyze the spatial
                        distribution of plants district-wise in Kerala. Among
                        the total species compiled, herbs constitute the highest
                        number in total species of Kerala and the total species
                        of each district. In the present study, districts which
                        are high elevated regions like Idukki, Palakkad and
                        Wayanad has the highest number of species among the
                        districts. Species rich zones in Kerala are witnessing
                        degradation due to large-scale land cover changes with
                        unplanned developmental activities in the ecologically
                        sensitive and hydrologically relevant regions evident
                        from the widespread monoculture plantations, land
                        degradation leading to deforestation, urbanization, etc.{" "}
                      </p>
                    </section>
                  </li>{" "}
                  <br />
                  <li className="nav-item">
                    <section id="References">
                      <p
                        style={{
                          textAlign: "justify",
                          fontSize: "0.999999999em",
                        }}
                      >
                        <h3>6. References</h3>
                        <ul>
                          <li style={{ fontSize: "0.999999em" }}>
                            <em>eflorakerala</em>. (n.d.). Retrieved from
                            https://www.eflorakerala.com/
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            <em>eFloraofIndia</em>. (n.d.). Retrieved from
                            https://efloraofindia.com/
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            <em>EIACP PC Hub: Kerala</em>. (n.d.). Retrieved
                            from Flowering Plants of Kerala:
                            https://kerenvis.nic.in/Database/FloweringplantsofKerala_1289.aspx
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            <em>India Biodiversity Portal</em>. (n.d.).
                            Retrieved from https://indiabiodiversity.org/
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            <em>Indian Flora Online</em>. (n.d.). Retrieved from
                            https://indiaflora-ces.iisc.ac.in/
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            <em>Kerala Forest Research Institute</em>. (n.d.).
                            Retrieved from Herbarium:
                            http://www.kfriherbarium.in/
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            <em>in</em>. (n.d.). Retrieved from
                            http://keralaplants.in/
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Sasidharan, N. (2006).{" "}
                            <em>
                              ILLUSTRATED MANUAL ON TREE FLORA OF KERALA
                              SUPPLEMENTED WITH COMPUTER-AIDED IDENTIFICATION.
                            </em>{" "}
                            Thrissur: Kerala Forest Research Institute.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            <em>State Medicinal Plants Board (SMPB) Kerala.</em>{" "}
                            (n.d.). Retrieved from Herbal Database:
                            https://smpbkerala.in/herbal-data/
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Pradhan, L. J. (2009). Saraca asoca (Ashoka): A
                            Review .{" "}
                            <em>
                              Journal of Chemical and Pharmaceutical Research
                            </em>
                            , 62-64.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            <em>Flora of Peninsular India - IISc</em>. (n.d.).
                            Retrieved from Herbarium JCB:
                            https://indiaflora-ces.iisc.ac.in/FloraPeninsular/herbsheet.php?id=2339&amp;cat=7
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            <em>M S Swaminathan Botanical Garden</em>. (n.d.).
                            Retrieved from Know our plant:
                            https://mssbg.mssrf.org/magnolia-champaca/
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            <em>World Agroforestry</em>. (n.d.). Retrieved from
                            Casia fistula:
                            https://apps.worldagroforestry.org/treedb/AFTPDFS/Cassia_fistula.PDF
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            <em>The World Flora Online</em>. (n.d.).
                            https://www.worldfloraonline.org/
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            <em>ENVIS Centre for Kerala</em>. (n.d.). Retrieved
                            from Medicinal Plants:
                            https://kerenvis.nic.in/Database/Medicinalplants_1290.aspx
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            <em>World Agroforestry Centre.</em>
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            MD, J. M. (2022). Medicinal Herbs in Primary Care.{" "}
                            <em>Elsevier</em>.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Keng, D., &amp; Bano, D. (n.d.).{" "}
                            <em>
                              Medicinal Plants of Kashmir Valley,their
                              distribution and mapping.
                            </em>{" "}
                            Director of Environment and Remote Sensing, Jammu
                            and Kashmir.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Alex, A., &amp; Vidhyasagaran, K. (2018). The Hosts,
                            Anatomy, and Utilization of the commercially
                            exploited parasitic herb Balanophora fungosa var.
                            indica in the Western Ghats region of Kerala, India.{" "}
                            <em>The Bioscan</em>.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Guruvayoorappan, K. M. (2012). Biophytum sensitivum:
                            Ancient medicine, modern targets.{" "}
                            <em>
                              Journal of Advanced Pharmaceutical Technologies
                            </em>
                            .
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Shyma, A. G. (2013). Medicinal plants used by the
                            tribes of Vythiri taluk, Wayanad district (Kerala
                            state) for the treatment of human and domestic
                            animal ailments .{" "}
                            <em>Journal of Medicinal Plants Research </em>.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Kalaimagal, G. U. (2015). QUALITATIVE AND
                            QUANTITATIVE ANALYSIS USING AERIAL PARTS FROM DOUBLE
                            FLOWER VARIETY OF TABERNEMONTANA DIVARICATA .{" "}
                            <em>
                              International Journal of Ayurveda and Pharma
                              Research{" "}
                            </em>
                            , 31.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Virtual Herbarium of Botanical Survey of India
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Asish, G., Deepak, M., George, S., &amp;
                            Balachandran, I. (2013). Phytochemical Profiling
                            &amp; Antioxidant Activity of Atuna indica(Bedd.)
                            Kosterm - An Unexplored Tree Species Reported
                            fromWestern Ghats, India.{" "}
                            <em>
                              International Journal of Pharmacognosy and
                              Phytochemical Research
                            </em>
                            , 27-30.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Jassim, S. F., &amp; V, G. (2018). Anticancer
                            activity of unexplored species of Atuna.{" "}
                            <em>
                              INTERNATIONAL JOURNAL OF RESEARCH IN
                              PHARMACEUTICAL SCIENCES
                            </em>
                            , 405-409.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            S. Santhosh Kumar, P.E. Roy &amp; S.M. Shareef
                            (2013) Rediscovery of Ophiorrhiza barnesii C.E.C.
                            Fisch. (Rubiaceae) from the southern Western Ghats,
                            Kerala, India. <em>Journal of Threatened Taxa</em>,
                            4115-4117
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Nayar T. S, S. M. (2008). Flowering plants of
                            Kerala: Status and Statistics. <em>Rheedea</em>,
                            95-106
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Santhosh Kumar E. S, Shanavas Khan E , &amp; Seema
                            G. Gopal. (2002). Andrographis chendurunii, a new
                            species of Acanthaceae from India.{" "}
                            <em>Nordic Journal of Botany</em>.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            FRANCINA CECILIA K, RAVINDHRAN R, &amp;
                            DURAIPANDIYAN V. (2012). ECBOLIN A: A BIOACTIVE
                            COMPOUND FROM THE ROOTS OF ECBOLIUM VIRIDE (FORSSK.)
                            ALSTON. Asian Journal of Pharmaceutical and Clinical
                            Research, 5, 99&ndash;101.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Ranjitsingh B Rathor, Rama Rao D &amp; Prasad Rao.
                            (2013). PHYTOCHEMICAL SREENING AND ANTIDIABETIC
                            ANTIOXIDANT EFFECT OF ECBOLIUM LIGUSTRINUM FLOWERS
                            EXTRACTS.{" "}
                            <em>
                              Indian Journal of Research in Pharmacy and
                              Biotechnology
                            </em>
                            , 576-580
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            S Santhosh Kumar, M. Abdul Jabbar, A. E Shanavas
                            Khan, S. Binu &amp; R. Raj Vikraman. (2002). A new
                            species of Strobilanthes Bl. (Acanthaceae) from
                            South India. Rheedea, 73-76
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            A. Sunil, V.S. Sunitha, E.K. Radhakrishnan, M.
                            Jyothis. (2017). Immunomodulatory activities of
                            Acacia catechu, a traditional thirst quencher of
                            South India. Journal of Ayurveda and Integrative
                            Medicine, 185-191
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Mathew dan, P. J. Mathew, C. M. Unnithan &amp; P.
                            Pushpangadan. (1996). <em>Thottea abrahamii </em>a
                            new species of <em>Aristolochiaceae</em> from
                            Peninsular India. Kew Bulletin, Vol. 51. 179-182
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Bhavadharaniparkavi and P. Abirami. (2023).
                            Phytochemical analysis and bioactive components of a
                            medicinal plant <em>Acalypha paniculata </em>Miq..
                            Biological Forum &ndash; An International Journal,
                            385-392
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Vibha S, Hebbar Sushmitha S, Mahalakshmi S.N, and
                            Prashith Kekuda T.R. (2019). A comprehensive review
                            on ethnobotanical applications and pharmacological
                            activities of <em>Acampe praemorsa</em> (Roxb.)
                            Blatt. &amp; McCann (Orchidaceae). Journal of Drug
                            Delivery &amp; Therapeutics, 331-336
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Dharya Singh and Vidhu Aeri. (2013). Phytochemical
                            and pharmacological potential of{" "}
                            <em>Acanthus ilicifolius</em>. Journal of Pharmacy
                            and Bioallied Sciences, 17-20.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Kwang Sik Suh, Young Soon Lee, and Eun Mi Choi.
                            (2013). The protective effects of{" "}
                            <em>Achyranthes bidentata </em>root extract on the
                            antimycin A induced damage of osteoblastic MC3T3-E1
                            cells. Cytotechnology, 925&ndash;935.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Gireesha and N.S. Raju. (2016). Phytochemical
                            analysis, antibacterial and antioxidant potential of{" "}
                            <em>Acronychia pedunculata</em> (L.) Miq. Annals of
                            phytomedicine, 147-151.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Cinthia C. Lima, Rosangela P. L. Lemos, Lucia M.
                            Conserva. (2014). Dilleniaceae family: an overview
                            of its ethnomedicinal uses, biological and
                            phytochemical profile. Journal of Pharmacognosy and
                            Phytochemistry, 181-204.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            S. Santhosh Kumar, P.E. Roy, N.B. Renjith and Mathew
                            Dan. (2011). <em>Acrotrema</em> <em>uniflorum</em>{" "}
                            var. <em>uniflorum</em> (Dilleniaceae) &ndash; A new
                            record for India. Rheedea, 167-169.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            S. Santhosh Kumar, Mathew Dan and G. M. Nair.
                            (2005). A new species of Acrotrema (Dilleniaceae)
                            from India. Nordic Journal of Botany, 543-546
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Haleshi, A. N. Sringeswara and Vijay Danapur.
                            (2020). Pharmacognostic study of{" "}
                            <em>Justicia beddomei </em>(C.B.Clarke) Bennet.
                            European Journal of Medicinal Plants,83-88.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Kumari Meenu &amp; Kiran Shukla. (2015).{" "}
                            <em>Aeginetia indica</em> : An interesting root
                            parasite of Dalma Wildlife Sanctuary, Jharkhand.
                            Biospectra, .83-86.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Joy Sarker, Md. Rahmat Ali, Muhammad Ali Khan, Md.
                            Mahbubur Rahman, ASM Sakhawat Hossain, AHM Khurshid
                            Alam. (2019). The Plant <em>Aerva sanguinolenta</em>
                            : A Review on Traditional Uses, Phytoconstituents
                            and Pharmacological Activities. Pharmacogn, 89-92.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            V.S.G.R. Naidu, Dr. N. T. Yaduraju &amp; Dr. A. K.
                            Gogoi.(2005). Weeds that heal. National research
                            centre for weed science, Jabalpur (M.P.)
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Alfred Maroyi. (2022). Traditional uses of wild and
                            tended plants in maintaining ecosystem services in
                            agricultural landscapes of the Eastern Cape Province
                            in South Africa.Journal of Ethnobiology and
                            Ethnomedicine.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Arup Kumar Misra and Sushil Kumar Varma. (2017).
                            Effect of an extract of <em>Agave americana </em>on
                            wound healing model in experimental animals. Journal
                            of Basic and Clinical Pharmacy.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Laxmi Bidari, Suma V Mallya, Suchitra Prabhu, Sunil
                            Kumar Koppala Narayana. (2017). Pharmacognosy,
                            nutritional value and antioxidant activity of{" "}
                            <em>Aglaia elaeagnoidea</em> (A.Juss.) Benth.
                            Journal of Ayurveda Medical Sciences,104-111.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            P.Krishnan Nambiar, N.Sasidharan, C.Renuka,
                            M.Balagopalan. (1985). Studies on the medicinal
                            plants of Kerala forests. KFRI Research Report 42.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            L. Brewbaker. (2004). Tree breeding, practices -
                            nitrogen-fixing tree improvement and culture.
                            Encyclopedia of forest sciences.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Poonam Dharmani, Pushpesh Kumar Mishra, Rakesh
                            Maurya, Vinay Singh Chauhan, Gautam Palit.(2005).{" "}
                            <em>Allophylus serratus</em>: A plant with potential
                            anti-ulcerogenic activity. Journal of
                            Ethnopharmacology.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Santhosh Kumar JU, Krishna Chaitanya MJ, Andrew J,
                            Semotiuk and Krishna V.(2019). Indigenous knowledge
                            of medicinal plants used by ethnic communities of
                            South India. Ethnobotany Research and Applications.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            P. Thomas &amp; M. Sabu. (2012). Two new species of
                            Amomum (zingiberaceae) from western ghats, india.
                            EDINBURGH JOURNAL OF BOTANY.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            P. Thomas, M. Sabu, P. M. Salim.(2012). On the
                            identity and typification of{" "}
                            <em>Amomum cannicarpum</em> (Zingiberaceae): a
                            narrowly endemic and endangered plant from Western
                            Ghats, South India. Kew Bulletin, 109-113.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            P. Thomas, M. Sabu, K.M. Prabhu Kumar. (2012).{" "}
                            <em>Amomum nilgiricum</em> (Zingiberaceae), a new
                            species from Western Ghats, India. PhytoKeys.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            P. Thomas, M. Sabu, K. M. Prabhu Kumar.(2013).{" "}
                            <em>Amomum sahyadricum</em>: (Zingiberaceae), a New
                            Species from the Western Ghats, India. Novon,
                            321-324
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            https://tropical.theferns.info/
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Poovan Elankani, Kallingil Gopi, Divya, Koppala
                            Narayanan, Sunil Kumar, Subramanian, Mutheeswaran.
                            (2021). Detailed microscopic profiling of{" "}
                            <em>Begonia albococcinea</em> used as kalthamarai.
                            Journal of research in Siddha medicine, 33-40
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            BSI- Medicinal Plant Database{" "}
                            <em>
                              https://bsi.gov.in/page/en/medicinal-plant-database{" "}
                            </em>
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Vasuki. (2014). Pharmacognostical, phytochemical
                            studies and evaluation of antidiabetic potential of{" "}
                            <em>Biophytum sensitivum</em> dc. and{" "}
                            <em>Biophytum intermedium</em> wt. Synopsis of the
                            Thesis. Pp 10.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Anupama R and T Sunilkumar. (2019). Phytochemical
                            analysis and nutraceutical studies on aril of{" "}
                            <em>Blighia sapida</em>D Koenig. Journal of
                            Pharmacognosy and Phytochemistry, 34-40
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Traditional ethnomedicinal investigation from
                            Pohradevi forest of Washim district. (2017).
                            Ijariie.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Kannan C. S. Warrier and S. Muthupandiyan. (2022).{" "}
                            <em>Boswellia serrata</em> Ex Coleb.: A Threatened
                            Tree. International Journal of Plant &amp; Soil
                            Science, 527-534
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            VB Sreekumar, P Sujanapal, PA Jose, KA Sreejith, AV
                            Raghu. (2017). Ex‐situ conservation of wild Orchids
                            in the Western Ghats of Kerala, India. Kerala Forest
                            Research Institute, Peechi, Thrissur, Report of
                            project KFRI RP‐663/13.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Sharad S. Kambale, Avinash R. Gholave, Avinash A.
                            Adsul, Malapati K. Janarthanam, Shrirang Ramchandra
                            Yadav. (2016). An Extended Distribution of Rare and
                            Endemic <em>Brachystelma kolarense</em>{" "}
                            (Apocynaceae) from Eastern Karnataka to Coastal
                            Plains of Kerala, India. Springer, 301&ndash;303
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Anjalam, R. Elangomathavan &amp; S. Premalatha.
                            (2014).Exploration of medicinal plants used by the
                            malayali tribes of Kolli hills, Tamil Nadu, India.
                            International Journal in Research and Ayurveda
                            Pharmacy, 201-204.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Kishore Kumar &amp; D. J. Goyder. (2001).{" "}
                            <em>Brachystelma swarupa</em> (Apocynaceae): a new
                            species from India. Kew Bulletin, 209 - 216.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Sharad S. Kambale, Siddharthan Surveswaran &amp;
                            Shrirang R. Yadav. (2014). Two new species of{" "}
                            <em>Brachystelma</em> Sims (Apocynaceae:
                            Asclepiadoideae-Ceropegieae) from the Western Ghats
                            of India. Kew bulletin.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Plants of the World Online website by Kew Botanic
                            Gardens, https://powo.science.kew.org/
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Hyoung-Geun Kim, Davin Jang, Young Sung Jung,
                            Hyun-Ji Oh, Seon Min Oh, Yeong-Geun Lee, Se Chan
                            Kang, Dae-Ok Kim, Dae Young Lee and Nam-In Baek.
                            (2020). Anti-Inflammatory Effect of Flavonoids from{" "}
                            <em>Brugmansia arborea</em> Flowers. Journal of
                            Microbiology and Biotechnology, 163-171
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Karuppusamy and V. Ravichandran.(2013). A new orchid
                            of the genus <em>Bulbophyllum</em> (orchidaceae)
                            from Western Ghats of Southern India. Taprobanica,
                            120&ndash;123.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Muktesh Kumar and Stephen Sequiera. (1999). Two new
                            species of Bulbophyllum Thouars (Orchidaceae) from
                            Southern Western Ghats, India.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Flowers of India, https://www.flowersofindia.net/
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Kanivalan, Rajendran A. (2021). Distribution of
                            Critically Endangered species &ndash;{" "}
                            <em>Burmannia Indica</em> (Burmanniaceae).
                            International Journal of Life Sciences Research,
                            (9-11.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Naoroji Godrej Centre for Plant Research
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            K. Ratheesh Narayanan, S. Mithunlal, P. Sujanapal,
                            N. Anil Kumar, M. Sivadasan, Ahmed H. Alfarhan and
                            A. A. Alatar. (2011). Ethnobotanically important
                            trees and their uses by Kattunaikka tribe in Wayanad
                            Wildlife Sanctuary, Kerala, India. Journal of
                            Medicinal Plants Research Vol. 5(4), pp. 604-612.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Subrahmanya Prasad and K. Raveendran. (2012).
                            Canscora bhatiana (gentianaceae), a new species from
                            Kerala, India. International Journal of Plant,
                            Animal and Environmental Sciences, 197-201.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Deepa, M., Udayan, P., (2017). Taxonomical and
                            phytosociological studies on Chithalikavu-A sacred
                            grove, Thrissur district, Kerala. Tropical
                            Plant&nbsp; Research, 20&ndash;30.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Ragunathan Muthuswamy, Asish. S, Maria Nison.
                            (2021). Review on <em>Capsicum frutescens</em>, A
                            Tribal herbal food used as Medicine. Research
                            Journal of Pharmacognosy and Phytochemistry, 191-194
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            S Ignacimuthu, M Ayyanar and Sankara Sivaraman K.
                            (2006). Ethnobotanical investigations among tribes
                            in Madurai District of Tamil Nadu (India). Journal
                            of Ethnobiology and Ethnomedicine.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            M. Dhivya, K. Kalaichelv. A study on traditional
                            medicinal plants of Pillur Beat (Pillur slope RF and
                            Nellithurai RF),Karamadai range, Coimbatore
                            district, Tamil Nadu. Journal of Pharmaceutical and
                            Biological Research, 39-51.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            http://www.theplantlist.org/ - The Plant List
                            website
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Avishek Bhattacharjee. (2011). On the status of some
                            species of <em>Cheirostylis Blume</em>(Orchidaceae)
                            from India. Candollea.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Archana, P. J. and Surabhi, S.(2022). ETHNOBOTANICAL
                            RELEVANCE OF FLORA FOUND IN THE DISTRICTS OF KOLLAM
                            AND THIRUVANANTHAPURAM, KERALA, INDIA. Journal of
                            Advances in Biological Science
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Konickal Mambetta Prabhu Kumar, Vadakkoot Sankaran
                            Hareesh, Avinash Asraji, Adsul, Kollencherri
                            Puthenveettil Vimal, Indira Balachandran &amp;
                            Shrirang Ramachandra Yadav. (2014). A new species of{" "}
                            <em>Chlorophytum</em> (Asparagaceae) from southern
                            Western Ghats of India. <em>Phytotaxa</em> 188 (5):
                            282&ndash;286
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Avinash A. Adsul, Manoj M. Lekhak &amp; Shrirang R.
                            Yadav. (2014). <em>Chlorophytum sharmae</em>{" "}
                            (Asparagaceae): a new species from Kerala, India.
                            KEW BULLETIN.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Ravi, N. Mohanan, M.S. Kiran Raj, T. Shaju and R.
                            Rajesh. (2000). Two new species of Poaceae from
                            Kerala, India. Rheedea 10((2)):91-98.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            N Sunil, M.K Ratheesh Narayanan, Sivadasan M, T.
                            Shaju. (2017). A new species of Chrysopogon
                            (Poaceae: Andropogoneae) from India. Phytotaxa
                            307(4):245.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Mohanan &amp; A.N.Henry. (1991).{" "}
                            <em>Cinnamomum chemung1anum</em> (Lauraceae)&mdash;
                            A new species from Kerala, Southern India, 97-99.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            S. Manilal and M. Shylaja. (1986). A new species of
                            Cinnamomum schaeffer (Lauracem) frw Malabar.
                            Bulletin of Botanical Survey of India, 111-113.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            M. Krishnakumar and S. Antony Ceasar. (2023). A Mini
                            Review On Ethnomedicinal Uses, Phytochemistry And
                            Pharmacological Properties Of Indian Wampi Plant:{" "}
                            <em>Clausena Indica </em>(Dalzell) Oliv. Current
                            Traditional Medicine.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            V. Sivarajan and Indu Balachandran. (1985).{" "}
                            <em>Cleistanthus sankunnianus</em>, a New Species of
                            Euphorbiaceae from India, 121-123
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Girishkumar E.&amp; P. Sunojkumar. (2020). A new
                            variety of <em>Cleistanthus </em>(Phyllanthaceae)
                            from southern Western Ghats, India, 278&ndash;281.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            A. Anilkumar. (2013). A New Species of Clematis L.
                            (Ranunculaceae) From Western Ghats of Kerala, India.
                            International Journal of Plant, Animal and
                            Environmental Sciences, 81-85
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Website - medicinalplantsindia.com
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Sheba M. Joseph, A. Anna Ancy Antony, and Santhosh
                            Nampy. (2012). Commelina clavatoides
                            (Commelinaceae), a new species from Kerala, Journal
                            of the Botanical Research Institute of Texas 6(1):
                            119-122.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Palanisamy Selvamani, Dhrubo Jyoti Sen and Jayanta
                            Kumar Gupta. (2009) Pharmacognostical
                            standardization of <em>Commiphora berryi </em>(Arn)
                            Engl and phytochemical studies on its crude
                            extracts. African Journal of Pharmacy and
                            Pharmacology Vol. 3(2). pp. 037-046
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            A new variety of <em>Crotalaria assamica</em>{" "}
                            (Fabaceae &ndash; Papilionoideae), from the Western
                            Ghats, India. (2011). Rheedea, 153-156.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Abdull Jabbar, M.V. Krishnaraj and N. Mohanan
                            (2010). <em>Crotalaria incana</em> subsp.{" "}
                            <em>purpurascens</em> (Fabaceae) &ndash; A New
                            Record for India. Rheedea 20(2), 131-132
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Sibichen, M. Thomas and Nampy, Santhosh. (2007).{" "}
                            <em>Crotalaria kurisumalayana</em> Sibichen &amp;
                            Nampy (Fabaceae), a new species from India.
                            Candollea 62(1 ] : 105-108
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Moothedathu Venugopalan Nair Krishnaraj &amp;
                            Narayanan Nair Mohanan. (2012). A new Combination in{" "}
                            <em>Crotalaria multiflora</em> (Arn.) Benth.
                            (Fabaceae). Phytotaxa 44: 58&ndash;62.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Ponnampadi Kunjumuhammed Fasila, Kandarumadathil
                            Hyder Amitha Bachan, Thekkum Parambil Girija,
                            Ayilliath Kuttiyeri Pradeep. (2020).{" "}
                            <em>Cryptocarya sheikelmudiyana</em> (Lauraceae), a
                            new species from the Western Ghats in Kerala, India.
                            Taiwania 65(3): 265‒271, 2020
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Jagadeesan Raveendran, Sureshkumar Pandikkattil,
                            Gangaprasad Appukuttan Nair &amp; Sam Paul Mathew.
                            (2021). <em>Cryptocarya muthuvariana</em>{" "}
                            (Lauraceae), a new species from the southern Western
                            Ghats, Kerala, India. Ann. Bot. Fennici 58:
                            377&ndash;380
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Aprilia Permata Sari1 and Unang Supratman (2022).
                            Phytochemistry and Biological Activities of Curcuma
                            aeruginosa (Roxb.). Indones. J. Chem., 2022, 2022
                            (2), 576 - 598.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Janeesha A.P. &amp; S. Nampy. (2020). A taxonomic
                            revision of Henckelia (Gesneriaceae) in South India
                            with a new species, one new combination and seven
                            lectotypifications. Rheedea. Vol. 30(1): 48&ndash;95
                            (2020).
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            STC Herbarium
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            M. Greller, N. Mohanan, K. Balasubramanyan and
                            D.S.A. Wijestmdara. (1997). Composition of forests
                            at the Tropical Botanic Garden and Research
                            Institute, Palode, and comparisons with some forests
                            of adjacent areas, Kallar and Ponmudi (Trivandrum
                            District, Kerala, India). J. South Asian nat. Hist,
                            ISSN 1022-0828. March, 1997. Vol. 2, No. 2, pp.
                            165-182.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            S. Santhosh Kumar, G. M. Nair &amp; S.S Yeragi.
                            (2004). Eclipta prostrata (L.) var. dixitii Anand
                            Kumar &amp; Khanna (Asteraceae)- A new record for
                            south India. J. Econ. Taxon. Bot. Vol. 28 No. 2,
                            507-509
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            <em>Eucalyptus globulus </em>(Tasmanian blue gum).
                            CABI Compendium Datasheet.
                            https://doi.org/10.1079/cabicompendium.22680
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Prashant Tiwari, Pratap Kumar Sahu.{" "}
                            <em>Eucalyptus tereticornis</em>: Phytochemical
                            Constituents and Medicinal Properties. Research J.
                            Pharm. and Tech 2018; 11(6): 2677-2680. doi:
                            10.5958/0974-360X.2018.00496.1
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Shareef SM, Kumar ESS. The genus Eugenia L.
                            (Myrtaceae) in India. Plant Science Today.
                            2020;7(3):360&ndash;370.
                            https://doi.org/10.14719/pst.2020.7.3.770
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            T Shaju, M P Rijuraj, A Rasiya Beegam, M
                            Rajendraprasad, M K Ratheesh Narayanan. Two New
                            Records of Dimeria R. Br. (Poaceae) from Kerala.
                            International Journal of Plant, Animal and
                            Environmental Sciences 10 (2020): 127-134.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Abhilash, E., Menon, A., &amp; N Sasidharan. (2013).
                            Ecological analysis of abandoned forest plantations
                            of Kannavam in Kerala, India.{" "}
                            <em>
                              Asia Pacific Journal of Environment Ecology and
                              Sustainable Development
                            </em>
                            , 22&ndash;25.
                            https://www.academia.edu/download/88607037/f1555d9781d8c8eb668f2cda0d6c9cc12a82.pdf
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Ameesha, P., &amp; Saradha, M. (2023). Documentation
                            of floristic diversity in Ponparakunnu hills,
                            Kozhikode District, Kerala and biological activities
                            of Eclipta prostrata L. and Eupatorium triplinerve
                            Vahl (Asteraceae) .{" "}
                            <em>Journal of Pharmacognosy and Phytochemistry</em>
                            , <em>12</em>, 55&ndash;61.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Ann E Russell. (2002). Relationships between
                            crop-species diversity and soil characteristics in
                            southwest Indian agroecosystems.{" "}
                            <em>Agriculture, Ecosystems &amp; Environment</em>,{" "}
                            <em>92</em>(2&ndash;3), 235&ndash;249.
                            https://www.sciencedirect.com/science/article/pii/S016788090100295X
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Anoop, P. B., Bibin, T., &amp; Joseph, M. (2017).
                            Floristic Diversity of Thevarmala Sacred Grove in
                            Western Ghats, Kerala, India .{" "}
                            <em>
                              International Journal of Advanced Research in
                              Botany (IJARB){" "}
                            </em>
                            , <em>3</em>(1), 1&ndash;11.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Antonelli, A. , et al. (2023).{" "}
                            <em>
                              State of the World&rsquo;s&nbsp; Plants and Fungi
                              2023{" "}
                            </em>
                            .
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            O. Varghese, &amp; A.R.R. Menon. (1998). VEGETATION
                            CHARACTERISTICS OF&nbsp; SOUTHERN SECONDARY MOIST
                            MIXED DECIDUOUS FORESTS OF AGASTHYAMALAI&nbsp;
                            REGION OF&nbsp; KERALA.{" "}
                            <em>Indian Journal of Forestry</em>.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Archana, K. N., &amp; Gayatri, R. N. (2021).
                            FLORISTIC DIVERSITY OF CHIRAKKAL CHIRA AND
                            RAJARAJESHWARA CHIRA IN KANNUR DISTRICT, KERALA
                            (INDIA)&nbsp; .{" "}
                            <em>Journal of Global Biosciences </em>, <em>10</em>
                            , 8980&ndash;8989.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Archana, P. J., &amp; Surabhi, S. (2022).
                            ETHNOBOTANICAL RELEVANCE OF FLORA FOUND IN THE
                            DISTRICTS OF KOLLAM AND THIRUVANANTHAPURAM, KERALA,
                            INDIA.{" "}
                            <em>Journal of Advances in Biological Science</em>,{" "}
                            <em>9</em>(1 and 2), 25&ndash;30.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Arisdason, W., &amp; Lakshminarasimhan, P. (n.d.).{" "}
                            <em>
                              STATUS OF PLANT DIVERSITY IN INDIA: AN OVERVIEW
                            </em>
                            . Central National Herbarium, Botanical Survey of
                            India, Howrah.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Arun, T. R., &amp; Shaji, C. S. (2013). DIVERSITY
                            AND DISTRIBUTION OF MANGROVES IN KUMBALAM ISLAND OF
                            KERALA, INDIA .{" "}
                            <em>23rd Swadeshi Science Congress - 2013 </em>,
                            367&ndash;380.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Augustine Jomy. (2008). Genus Strobilanthes in High
                            Ranges of Kerala: Diversity, Distribution and
                            Endemism.{" "}
                            <em>
                              Special Habitats and Threatened Plants of India,
                              ENVIS Bulletin
                            </em>
                            , 139&ndash;146.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Barthlott, W., Mutke, J., Rafiqpoor, D., Kier, G.,
                            &amp; Kreft, H. (2005). Global Centers of Vascular
                            Plant Diversity . <em>Nova Acta Leopoldina </em>,
                            61&ndash;83.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Bindhu, K. B., Anjana, K. S., &amp; Fathima, P.
                            (2020). A PRELIMINARY STUDY ON THE MEDICINAL PLANTS
                            OF ANNALLUR KOLE LANDS, CHALAKUDY, THRISSUR, KERALA.{" "}
                            <em>
                              International Journal of Creative Research
                              Thoughts (IJCRT)
                            </em>
                            , <em>8</em>(6), 914&ndash;920.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Champion, H., &amp; Seth, S. (1968). A revised
                            survey of the forest types of India.{" "}
                            <em> India Publ. Delhi.</em>
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Chandrasekaran, C. (1960). Forest Types of Kerala
                            State. <em>Indian Forester</em>, 660&ndash;674.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Chandrashekara, U. M. (1996). Ecology of Bambusa
                            arudinacea (retz.) willd. growing in teak
                            plantations of Kerala, India.{" "}
                            <em>Forest Ecology and Management</em>, <em>87</em>
                            (1&ndash;3), 149&ndash;162.
                            https://doi.org/10.1016/S0378-1127(96)03799-1
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Chandrashekara, U. M., &amp; Sankar, S. (1998).
                            Ecology and management of sacred groves in Kerala,
                            India. <em>Forest Ecology and Management</em>,{" "}
                            <em>112</em>(1&ndash;2), 165&ndash;177.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            CHANDRASHEKARA, U. M., &amp; THASINI, V. M. (2016).
                            Non-Crop Edible Plants and Medicinal Plants in
                            Homegarden Agroforestry System of Palakkad District,
                            Kerala.{" "}
                            <em>
                              International Journal of Ecology and Environmental
                              Sciences
                            </em>
                            , <em>42</em>(2), 183&ndash;191.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Chandrashekara, U., Rep, K. J.-K. Res., &amp; 2002,
                            undefined. (2002). Stand structural diversity and
                            dynamics in natural forests of Kerala.{" "}
                            <em>Kfri.Res.In</em>.
                            https://docs.kfri.res.in/KFRI-RR/KFRI-RR232.pdf
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Chandrashekara UM. (2015). Edible non-crop plants in
                            homegardens of Kerala: their diversity, management
                            and nutritive value.{" "}
                            <em>International Journal of Ecology</em>,{" "}
                            <em>41</em>(4), 141&ndash;146.
                            https://www.researchgate.net/profile/Chandrashekara-M/publication/305143190_Edible_Non-Crop_Plants_in_Homegardens_of_Kerala_Their_Diversity_Management_and_Nutritive_Value/links/57835fc108ae34944e6dc34f/Edible-Non-Crop-Plants-in-Homegardens-of-Kerala-Their-Diversity-Management-and-Nutritive-Value.pdf
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Cherullipadi, L., Sci, J. P.-S. I. J. Biol., &amp;
                            2016, undefined. (2016). Diversity of herbaceous
                            riparian flora in the lower stretch of
                            Bharathappuzha river, Kerala. <em>Edu</em>.
                            https://www.academia.edu/download/45240296/191-197.pdf
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Corlett, R. T. (2016). Plant diversity in a changing
                            world: Status, trends, and conservation needs.{" "}
                            <em>Plant Diversity</em>, <em>38</em>(1),
                            10&ndash;16.
                            https://doi.org/10.1016/j.pld.2016.01.001
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Cowell, C., Bullough, L., Dhanda, S.,
                            Sustainability, V. H. N.-, &amp; 2022, undefined.
                            (2022). Fortuitous Alignment: The Royal Botanic
                            Gardens, Kew and the Sustainable Development Goals.{" "}
                            <em>Com</em>.
                            https://www.mdpi.com/2071-1050/14/4/2366
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Dantas&nbsp;Kuttikkatt&nbsp;Jose, &amp;
                            Nanu&nbsp;Sasidharan. (2016).
                            Check&nbsp;list&nbsp;of&nbsp;wild&nbsp;edible&nbsp;plants&nbsp;of&nbsp;Aralam&nbsp;Wildlife&nbsp;sanctuary,&nbsp;Kerala,&nbsp;India&nbsp;.{" "}
                            <em>
                              South&nbsp;Indian&nbsp;Journal&nbsp;Of&nbsp;Biological&nbsp;Sciences
                            </em>
                            , 1114.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            David Cooper. (2023, May 12).{" "}
                            <em>
                              Statement by David Cooper Acting Executive
                              Secretary of the Convention on Biological
                              Diversity{" "}
                            </em>
                            . Convention on Biological Diversity&nbsp; .
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Deepa, M., Dharmapal, S., &amp; Udayan, P. S.
                            (2016). Floristic diversities and medicinal
                            importance of selected sacred groves in Thrissur
                            district, Kerala. <em>Com</em>.
                            https://www.tropicalplantresearch.com/download/110/31.pdf
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Deepa, M., Udayan, P., Plant, K. A.-T., &amp; 2017,
                            undefined. (2017). Taxonomical and phytosociological
                            studies on Chithalikavu-A sacred grove, Thrissur
                            district, Kerala.{" "}
                            <em>Tropical Plant&nbsp; Research</em>, 20&ndash;30.
                            https://doi.org/10.22271/tpr.2017.v4.i1.004
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Deepa M.R, Dharmapal Sheema, &amp; Udayan P.S.
                            (2016). Rare, endemic and medicinal plants of
                            selected sacred groves in Chavakkad, Thrissur
                            district, Kerala.{" "}
                            <em>
                              Asian Journal of Biological and Life Sciences
                            </em>
                            , <em>5</em>, 78&ndash;87.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Deepa MR, Sheema Dharmapal, &amp; Udayan PS. (2016).
                            Medicinal plants in the selected sacred groves of
                            Kodungallur, Thrissur district, Kerala .{" "}
                            <em>Journal of Medicinal Plants Studies</em>,
                            149&ndash;155.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Digvijay, S. (2014).{" "}
                            <em>
                              TASK OF BIOLOGICAL DIVERSITY CONSERVATION AND ROLE
                              OF INSTITUTIONAL MECHANISM IN INDIA
                            </em>
                            .
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Divya, N. M., Sam, P. M., &amp; Gangaprasad, A.
                            (2021). Diversity, classification and ethnobotanical
                            uses of wild edible fruit plants with special
                            reference to Kallar and Ponmudi region of
                            Agasthyamala Biosphere Reserve, Kerala, India.{" "}
                            <em>Journal of Traditional and Folk Practices</em>,{" "}
                            <em>9</em>, 104&ndash;119.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Divya, S., &amp; Anitha, V. (2020). Community
                            dependence on the natural resources of Parambikulam
                            Tiger Reserve, Kerala, India.{" "}
                            <em>Trees, Forests and People</em>, <em>2</em>.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Faizal, S., Sheela, R., &amp; of, P. N. (2022).
                            Status of plant bioresources utilised in herbal
                            industries and the need for conservation in kerala.{" "}
                            <em>
                              INTERNATIONAL JOURNAL OF CONSERVATION SCIENCE
                            </em>
                            , <em>13</em>(1), 267&ndash;278.
                            https://ijcs.ro/public/IJCS-22-20_Faizal.pdf
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            George, M. V., &amp; Christopher, G. (2020).
                            Structure, diversity and utilization of plant
                            species in tribal homegardens of Kerala, India.{" "}
                            <em>Agroforestry Systems</em>, <em>94</em>(1),
                            297&ndash;307.
                            https://doi.org/10.1007/S10457-019-00393-5
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Gopalan, R. (1997). Plant diversity in Agastyamalai
                            hills, Southern Western Ghats .{" "}
                            <em>
                              Plant Diversity Hotspots in India, an Overview
                            </em>
                            , 11&ndash;22.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Govaerts, R., Lughadha, E. N., Black, N., data, R.
                            T.-S., &amp; 2021, undefined. (2021). The World
                            Checklist of Vascular Plants, a continuously updated
                            resource for exploring global plant diversity.{" "}
                            <em>Com</em>.
                            https://www.nature.com/articles/s41597-021-00997-6
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Grinson George, P. Krishnan, K. G. Mini, S. S.
                            Salim, P. Ragavan, S. Y. Tenjing, R. Muruganandam,
                            S. K. Dubey, A. Gopalakrishnan, R. Purvaja, &amp; R.
                            Ramesh. (2018). Structure and regeneration status of
                            mangrove patches along the estuarine and coastal
                            stretches of Kerala, India. <em>Springer</em>.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Hajra P.K, &amp; Mudgal V. (1997).{" "}
                            <em>
                              Plant Diversity Hotspots in India - An Overview
                            </em>
                            .
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Halliru Bilyaminu, K. Vidyasagaran, S. Gopakumar,
                            &amp; Nadan Vijaykumar. (2021). Ecological Studies
                            on Southern Secondary Moist Deciduous Forest of
                            Shendurney Wildlife Sanctuary.{" "}
                            <em>Indian Journal of Ecology</em>, 1747&ndash;1754.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            J Augustine. (2012). Agricultural Land use Pattern
                            and the Flowering Plant Diversity of Cardamom Hill
                            Reserve (CHR), Southern Western Ghats, Kerala,
                            India. <em>KERALA ENVIRONMENT CONGRESS</em>.
                            https://www.academia.edu/download/55142983/_kerala_environment_congress__2012.pdf#page=339
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Jacob John, &amp; M. Achuthan Nair. (1999).
                            CROP-TREE INVENTORY OF THE HOME GARDENS OF SOUTHERN
                            KERALA. <em>JOURNAL OF TROPICAL AGRICULTURE</em>,
                            110&ndash;114.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Jose, S., Sreepathy, A., Mohan Kumar, B., &amp;
                            Venugopal, V. K. (1994). Structural, floristic and
                            edaphic attributes of the grassland-shola forests of
                            Eravikulam in peninsular India.{" "}
                            <em>Forest Ecology and Management</em>, <em>65</em>
                            (2&ndash;3), 279&ndash;291.
                            https://doi.org/10.1016/0378-1127(94)90176-7
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            K Praveenkumar. (2018). Floristic Diversity of the
                            Sacred Grove of Madathody Naga Kavu, Chalavara,
                            Palakkad District, Kerala State .{" "}
                            <em>
                              International Journal of Environment, Agriculture
                              and Biotechnology (IJEAB)&nbsp;{" "}
                            </em>
                            , <em>3</em>(6).
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            <em>Kerala Forests and Wildlife Department</em>.
                            (n.d.). Https://Forest.Kerala.Gov.In/.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            <em>Kerala Soil Health Information System</em>.
                            (n.d.).
                            Https://Www.Keralasoilfertility.Net/En/Intro.Jsp.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Kiran M, Rahees N, Vishal V, &amp; Vidyasagaran K.
                            (2015). FLORISTIC DIVERSITY AND STRUCTURAL DYNAMICS
                            OF MANGROVES IN THE NORTH WEST COAST OF KERALA,
                            INDIA .{" "}
                            <em>Journal of Plant Development Sciences</em>,{" "}
                            <em>7</em>(7), 549&ndash;553.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Krishnan Remya, &amp; S Nelson Jiji. (2023).
                            Floristic study on some selected paddy fields of
                            Thiruvananthapuram district, Kerala.{" "}
                            <em>
                              World Journal of Advanced Research and Reviews
                            </em>
                            , 8&ndash;17.
                            https://doi.org/10.30574/wjarr.2023.17.1.1460
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Kumr K, K. (2015). A checklist to the vascular flora
                            of Anamudi Shola National Park, Munnar, Idukki
                            district, Kerala. <em>Scientia </em>, <em>11</em>,
                            51&ndash;73.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Lekshmi, G. M., Anju, A., Nimina, S., Aiswarya, K.
                            R., Aswathy, V. S., Gopika, G. S., Princy, L.,
                            Santhikrishna, G. S., Thara, A. T., Akhiljith, S.,
                            &amp; AryaVijayan, U. (2022). FLORAL DIVERSITY IN
                            VILLUMALA, KULATHUPUZHA, KERALA&nbsp; .{" "}
                            <em>Journal of Advances in Biological Science </em>,{" "}
                            <em>9</em>(1 and 2), 31&ndash;33.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Madhusudhanan, K., &amp; Jayesh, R. (2011).
                            Physico-Chemical and Floristic Studies of
                            Mangalavanam Mangrove Ecosystem in Ernakulam
                            District, Kerala, South India.{" "}
                            <em>
                              Nature Environment and Pollution Technology{" "}
                            </em>
                            , <em>10</em>, 15&ndash;20.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Magesh, G., Forester, A. M.-T. I., &amp; 2011,
                            undefined. (2011). Vegetation status, species
                            diversity and endemism of Sulimudi forests in
                            southern Western Ghats of Kerala, India.{" "}
                            <em>Indiaenvironmentportal.Org.In</em>.
                            http://re.indiaenvironmentportal.org.in/files/Sulimudi%20forests.pdf
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Manilal, K. S., &amp; Raveendrakumar, K. (1998).
                            Additions to the Flora of Kerala since Gamble
                            (1935). <em>Rheedea</em>, <em>8</em>, 179&ndash;241.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Manoj, K., Nandakumar, M. K., Remya, M. P., Shinila,
                            K., &amp; Divya lakshmi, P. (2012).
                            Phytosociological analysis of riparian tree species
                            of Alakyam stream; Pariyaram, Kerala, India.{" "}
                            <em>
                              INTERNATIONAL JOURNAL OF ENVIRONMENTAL SCIENCES
                            </em>
                            , <em>2</em>, 1895&ndash;1903.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Mathew, S., Augustine, J., Biology, S. B.-R. in P.,
                            &amp; 2014, undefined. (2014). The Grass Diversity
                            of Vagamon Hills in Kerala. <em>Edu</em>.
                            https://www.academia.edu/download/80380860/plantbiology-2-1012.pdf
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Menon, A. R. R., Varghese, A. O., &amp; Pious, O. L.
                            (2010). VEGETATION CHARACTERISTICS OF SOUTHERN
                            SECONDARY MOIST MIXED DECIDUOUS FORESTS OF TRICHUR
                            DISTRICT, KERALA.{" "}
                            <em>Indian Journal of Forestry</em>, 293&ndash;296.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Mohan Kumar, B. (2011). Species richness and
                            aboveground carbon stocks in the homegardens of
                            central Kerala.{" "}
                            <em>Agriculture, Ecosystems &amp; Environment</em>,
                            430&ndash;440.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Mohan Kumar, B., George, S. J., &amp; Chinnamani, S.
                            (1994). Diversity, structure and standing stock of
                            wood in the homegardens of Kerala in peninsular
                            India. <em>Agroforestry Systems</em>, <em>25</em>
                            (3), 243&ndash;262.
                            https://doi.org/10.1007/BF00707463/METRICS
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Mohanan, M., &amp; Henry, A. N. (1994).{" "}
                            <em>Flora of Thiruvananthapuram</em>. Botanical
                            Survey of India.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Morvin Yabesh, J. E., Prabhu, S., &amp; Vijayakumar,
                            S. (2014). An ethnobotanical study of medicinal
                            plants used by traditional healers in silent valley
                            of Kerala, India.{" "}
                            <em>Journal of Ethnopharmacology</em>, <em>154</em>
                            (3), 774&ndash;789.
                            https://doi.org/10.1016/J.JEP.2014.05.004
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Sasidharan. (2006).{" "}
                            <em>
                              ILLUSTRATED MANUAL ON TREE FLORA OF KERALA
                              SUPPLEMENTED WITH COMPUTER-AIDED IDENTIFICATION
                            </em>
                            .
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Nair, K., Renuka, C., &hellip; K. M.-&hellip;
                            research: challenges in, &amp; 2001, undefined.
                            (2001). Knowledge on the plant diversity of Kerala:
                            the present scenario and future needs. <em>Org</em>.
                            https://www.cabdirect.org/cabdirect/abstract/20023156085
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Nair, M. S. (2013).{" "}
                            <em>
                              A comprehensive study on the socio-economic and
                              cultural aspects of sacred groves in Kerala-
                              Report 1- Thiruvananthapuram district
                            </em>
                            .
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Nair, M. S. (2015).{" "}
                            <em>
                              A comprehensive study on the socio-economic and
                              cultural aspects of sacred groves in Kerala-
                              Report no.2- Kollam district
                            </em>
                            .
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Nair, M. S. (2016a).{" "}
                            <em>
                              A comprehensive study on the socio-economic and
                              cultural aspects of sacred groves in Kerala-
                              Report no.3- Kozhikode district
                            </em>
                            .
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Nair, M. S. (2016b).{" "}
                            <em>
                              A comprehensive study on the socio-economic and
                              cultural aspects of sacred groves in Kerala-
                              Report no.4- Thrissur district
                            </em>
                            .
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            &rsquo;Nair, M. S. (2018a).{" "}
                            <em>
                              A comprehensive study on the socio-economic and
                              cultural aspects of sacred groves in Kerala-
                              Report no.5- Alappuzha district
                            </em>
                            .
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            &rsquo;Nair, M. S. (2018b).{" "}
                            <em>
                              A comprehensive study on the socio-economic and
                              cultural aspects of sacred groves in Kerala-
                              Report no.6- Kannur district
                            </em>
                            .
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            &rsquo;Nair, M. S. (2019).{" "}
                            <em>
                              A comprehensive study on the socio-economic and
                              cultural aspects of sacred groves in Kerala-
                              Report no.7- Kottayam district
                            </em>
                            .
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Nair, M. S. (2020a).{" "}
                            <em>
                              A comprehensive study on the socio-economic and
                              cultural aspects of sacred groves in Kerala-
                              Report no.8- Idukki district
                            </em>
                            .
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Nair, M. S. (2020b).{" "}
                            <em>
                              A comprehensive study on the socio-economic and
                              cultural aspects of sacred groves in Kerala-
                              Report no.9- Palakkad district
                            </em>
                            .
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Nair, M. S. (2021).{" "}
                            <em>
                              A comprehensive study on the socio-economic and
                              cultural aspects of sacred groves in Kerala-
                              Report no.10- Kasaragod district
                            </em>
                            .
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Nair, M. S. (2022a).{" "}
                            <em>
                              A comprehensive study on the socio-economic and
                              cultural aspects of sacred groves in Kerala-
                              Report no.11- Pathanamthitta district
                            </em>
                            .
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Nair, M. S. (2022b).{" "}
                            <em>
                              A comprehensive study on the socio-economic and
                              cultural aspects of sacred groves in Kerala-
                              Report no.12- Malappuram district
                            </em>
                            .
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Nair, M. S. (2022c).{" "}
                            <em>
                              A comprehensive study on the socio-economic and
                              cultural aspects of sacred groves in Kerala-
                              Report no.13- Ernakulam district
                            </em>
                            .
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Nair, M. S. (2022d).{" "}
                            <em>
                              A comprehensive study on the socio-economic and
                              cultural aspects of sacred groves in Kerala-
                              Report no.14- Wayanad district{" "}
                            </em>
                            .
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Nayar T. S, Sibi M, Beegam Rasiya, Mohanan N, &amp;
                            Rajkumar G. (2008). Flowering plants of Kerala:
                            Status and Statistics. <em>Rheedea </em>,{" "}
                            <em>18</em>(2), 95&ndash;106.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Neethu G Pillai, &amp; Harilal C.C. (2018).
                            INVENTORY ON THE DIVERSITY AND DISTRIBUTION OF
                            MANGROVES FROM THE COASTAL ECOSYSTEMS OF KERALA
                            STATE, INDIA .{" "}
                            <em>
                              International Journal of Recent Scientific&nbsp;
                              Research
                            </em>
                            , <em>9</em>, 24002&ndash;24007.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            <em>Government of Kerala</em>. (n.d.).
                            Https://Www.Kerala.Gov.In/.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Peyre, A., Guidal, A., Wiersum, K. F., &amp;
                            Bongers, F. (2006). Dynamics of homegarden structure
                            and function in Kerala, India.{" "}
                            <em>Agroforestry Systems</em>, <em>66</em>(2),
                            101&ndash;115.
                            https://doi.org/10.1007/S10457-005-2919-X
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Pius OL, Sujanapal P, &amp; Udayan PS. (2015).
                            Diversity inventory and conservation of endemic and
                            threatened medicinal plants of Malappuram District,
                            Kerala. <em>Annals of Plant Sciences </em>,{" "}
                            <em>4</em>(03).
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Pradheep, K., John, K. J., &hellip; M. L.-G. R. and,
                            &amp; 2021, undefined. (2021). Status of crop plants
                            of agricultural importance in Kerala state, India:
                            an update. <em>Springer</em>.
                            https://link.springer.com/article/10.1007/s10722-020-01100-5
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Prajeesh Parameswaran, Ratheesh Narayanan MK, &amp;
                            Anil Kumar N. (2014). Diversity of Vascular Plants
                            Associated with Wetland Paddy Fields (Vayals) of
                            Wayanad District in Western Ghats, India .{" "}
                            <em>Annals of Plant Sciences</em>, 704&ndash;714.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Praveenkumar, K. (2018). Floristic Diversity of
                            Puliyanamkunnu, Chalavara Grama Panchayath, Palakkad
                            District, Kerala State.{" "}
                            <em>
                              International Journal of Environment, Agriculture
                              and Biotechnology (IJEAB)&nbsp;{" "}
                            </em>
                            , <em>3</em>(6), 2146&ndash;2150.
                            https://www.academia.edu/download/57995440/25_FloristicDiversity.pdf
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Rahees, N., Kiran, M., &amp; Vishal, V. (2014).
                            PHYTOSOCIOLOGICAL ANALYSIS OF MANGROVE FOREST AT
                            KADALUNDI- VALLIKKUNNU COMMUNITY RESERVE, KERALA.{" "}
                            <em>
                              International Journal of Science, Environment and
                              Technology
                            </em>
                            , <em>3</em>, 2154&ndash;2159.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Raj, M., Sivadasan, M., Narasimhan, N. R.-,
                            Diversity, D. P., &amp; 2003, undefined. (2003).
                            Grass diversity of Kerala&ndash;Endemism and its
                            phytogeographical significance. <em>Net</em>.
                            https://www.researchgate.net/profile/Kiran-Raj-S/publication/257952816_Grass_Diversity_of_Kerala_-_Endemism_and_its_Phytogeographical_significance/links/56482dc508aef646e6cfe8ad/Grass-Diversity-of-Kerala-Endemism-and-its-Phytogeographical-significance.pdf
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Rajan, B., Varghese, V., Paul<sup>o</sup>, J., &amp;
                            AP, P. (2013). Floristic diversity and associated
                            fauna in a high altitude tourism destination of
                            Western Ghats, Kerala, S. India. <em>Net</em>.
                            https://www.researchgate.net/profile/Pradeepkumar-Ap/publication/265726628_Floristic_diversity_and_associated_fauna_in_a_high_altitude_tourism_destination_of_Western_Ghats_Kerala_south_India/links/5419ab640cf25ebee9887b0e/Floristic-diversity-and-associated-fauna-in-a-high-altitude-tourism-destination-of-Western-Ghats-Kerala-south-India.pdf
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Ramachandran, V. S., &amp; Nair, V. J. (1988).{" "}
                            <em>Flora of Cannanore</em>.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Ratheesh N., K.B. Manoj, &amp; Lekshmi S. (2017).
                            Diversity of&nbsp; Mangroves in Asramam, Kollam
                            District, Kerala.{" "}
                            <em>Journal of Advances in Biological Science </em>,{" "}
                            <em>4</em>, 20&ndash;24.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Ratheesh Narayanan, M. K., Anilkumar, N.,
                            Balakrishnan, V., Sivadasan, M., Ahmed Alfarhan, H.,
                            &amp; Alatar, A. A. (2011). Wild edible plants used
                            by the Kattunaikka, Paniya and Kuruma tribes of
                            Wayanad District, Kerala, India.{" "}
                            <em>Journal of Medicinal Plants Research </em>,{" "}
                            <em>5</em>, . 3520-3529.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Ratheesh Narayanan, M. K., Mithunlal, S., Sujanapal,
                            P., Anil Kumar, N., Sivadasan, M., Ahmed H.
                            Alfarhan, &amp; Alatar, A. A. (2011).
                            Ethnobotanically important trees and their uses by
                            Kattunaikka tribe in Wayanad Wildlife Sanctuary,
                            Kerala, India.{" "}
                            <em>Journal of Medicinal Plants Research</em>,
                            604&ndash;612.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Reneela, P., &amp; Remesh. M. (2012). Plant
                            Resources of Kerala: Scope for Exploring Promising
                            Natural Products. <em>SAMAGRA</em>, <em>8</em>,
                            15&ndash;19.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Renuka, C., Bhat, K. V., &amp; Chand Basha, S.
                            (1996).{" "}
                            <em>
                              PALM RESOURCES OF KERALA AND THEIR UTILISATION
                            </em>
                            .
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Sabu, T., &amp; Babu, A. (2007). FLORISTIC ANALYSIS
                            OF WETLANDS OF KERALA.{" "}
                            <em>Kerala Environment Congress&nbsp; 2007</em>,
                            91&ndash;105.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            SAJEEV, K. K., &amp; SASIDHARAN, N. (1997).
                            ETHNOBOTANICAL OBSERVATIONS ON THE TRIBALS OF
                            CHINNAR WILDLIFE SANCTUARY.{" "}
                            <em>Ancient Science of Life</em>, 284&ndash;292.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Sankaran K. V, Sajeev T.V, &amp; Suresh T. A.
                            (2014). Invasive Plant Threats to Forests in the
                            Humid Tropics: A Case Study from Kerala State, India
                            .{" "}
                            <em>
                              Proceedings of the International Conference on
                              Invasive Alien Species Management
                            </em>
                            , 7&ndash;17.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Sasidharan, N. (1998).{" "}
                            <em>
                              STUDIES ON THE FLORA OF PERIYAR TIGER RESERVE
                            </em>
                            .
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Sasidharan N. (1999). Floristic diversity of
                            Shenduruny Wildlife Sanctuary, Southern Western
                            Ghats, Kerala.{" "}
                            <em>
                              Biodiversity, Taxonomy and Conservation of Plants
                            </em>
                            , 261&ndash;273.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Sasidharan, N. (1999).{" "}
                            <em>
                              STUDY ON THE FLORA OF CHINNAR WILDLIFE SANCTUARY
                            </em>
                            .
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Sasidharan, N. (2002).{" "}
                            <em>
                              FLORISTIC STUDIES IN PARAMBIKULAM WILDLIFE
                              SANCTUARY
                            </em>
                            .
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Sasidharan N. (2003). Red listed threatened tree
                            species in Kerala: a review. <em>Org</em>.
                            http://www.azkurs.org/pars_docs/refs/28/27215/27215.pdf
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Sasidharan, N. (2013).{" "}
                            <em>
                              FLORISTIC STUDIES IN ARALAM WILDLIFE SANCTUARY{" "}
                            </em>
                            .
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Sasidharan, N., Chand Bhasha, S., &amp; Renuka, C.
                            (1994).{" "}
                            <em>
                              BOTANICAL STUDIES IN THE MEDICINAL PLANT
                              CONSERVATION AREAS IN KERALA
                            </em>
                            .
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Sasidharan N., &amp; P. Sujanapal. (2011). The genus
                            Atuna (Chrysobalanaceae) in Southern Western Ghats,
                            India. <em>Rheedea</em>, <em>21</em>(1),
                            81&ndash;83.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Sebastian, J., &hellip; D. K.-J. of T., &amp; 2021,
                            undefined. (2021). Species diversity and abundance
                            patterns of epiphytic orchids in Aralam Wildlife
                            Sanctuary in Kerala, India. <em>Org</em>.
                            https://threatenedtaxa.org/index.php/JoTT/article/view/4852
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Senthilkumar, N., Prakash, S., Rajesh Kannan, C.,
                            Arun Prasath, A., &amp; Krishnakumar, N. (2014).
                            Revisiting forest types of India (Champion and Seth,
                            1968): A case study on Myristica swamp forest in
                            Kerala.{" "}
                            <em>International Journal of Advanced Research</em>,{" "}
                            <em>2</em>(2), 492&ndash;501.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Sharma, J. K., Nair, K. K. N., Mathew, G.,
                            Ramachandran, K. K., Jayson, E. A., Mohanadas, K.,
                            Nandakumar, U. N., &amp; Vijayakumaran Nair, P.
                            (2002).{" "}
                            <em>
                              STUDIES ON THE BIODIVERSITY OF&nbsp; NEW
                              AMARAMBALAM RESERVED FORESTS OF NILGIRI BIOSPHERE
                              RESERVE
                            </em>
                            .
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Sharrock, S. (2020).{" "}
                            <em>
                              Plant Conservation Report 2020: A review of
                              progress in implementation of the Global Strategy
                              for Plant Conservation 2011-2020{" "}
                            </em>
                            .
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Silija, V., Samitha Varma, K., &amp; Mohanana, K.
                            (2008). Ethnomedicinal plant knowledge of the Mullu
                            kuruma tribe of Wayanad district, Kerala.{" "}
                            <em>Indian Journal of Traditional Knowledge</em>,{" "}
                            <em>7</em>, 604&ndash;612.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Sreedharan, T. P. (2004).{" "}
                            <em>
                              Biological Diversity of Kerala: A survey of
                              Kalliasseri panchayat, Kannur district
                            </em>
                            .
                            http://www.cds.ac.in/krpcds/publication/downloads/62.pdf
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Sreeja, K., Natural, P. U.-J. of E. and T., &amp;
                            2016, undefined. (2016). Floristic diversity of
                            Vallikkaattu Kaavu, a sacred grove of Kozhikode,
                            Kerala, India. <em>Org</em>.
                            https://academicjournals.org/journal/JENE/article-full-text/581585460780
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            SREEJITH, K. A., CHANDRASHEKARA, U. M., NIRMESH, T.
                            K., &amp; SREEKUMAR, V. B. (2016). Tree Species
                            Composition and Distribution Pattern in a Myristica
                            Swamp of Northern Kerala, India.{" "}
                            <em>Current World Environment </em>, 743&ndash;750.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Sreejith, K., Prashob, P., Sreekumar, V.,
                            Manjunatha, H., &amp; Prejith, M. (2016).
                            Microhabitat Diversity in a Lateritic Hillock of
                            Northern Kerala, India.{" "}
                            <em>
                              Vegetos- An International Journal of Plant
                              Research
                            </em>
                            , <em>29</em>(3), 101&ndash;192.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Sreelekshmi, S., Preethy, C., &hellip; R. V.-J. of
                            A.-P., &amp; 2018, undefined. (2018). Diversity,
                            stand structure, and zonation pattern of mangroves
                            in southwest coast of India. <em>Elsevier</em>.
                            https://www.sciencedirect.com/science/article/pii/S2287884X1830013X
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Sreelekshmi, S., Veettil, B. K., Bijoy Nandan, S.,
                            &amp; Harikrishnan, M. (2021). Mangrove forests
                            along the coastline of Kerala, southern India:
                            Current status and future prospects.{" "}
                            <em>Regional Studies in Marine Science</em>,{" "}
                            <em>41</em>, 101573.
                            https://doi.org/10.1016/J.RSMA.2020.101573
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Sujana, K., &amp; Sivaperuman C. (2008). Status and
                            conservation of threatened flora in selected sacred
                            groves of coastal Kerala. <em>Eco News</em>,{" "}
                            <em>14</em>, 6&ndash;10.
                            http://environmentportal.in/files/Status%20and%20conservation%20of%20threatened%20flora.pdf
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Sundarapandian, S., research, P. K.-J. of forestry,
                            &amp; 2013, undefined. (2013). Edge effects on plant
                            diversity in tropical forest ecosystems at Periyar
                            Wildlife sanctuary in the Western Ghats of India.{" "}
                            <em>Springer</em>, <em>24</em>(3), 403&ndash;418.
                            https://doi.org/10.1007/s11676-013-0373-6
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Sureshkumar, J., Silambarasan, R., &amp; Ayyanar, M.
                            (2017). An ethnopharmacological analysis of
                            medicinal plants used by the Adiyan community in
                            Wayanad district of Kerala, India.{" "}
                            <em>European Journal of Integrative Medicine</em>,{" "}
                            <em>12</em>, 60&ndash;73.
                            https://doi.org/10.1016/J.EUJIM.2017.04.006
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Swarupanandan, K., &amp; Balasubramanyan, K. (2013).{" "}
                            <em>
                              Ecology and Conservation of Selected Tree Endemics
                              of Kerala
                            </em>
                            .
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Synudeen Sahib, S. (2017). BIODIVERSITY OF MYRISTICA
                            SWAMP FORESTS OF SOUTH WESTERN GHATS.{" "}
                            <em>
                              Journal of Emerging Technologies and Innovative
                              Research (JETIR){" "}
                            </em>
                            , <em>4</em>(8), 437&ndash;443.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Thomas, B., UM, C., &amp; A, R. (2011). Floristic
                            diversity along an altitudinal gradient of Mannavan
                            Shola forest in Southern Western Ghats of Kerala.{" "}
                            <em>Journal of Research in Biology</em>, <em>1</em>
                            (2), 101&ndash;109.
                            https://ojs.jresearchbiology.com/index.php/jrb/article/view/42
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Thomas, R., Sreekumar, K., Bijeshmon, P., &amp;
                            Paul, J. (2020). Angiosperm Diversity of
                            agro-ecosystems-a case study from Kooroppada
                            Gramapanchayath, Kottayam, Kerala State.{" "}
                            <em>Com</em>, 27.
                            http://www.envirobiotechjournals.com/EEC/v27FebSupplIssue2021/EEC-42without%20email.pdf
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            M. Chandrashekara, A.R.R. Menon, K.K.N. Nair, N.
                            Sasidharan, &amp; K. Swarupanandan. (1998).{" "}
                            <em>
                              EVALUATING PLANT DIVERSITY IN DIFFERENT FOREST
                              TYPES OF KERALA BY LAYING OUT PERMANENT SAMPLE
                              PLOTS
                            </em>
                            .
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Vaheeda, K. K., &amp; Uma, K. (2013). PLANT
                            DIVERSITY ALONG THE LOWER REACHES OF BHARATHAPUZHA
                            RIVER, KERALA, INDIA.{" "}
                            <em>International Journal of Current Research</em>,{" "}
                            <em>5</em>(12), 4133&ndash;4137.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Varghese, A., Hist, K. B.-J. S. A. Nat., &amp; 1999,
                            undefined. (1999). Structure, composition and
                            diversity of the tropical wet evergreen forest of
                            the Agasthyamalai region of Kerala, Western Ghats.{" "}
                            <em>Ces.Iisc.Ac.In</em>, <em>4</em>(1), 87&ndash;98.
                            https://wgbis.ces.iisc.ac.in/biodiversity/sahyadri_enews/newsletter/issue42/bibliography/Structure-composition-and-diversity-of-the-tropical-wet-evergreen-forest-of-the-Agasthyamalai-Region-of-Kerala.PDF
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Varghese AO, &amp; Menon ARR. (1999). Floristic
                            composition, dynamics and diversity of Myristica
                            swamp forests of Southern-Western Ghats, Kerala.{" "}
                            <em>Net</em>.
                            https://www.researchgate.net/profile/Varghese-A-O/publication/349027090_MYRISTIDOC/data/601b8a44299bf1cc26a00c9b/MYRISTI.DOC
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Venkatesan, K., Mokhtar, A., Rampradap, M., &amp;
                            Zaheer, A. N. (2023). Conservation Status and
                            Diversity of Medicinal Plants Used in Indian System
                            of Medicine - A Survey Report from the Munaru Forest
                            Division, Kerala, India.{" "}
                            <em>
                              International Research Journal of Pharmaceutical
                              and Applied Sciences
                            </em>
                            , 1&ndash;11.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Vidyasagaran, K., &amp; Anilkumar, K. K. (2011).
                            Structural analysis of forest ecosystems of
                            Attappady, Kerala.{" "}
                            <em>Indian Journal of Forestry</em>, <em>34</em>,
                            439&ndash;446.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Vidyasagaran, K., M.V, R., M, M., &amp; T.P, P.
                            (2011). Phytosociological analysis of Mangroves at
                            Kannur district, Kerala.{" "}
                            <em>
                              INTERNATIONAL&nbsp;JOURNAL&nbsp;OF&nbsp;ENVIRONMENTAL&nbsp;SCIENCES
                            </em>
                            .
                            https://www.indianjournals.com/ijor.aspx?target=ijor:ijes&amp;volume=2&amp;issue=2&amp;article=027
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Vidyasagaran, K., Sci, V. M.-J. B. E., &amp; 2014,
                            undefined. (2014). Distribution and plant diversity
                            of mangroves in the west coast of Kerala, India.{" "}
                            <em>Net</em>, <em>4</em>(5), 38&ndash;45.
                            https://www.researchgate.net/profile/Vidyasagaran-Kattany/publication/282276621_Distribution_and_plant_diversity_of_mangroves_in_the_west_coast_of_Kerala_India/links/560a41a708ae4d86bb136b6c/Distribution-and-plant-diversity-of-mangroves-in-the-west-coast-of-Kerala-India.pdf
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Vijayakumar, S., Morvin Yabesha, J. E., Prabhua, S.,
                            Manikandan, R., &amp; Muralidharan, B. (2015).
                            Quantitative ethnomedicinal study of plants used in
                            the Nelliyampathy hills of Kerala, India.{" "}
                            <em>JournalofEthnopharmacology</em>, 238&ndash;254.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Vijayan, V., Rahees, N., Development, K. V.-J. of
                            P., &amp; 2015, undefined. (2015). Floristic
                            diversity and structural analysis of mangrove
                            forests at Ayiramthengu, Kollam district, Kerala.{" "}
                            <em>Co.In</em>, <em>7</em>(2), 105&ndash;108.
                            http://jpds.co.in/wp-content/uploads/2019/07/03.-Vishal-Vijayan-694.pdf
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Vincy, M. V., Brilliant, R., Paul, J., &amp;
                            Pradeepkumar, A. P. (2015). Comparison of riparian
                            species diversity between the main river channel and
                            subwatersheds of Meenachil river basin, Kerala,
                            Southern India.{" "}
                            <em>Revista Brasileira de Botanica</em>, <em>38</em>
                            (1), 81&ndash;98.
                            https://doi.org/10.1007/S40415-014-0068-Z
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Vivekananthan, K., Daniel, P., &amp; Premanath, R.
                            K. (1997). Plant diversity in Nilgiri Biosphere
                            Reserve.{" "}
                            <em>
                              Plant Diversity Hotspots in India, an Overview
                            </em>
                            , 25&ndash;61.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Xavier, T. F., Kannan, M., Lija, L., Auxillia, A.,
                            Rose, A. K. F., &amp; Kumar, S. S. (2014).
                            Ethnobotanical study of Kani tribes in Thoduhills of
                            Kerala, South India.{" "}
                            <em>Journal of Ethnopharmacology</em>, <em>152</em>
                            (1), 78&ndash;90.
                            https://doi.org/10.1016/j.jep.2013.12.016
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Yesodharan, K., &amp; Sujana, K. A. (2007a). Status
                            of ethnomedicinal plants in the Parambikulam
                            Wildlife sanctuary, Kerala, South India.{" "}
                            <em>Annals of Forestry</em>, <em>2</em>,
                            322&ndash;334.
                          </li>
                          <li style={{ fontSize: "0.999999em" }}>
                            Yesodharan, K., &amp; Sujana, K. A. (2007b). Wild
                            edible plants traditionally used by the tribes in
                            the Parambikulam Wildlife Sanctuary, Kerala, India.{" "}
                            <em>Natural Product Radiance</em>, 74&ndash;80.
                          </li>
                        </ul>
                        <p>&nbsp;</p>
                      </p>
                    </section>
                  </li>{" "}
                  <br />
                </ul>
              </nav>
            </div>
          </div>
        </>
      }
    />
  );
}

export default ArticlePage;
